// Ловушка вызовов jQuery (этап выпила jQuery из бандла).
// Режим A: jQuery ещё загружен — прозрачная обёртка, вызовы $() репортятся в Sentry.
// Режим B: jQuery удалён — безопасная chainable-заглушка вместо падений,
// $(fn)/.ready(fn) выполняются на DOMContentLoaded, обращения репортятся.
// Репорты: дедуп по сигнатуре, максимум 10 на страницу, тег jqueryTrap.
;(function () {
    'use strict';

    var reported = {};
    var reportsLeft = 10;

    var describe = function (arg) {
        try {
            if (arg === undefined) return 'undefined';
            if (arg === null) return 'null';
            if (typeof arg === 'string') return '"' + arg.slice(0, 80) + '"';
            if (typeof arg === 'function') return 'function';
            if (arg === window) return 'window';
            if (arg === document) return 'document';
            if (arg.nodeType) return '<' + String(arg.nodeName || 'node').toLowerCase() + '>';
            return Object.prototype.toString.call(arg);
        } catch (e) {
            return '?';
        }
    };

    var report = function (kind, detail) {
        var key = kind + ':' + detail;
        if (reported[key] || reportsLeft <= 0) return;
        reported[key] = true;
        reportsLeft--;
        var stack = '';
        try {
            stack = String(new Error().stack || '').split('\n').slice(2, 6).join(' | ').slice(0, 500);
        } catch (e) {}
        var message = 'jquery-trap: ' + kind + (detail ? ' ' + detail : '');
        try {
            if (window.Sentry && window.Sentry.captureMessage) {
                window.Sentry.captureMessage(message, {
                    level: 'warning',
                    tags: { jqueryTrap: kind },
                    extra: { detail: detail, stack: stack, page: location.pathname + location.search }
                });
            } else if (window.console && console.warn) {
                console.warn(message, stack);
            }
        } catch (e) {}
    };

    // --- Режим A: настоящий jQuery на месте — только телеметрия вызовов ---
    if (typeof window.jQuery === 'function') {
        var real = window.jQuery;
        var wrapped = new Proxy(real, {
            apply: function (target, thisArg, args) {
                if (typeof args[0] === 'function') {
                    report('ready', 'callback');
                } else {
                    report('$()', describe(args[0]));
                }
                return Reflect.apply(target, thisArg, args);
            },
            // receiver = target: внутренние this-зависимые геттеры jQuery работают как раньше
            get: function (target, prop) {
                return Reflect.get(target, prop, target);
            },
            set: function (target, prop, value) {
                target[prop] = value;
                return true;
            }
        });
        window.jQuery = wrapped;
        window.$ = wrapped;
        return;
    }

    // --- Режим B: jQuery удалён — заглушка вместо каскадных падений ---

    var onReady = function (fn) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function () {
                try { fn(); } catch (e) { report('ready-error', String(e).slice(0, 120)); }
            });
        } else {
            try { fn(); } catch (e) { report('ready-error', String(e).slice(0, 120)); }
        }
    };

    // Служебные ключи: отдаём безопасные значения без репорта
    var quietKeys = {
        prototype: true, constructor: true, name: true, length: true,
        call: true, apply: true, bind: true,
        toString: true, valueOf: true, toJSON: true,
        then: true, 'catch': true, 'finally': true,
        jquery: true, noConflict: true, __proto__: true
    };

    var stub = new Proxy(function () {}, {
        get: function (target, prop) {
            if (typeof prop === 'symbol') {
                if (prop === Symbol.toPrimitive) return function () { return ''; };
                if (prop === Symbol.iterator) return function () { return [][Symbol.iterator](); };
                return undefined;
            }
            if (prop === 'length') return 0;
            if (prop === 'jquery') return '0.0.0-trap';
            if (prop === 'toString' || prop === 'valueOf') return function () { return ''; };
            if (prop === 'then' || prop === 'catch' || prop === 'finally' || prop === 'toJSON') return undefined;
            if (prop === 'ready') {
                return function (fn) {
                    report('ready', 'callback');
                    if (typeof fn === 'function') onReady(fn);
                    return stub;
                };
            }
            return stub;
        },
        set: function () { return true; },
        apply: function () { return stub; },
        has: function () { return true; }
    });

    // $.fn — реальный объект: регистрация плагинов (slick и пр.) не падает
    var fnStore = {};

    var fakeJQuery = new Proxy(function () {}, {
        apply: function (target, thisArg, args) {
            if (typeof args[0] === 'function') {
                report('ready', 'callback');
                onReady(args[0]);
                return stub;
            }
            report('$()', describe(args[0]));
            return stub;
        },
        get: function (target, prop) {
            if (typeof prop === 'symbol') {
                if (prop === Symbol.toPrimitive) return function () { return ''; };
                return undefined;
            }
            if (prop === 'fn') {
                report('jQuery.fn', 'plugin-access');
                return fnStore;
            }
            if (quietKeys[prop]) {
                if (prop === 'toString' || prop === 'valueOf') return function () { return 'jquery-trap'; };
                if (prop === 'jquery') return '0.0.0-trap';
                if (prop === 'length') return 0;
                return undefined;
            }
            report('jQuery.' + String(prop), '');
            return stub;
        },
        set: function (target, prop, value) {
            target[prop] = value;
            return true;
        }
    });

    window.jQuery = fakeJQuery;
    window.$ = fakeJQuery;
})();
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e=e||self).GLightbox=t()}(this,(function(){"use strict";function e(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function t(e,t){for(var i=0;i<t.length;i++){var s=t[i];s.enumerable=s.enumerable||!1,s.configurable=!0,"value"in s&&(s.writable=!0),Object.defineProperty(e,n(s.key),s)}}function i(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),Object.defineProperty(e,"prototype",{writable:!1}),e}function n(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var i=e[Symbol.toPrimitive];if(void 0!==i){var n=i.call(e,t||"default");if("object"!=typeof n)return n;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}function s(e){return(s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var l=Date.now();function o(){var e={},t=!0,i=0,n=arguments.length;"[object Boolean]"===Object.prototype.toString.call(arguments[0])&&(t=arguments[0],i++);for(var s=function(i){for(var n in i)Object.prototype.hasOwnProperty.call(i,n)&&(t&&"[object Object]"===Object.prototype.toString.call(i[n])?e[n]=o(!0,e[n],i[n]):e[n]=i[n])};i<n;i++){var l=arguments[i];s(l)}return e}function r(e,t){if((E(e)||e===window||e===document)&&(e=[e]),L(e)||I(e)||(e=[e]),0!=M(e))if(L(e)&&!I(e))for(var i=e.length,n=0;n<i&&!1!==t.call(e[n],e[n],n,e);n++);else if(I(e))for(var s in e)if(P(e,s)&&!1===t.call(e[s],e[s],s,e))break}function a(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,n=e[l]=e[l]||[],s={all:n,evt:null,found:null};return t&&i&&M(n)>0&&r(n,(function(e,n){if(e.eventName==t&&e.fn.toString()==i.toString())return s.found=!0,s.evt=n,!1})),s}function h(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=t.onElement,n=t.withCallback,s=t.avoidDuplicate,l=void 0===s||s,o=t.once,h=void 0!==o&&o,d=t.useCapture,c=void 0!==d&&d,u=arguments.length>2?arguments[2]:void 0,g=i||[];function v(e){C(n)&&n.call(u,e,this),h&&v.destroy()}return k(g)&&(g=document.querySelectorAll(g)),v.destroy=function(){r(g,(function(t){var i=a(t,e,v);i.found&&i.all.splice(i.evt,1),t.removeEventListener&&t.removeEventListener(e,v,c)}))},r(g,(function(t){var i=a(t,e,v);(t.addEventListener&&l&&!i.found||!l)&&(t.addEventListener(e,v,c),i.all.push({eventName:e,fn:v}))})),v}function d(e,t){r(t.split(" "),(function(t){return e.classList.add(t)}))}function c(e,t){r(t.split(" "),(function(t){return e.classList.remove(t)}))}function u(e,t){return e.classList.contains(t)}function g(e,t){for(;e!==document.body;){if(!(e=e.parentElement))return!1;if("function"==typeof e.matches?e.matches(t):e.msMatchesSelector(t))return e}}function v(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",i=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(!e||""===t)return!1;if("none"===t)return C(i)&&i(),!1;var n=b(),s=t.split(" ");r(s,(function(t){d(e,"g"+t)})),h(n,{onElement:e,avoidDuplicate:!1,once:!0,withCallback:function(e,t){r(s,(function(e){c(t,"g"+e)})),C(i)&&i()}})}function f(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";if(""===t)return e.style.webkitTransform="",e.style.MozTransform="",e.style.msTransform="",e.style.OTransform="",e.style.transform="",!1;e.style.webkitTransform=t,e.style.MozTransform=t,e.style.msTransform=t,e.style.OTransform=t,e.style.transform=t}function p(e){e.style.display="block"}function m(e){e.style.display="none"}function y(e){var t=document.createDocumentFragment(),i=document.createElement("div");for(i.innerHTML=e;i.firstChild;)t.appendChild(i.firstChild);return t}function x(){return{width:window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth,height:window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight}}function b(){var e,t=document.createElement("fakeelement"),i={animation:"animationend",OAnimation:"oAnimationEnd",MozAnimation:"animationend",WebkitAnimation:"webkitAnimationEnd"};for(e in i)if(void 0!==t.style[e])return i[e]}function S(e,t,i,n){if(e())t();else{var s;i||(i=100);var l=setInterval((function(){e()&&(clearInterval(l),s&&clearTimeout(s),t())}),i);n&&(s=setTimeout((function(){clearInterval(l)}),n))}}function w(e,t,i){if(O(e))console.error("Inject assets error");else if(C(t)&&(i=t,t=!1),k(t)&&t in window)C(i)&&i();else{var n;if(-1!==e.indexOf(".css")){if((n=document.querySelectorAll('link[href="'+e+'"]'))&&n.length>0)return void(C(i)&&i());var s=document.getElementsByTagName("head")[0],l=s.querySelectorAll('link[rel="stylesheet"]'),o=document.createElement("link");return o.rel="stylesheet",o.type="text/css",o.href=e,o.media="all",l?s.insertBefore(o,l[0]):s.appendChild(o),void(C(i)&&i())}if((n=document.querySelectorAll('script[src="'+e+'"]'))&&n.length>0){if(C(i)){if(k(t))return S((function(){return void 0!==window[t]}),(function(){i()})),!1;i()}}else{var r=document.createElement("script");r.type="text/javascript",r.src=e,r.onload=function(){if(C(i)){if(k(t))return S((function(){return void 0!==window[t]}),(function(){i()})),!1;i()}},document.body.appendChild(r)}}}function T(){return"navigator"in window&&window.navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(Android)|(PlayBook)|(BB10)|(BlackBerry)|(Opera Mini)|(IEMobile)|(webOS)|(MeeGo)/i)}function C(e){return"function"==typeof e}function k(e){return"string"==typeof e}function E(e){return!(!e||!e.nodeType||1!=e.nodeType)}function A(e){return Array.isArray(e)}function L(e){return e&&e.length&&isFinite(e.length)}function I(e){return"object"===s(e)&&null!=e&&!C(e)&&!A(e)}function O(e){return null==e}function P(e,t){return null!==e&&hasOwnProperty.call(e,t)}function M(e){if(I(e)){if(e.keys)return e.keys().length;var t=0;for(var i in e)P(e,i)&&t++;return t}return e.length}function z(e){return!isNaN(parseFloat(e))&&isFinite(e)}function X(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:-1,t=document.querySelectorAll(".gbtn[data-taborder]:not(.disabled)");if(!t.length)return!1;if(1==t.length)return t[0];"string"==typeof e&&(e=parseInt(e));var i=[];r(t,(function(e){i.push(e.getAttribute("data-taborder"))}));var n=Math.max.apply(Math,i.map((function(e){return parseInt(e)}))),s=e<0?1:e+1;s>n&&(s="1");var l=i.filter((function(e){return e>=parseInt(s)})),o=l.sort()[0];return document.querySelector('.gbtn[data-taborder="'.concat(o,'"]'))}function Y(e){if(e.events.hasOwnProperty("keyboard"))return!1;e.events.keyboard=h("keydown",{onElement:window,withCallback:function(t,i){var n=(t=t||window.event).keyCode;if(9==n){var s=document.querySelector(".gbtn.focused");if(!s){var l=!(!document.activeElement||!document.activeElement.nodeName)&&document.activeElement.nodeName.toLocaleLowerCase();if("input"==l||"textarea"==l||"button"==l)return}t.preventDefault();var o=document.querySelectorAll(".gbtn[data-taborder]");if(!o||o.length<=0)return;if(!s){var r=X();return void(r&&(r.focus(),d(r,"focused")))}var a=X(s.getAttribute("data-taborder"));c(s,"focused"),a&&(a.focus(),d(a,"focused"))}39==n&&e.nextSlide(),37==n&&e.prevSlide(),27==n&&e.close()}})}var q=i((function t(i,n){var s=this,l=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;if(e(this,t),this.img=i,this.slide=n,this.onclose=l,this.img.setZoomEvents)return!1;this.active=!1,this.zoomedIn=!1,this.dragging=!1,this.currentX=null,this.currentY=null,this.initialX=null,this.initialY=null,this.xOffset=0,this.yOffset=0,this.img.addEventListener("mousedown",(function(e){return s.dragStart(e)}),!1),this.img.addEventListener("mouseup",(function(e){return s.dragEnd(e)}),!1),this.img.addEventListener("mousemove",(function(e){return s.drag(e)}),!1),this.img.addEventListener("click",(function(e){return s.slide.classList.contains("dragging-nav")?(s.zoomOut(),!1):s.zoomedIn?void(s.zoomedIn&&!s.dragging&&s.zoomOut()):s.zoomIn()}),!1),this.img.setZoomEvents=!0}),[{key:"zoomIn",value:function(){var e=this.widowWidth();if(!(this.zoomedIn||e<=768)){var t=this.img;if(t.setAttribute("data-style",t.getAttribute("style")),t.style.maxWidth=t.naturalWidth+"px",t.style.maxHeight=t.naturalHeight+"px",t.naturalWidth>e){var i=e/2-t.naturalWidth/2;this.setTranslate(this.img.parentNode,i,0)}this.slide.classList.add("zoomed"),this.zoomedIn=!0}}},{key:"zoomOut",value:function(){this.img.parentNode.setAttribute("style",""),this.img.setAttribute("style",this.img.getAttribute("data-style")),this.slide.classList.remove("zoomed"),this.zoomedIn=!1,this.currentX=null,this.currentY=null,this.initialX=null,this.initialY=null,this.xOffset=0,this.yOffset=0,this.onclose&&"function"==typeof this.onclose&&this.onclose()}},{key:"dragStart",value:function(e){e.preventDefault(),this.zoomedIn?("touchstart"===e.type?(this.initialX=e.touches[0].clientX-this.xOffset,this.initialY=e.touches[0].clientY-this.yOffset):(this.initialX=e.clientX-this.xOffset,this.initialY=e.clientY-this.yOffset),e.target===this.img&&(this.active=!0,this.img.classList.add("dragging"))):this.active=!1}},{key:"dragEnd",value:function(e){var t=this;e.preventDefault(),this.initialX=this.currentX,this.initialY=this.currentY,this.active=!1,setTimeout((function(){t.dragging=!1,t.img.isDragging=!1,t.img.classList.remove("dragging")}),100)}},{key:"drag",value:function(e){this.active&&(e.preventDefault(),"touchmove"===e.type?(this.currentX=e.touches[0].clientX-this.initialX,this.currentY=e.touches[0].clientY-this.initialY):(this.currentX=e.clientX-this.initialX,this.currentY=e.clientY-this.initialY),this.xOffset=this.currentX,this.yOffset=this.currentY,this.img.isDragging=!0,this.dragging=!0,this.setTranslate(this.img,this.currentX,this.currentY))}},{key:"onMove",value:function(e){if(this.zoomedIn){var t=e.clientX-this.img.naturalWidth/2,i=e.clientY-this.img.naturalHeight/2;this.setTranslate(this.img,t,i)}}},{key:"setTranslate",value:function(e,t,i){e.style.transform="translate3d("+t+"px, "+i+"px, 0)"}},{key:"widowWidth",value:function(){return window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth}}]),N=i((function t(){var i=this,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};e(this,t);var s=n.dragEl,l=n.toleranceX,o=void 0===l?40:l,r=n.toleranceY,a=void 0===r?65:r,h=n.slide,d=void 0===h?null:h,c=n.instance,u=void 0===c?null:c;this.el=s,this.active=!1,this.dragging=!1,this.currentX=null,this.currentY=null,this.initialX=null,this.initialY=null,this.xOffset=0,this.yOffset=0,this.direction=null,this.lastDirection=null,this.toleranceX=o,this.toleranceY=a,this.toleranceReached=!1,this.dragContainer=this.el,this.slide=d,this.instance=u,this.el.addEventListener("mousedown",(function(e){return i.dragStart(e)}),!1),this.el.addEventListener("mouseup",(function(e){return i.dragEnd(e)}),!1),this.el.addEventListener("mousemove",(function(e){return i.drag(e)}),!1)}),[{key:"dragStart",value:function(e){if(this.slide.classList.contains("zoomed"))this.active=!1;else{"touchstart"===e.type?(this.initialX=e.touches[0].clientX-this.xOffset,this.initialY=e.touches[0].clientY-this.yOffset):(this.initialX=e.clientX-this.xOffset,this.initialY=e.clientY-this.yOffset);var t=e.target.nodeName.toLowerCase();e.target.classList.contains("nodrag")||g(e.target,".nodrag")||-1!==["input","select","textarea","button","a"].indexOf(t)?this.active=!1:(e.preventDefault(),(e.target===this.el||"img"!==t&&g(e.target,".gslide-inline"))&&(this.active=!0,this.el.classList.add("dragging"),this.dragContainer=g(e.target,".ginner-container")))}}},{key:"dragEnd",value:function(e){var t=this;e&&e.preventDefault(),this.initialX=0,this.initialY=0,this.currentX=null,this.currentY=null,this.initialX=null,this.initialY=null,this.xOffset=0,this.yOffset=0,this.active=!1,this.doSlideChange&&(this.instance.preventOutsideClick=!0,"right"==this.doSlideChange&&this.instance.prevSlide(),"left"==this.doSlideChange&&this.instance.nextSlide()),this.doSlideClose&&this.instance.close(),this.toleranceReached||this.setTranslate(this.dragContainer,0,0,!0),setTimeout((function(){t.instance.preventOutsideClick=!1,t.toleranceReached=!1,t.lastDirection=null,t.dragging=!1,t.el.isDragging=!1,t.el.classList.remove("dragging"),t.slide.classList.remove("dragging-nav"),t.dragContainer.style.transform="",t.dragContainer.style.transition=""}),100)}},{key:"drag",value:function(e){if(this.active){e.preventDefault(),this.slide.classList.add("dragging-nav"),"touchmove"===e.type?(this.currentX=e.touches[0].clientX-this.initialX,this.currentY=e.touches[0].clientY-this.initialY):(this.currentX=e.clientX-this.initialX,this.currentY=e.clientY-this.initialY),this.xOffset=this.currentX,this.yOffset=this.currentY,this.el.isDragging=!0,this.dragging=!0,this.doSlideChange=!1,this.doSlideClose=!1;var t=Math.abs(this.currentX),i=Math.abs(this.currentY);if(t>0&&t>=Math.abs(this.currentY)&&(!this.lastDirection||"x"==this.lastDirection)){this.yOffset=0,this.lastDirection="x",this.setTranslate(this.dragContainer,this.currentX,0);var n=this.shouldChange();if(!this.instance.settings.dragAutoSnap&&n&&(this.doSlideChange=n),this.instance.settings.dragAutoSnap&&n)return this.instance.preventOutsideClick=!0,this.toleranceReached=!0,this.active=!1,this.instance.preventOutsideClick=!0,this.dragEnd(null),"right"==n&&this.instance.prevSlide(),void("left"==n&&this.instance.nextSlide())}if(this.toleranceY>0&&i>0&&i>=t&&(!this.lastDirection||"y"==this.lastDirection)){this.xOffset=0,this.lastDirection="y",this.setTranslate(this.dragContainer,0,this.currentY);var s=this.shouldClose();return!this.instance.settings.dragAutoSnap&&s&&(this.doSlideClose=!0),void(this.instance.settings.dragAutoSnap&&s&&this.instance.close())}}}},{key:"shouldChange",value:function(){var e=!1;if(Math.abs(this.currentX)>=this.toleranceX){var t=this.currentX>0?"right":"left";("left"==t&&this.slide!==this.slide.parentNode.lastChild||"right"==t&&this.slide!==this.slide.parentNode.firstChild)&&(e=t)}return e}},{key:"shouldClose",value:function(){var e=!1;return Math.abs(this.currentY)>=this.toleranceY&&(e=!0),e}},{key:"setTranslate",value:function(e,t,i){var n=arguments.length>3&&void 0!==arguments[3]&&arguments[3];e.style.transition=n?"all .2s ease":"",e.style.transform="translate3d(".concat(t,"px, ").concat(i,"px, 0)")}}]);function D(e,t,i,n){var s=e.querySelector(".gslide-media"),l=new Image,o="gSlideTitle_"+i,r="gSlideDesc_"+i;l.addEventListener("load",(function(){C(n)&&n()}),!1),l.src=t.href,""!=t.sizes&&""!=t.srcset&&(l.sizes=t.sizes,l.srcset=t.srcset),l.alt="",O(t.alt)||""===t.alt||(l.alt=t.alt),""!==t.title&&l.setAttribute("aria-labelledby",o),""!==t.description&&l.setAttribute("aria-describedby",r),t.hasOwnProperty("_hasCustomWidth")&&t._hasCustomWidth&&(l.style.width=t.width),t.hasOwnProperty("_hasCustomHeight")&&t._hasCustomHeight&&(l.style.height=t.height),s.insertBefore(l,s.firstChild)}function _(e,t,i,n){var s=this,l=e.querySelector(".ginner-container"),o="gvideo"+i,r=e.querySelector(".gslide-media"),a=this.getAllPlayers();d(l,"gvideo-container"),r.insertBefore(y('<div class="gvideo-wrapper"></div>'),r.firstChild);var h=e.querySelector(".gvideo-wrapper");w(this.settings.plyr.css,"Plyr");var c=t.href,u=null==t?void 0:t.videoProvider,g=!1;r.style.maxWidth=t.width,w(this.settings.plyr.js,"Plyr",(function(){if(!u&&c.match(/vimeo\.com\/([0-9]*)/)&&(u="vimeo"),!u&&(c.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/)||c.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/)||c.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/)||c.match(/(youtube\.com|youtube-nocookie\.com)\/shorts\/([a-zA-Z0-9\-_]+)/))&&(u="youtube"),"local"===u||!u){u="local";var l='<video id="'+o+'" ';l+='style="background:#000; max-width: '.concat(t.width,';" '),l+='preload="metadata" ',l+='x-webkit-airplay="allow" ',l+="playsinline ",l+="controls ",l+='class="gvideo-local">',l+='<source src="'.concat(c,'">'),g=y(l+="</video>")}var r=g||y('<div id="'.concat(o,'" data-plyr-provider="').concat(u,'" data-plyr-embed-id="').concat(c,'"></div>'));d(h,"".concat(u,"-video gvideo")),h.appendChild(r),h.setAttribute("data-id",o),h.setAttribute("data-index",i);var v=P(s.settings.plyr,"config")?s.settings.plyr.config:{},f=new Plyr("#"+o,v);f.on("ready",(function(e){a[o]=e.detail.plyr,C(n)&&n()})),S((function(){return e.querySelector("iframe")&&"true"==e.querySelector("iframe").dataset.ready}),(function(){s.resize(e)})),f.on("enterfullscreen",W),f.on("exitfullscreen",W)}))}function W(e){var t=g(e.target,".gslide-media");"enterfullscreen"===e.type&&d(t,"fullscreen"),"exitfullscreen"===e.type&&c(t,"fullscreen")}function B(e,t,i,n){var s,l=this,o=e.querySelector(".gslide-media"),r=!(!P(t,"href")||!t.href)&&t.href.split("#").pop().trim(),a=!(!P(t,"content")||!t.content)&&t.content;if(a&&(k(a)&&(s=y('<div class="ginlined-content">'.concat(a,"</div>"))),E(a))){"none"==a.style.display&&(a.style.display="block");var c=document.createElement("div");c.className="ginlined-content",c.appendChild(a),s=c}if(r){var u=document.getElementById(r);if(!u)return!1;var g=u.cloneNode(!0);g.style.height=t.height,g.style.maxWidth=t.width,d(g,"ginlined-content"),s=g}if(!s)return console.error("Unable to append inline slide content",t),!1;o.style.height=t.height,o.style.width=t.width,o.appendChild(s),this.events["inlineclose"+r]=h("click",{onElement:o.querySelectorAll(".gtrigger-close"),withCallback:function(e){e.preventDefault(),l.close()}}),C(n)&&n()}function H(e,t,i,n){var s=e.querySelector(".gslide-media"),l=function(e){var t=e.url,i=e.allow,n=e.callback,s=e.appendTo,l=document.createElement("iframe");return l.className="vimeo-video gvideo",l.src=t,l.style.width="100%",l.style.height="100%",i&&l.setAttribute("allow",i),l.onload=function(){l.onload=null,d(l,"node-ready"),C(n)&&n()},s&&s.appendChild(l),l}({url:t.href,callback:n});s.parentNode.style.maxWidth=t.width,s.parentNode.style.height=t.height,s.appendChild(l)}var j=i((function t(){var i=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};e(this,t),this.defaults={href:"",sizes:"",srcset:"",title:"",type:"",videoProvider:"",description:"",alt:"",descPosition:"bottom",effect:"",width:"",height:"",content:!1,zoomable:!0,draggable:!0},I(i)&&(this.defaults=o(this.defaults,i))}),[{key:"sourceType",value:function(e){var t=e;return null!==(e=e.toLowerCase()).match(/\.(jpeg|jpg|jpe|gif|png|apn|webp|avif|svg)/)?"image":e.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/)||e.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/)||e.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/)||e.match(/(youtube\.com|youtube-nocookie\.com)\/shorts\/([a-zA-Z0-9\-_]+)/)||e.match(/vimeo\.com\/([0-9]*)/)||null!==e.match(/\.(mp4|ogg|webm|mov)/)?"video":null!==e.match(/\.(mp3|wav|wma|aac|ogg)/)?"audio":e.indexOf("#")>-1&&""!==t.split("#").pop().trim()?"inline":e.indexOf("goajax=true")>-1?"ajax":"external"}},{key:"parseConfig",value:function(e,t){var i=this,n=o({descPosition:t.descPosition},this.defaults);if(I(e)&&!E(e)){P(e,"type")||(P(e,"content")&&e.content?e.type="inline":P(e,"href")&&(e.type=this.sourceType(e.href)));var s=o(n,e);return this.setSize(s,t),s}var l="",a=e.getAttribute("data-glightbox"),h=e.nodeName.toLowerCase();if("a"===h&&(l=e.href),"img"===h&&(l=e.src,n.alt=e.alt),n.href=l,r(n,(function(s,l){P(t,l)&&"width"!==l&&(n[l]=t[l]);var o=e.dataset[l];O(o)||(n[l]=i.sanitizeValue(o))})),n.content&&(n.type="inline"),!n.type&&l&&(n.type=this.sourceType(l)),O(a)){if(!n.title&&"a"==h){var d=e.title;O(d)||""===d||(n.title=d)}if(!n.title&&"img"==h){var c=e.alt;O(c)||""===c||(n.title=c)}}else{var u=[];r(n,(function(e,t){u.push(";\\s?"+t)})),u=u.join("\\s?:|"),""!==a.trim()&&r(n,(function(e,t){var s=a,l=new RegExp("s?"+t+"s?:s?(.*?)("+u+"s?:|$)"),o=s.match(l);if(o&&o.length&&o[1]){var r=o[1].trim().replace(/;\s*$/,"");n[t]=i.sanitizeValue(r)}}))}if(n.description&&"."===n.description.substring(0,1)){var g;try{g=document.querySelector(n.description).innerHTML}catch(e){if(!(e instanceof DOMException))throw e}g&&(n.description=g)}if(!n.description){var v=e.querySelector(".glightbox-desc");v&&(n.description=v.innerHTML)}return this.setSize(n,t,e),this.slideConfig=n,n}},{key:"setSize",value:function(e,t){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,n="video"==e.type?this.checkSize(t.videosWidth):this.checkSize(t.width),s=this.checkSize(t.height);return e.width=P(e,"width")&&""!==e.width?this.checkSize(e.width):n,e.height=P(e,"height")&&""!==e.height?this.checkSize(e.height):s,i&&"image"==e.type&&(e._hasCustomWidth=!!i.dataset.width,e._hasCustomHeight=!!i.dataset.height),e}},{key:"checkSize",value:function(e){return z(e)?"".concat(e,"px"):e}},{key:"sanitizeValue",value:function(e){return"true"!==e&&"false"!==e?e:"true"===e}}]),V=i((function t(i,n,s){e(this,t),this.element=i,this.instance=n,this.index=s}),[{key:"setContent",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(u(t,"loaded"))return!1;var n=this.instance.settings,s=this.slideConfig,l=T();C(n.beforeSlideLoad)&&n.beforeSlideLoad({index:this.index,slide:t,player:!1});var o=s.type,r=s.descPosition,a=t.querySelector(".gslide-media"),h=t.querySelector(".gslide-title"),c=t.querySelector(".gslide-desc"),g=t.querySelector(".gdesc-inner"),v=i,f="gSlideTitle_"+this.index,p="gSlideDesc_"+this.index;if(C(n.afterSlideLoad)&&(v=function(){C(i)&&i(),n.afterSlideLoad({index:e.index,slide:t,player:e.instance.getSlidePlayerInstance(e.index)})}),""==s.title&&""==s.description?g&&g.parentNode.parentNode.removeChild(g.parentNode):(h&&""!==s.title?(h.id=f,h.innerHTML=s.title):h.parentNode.removeChild(h),c&&""!==s.description?(c.id=p,l&&n.moreLength>0?(s.smallDescription=this.slideShortDesc(s.description,n.moreLength,n.moreText),c.innerHTML=s.smallDescription,this.descriptionEvents(c,s)):c.innerHTML=s.description):c.parentNode.removeChild(c),d(a.parentNode,"desc-".concat(r)),d(g.parentNode,"description-".concat(r))),d(a,"gslide-".concat(o)),d(t,"loaded"),"video"!==o){if("external"!==o)return"inline"===o?(B.apply(this.instance,[t,s,this.index,v]),void(s.draggable&&new N({dragEl:t.querySelector(".gslide-inline"),toleranceX:n.dragToleranceX,toleranceY:n.dragToleranceY,slide:t,instance:this.instance}))):void("image"!==o?C(v)&&v():D(t,s,this.index,(function(){var i=t.querySelector("img");s.draggable&&new N({dragEl:i,toleranceX:n.dragToleranceX,toleranceY:n.dragToleranceY,slide:t,instance:e.instance}),s.zoomable&&i.naturalWidth>i.offsetWidth&&(d(i,"zoomable"),new q(i,t,(function(){e.instance.resize()}))),C(v)&&v()})));H.apply(this,[t,s,this.index,v])}else _.apply(this.instance,[t,s,this.index,v])}},{key:"slideShortDesc",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:50,i=arguments.length>2&&void 0!==arguments[2]&&arguments[2],n=document.createElement("div");n.innerHTML=e;var s=n.innerText,l=i;if((e=s.trim()).length<=t)return e;var o=e.substr(0,t-1);return l?(n=null,o+'... <a href="#" class="desc-more">'+i+"</a>"):o}},{key:"descriptionEvents",value:function(e,t){var i=this,n=e.querySelector(".desc-more");if(!n)return!1;h("click",{onElement:n,withCallback:function(e,n){e.preventDefault();var s=document.body,l=g(n,".gslide-desc");if(!l)return!1;l.innerHTML=t.description,d(s,"gdesc-open");var o=h("click",{onElement:[s,g(l,".gslide-description")],withCallback:function(e,n){"a"!==e.target.nodeName.toLowerCase()&&(c(s,"gdesc-open"),d(s,"gdesc-closed"),l.innerHTML=t.smallDescription,i.descriptionEvents(l,t),setTimeout((function(){c(s,"gdesc-closed")}),400),o.destroy())}})}})}},{key:"create",value:function(){return y(this.instance.settings.slideHTML)}},{key:"getConfig",value:function(){E(this.element)||this.element.hasOwnProperty("draggable")||(this.element.draggable=this.instance.settings.draggable);var e=new j(this.instance.settings.slideExtraAttributes);return this.slideConfig=e.parseConfig(this.element,this.instance.settings),this.slideConfig}}]);function F(e){return Math.sqrt(e.x*e.x+e.y*e.y)}function R(e,t){var i=function(e,t){var i=F(e)*F(t);if(0===i)return 0;var n=function(e,t){return e.x*t.x+e.y*t.y}(e,t)/i;return n>1&&(n=1),Math.acos(n)}(e,t);return function(e,t){return e.x*t.y-t.x*e.y}(e,t)>0&&(i*=-1),180*i/Math.PI}var G=i((function t(i){e(this,t),this.handlers=[],this.el=i}),[{key:"add",value:function(e){this.handlers.push(e)}},{key:"del",value:function(e){e||(this.handlers=[]);for(var t=this.handlers.length;t>=0;t--)this.handlers[t]===e&&this.handlers.splice(t,1)}},{key:"dispatch",value:function(){for(var e=0,t=this.handlers.length;e<t;e++){var i=this.handlers[e];"function"==typeof i&&i.apply(this.el,arguments)}}}]);function Z(e,t){var i=new G(e);return i.add(t),i}var U=i((function t(i,n){e(this,t),this.element="string"==typeof i?document.querySelector(i):i,this.start=this.start.bind(this),this.move=this.move.bind(this),this.end=this.end.bind(this),this.cancel=this.cancel.bind(this),this.element.addEventListener("touchstart",this.start,!1),this.element.addEventListener("touchmove",this.move,!1),this.element.addEventListener("touchend",this.end,!1),this.element.addEventListener("touchcancel",this.cancel,!1),this.preV={x:null,y:null},this.pinchStartLen=null,this.zoom=1,this.isDoubleTap=!1;var s=function(){};this.rotate=Z(this.element,n.rotate||s),this.touchStart=Z(this.element,n.touchStart||s),this.multipointStart=Z(this.element,n.multipointStart||s),this.multipointEnd=Z(this.element,n.multipointEnd||s),this.pinch=Z(this.element,n.pinch||s),this.swipe=Z(this.element,n.swipe||s),this.tap=Z(this.element,n.tap||s),this.doubleTap=Z(this.element,n.doubleTap||s),this.longTap=Z(this.element,n.longTap||s),this.singleTap=Z(this.element,n.singleTap||s),this.pressMove=Z(this.element,n.pressMove||s),this.twoFingerPressMove=Z(this.element,n.twoFingerPressMove||s),this.touchMove=Z(this.element,n.touchMove||s),this.touchEnd=Z(this.element,n.touchEnd||s),this.touchCancel=Z(this.element,n.touchCancel||s),this.translateContainer=this.element,this._cancelAllHandler=this.cancelAll.bind(this),window.addEventListener("scroll",this._cancelAllHandler),this.delta=null,this.last=null,this.now=null,this.tapTimeout=null,this.singleTapTimeout=null,this.longTapTimeout=null,this.swipeTimeout=null,this.x1=this.x2=this.y1=this.y2=null,this.preTapPosition={x:null,y:null}}),[{key:"start",value:function(e){if(e.touches)if(e.target&&e.target.nodeName&&["a","button","input"].indexOf(e.target.nodeName.toLowerCase())>=0)console.log("ignore drag for this touched element",e.target.nodeName.toLowerCase());else{this.now=Date.now(),this.x1=e.touches[0].pageX,this.y1=e.touches[0].pageY,this.delta=this.now-(this.last||this.now),this.touchStart.dispatch(e,this.element),null!==this.preTapPosition.x&&(this.isDoubleTap=this.delta>0&&this.delta<=250&&Math.abs(this.preTapPosition.x-this.x1)<30&&Math.abs(this.preTapPosition.y-this.y1)<30,this.isDoubleTap&&clearTimeout(this.singleTapTimeout)),this.preTapPosition.x=this.x1,this.preTapPosition.y=this.y1,this.last=this.now;var t=this.preV;if(e.touches.length>1){this._cancelLongTap(),this._cancelSingleTap();var i={x:e.touches[1].pageX-this.x1,y:e.touches[1].pageY-this.y1};t.x=i.x,t.y=i.y,this.pinchStartLen=F(t),this.multipointStart.dispatch(e,this.element)}this._preventTap=!1,this.longTapTimeout=setTimeout(function(){this.longTap.dispatch(e,this.element),this._preventTap=!0}.bind(this),750)}}},{key:"move",value:function(e){if(e.touches){var t=this.preV,i=e.touches.length,n=e.touches[0].pageX,s=e.touches[0].pageY;if(this.isDoubleTap=!1,i>1){var l=e.touches[1].pageX,o=e.touches[1].pageY,r={x:e.touches[1].pageX-n,y:e.touches[1].pageY-s};null!==t.x&&(this.pinchStartLen>0&&(e.zoom=F(r)/this.pinchStartLen,this.pinch.dispatch(e,this.element)),e.angle=R(r,t),this.rotate.dispatch(e,this.element)),t.x=r.x,t.y=r.y,null!==this.x2&&null!==this.sx2?(e.deltaX=(n-this.x2+l-this.sx2)/2,e.deltaY=(s-this.y2+o-this.sy2)/2):(e.deltaX=0,e.deltaY=0),this.twoFingerPressMove.dispatch(e,this.element),this.sx2=l,this.sy2=o}else{if(null!==this.x2){e.deltaX=n-this.x2,e.deltaY=s-this.y2;var a=Math.abs(this.x1-this.x2),h=Math.abs(this.y1-this.y2);(a>10||h>10)&&(this._preventTap=!0)}else e.deltaX=0,e.deltaY=0;this.pressMove.dispatch(e,this.element)}this.touchMove.dispatch(e,this.element),this._cancelLongTap(),this.x2=n,this.y2=s,i>1&&e.preventDefault()}}},{key:"end",value:function(e){if(e.changedTouches){this._cancelLongTap();var t=this;e.touches.length<2&&(this.multipointEnd.dispatch(e,this.element),this.sx2=this.sy2=null),this.x2&&Math.abs(this.x1-this.x2)>30||this.y2&&Math.abs(this.y1-this.y2)>30?(e.direction=this._swipeDirection(this.x1,this.x2,this.y1,this.y2),this.swipeTimeout=setTimeout((function(){t.swipe.dispatch(e,t.element)}),0)):(this.tapTimeout=setTimeout((function(){t._preventTap||t.tap.dispatch(e,t.element),t.isDoubleTap&&(t.doubleTap.dispatch(e,t.element),t.isDoubleTap=!1)}),0),t.isDoubleTap||(t.singleTapTimeout=setTimeout((function(){t.singleTap.dispatch(e,t.element)}),250))),this.touchEnd.dispatch(e,this.element),this.preV.x=0,this.preV.y=0,this.zoom=1,this.pinchStartLen=null,this.x1=this.x2=this.y1=this.y2=null}}},{key:"cancelAll",value:function(){this._preventTap=!0,clearTimeout(this.singleTapTimeout),clearTimeout(this.tapTimeout),clearTimeout(this.longTapTimeout),clearTimeout(this.swipeTimeout)}},{key:"cancel",value:function(e){this.cancelAll(),this.touchCancel.dispatch(e,this.element)}},{key:"_cancelLongTap",value:function(){clearTimeout(this.longTapTimeout)}},{key:"_cancelSingleTap",value:function(){clearTimeout(this.singleTapTimeout)}},{key:"_swipeDirection",value:function(e,t,i,n){return Math.abs(e-t)>=Math.abs(i-n)?e-t>0?"Left":"Right":i-n>0?"Up":"Down"}},{key:"on",value:function(e,t){this[e]&&this[e].add(t)}},{key:"off",value:function(e,t){this[e]&&this[e].del(t)}},{key:"destroy",value:function(){return this.singleTapTimeout&&clearTimeout(this.singleTapTimeout),this.tapTimeout&&clearTimeout(this.tapTimeout),this.longTapTimeout&&clearTimeout(this.longTapTimeout),this.swipeTimeout&&clearTimeout(this.swipeTimeout),this.element.removeEventListener("touchstart",this.start),this.element.removeEventListener("touchmove",this.move),this.element.removeEventListener("touchend",this.end),this.element.removeEventListener("touchcancel",this.cancel),this.rotate.del(),this.touchStart.del(),this.multipointStart.del(),this.multipointEnd.del(),this.pinch.del(),this.swipe.del(),this.tap.del(),this.doubleTap.del(),this.longTap.del(),this.singleTap.del(),this.pressMove.del(),this.twoFingerPressMove.del(),this.touchMove.del(),this.touchEnd.del(),this.touchCancel.del(),this.preV=this.pinchStartLen=this.zoom=this.isDoubleTap=this.delta=this.last=this.now=this.tapTimeout=this.singleTapTimeout=this.longTapTimeout=this.swipeTimeout=this.x1=this.x2=this.y1=this.y2=this.preTapPosition=this.rotate=this.touchStart=this.multipointStart=this.multipointEnd=this.pinch=this.swipe=this.tap=this.doubleTap=this.longTap=this.singleTap=this.pressMove=this.touchMove=this.touchEnd=this.touchCancel=this.twoFingerPressMove=null,window.removeEventListener("scroll",this._cancelAllHandler),null}}]);function $(e){var t=function(){var e,t=document.createElement("fakeelement"),i={transition:"transitionend",OTransition:"oTransitionEnd",MozTransition:"transitionend",WebkitTransition:"webkitTransitionEnd"};for(e in i)if(void 0!==t.style[e])return i[e]}(),i=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth,n=u(e,"gslide-media")?e:e.querySelector(".gslide-media"),s=g(n,".ginner-container"),l=e.querySelector(".gslide-description");i>769&&(n=s),d(n,"greset"),f(n,"translate3d(0, 0, 0)"),h(t,{onElement:n,once:!0,withCallback:function(e,t){c(n,"greset")}}),n.style.opacity="",l&&(l.style.opacity="")}function J(e){if(e.events.hasOwnProperty("touch"))return!1;var t,i,n,s=x(),l=s.width,o=s.height,r=!1,a=null,h=null,v=null,p=!1,m=1,y=1,b=!1,S=!1,w=null,T=null,C=null,k=null,E=0,A=0,L=!1,I=!1,O={},P={},M=0,z=0,X=document.getElementById("glightbox-slider"),Y=document.querySelector(".goverlay"),q=new U(X,{touchStart:function(t){if(r=!0,(u(t.targetTouches[0].target,"ginner-container")||g(t.targetTouches[0].target,".gslide-desc")||"a"==t.targetTouches[0].target.nodeName.toLowerCase())&&(r=!1),g(t.targetTouches[0].target,".gslide-inline")&&!u(t.targetTouches[0].target.parentNode,"gslide-inline")&&(r=!1),r){if(P=t.targetTouches[0],O.pageX=t.targetTouches[0].pageX,O.pageY=t.targetTouches[0].pageY,M=t.targetTouches[0].clientX,z=t.targetTouches[0].clientY,a=e.activeSlide,h=a.querySelector(".gslide-media"),n=a.querySelector(".gslide-inline"),v=null,u(h,"gslide-image")&&(v=h.querySelector("img")),(window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth)>769&&(h=a.querySelector(".ginner-container")),c(Y,"greset"),t.pageX>20&&t.pageX<window.innerWidth-20)return;t.preventDefault()}},touchMove:function(s){if(r&&(P=s.targetTouches[0],!b&&!S)){if(n&&n.offsetHeight>o){var a=O.pageX-P.pageX;if(Math.abs(a)<=13)return!1}p=!0;var d,c=s.targetTouches[0].clientX,u=s.targetTouches[0].clientY,g=M-c,m=z-u;if(Math.abs(g)>Math.abs(m)?(L=!1,I=!0):(I=!1,L=!0),t=P.pageX-O.pageX,E=100*t/l,i=P.pageY-O.pageY,A=100*i/o,L&&v&&(d=1-Math.abs(i)/o,Y.style.opacity=d,e.settings.touchFollowAxis&&(E=0)),I&&(d=1-Math.abs(t)/l,h.style.opacity=d,e.settings.touchFollowAxis&&(A=0)),!v)return f(h,"translate3d(".concat(E,"%, 0, 0)"));f(h,"translate3d(".concat(E,"%, ").concat(A,"%, 0)"))}},touchEnd:function(){if(r){if(p=!1,S||b)return C=w,void(k=T);var t=Math.abs(parseInt(A)),i=Math.abs(parseInt(E));if(!(t>29&&v))return t<29&&i<25?(d(Y,"greset"),Y.style.opacity=1,$(h)):void 0;e.close()}},multipointEnd:function(){setTimeout((function(){b=!1}),50)},multipointStart:function(){b=!0,m=y||1},pinch:function(e){if(!v||p)return!1;b=!0,v.scaleX=v.scaleY=m*e.zoom;var t=m*e.zoom;if(S=!0,t<=1)return S=!1,t=1,k=null,C=null,w=null,T=null,void v.setAttribute("style","");t>4.5&&(t=4.5),v.style.transform="scale3d(".concat(t,", ").concat(t,", 1)"),y=t},pressMove:function(e){if(S&&!b){var t=P.pageX-O.pageX,i=P.pageY-O.pageY;C&&(t+=C),k&&(i+=k),w=t,T=i;var n="translate3d(".concat(t,"px, ").concat(i,"px, 0)");y&&(n+=" scale3d(".concat(y,", ").concat(y,", 1)")),f(v,n)}},swipe:function(t){if(!S)if(b)b=!1;else{if("Left"==t.direction){if(e.index==e.elements.length-1)return $(h);e.nextSlide()}if("Right"==t.direction){if(0==e.index)return $(h);e.prevSlide()}}}});e.events.touch=q}var K=T(),Q=null!==T()||void 0!==document.createTouch||"ontouchstart"in window||"onmsgesturechange"in window||navigator.msMaxTouchPoints,ee=document.getElementsByTagName("html")[0],te={selector:".glightbox",elements:null,skin:"clean",theme:"clean",closeButton:!0,startAt:null,autoplayVideos:!0,autofocusVideos:!0,descPosition:"bottom",width:"900px",height:"506px",videosWidth:"960px",beforeSlideChange:null,afterSlideChange:null,beforeSlideLoad:null,afterSlideLoad:null,slideInserted:null,slideRemoved:null,slideExtraAttributes:null,onOpen:null,onClose:null,loop:!1,zoomable:!0,draggable:!0,dragAutoSnap:!1,dragToleranceX:40,dragToleranceY:65,preload:!0,oneSlidePerOpen:!1,touchNavigation:!0,touchFollowAxis:!0,keyboardNavigation:!0,closeOnOutsideClick:!0,plugins:!1,plyr:{css:"https://cdn.plyr.io/3.6.12/plyr.css",js:"https://cdn.plyr.io/3.6.12/plyr.js",config:{ratio:"16:9",fullscreen:{enabled:!0,iosNative:!0},youtube:{noCookie:!0,rel:0,showinfo:0,iv_load_policy:3},vimeo:{byline:!1,portrait:!1,title:!1,transparent:!1}}},openEffect:"zoom",closeEffect:"zoom",slideEffect:"slide",moreText:"See more",moreLength:60,cssEfects:{fade:{in:"fadeIn",out:"fadeOut"},zoom:{in:"zoomIn",out:"zoomOut"},slide:{in:"slideInRight",out:"slideOutLeft"},slideBack:{in:"slideInLeft",out:"slideOutRight"},none:{in:"none",out:"none"}},svg:{close:'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><g><g><path d="M505.943,6.058c-8.077-8.077-21.172-8.077-29.249,0L6.058,476.693c-8.077,8.077-8.077,21.172,0,29.249C10.096,509.982,15.39,512,20.683,512c5.293,0,10.586-2.019,14.625-6.059L505.943,35.306C514.019,27.23,514.019,14.135,505.943,6.058z"/></g></g><g><g><path d="M505.942,476.694L35.306,6.059c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.076-8.077,21.171,0,29.248l470.636,470.636c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.587-2.019,14.624-6.057C514.018,497.866,514.018,484.771,505.942,476.694z"/></g></g></svg>',next:'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"> <g><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"/></g></svg>',prev:'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"><g><path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/></g></svg>'},slideHTML:'<div class="gslide">\n    <div class="gslide-inner-content">\n        <div class="ginner-container">\n            <div class="gslide-media">\n            </div>\n            <div class="gslide-description">\n                <div class="gdesc-inner">\n                    <h4 class="gslide-title"></h4>\n                    <div class="gslide-desc"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>',lightboxHTML:'<div id="glightbox-body" class="glightbox-container" tabindex="-1" role="dialog" aria-hidden="false">\n    <div class="gloader visible"></div>\n    <div class="goverlay"></div>\n    <div class="gcontainer">\n    <div id="glightbox-slider" class="gslider"></div>\n    <button class="gclose gbtn" aria-label="Close" data-taborder="3">{closeSVG}</button>\n    <button class="gprev gbtn" aria-label="Previous" data-taborder="2">{prevSVG}</button>\n    <button class="gnext gbtn" aria-label="Next" data-taborder="1">{nextSVG}</button>\n</div>\n</div>'},ie=i((function t(){var i=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};e(this,t),this.customOptions=i,this.settings=o(te,i),this.effectsClasses=this.getAnimationClasses(),this.videoPlayers={},this.apiEvents=[],this.fullElementsList=!1}),[{key:"init",value:function(){var e=this,t=this.getSelector();t&&(this.baseEvents=h("click",{onElement:t,withCallback:function(t,i){t.preventDefault(),e.open(i)}})),this.elements=this.getElements()}},{key:"open",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;if(0===this.elements.length)return!1;this.activeSlide=null,this.prevActiveSlideIndex=null,this.prevActiveSlide=null;var i=z(t)?t:this.settings.startAt;if(E(e)){var n=e.getAttribute("data-gallery");n&&(this.fullElementsList=this.elements,this.elements=this.getGalleryElements(this.elements,n)),O(i)&&(i=this.getElementIndex(e))<0&&(i=0)}z(i)||(i=0),this.build(),v(this.overlay,"none"===this.settings.openEffect?"none":this.settings.cssEfects.fade.in);var s=document.body,l=window.innerWidth-document.documentElement.clientWidth;if(l>0){var o=document.createElement("style");o.type="text/css",o.className="gcss-styles",o.innerText=".gscrollbar-fixer {margin-right: ".concat(l,"px}"),document.head.appendChild(o),d(s,"gscrollbar-fixer")}d(s,"glightbox-open"),d(ee,"glightbox-open"),K&&(d(document.body,"glightbox-mobile"),this.settings.slideEffect="slide"),this.showSlide(i,!0),1===this.elements.length?(d(this.prevButton,"glightbox-button-hidden"),d(this.nextButton,"glightbox-button-hidden")):(c(this.prevButton,"glightbox-button-hidden"),c(this.nextButton,"glightbox-button-hidden")),this.lightboxOpen=!0,this.trigger("open"),C(this.settings.onOpen)&&this.settings.onOpen(),Q&&this.settings.touchNavigation&&J(this),this.settings.keyboardNavigation&&Y(this)}},{key:"openAt",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;this.open(null,e)}},{key:"showSlide",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1];p(this.loader),this.index=parseInt(t);var n=this.slidesContainer.querySelector(".current");n&&c(n,"current"),this.slideAnimateOut();var s=this.slidesContainer.querySelectorAll(".gslide")[t];if(u(s,"loaded"))this.slideAnimateIn(s,i),m(this.loader);else{p(this.loader);var l=this.elements[t],o={index:this.index,slide:s,slideNode:s,slideConfig:l.slideConfig,slideIndex:this.index,trigger:l.node,player:null};this.trigger("slide_before_load",o),l.instance.setContent(s,(function(){m(e.loader),e.resize(),e.slideAnimateIn(s,i),e.trigger("slide_after_load",o)}))}this.slideDescription=s.querySelector(".gslide-description"),this.slideDescriptionContained=this.slideDescription&&u(this.slideDescription.parentNode,"gslide-media"),this.settings.preload&&(this.preloadSlide(t+1),this.preloadSlide(t-1)),this.updateNavigationClasses(),this.activeSlide=s}},{key:"preloadSlide",value:function(e){var t=this;if(e<0||e>this.elements.length-1)return!1;if(O(this.elements[e]))return!1;var i=this.slidesContainer.querySelectorAll(".gslide")[e];if(u(i,"loaded"))return!1;var n=this.elements[e],s=n.type,l={index:e,slide:i,slideNode:i,slideConfig:n.slideConfig,slideIndex:e,trigger:n.node,player:null};this.trigger("slide_before_load",l),"video"===s||"external"===s?setTimeout((function(){n.instance.setContent(i,(function(){t.trigger("slide_after_load",l)}))}),200):n.instance.setContent(i,(function(){t.trigger("slide_after_load",l)}))}},{key:"prevSlide",value:function(){this.goToSlide(this.index-1)}},{key:"nextSlide",value:function(){this.goToSlide(this.index+1)}},{key:"goToSlide",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(this.prevActiveSlide=this.activeSlide,this.prevActiveSlideIndex=this.index,!this.loop()&&(e<0||e>this.elements.length-1))return!1;e<0?e=this.elements.length-1:e>=this.elements.length&&(e=0),this.showSlide(e)}},{key:"insertSlide",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:-1;t<0&&(t=this.elements.length);var i=new V(e,this,t),n=i.getConfig(),s=o({},n),l=i.create(),r=this.elements.length-1;s.index=t,s.node=!1,s.instance=i,s.slideConfig=n,this.elements.splice(t,0,s);var a=null,h=null;if(this.slidesContainer){if(t>r)this.slidesContainer.appendChild(l);else{var d=this.slidesContainer.querySelectorAll(".gslide")[t];this.slidesContainer.insertBefore(l,d)}(this.settings.preload&&0==this.index&&0==t||this.index-1==t||this.index+1==t)&&this.preloadSlide(t),0===this.index&&0===t&&(this.index=1),this.updateNavigationClasses(),a=this.slidesContainer.querySelectorAll(".gslide")[t],h=this.getSlidePlayerInstance(t),s.slideNode=a}this.trigger("slide_inserted",{index:t,slide:a,slideNode:a,slideConfig:n,slideIndex:t,trigger:null,player:h}),C(this.settings.slideInserted)&&this.settings.slideInserted({index:t,slide:a,player:h})}},{key:"removeSlide",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:-1;if(e<0||e>this.elements.length-1)return!1;var t=this.slidesContainer&&this.slidesContainer.querySelectorAll(".gslide")[e];t&&(this.getActiveSlideIndex()==e&&(e==this.elements.length-1?this.prevSlide():this.nextSlide()),t.parentNode.removeChild(t)),this.elements.splice(e,1),this.trigger("slide_removed",e),C(this.settings.slideRemoved)&&this.settings.slideRemoved(e)}},{key:"slideAnimateIn",value:function(e,t){var i=this,n=e.querySelector(".gslide-media"),s=e.querySelector(".gslide-description"),l={index:this.prevActiveSlideIndex,slide:this.prevActiveSlide,slideNode:this.prevActiveSlide,slideIndex:this.prevActiveSlide,slideConfig:O(this.prevActiveSlideIndex)?null:this.elements[this.prevActiveSlideIndex].slideConfig,trigger:O(this.prevActiveSlideIndex)?null:this.elements[this.prevActiveSlideIndex].node,player:this.getSlidePlayerInstance(this.prevActiveSlideIndex)},o={index:this.index,slide:this.activeSlide,slideNode:this.activeSlide,slideConfig:this.elements[this.index].slideConfig,slideIndex:this.index,trigger:this.elements[this.index].node,player:this.getSlidePlayerInstance(this.index)};if(n.offsetWidth>0&&s&&(m(s),s.style.display=""),c(e,this.effectsClasses),t)v(e,this.settings.cssEfects[this.settings.openEffect].in,(function(){i.settings.autoplayVideos&&i.slidePlayerPlay(e),i.trigger("slide_changed",{prev:l,current:o}),C(i.settings.afterSlideChange)&&i.settings.afterSlideChange.apply(i,[l,o])}));else{var r=this.settings.slideEffect,a="none"!==r?this.settings.cssEfects[r].in:r;this.prevActiveSlideIndex>this.index&&"slide"==this.settings.slideEffect&&(a=this.settings.cssEfects.slideBack.in),v(e,a,(function(){i.settings.autoplayVideos&&i.slidePlayerPlay(e),i.trigger("slide_changed",{prev:l,current:o}),C(i.settings.afterSlideChange)&&i.settings.afterSlideChange.apply(i,[l,o])}))}setTimeout((function(){i.resize(e)}),100),d(e,"current")}},{key:"slideAnimateOut",value:function(){if(!this.prevActiveSlide)return!1;var e=this.prevActiveSlide;c(e,this.effectsClasses),d(e,"prev");var t=this.settings.slideEffect,i="none"!==t?this.settings.cssEfects[t].out:t;this.slidePlayerPause(e),this.trigger("slide_before_change",{prev:{index:this.prevActiveSlideIndex,slide:this.prevActiveSlide,slideNode:this.prevActiveSlide,slideIndex:this.prevActiveSlideIndex,slideConfig:O(this.prevActiveSlideIndex)?null:this.elements[this.prevActiveSlideIndex].slideConfig,trigger:O(this.prevActiveSlideIndex)?null:this.elements[this.prevActiveSlideIndex].node,player:this.getSlidePlayerInstance(this.prevActiveSlideIndex)},current:{index:this.index,slide:this.activeSlide,slideNode:this.activeSlide,slideIndex:this.index,slideConfig:this.elements[this.index].slideConfig,trigger:this.elements[this.index].node,player:this.getSlidePlayerInstance(this.index)}}),C(this.settings.beforeSlideChange)&&this.settings.beforeSlideChange.apply(this,[{index:this.prevActiveSlideIndex,slide:this.prevActiveSlide,player:this.getSlidePlayerInstance(this.prevActiveSlideIndex)},{index:this.index,slide:this.activeSlide,player:this.getSlidePlayerInstance(this.index)}]),this.prevActiveSlideIndex>this.index&&"slide"==this.settings.slideEffect&&(i=this.settings.cssEfects.slideBack.out),v(e,i,(function(){var t=e.querySelector(".ginner-container"),i=e.querySelector(".gslide-media"),n=e.querySelector(".gslide-description");t.style.transform="",i.style.transform="",c(i,"greset"),i.style.opacity="",n&&(n.style.opacity=""),c(e,"prev")}))}},{key:"getAllPlayers",value:function(){return this.videoPlayers}},{key:"getSlidePlayerInstance",value:function(e){var t="gvideo"+e,i=this.getAllPlayers();return!(!P(i,t)||!i[t])&&i[t]}},{key:"stopSlideVideo",value:function(e){if(E(e)){var t=e.querySelector(".gvideo-wrapper");t&&(e=t.getAttribute("data-index"))}console.log("stopSlideVideo is deprecated, use slidePlayerPause");var i=this.getSlidePlayerInstance(e);i&&i.playing&&i.pause()}},{key:"slidePlayerPause",value:function(e){if(E(e)){var t=e.querySelector(".gvideo-wrapper");t&&(e=t.getAttribute("data-index"))}var i=this.getSlidePlayerInstance(e);i&&i.playing&&i.pause()}},{key:"playSlideVideo",value:function(e){if(E(e)){var t=e.querySelector(".gvideo-wrapper");t&&(e=t.getAttribute("data-index"))}console.log("playSlideVideo is deprecated, use slidePlayerPlay");var i=this.getSlidePlayerInstance(e);i&&!i.playing&&i.play()}},{key:"slidePlayerPlay",value:function(e){var t;if(!K||null!==(t=this.settings.plyr.config)&&void 0!==t&&t.muted){if(E(e)){var i=e.querySelector(".gvideo-wrapper");i&&(e=i.getAttribute("data-index"))}var n=this.getSlidePlayerInstance(e);n&&!n.playing&&(n.play(),this.settings.autofocusVideos&&n.elements.container.focus())}}},{key:"setElements",value:function(e){var t=this;this.settings.elements=!1;var i=[];e&&e.length&&r(e,(function(e,n){var s=new V(e,t,n),l=s.getConfig(),r=o({},l);r.slideConfig=l,r.instance=s,r.index=n,i.push(r)})),this.elements=i,this.lightboxOpen&&(this.slidesContainer.innerHTML="",this.elements.length&&(r(this.elements,(function(){var e=y(t.settings.slideHTML);t.slidesContainer.appendChild(e)})),this.showSlide(0,!0)))}},{key:"getElementIndex",value:function(e){var t=!1;return r(this.elements,(function(i,n){if(P(i,"node")&&i.node==e)return t=n,!0})),t}},{key:"getElements",value:function(){var e=this,t=[];this.elements=this.elements?this.elements:[],!O(this.settings.elements)&&A(this.settings.elements)&&this.settings.elements.length&&r(this.settings.elements,(function(i,n){var s=new V(i,e,n),l=s.getConfig(),r=o({},l);r.node=!1,r.index=n,r.instance=s,r.slideConfig=l,t.push(r)}));var i=!1;return this.getSelector()&&(i=document.querySelectorAll(this.getSelector())),i?(r(i,(function(i,n){var s=new V(i,e,n),l=s.getConfig(),r=o({},l);r.node=i,r.index=n,r.instance=s,r.slideConfig=l,r.gallery=i.getAttribute("data-gallery"),t.push(r)})),t):t}},{key:"getGalleryElements",value:function(e,t){return e.filter((function(e){return e.gallery==t}))}},{key:"getSelector",value:function(){return!this.settings.elements&&(this.settings.selector&&"data-"==this.settings.selector.substring(0,5)?"*[".concat(this.settings.selector,"]"):this.settings.selector)}},{key:"getActiveSlide",value:function(){return this.slidesContainer.querySelectorAll(".gslide")[this.index]}},{key:"getActiveSlideIndex",value:function(){return this.index}},{key:"getAnimationClasses",value:function(){var e=[];for(var t in this.settings.cssEfects)if(this.settings.cssEfects.hasOwnProperty(t)){var i=this.settings.cssEfects[t];e.push("g".concat(i.in)),e.push("g".concat(i.out))}return e.join(" ")}},{key:"build",value:function(){var e=this;if(this.built)return!1;var t=document.body.childNodes,i=[];r(t,(function(e){e.parentNode==document.body&&"#"!==e.nodeName.charAt(0)&&e.hasAttribute&&!e.hasAttribute("aria-hidden")&&(i.push(e),e.setAttribute("aria-hidden","true"))}));var n=P(this.settings.svg,"next")?this.settings.svg.next:"",s=P(this.settings.svg,"prev")?this.settings.svg.prev:"",l=P(this.settings.svg,"close")?this.settings.svg.close:"",o=this.settings.lightboxHTML;o=y(o=(o=(o=o.replace(/{nextSVG}/g,n)).replace(/{prevSVG}/g,s)).replace(/{closeSVG}/g,l)),document.body.appendChild(o);var a=document.getElementById("glightbox-body");this.modal=a;var c=a.querySelector(".gclose");this.prevButton=a.querySelector(".gprev"),this.nextButton=a.querySelector(".gnext"),this.overlay=a.querySelector(".goverlay"),this.loader=a.querySelector(".gloader"),this.slidesContainer=document.getElementById("glightbox-slider"),this.bodyHiddenChildElms=i,this.events={},d(this.modal,"glightbox-"+this.settings.skin),this.settings.closeButton&&c&&(this.events.close=h("click",{onElement:c,withCallback:function(t,i){t.preventDefault(),e.close()}})),c&&!this.settings.closeButton&&c.parentNode.removeChild(c),this.nextButton&&(this.events.next=h("click",{onElement:this.nextButton,withCallback:function(t,i){t.preventDefault(),e.nextSlide()}})),this.prevButton&&(this.events.prev=h("click",{onElement:this.prevButton,withCallback:function(t,i){t.preventDefault(),e.prevSlide()}})),this.settings.closeOnOutsideClick&&(this.events.outClose=h("click",{onElement:a,withCallback:function(t,i){e.preventOutsideClick||u(document.body,"glightbox-mobile")||g(t.target,".ginner-container")||g(t.target,".gbtn")||u(t.target,"gnext")||u(t.target,"gprev")||e.close()}})),r(this.elements,(function(t,i){e.slidesContainer.appendChild(t.instance.create()),t.slideNode=e.slidesContainer.querySelectorAll(".gslide")[i]})),Q&&d(document.body,"glightbox-touch"),this.events.resize=h("resize",{onElement:window,withCallback:function(){e.resize()}}),this.built=!0}},{key:"resize",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;if((e=e||this.activeSlide)&&!u(e,"zoomed")){var t=x(),i=e.querySelector(".gvideo-wrapper"),n=e.querySelector(".gslide-image"),s=this.slideDescription,l=t.width,o=t.height;if(l<=768?d(document.body,"glightbox-mobile"):c(document.body,"glightbox-mobile"),i||n){var r=!1;if(s&&(u(s,"description-bottom")||u(s,"description-top"))&&!u(s,"gabsolute")&&(r=!0),n)if(l<=768)n.querySelector("img");else if(r){var a,h,g=s.offsetHeight,v=n.querySelector("img"),f=null===(a=this.elements[this.index])||void 0===a?void 0:a.node,p="100vh";f&&(p=null!==(h=f.getAttribute("data-height"))&&void 0!==h?h:p),v.setAttribute("style","max-height: calc(".concat(p," - ").concat(g,"px)")),s.setAttribute("style","max-width: ".concat(v.offsetWidth,"px;"))}if(i){var m=P(this.settings.plyr.config,"ratio")?this.settings.plyr.config.ratio:"";if(!m){var y=i.clientWidth,b=i.clientHeight,S=y/b;m="".concat(y/S,":").concat(b/S)}var w=m.split(":"),T=this.settings.videosWidth,C=this.settings.videosWidth,k=(C=z(T)||-1!==T.indexOf("px")?parseInt(T):-1!==T.indexOf("vw")?l*parseInt(T)/100:-1!==T.indexOf("vh")?o*parseInt(T)/100:-1!==T.indexOf("%")?l*parseInt(T)/100:parseInt(i.clientWidth))/(parseInt(w[0])/parseInt(w[1]));if(k=Math.floor(k),r&&(o-=s.offsetHeight),C>l||k>o||o<k&&l>C){var E=i.offsetWidth,A=i.offsetHeight,L=o/A,I={width:E*L,height:A*L};i.parentNode.setAttribute("style","max-width: ".concat(I.width,"px")),r&&s.setAttribute("style","max-width: ".concat(I.width,"px;"))}else i.parentNode.style.maxWidth="".concat(T),r&&s.setAttribute("style","max-width: ".concat(T,";"))}}}}},{key:"reload",value:function(){this.init()}},{key:"updateNavigationClasses",value:function(){var e=this.loop();c(this.nextButton,"disabled"),c(this.prevButton,"disabled"),0==this.index&&this.elements.length-1==0?(d(this.prevButton,"disabled"),d(this.nextButton,"disabled")):0!==this.index||e?this.index!==this.elements.length-1||e||d(this.nextButton,"disabled"):d(this.prevButton,"disabled")}},{key:"loop",value:function(){var e=P(this.settings,"loopAtEnd")?this.settings.loopAtEnd:null;return e=P(this.settings,"loop")?this.settings.loop:e,e}},{key:"close",value:function(){var e=this;if(!this.lightboxOpen){if(this.events){for(var t in this.events)this.events.hasOwnProperty(t)&&this.events[t].destroy();this.events=null}return!1}if(this.closing)return!1;this.closing=!0,this.slidePlayerPause(this.activeSlide),this.fullElementsList&&(this.elements=this.fullElementsList),this.bodyHiddenChildElms.length&&r(this.bodyHiddenChildElms,(function(e){e.removeAttribute("aria-hidden")})),d(this.modal,"glightbox-closing"),v(this.overlay,"none"==this.settings.openEffect?"none":this.settings.cssEfects.fade.out),v(this.activeSlide,this.settings.cssEfects[this.settings.closeEffect].out,(function(){if(e.activeSlide=null,e.prevActiveSlideIndex=null,e.prevActiveSlide=null,e.built=!1,e.events){for(var t in e.events)e.events.hasOwnProperty(t)&&e.events[t].destroy();e.events=null}var i=document.body;c(ee,"glightbox-open"),c(i,"glightbox-open touching gdesc-open glightbox-touch glightbox-mobile gscrollbar-fixer"),e.modal.parentNode.removeChild(e.modal),e.trigger("close"),C(e.settings.onClose)&&e.settings.onClose();var n=document.querySelector(".gcss-styles");n&&n.parentNode.removeChild(n),e.lightboxOpen=!1,e.closing=null}))}},{key:"destroy",value:function(){this.close(),this.clearAllEvents(),this.baseEvents&&this.baseEvents.destroy()}},{key:"on",value:function(e,t){var i=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(!e||!C(t))throw new TypeError("Event name and callback must be defined");this.apiEvents.push({evt:e,once:i,callback:t})}},{key:"once",value:function(e,t){this.on(e,t,!0)}},{key:"trigger",value:function(e){var t=this,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,n=[];r(this.apiEvents,(function(t,s){var l=t.evt,o=t.once,r=t.callback;l==e&&(r(i),o&&n.push(s))})),n.length&&r(n,(function(e){return t.apiEvents.splice(e,1)}))}},{key:"clearAllEvents",value:function(){this.apiEvents.splice(0,this.apiEvents.length)}},{key:"version",value:function(){return"3.3.1"}}]);return function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=new ie(e);return t.init(),t}}));/**
 * ymaps3-core — общий бутстрап Yandex Maps JS API v3 для flip.kz.
 *
 * Назначение: убрать дублирование самого багоопасного кода (загрузка скрипта,
 * ymaps3.ready, импорт модулей кластерера/темы, флип координат v2[lat,lng] -> v3[lng,lat],
 * вычисление bounds, создание карты со скрытыми POI) между всеми картами сайта.
 *
 * Ключ берётся ТОЛЬКО из <body data-ymaps-v3-key> (его проставляет Smarty из
 * Utils::getYmapsKey('jsmaps-v3')). Хардкодить ключ в JS нельзя.
 *
 * Использование:
 *   YmapsV3.ready().then(function (api) {
 *       var map = api.makeMap('my-map', { center: YmapsV3.flip(43.24, 76.91), zoom: 11 });
 *       var marker = new api.ymaps3.YMapMarker({ coordinates: YmapsV3.flip(lat, lng) }, el);
 *       map.addChild(marker);
 *   });
 *
 * Статические хелперы (без ymaps3): YmapsV3.flip, .toCoord, .getBoundsFromPoints,
 *   .padBounds, .isCollapsedBounds, .shiftLatByPixels.
 *
 * ВНИМАНИЕ: v3 использует порядок координат [долгота, широта] (GeoJSON),
 * тогда как v2 был [широта, долгота]. Всегда прогоняй координаты через YmapsV3.flip().
 */
(function () {
    'use strict';

    if (window.YmapsV3) return;

    /* Модули кластерера и темы самохостятся в js/vendor/ — сторонний CDN (jsdelivr)
       убран с критического пути загрузки карты и как точка отказа.
       Загрузчик v3 строит URL как <база>/{package}@{version}/dist/index.js, поэтому
       иерархия в vendor повторяет npm: js/vendor/@yandex/<имя>@<версия>/dist/index.js.
       Версии пинованы: при обновлении пакета положить рядом папку с новой версией
       и поменять её здесь (и в js/addresses.onmap.v3.js). */
    var CDN_MODULES = ['@yandex/ymaps3-clusterer@0.0.12', '@yandex/ymaps3-default-ui-theme@0.0.24'];

    // База vendor-каталога. Считается лениво: <body data-domain-static> может быть
    // ещё недоступен на момент парсинга этого файла. Без атрибута — same-origin.
    function getCdnTemplate() {
        var staticDomain = (document.body && document.body.dataset && document.body.dataset.domainStatic) || '';
        return staticDomain + '/js/vendor/{package}';
    }

    var ALMATY = [76.915506, 43.240385]; // [lng, lat]

    var loadPromise = null;
    var modulesPromise = null;

    function getKey() {
        return (document.body && document.body.dataset && document.body.dataset.ymapsV3Key) || '';
    }

    // v2 JS-карты грузились с lang=ru-RU без локализации. Сохраняем паритет (по умолчанию ru_RU),
    // но даём шаблону возможность переопределить через <body data-ymaps-v3-lang>.
    function getLang() {
        return (document.body && document.body.dataset && document.body.dataset.ymapsV3Lang) || 'ru_RU';
    }

    /**
     * Грузит <script> v3 (если ещё не загружен) и резолвится, когда window.ymaps3 доступен.
     * Поддерживает оба сценария: скрипт уже добавлен шаблоном (<script src=.../v3/...>)
     * или его нужно вставить лениво из JS (модалка адреса).
     */
    function loadScript() {
        if (loadPromise) return loadPromise;
        loadPromise = new Promise(function (resolve, reject) {
            var attempt = 0;
            var run = function () {
                attempt++;
                injectLoader().then(function () {
                    return window.ymaps3.ready;
                }).then(resolve, function (err) {
                    if (attempt >= LOAD_ATTEMPTS) { reject(err); return; }
                    if (window.console && console.warn) {
                        console.warn('ymaps3 core load failed, retry ' + attempt + '/' + (LOAD_ATTEMPTS - 1), err);
                    }
                    resetLoader();
                    setTimeout(run, 500 * attempt);
                });
            };
            run();
        });
        return loadPromise;
    }

    /* Статика v3 (api-maps.yandex.ru/3.0/static, в т.ч. main.js ядра) периодически
       отвечает 429 «limited». Загрузчик тогда отклоняет ymaps3.ready навсегда, а повторно
       не запускается («ymaps3: already defined») — поэтому при сбое убираем его тег
       и window.ymaps3 и вставляем загрузчик заново. */
    var LOAD_ATTEMPTS = 4;
    var LOADER_SELECTOR = 'script[src*="api-maps.yandex.ru/v3/"]';
    var loaderSrc = null;

    function injectLoader() {
        return new Promise(function (resolve, reject) {
            if (typeof window.ymaps3 !== 'undefined') { resolve(); return; }

            // Тег, вставленный шаблоном (contacts/office/helpdocs), ещё грузится — ждём его.
            var existing = document.querySelector(LOADER_SELECTOR);
            if (existing && !loaderSrc) loaderSrc = existing.src;
            if (existing && document.readyState === 'loading') {
                existing.addEventListener('load', function () { resolve(); });
                existing.addEventListener('error', function () { reject(new Error('ymaps3 script error')); });
                return;
            }

            if (!loaderSrc) {
                var key = getKey();
                if (!key) { reject(new Error('ymaps3 key missing (body[data-ymaps-v3-key])')); return; }
                loaderSrc = 'https://api-maps.yandex.ru/v3/?apikey=' + encodeURIComponent(key) +
                    '&lang=' + encodeURIComponent(getLang());
            }

            if (existing) existing.parentNode.removeChild(existing);
            var s = document.createElement('script');
            s.src = loaderSrc;
            s.type = 'text/javascript';
            s.onload = function () { resolve(); };
            s.onerror = function () { reject(new Error('ymaps3 script failed to load')); };
            document.head.appendChild(s);
        });
    }

    function resetLoader() {
        document.querySelectorAll(LOADER_SELECTOR).forEach(function (el) {
            el.parentNode.removeChild(el);
        });
        try {
            delete window.ymaps3;
        } catch (e) {
            window.ymaps3 = undefined;
        }
    }

    // Импортирует модули кластерера и темы один раз (кэшируется).
    // Тема необязательна: при загрузке она тянет @yandex/ymaps3-ruler со статики Яндекса
    // (api-maps.yandex.ru/3.0/static), которая отвечает 429 «limited», а загрузчик v3
    // кэширует упавший импорт до перезагрузки страницы. Без темы карта работает —
    // makeMap ставит свои кнопки на ядре (addFallbackControls).
    function importModules() {
        if (modulesPromise) return modulesPromise;
        modulesPromise = ymaps3.ready.then(function () {
            ymaps3.import.registerCdn(getCdnTemplate(), CDN_MODULES);
            return Promise.all([
                ymaps3.import('@yandex/ymaps3-clusterer'),
                ymaps3.import('@yandex/ymaps3-default-ui-theme').catch(function (err) {
                    if (window.console && console.warn) {
                        console.warn('ymaps3 default-ui-theme unavailable, fallback controls', err);
                    }
                    return null;
                })
            ]);
        }).then(function (mods) {
            var theme = mods[1] || {};
            return {
                YMapClusterer: mods[0].YMapClusterer,
                clusterByGrid: mods[0].clusterByGrid,
                YMapZoomControl: theme.YMapZoomControl,
                YMapGeolocationControl: theme.YMapGeolocationControl
            };
        });
        return modulesPromise;
    }

    // --- координатные и bounds-хелперы (портированы из addresses.onmap.v3.js) ---

    function flip(lat, lng) {
        return [lng, lat];
    }

    function toCoord(v) {
        var n = parseFloat(v);
        return isFinite(n) && n !== 0 ? n : null;
    }

    // points: [{latitude, longitude}, ...] -> [[minLng, minLat], [maxLng, maxLat]] | null
    function getBoundsFromPoints(points) {
        var minLat = null, minLng = null, maxLat = null, maxLng = null;
        for (var i = 0; i < points.length; i++) {
            var lat = toCoord(points[i].latitude);
            var lng = toCoord(points[i].longitude);
            if (lat === null || lng === null) continue;
            if (minLat === null || lat < minLat) minLat = lat;
            if (minLng === null || lng < minLng) minLng = lng;
            if (maxLat === null || lat > maxLat) maxLat = lat;
            if (maxLng === null || lng > maxLng) maxLng = lng;
        }
        if (minLat === null) return null;
        return [[minLng, minLat], [maxLng, maxLat]];
    }

    function padBounds(bounds, factor) {
        if (!bounds) return bounds;
        var dLng = bounds[1][0] - bounds[0][0];
        var dLat = bounds[1][1] - bounds[0][1];
        if (!isFinite(dLng) || !isFinite(dLat)) return bounds;
        return [
            [bounds[0][0] - dLng * factor, bounds[0][1] - dLat * factor],
            [bounds[1][0] + dLng * factor, bounds[1][1] + dLat * factor]
        ];
    }

    function isCollapsedBounds(b) {
        return !!b && b[0][0] === b[1][0] && b[0][1] === b[1][1];
    }

    // Сдвиг широты на N пикселей при заданном zoom (для центрирования с учётом popup).
    function shiftLatByPixels(lat, pixels, zoom) {
        var metersPerPixel = 156543.03392 * Math.cos(lat * Math.PI / 180) / Math.pow(2, zoom);
        return lat + (pixels * metersPerPixel) / 111320;
    }

    /**
     * Применяет bounds или, если он вырожденный (одна точка), центрирует с фикс. зумом.
     * coordsOrder: bounds в формате v3 [[lng,lat],[lng,lat]].
     */
    function applyBoundsOrCenter(map, bounds, opts) {
        opts = opts || {};
        if (!bounds) return;
        if (isCollapsedBounds(bounds)) {
            map.setLocation({ center: bounds[0], zoom: opts.singleZoom != null ? opts.singleZoom : 16, duration: opts.duration || 0 });
        } else {
            map.setLocation({ bounds: padBounds(bounds, opts.pad != null ? opts.pad : 0.2), duration: opts.duration || 0 });
        }
    }

    function buildApi(mods) {
        var POI_HIDDEN = [{ tags: { any: ['poi'] }, stylers: [{ visibility: 'off' }] }];

        /**
         * Создаёт карту v3 с дефолтным scheme-слоем (POI скрыты), features-слоем,
         * опциональным zoom-контролом и ограничением зума.
         *
         * opts:
         *   center [lng,lat] (по умолч. Алматы), zoom (4),
         *   minZoom/maxZoom -> zoomRange,
         *   theme ('light'|'dark', по умолч. light),
         *   hidePoi (true по умолч.),
         *   zoomControl (false по умолч.) — кнопки +/-,
         *   geolocationControl (false по умолч.) — кнопка «моё местоположение»,
         *   copyrights (false по умолч.).
         */
        function makeMap(container, opts) {
            opts = opts || {};
            var el = typeof container === 'string' ? document.getElementById(container) : container;

            var props = {
                location: {
                    center: opts.center || ALMATY.slice(),
                    zoom: opts.zoom != null ? opts.zoom : 4
                },
                copyrights: opts.copyrights === true
            };
            if (opts.minZoom != null || opts.maxZoom != null) {
                props.zoomRange = {
                    min: opts.minZoom != null ? opts.minZoom : 0,
                    max: opts.maxZoom != null ? opts.maxZoom : 21
                };
            }

            var map = new ymaps3.YMap(el, props);

            map.addChild(new ymaps3.YMapDefaultSchemeLayer({
                theme: opts.theme || 'light',
                customization: opts.hidePoi === false ? undefined : POI_HIDDEN
            }));
            map.addChild(new ymaps3.YMapDefaultFeaturesLayer());

            // Контролы карты. zoom (+/-) и geolocation («моё местоположение»)
            // складываем в один блок справа, чтобы они шли друг под другом.
            // Тема не загрузилась — те же кнопки на ядре v3.
            if (opts.zoomControl || opts.geolocationControl) {
                var controls = new ymaps3.YMapControls({ position: opts.controlsPosition || 'right' });
                if (opts.zoomControl) {
                    if (mods.YMapZoomControl) {
                        controls.addChild(new mods.YMapZoomControl({}));
                    } else {
                        addFallbackZoom(map, controls, props.zoomRange);
                    }
                }
                if (opts.geolocationControl) {
                    // geolocationZoom — зум перелёта по стрелке (без него контрол только
                    // центрирует). onGeolocatePosition([lng,lat]) — колбэк после клика:
                    // контрол двигает карту программно, action-событий нет.
                    if (mods.YMapGeolocationControl) {
                        var geoProps = {};
                        if (opts.geolocationZoom != null) geoProps.zoom = opts.geolocationZoom;
                        if (typeof opts.onGeolocatePosition === 'function') geoProps.onGeolocatePosition = opts.onGeolocatePosition;
                        controls.addChild(new mods.YMapGeolocationControl(geoProps));
                    } else {
                        addFallbackGeolocation(map, controls, opts);
                    }
                }
                map.addChild(controls);
            }

            return map;
        }

        function addFallbackZoom(map, controls, zoomRange) {
            var range = zoomRange || { min: 0, max: 21 };
            var zoomBy = function (delta) {
                var zoom = Math.max(range.min, Math.min(range.max, Math.round(map.zoom) + delta));
                map.setLocation({ center: map.center, zoom: zoom, duration: 200 });
            };
            controls.addChild(new ymaps3.YMapControlButton({ text: '+', onClick: function () { zoomBy(1); } }));
            controls.addChild(new ymaps3.YMapControlButton({ text: '−', onClick: function () { zoomBy(-1); } }));
        }

        function addFallbackGeolocation(map, controls, opts) {
            var icon = document.createElement('span');
            icon.style.display = 'flex';
            icon.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
                '<path d="M21 3 3 10.5l7.5 3 3 7.5L21 3z"/></svg>';
            controls.addChild(new ymaps3.YMapControlButton({
                element: icon,
                onClick: function () {
                    ymaps3.geolocation.getPosition().then(function (res) {
                        var pos = res.coords; // [lng, lat]
                        map.setLocation({
                            center: pos,
                            zoom: opts.geolocationZoom != null ? opts.geolocationZoom : map.zoom,
                            duration: 500
                        });
                        if (typeof opts.onGeolocatePosition === 'function') opts.onGeolocatePosition(pos);
                    }).catch(function (err) {
                        if (window.console && console.warn) console.warn('ymaps3 geolocation failed', err);
                    });
                }
            }));
        }

        return {
            ymaps3: ymaps3,
            YMapClusterer: mods.YMapClusterer,
            clusterByGrid: mods.clusterByGrid,
            YMapZoomControl: mods.YMapZoomControl,
            YMapGeolocationControl: mods.YMapGeolocationControl,
            makeMap: makeMap,
            applyBoundsOrCenter: applyBoundsOrCenter
        };
    }

    /**
     * Единая точка входа: грузит скрипт v3, дожидается ready, импортирует модули,
     * резолвится объектом api { ymaps3, YMapClusterer, clusterByGrid, YMapZoomControl,
     * makeMap, applyBoundsOrCenter }.
     */
    function ready() {
        return loadScript().then(importModules).then(buildApi);
    }

    window.YmapsV3 = {
        ready: ready,
        loadCore: loadScript,
        flip: flip,
        toCoord: toCoord,
        getBoundsFromPoints: getBoundsFromPoints,
        padBounds: padBounds,
        isCollapsedBounds: isCollapsedBounds,
        shiftLatByPixels: shiftLatByPixels,
        applyBoundsOrCenter: applyBoundsOrCenter,
        getKey: getKey,
        getLang: getLang
    };
})();
// Куки с семантикой jquery.cookie: чтение flipCookie(name),
// запись flipCookie(name, value, {expires: дни|Date, path, domain, secure}),
// value null — удаление; path по умолчанию не ставится (как в плагине)
var flipCookie = function (name, value, options) {
    if (typeof value === 'undefined') {
        var cookies = document.cookie ? document.cookie.split(';') : [];
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].replace(/^\s+|\s+$/g, '');
            if (cookie.substring(0, name.length + 1) === name + '=') {
                return decodeURIComponent(cookie.substring(name.length + 1));
            }
        }
        return null;
    }

    options = options || {};
    var expires = options.expires;
    if (value === null) {
        value = '';
        expires = -1;
    }

    var expiresPart = '';
    if (expires && (typeof expires === 'number' || expires.toUTCString)) {
        var date = typeof expires === 'number' ? new Date(Date.now() + expires * 864e5) : expires;
        expiresPart = '; expires=' + date.toUTCString();
    }

    document.cookie = name + '=' + encodeURIComponent(value)
        + expiresPart
        + (options.path ? '; path=' + options.path : '')
        + (options.domain ? '; domain=' + options.domain : '')
        + (options.secure ? '; secure' : '');
};

// Единая точка настроек GLightbox для всех галерей сайта.
// Одно фото: без loop — иначе клавиатура и свайп «пролистывают» его по кругу
var flipLightbox = function (options) {
    var count = options.elements
        ? options.elements.length
        : document.querySelectorAll(options.selector || '.glightbox').length;

    return GLightbox(Object.assign({
        loop: count > 1,
        autoplayVideos: false
    }, options));
};

// Ховер-зум фото товара: линза на фото и панель с увеличением справа.
// anchor — ссылка на крупное фото с <img> внутри; возвращает {destroy} или null
var flipImageZoom = function (anchor) {
    var img = anchor.querySelector('img');
    var bigSrc = anchor.getAttribute('href');
    if (!img || !bigSrc) return null;

    var bigW = 0;
    var bigH = 0;
    var ready = false;
    var over = false;
    var lens = null;
    var pane = null;
    var raf = 0;
    var tx = 0;
    var ty = 0;
    var lx = 0;
    var ly = 0;
    var lensW = 0;
    var lensH = 0;
    var sx = 1;
    var sy = 1;
    var maxX = 0;
    var maxY = 0;

    var big = new Image();
    big.onload = function () {
        bigW = big.naturalWidth;
        bigH = big.naturalHeight;
        ready = bigW > 0 && bigH > 0;
    };
    big.src = bigSrc;

    anchor.style.position = 'relative';
    anchor.style.display = 'block';

    function show() {
        var w = img.offsetWidth;
        var h = img.offsetHeight;
        if (!w || !h) return;

        sx = bigW / w;
        sy = bigH / h;
        // Большое изображение не крупнее показанного — зум бессмысленен
        if (sx <= 1 && sy <= 1) return;

        lensW = Math.round(w / sx);
        lensH = Math.round(h / sy);
        maxX = w - lensW;
        maxY = h - lensH;

        lens = document.createElement('div');
        lens.className = 'clothes-zoom-lens';
        lens.style.width = lensW + 'px';
        lens.style.height = lensH + 'px';

        pane = document.createElement('div');
        pane.className = 'clothes-zoom-pane';
        pane.style.width = w + 'px';
        pane.style.height = h + 'px';
        pane.style.left = (img.offsetLeft + w + 20) + 'px';
        pane.style.top = img.offsetTop + 'px';
        pane.style.backgroundImage = 'url("' + bigSrc + '")';
        pane.style.backgroundSize = bigW + 'px ' + bigH + 'px';

        anchor.appendChild(lens);
        anchor.appendChild(pane);
        anchor.style.cursor = 'zoom-in';
        over = true;
    }

    function hide() {
        over = false;
        if (raf) { cancelAnimationFrame(raf); raf = 0; }
        if (lens) { lens.remove(); lens = null; }
        if (pane) { pane.remove(); pane = null; }
        anchor.style.cursor = '';
    }

    function step() {
        raf = 0;
        if (!over || !lens) return;

        // Плавное доведение линзы к курсору
        lx += (tx - lx) * 0.3;
        ly += (ty - ly) * 0.3;

        lens.style.left = (img.offsetLeft + lx) + 'px';
        lens.style.top = (img.offsetTop + ly) + 'px';
        pane.style.backgroundPosition = (-lx * sx) + 'px ' + (-ly * sy) + 'px';

        if (Math.abs(tx - lx) > 0.3 || Math.abs(ty - ly) > 0.3) {
            raf = requestAnimationFrame(step);
        }
    }

    function onMove(e) {
        if (!over || !lens) return;
        var rect = img.getBoundingClientRect();
        tx = Math.max(0, Math.min(maxX, e.clientX - rect.left - lensW / 2));
        ty = Math.max(0, Math.min(maxY, e.clientY - rect.top - lensH / 2));
        if (!raf) raf = requestAnimationFrame(step);
    }

    function onEnter(e) {
        if (!ready || over) return;
        show();
        if (over) {
            var rect = img.getBoundingClientRect();
            lx = tx = Math.max(0, Math.min(maxX, e.clientX - rect.left - lensW / 2));
            ly = ty = Math.max(0, Math.min(maxY, e.clientY - rect.top - lensH / 2));
            step();
        }
    }

    anchor.addEventListener('mouseenter', onEnter);
    anchor.addEventListener('mousemove', onMove);
    anchor.addEventListener('mouseleave', hide);

    return {
        destroy: function () {
            hide();
            anchor.removeEventListener('mouseenter', onEnter);
            anchor.removeEventListener('mousemove', onMove);
            anchor.removeEventListener('mouseleave', hide);
        }
    };
};

// Автокомплит (замена jQuery.autocomplete): подсказки под полем из GET url?q=…,
// формат ответа — строки через \n, ячейки через cellSeparator.
// Единственный потребитель — поиск адреса в модалке локации.
var flipAutocomplete = function (input, url, options) {
    options = Object.assign({
        inputClass: 'ac_input', resultsClass: 'ac_results', lineSeparator: '\n', cellSeparator: '|',
        minChars: 1, delay: 400, matchCase: 0, extraParams: {}, loadingClass: 'ac_loading',
        selectFirst: false, selectOnly: false, maxItemsToShow: -1, width: 0
    }, options || {});
    options.width = parseInt(options.width, 10);

    input.setAttribute('autocomplete', 'off');
    if (options.inputClass) input.classList.add(options.inputClass);

    var results = document.createElement('div');
    results.className = options.resultsClass;
    results.style.position = 'absolute';
    results.style.display = 'none';
    if (options.width > 0) results.style.width = options.width + 'px';
    document.body.appendChild(results);

    var timeout = null;
    var prev = '';
    var active = -1;
    var hasFocus = false;
    var lastKeyPressCode = null;
    var mouseDownOnSelect = false;

    var qLis = function () {
        return Array.prototype.slice.call(results.querySelectorAll('li'));
    };

    var findPos = function (obj) {
        var curleft = obj.offsetLeft || 0;
        var curtop = obj.offsetTop || 0;
        while (obj = obj.offsetParent) {
            curleft += obj.offsetLeft;
            curtop += obj.offsetTop;
        }
        return { x: curleft, y: curtop };
    };

    var showResults = function () {
        var pos = findPos(input);
        var iWidth = options.width;
        if (!(iWidth > 0)) {
            var style = getComputedStyle(input);
            iWidth = input.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        }
        results.style.width = parseInt(iWidth, 10) + 'px';
        results.style.top = (pos.y + input.offsetHeight) + 'px';
        results.style.left = pos.x + 'px';
        results.style.display = 'block';
    };

    var hideResultsNow = function () {
        if (timeout) clearTimeout(timeout);
        input.classList.remove(options.loadingClass);
        results.style.display = 'none';
    };

    var hideResults = function () {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(hideResultsNow, 200);
    };

    var selectItem = function (li) {
        var v = (li.selectValue ? li.selectValue : li.innerHTML).trim();
        input.lastSelected = v;
        prev = v;
        results.innerHTML = '';
        hideResultsNow();
        if (options.onItemSelect) {
            setTimeout(function () { options.onItemSelect(li); }, 1);
        }
        input.value = v;
        input.focus();
    };

    var selectCurrent = function () {
        var li = results.querySelector('li.ac_over');
        if (!li) {
            var lis = qLis();
            if (options.selectOnly) {
                if (lis.length === 1) li = lis[0];
            } else if (options.selectFirst) {
                li = lis[0];
            }
        }
        if (li) {
            selectItem(li);
            return true;
        }
        return false;
    };

    var moveSelect = function (step) {
        var lis = qLis();
        if (!lis.length) return;
        active += step;
        if (active < 0) {
            active = 0;
        } else if (active >= lis.length) {
            active = lis.length - 1;
        }
        lis.forEach(function (li) { li.classList.remove('ac_over'); });
        if (lis[active]) lis[active].classList.add('ac_over', 'gallery', 'c-zoom-in');
    };

    var makeUrl = function (q) {
        var sep = url.indexOf('?') === -1 ? '?' : '&';
        var result = url + sep + 'q=' + encodeURI(q);
        for (var i in options.extraParams) {
            var extra = options.extraParams[i];
            result += '&' + i + '=' + encodeURI(typeof extra === 'function' ? extra() : extra);
        }
        return result;
    };

    var parseData = function (data) {
        if (!data) return null;
        var parsed = [];
        var rows = data.split(options.lineSeparator);
        for (var i = 0; i < rows.length; i++) {
            var row = rows[i].trim();
            if (row) parsed.push(row.split(options.cellSeparator));
        }
        return parsed;
    };

    var dataToDom = function (data) {
        var ul = document.createElement('ul');
        var num = data.length;
        if (options.maxItemsToShow > 0 && options.maxItemsToShow < num) num = options.maxItemsToShow;
        for (var i = 0; i < num; i++) {
            var row = data[i];
            if (!row) continue;
            var li = document.createElement('li');
            li.innerHTML = options.formatItem ? options.formatItem(row, i, num) : row[0];
            li.selectValue = row[0];
            li.extra = row.slice(1);
            ul.appendChild(li);
            li.addEventListener('mouseenter', function () {
                var lis = qLis();
                lis.forEach(function (item) { item.classList.remove('ac_over'); });
                this.classList.add('ac_over');
                active = lis.indexOf(this);
            });
            li.addEventListener('mouseleave', function () {
                this.classList.remove('ac_over');
            });
            li.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                selectItem(this);
            });
        }
        ul.addEventListener('mousedown', function () { mouseDownOnSelect = true; });
        ul.addEventListener('mouseup', function () { mouseDownOnSelect = false; });
        return ul;
    };

    var receiveData = function (data) {
        if (data) {
            input.classList.remove(options.loadingClass);
            results.innerHTML = '';
            if (!hasFocus || data.length === 0) return hideResultsNow();
            results.appendChild(dataToDom(data));
            showResults();
        } else {
            hideResultsNow();
        }
    };

    var requestData = function (q) {
        if (!options.matchCase) q = q.toLowerCase();
        fetch(makeUrl(q), {
            credentials: 'same-origin',
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        }).then(function (res) {
            if (!res.ok) throw new Error(res.status);
            return res.text();
        }).then(function (data) {
            receiveData(parseData(data));
        })['catch'](function () {
            input.classList.remove(options.loadingClass);
        });
    };

    var onChange = function () {
        if (lastKeyPressCode == 46 || (lastKeyPressCode > 8 && lastKeyPressCode < 32)) {
            results.style.display = 'none';
            return;
        }
        var v = input.value;
        if (v == prev) return;
        prev = v;
        if (v.length >= options.minChars) {
            input.classList.add(options.loadingClass);
            requestData(v);
        } else {
            input.classList.remove(options.loadingClass);
            results.style.display = 'none';
        }
    };

    input.addEventListener('keydown', function (e) {
        lastKeyPressCode = e.keyCode;
        switch (e.keyCode) {
            case 38:
                e.preventDefault();
                moveSelect(-1);
                break;
            case 40:
                e.preventDefault();
                moveSelect(1);
                break;
            case 9:
            case 13:
                if (selectCurrent()) {
                    input.blur();
                    e.preventDefault();
                }
                break;
            default:
                active = -1;
                if (timeout) clearTimeout(timeout);
                timeout = setTimeout(onChange, options.delay);
                break;
        }
    });
    input.addEventListener('focus', function () { hasFocus = true; });
    input.addEventListener('blur', function () {
        hasFocus = false;
        if (!mouseDownOnSelect) hideResults();
    });

    hideResultsNow();
};



/**
 * Множественная форма текста
 * @param number
 * @param one
 * @param two
 * @param five
 * @returns {*}
 */
function getNoun(number, one, two, five) {
    let n = Math.abs(number);
    n %= 100;
    if (n >= 5 && n <= 20) {
        return five;
    }
    n %= 10;
    if (n === 1) {
        return one;
    }
    if (n >= 2 && n <= 4) {
        return two;
    }
    return five;
}

/**
 * Заполнение полей шаблона
 * @param template
 * @param data
 * @returns {*}
 */
function fillTemplate(template, data) {
    var escapeHtml = function (value) {
        return String(value).replace(/[&<>"']/g, function (ch) {
            return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[ch];
        });
    };
    for (let i in data) {
        template = template.split('%' + i + '%').join(escapeHtml(data[i]));
    }
    return template;
}

/**
 * Глобальное обновление бейджа количества ожидающих отзывов
 * Обновляет:
 *  - Бейдж в левом меню (исключая локальные переключатели на самой странице)
 *  - Мобильные бейджи в шапке/меню
 * @param {number} count
 */
window.updateAwaitReviewsBadge = window.updateAwaitReviewsBadge || function (count) {
    try {
        // Desktop: обновляем бейдж только в левом меню, исключая локальные switcher-элементы
        const reviewsLinks = document.querySelectorAll(
            '.menu-lite .menu-lite-item a[href*="/user?personalis=reviews"],\
 .menu-lite .menu-lite-item > span'
        );
        reviewsLinks.forEach(function (el) {
            const container = el.closest('.menu-lite-item') || el;
            if (!container) return;
            let badge = container.querySelector('.label.red');
            if (!badge && count > 0) {
                badge = document.createElement('span');
                badge.className = 'label red';
                container.appendChild(badge);
            }
            if (badge) {
                if (count > 0) {
                    badge.textContent = count;
                    badge.style.display = '';
                } else {
                    badge.textContent = '';
                    badge.style.display = 'none';
                }
            }
        });

        // Mobile: красные бейджи с количеством
        const mobileBadges = document.querySelectorAll('.inside-baggage.baggage-red');
        mobileBadges.forEach(function (badge) {
            if (count > 0) {
                badge.textContent = count;
                badge.style.display = '';
            } else {
                badge.textContent = '';
                badge.style.display = 'none';
            }
        });
    } catch (e) {
        // молча игнорируем ошибки DOM
    }
};

/**
 * Унифицированное обновление бейджа «ожидающих отзывов» по ответу сервера
 * Если сервер вернул точное значение в `response.count_reviews.await` — используем его.
 * Иначе — уменьшаем текущее значение бейджа на 1 (не ниже 0).
 * Работает только при наличии `window.updateAwaitReviewsBadge`.
 * @param {Object} response
 */
window.updateAwaitReviewsBadgeFromResponse = window.updateAwaitReviewsBadgeFromResponse || function (response) {
    try {
        const _upd = (typeof window.updateAwaitReviewsBadge === 'function') ? window.updateAwaitReviewsBadge : null;
        if (!_upd) return;

        if (response &&
            response["count_reviews"] &&
            typeof response["count_reviews"]["await"] !== 'undefined') {
            _upd(parseInt(response["count_reviews"]["await"], 10) || 0);
        } else {
            const current = document.querySelector('.menu-lite-item .label.red');
            const val = current ? (parseInt(current.textContent, 10) || 0) : 0;
            const next = Math.max(val - 1, 0);
            _upd(next);
        }
    } catch (e) {
    }
};

function kk() {
    setTimeout(() => {
        const lang = document.documentElement.getAttribute('lang')
        if (lang === 'kk') {
            document.querySelectorAll('a').forEach(function (a) {
                let url = a.getAttribute('href')
                if (url) {
                    if (url.includes('kk')) {
                        url = url.replace('/kk/kk', '/kk')
                        if (url[0] === 'k') {
                            url = '/' + url
                        }
                    } else {
                        url = url.replace('/descript', '/kk/descript')
                    }
                    a.setAttribute('href', url)
                }
            })
        }
    }, 200)
}

kk();

// Global app object
window.app = ({
    debug: false,
    domain: null,
    domain_static: null,
    visible: false,
    user: ({
        session: null,
        id: null,
        city: null,
    }),
    contacts: ({
        phone: ({
            common: true,
            number: ({
                view: '8 700 800 3547',
                raw: '8 700 800 3547',
                note: '08:00-01:00'
            })
        })
    }),
    counters: ({
        metrika: null,
        ga: null,
        piwik: null
    })
});

var FlipSlider = function (layout) {

    this.slideIndex = 0;
    this.activeIndex = -1;
    this.slides = [];
    this.isAutoPlay = true;
    this.timeoutId = 0;
    this.layout = layout;

    this.plusSlides = function (n) {
        this.showSlides(this.slideIndex += n);
    };

    this.currentSlide = function (n) {
        this.showSlides(this.slideIndex = n);
    };

    this.showSlides = function (n) {
        if (!(this.slides && this.slides.length)) {
            return;
        }
        var dots = Array.prototype.slice.call(this.layout.querySelectorAll('.dot'));
        if (n > this.slides.length) { this.slideIndex = 1 }
        if (n < 1) { this.slideIndex = this.slides.length }
        var index = this.slideIndex - 1;
        if (index < 0) {
            index = 0;
        }

        // Material "fade through": у главного баннера слайды наложены (absolute) —
        // делаем настоящий crossfade; у .mini (relative) и при prefers-reduced-motion
        // прячем старый кадр сразу, без наложения.
        var reduceMotion = window.matchMedia &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var crossfade = !reduceMotion && !this.layout.classList.contains('mini');
        var prev = (this.activeIndex >= 0 && this.activeIndex !== index)
            ? this.slides[this.activeIndex] : null;

        for (var i = 0; i < this.slides.length; i++) {
            var slide = this.slides[i];
            if (i === index || (crossfade && slide === prev)) {
                continue;
            }
            slide.style.display = "none";
            slide.classList.remove('is-entering', 'is-leaving');
            clearTimeout(slide._ftHide);
        }

        for (var j = 0; j < dots.length; j++) {
            dots[j].className = dots[j].className.replace(" active", "");
        }

        // Входящий кадр: перезапускаем анимацию появления.
        var next = this.slides[index];
        clearTimeout(next._ftHide);
        next.classList.remove('is-entering', 'is-leaving');
        next.style.display = "block";
        void next.offsetWidth; // форсируем reflow, чтобы анимация проиграла заново
        next.classList.add('is-entering');

        // Уходящий кадр: гаснет поверх входящего, затем скрывается.
        if (crossfade && prev) {
            prev.classList.remove('is-entering');
            prev.classList.add('is-leaving');
            clearTimeout(prev._ftHide);
            prev._ftHide = setTimeout(function () {
                prev.classList.remove('is-leaving');
                prev.style.display = "none";
            }, 140);
        }

        this.activeIndex = index;

        if (dots[index]) {
            dots[index].className += " active";
        }
    };

    this.restartAutoplay = function (time) {
        var self = this;
        this.isAutoPlay = true;
        if (!time) {
            time = 60000;
        }
        setTimeout(function () {
            self.startAutoplay();
        }, time);
    };

    this.stopAutoplay = function () {
        this.isAutoPlay = false;
    };

    this.startAutoplay = function (time) {
        this.slides = Array.prototype.slice.call(this.layout.querySelectorAll('.mySlides'));
        // Один баннер (или ноль) — переключать нечего, автопрокрутку не запускаем.
        if (this.slides && this.slides.length > 1) {
            if (!time) {
                time = 4000;
            }
            var self = this;
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(function () {
                if (self.isAutoPlay) {
                    if (self.slideIndex > self.slides.length) {
                        self.slideIndex = 1;
                    }
                    self.startAutoplay();
                    self.slideIndex++;
                    self.showSlides(self.slideIndex);
                }
            }, time);
        }
    };

    this.initEvents = function () {
        var self = this;

        // Как jQuery $('.slideshow-container', layout) — только потомки layout:
        // у мини-баннера контейнер сам .slideshow-container, ховер-паузы там не было
        this.layout.querySelectorAll('.slideshow-container').forEach(function (container) {
            container.addEventListener('mouseover', function () {
                self.stopAutoplay();
            });
            container.addEventListener('mouseout', function () {
                self.restartAutoplay(1000);
            });
        });

        this.layout.querySelectorAll('.slider.prev').forEach(function (el) {
            el.addEventListener('click', function () {
                self.plusSlides(-1);
            });
        });

        this.layout.querySelectorAll('.slider.next').forEach(function (el) {
            el.addEventListener('click', function () {
                self.plusSlides(1);
            });
        });

        this.layout.querySelectorAll('.slider.dot').forEach(function (dot) {
            dot.addEventListener('click', function () {
                self.currentSlide(dot.getAttribute('data-index'));
            });
        });
    }

    this.startAutoplay(1);
    this.initEvents();
};

document.querySelectorAll('.banner_slick').forEach(function (el) {
    new FlipSlider(el);
})
const imgScroll = function () {
    document.querySelectorAll('.product-image').forEach(function (card) {
        var hovers = Array.prototype.slice.call(card.querySelectorAll('.img-scrolling .hover-to-scroll'));
        var showByIndex = function (index) {
            var imgs = card.querySelectorAll('.img-to-scroll img');
            var dots = card.querySelectorAll('.scroll-dots span');
            Array.prototype.forEach.call(imgs, function (im) { im.style.display = 'none'; });
            if (imgs[index]) imgs[index].style.display = 'block';
            Array.prototype.forEach.call(dots, function (d) { d.classList.remove('active'); });
            if (dots[index]) dots[index].classList.add('active');
        };
        hovers.forEach(function (zone, index) {
            zone.addEventListener('mouseenter', function () { showByIndex(index); });
            zone.addEventListener('mouseleave', function () { showByIndex(0); });
        });
    });
}

;(function () {
    'use strict';

    function init() {

    var qa = function (selector, root) {
        return Array.prototype.slice.call((root || document).querySelectorAll(selector));
    };

    var floatingLabelSel = '.form-control .form-element > label, .form-control-flip .form-element > label';
    var floatingInputSel = '.form-control .form-element > input, .form-control-flip .form-element > input';
    var floatingTouch = { x: null, y: null };
    var floatingIsTextInput = function (el) {
        return /^(text|search|tel|url|password)$/.test(el.type);
    };
    var floatingCaretToEnd = function (input) {
        input.focus();
        var len = input.value.length;
        try { input.setSelectionRange(len, len); } catch (e) {}
    };
    var floatingInTopPad = function (input, clientY) {
        var rect = input.getBoundingClientRect();
        var topPad = parseFloat(getComputedStyle(input).paddingTop) || 0;
        return clientY - rect.top < topPad;
    };
    var floatingTap = function (event) {
        var t = event.changedTouches[0];
        if (!t || floatingTouch.x === null) return null;
        return Math.abs(t.clientX - floatingTouch.x) <= 10 && Math.abs(t.clientY - floatingTouch.y) <= 10 ? t : null;
    };
    var closestIn = function (event, selector) {
        return event.target && event.target.closest ? event.target.closest(selector) : null;
    };

    document.addEventListener('mousedown', function (event) {
        var label = closestIn(event, floatingLabelSel);
        if (label) {
            var input = document.getElementById(label.htmlFor);
            if (!input || !floatingIsTextInput(input)) return;
            event.preventDefault();
            floatingCaretToEnd(input);
            return;
        }
        var field = closestIn(event, floatingInputSel);
        if (field) {
            if (!floatingIsTextInput(field) || !floatingInTopPad(field, event.clientY)) return;
            event.preventDefault();
            floatingCaretToEnd(field);
        }
    });
    document.addEventListener('touchstart', function (event) {
        if (!closestIn(event, floatingLabelSel + ', ' + floatingInputSel)) return;
        var t = event.touches[0];
        floatingTouch.x = t ? t.clientX : null;
        floatingTouch.y = t ? t.clientY : null;
    }, {passive: true});
    document.addEventListener('touchend', function (event) {
        var label = closestIn(event, floatingLabelSel);
        if (label) {
            var input = document.getElementById(label.htmlFor);
            if (!input || !floatingIsTextInput(input) || !floatingTap(event)) return;
            event.preventDefault();
            floatingCaretToEnd(input);
            return;
        }
        var field = closestIn(event, floatingInputSel);
        if (field) {
            var t = floatingTap(event);
            if (!floatingIsTextInput(field) || !t || !floatingInTopPad(field, t.clientY)) return;
            event.preventDefault();
            floatingCaretToEnd(field);
        }
    });

    var header = document.querySelector('.header-outer');

    if (header) {
        var bgBlack = qa('.bg-black:not(.category-list-bg)');
        var cartBlokSticky = qa('.cart-blok-sticky, html.has-content-right .cell.right .right-sticky-col, .rv-summary');

        var lastScrollY = Math.max(window.scrollY, 0); // защита от отрицательного scrollY
        var offset = 0;
        var maxOffset = header.offsetHeight;
        var ticking = false;

        var onScroll = function () {
            var currentScrollY = Math.max(window.scrollY, 0); // защита от bounce в Safari
            var delta = currentScrollY - lastScrollY;

            offset += delta;
            offset = Math.min(Math.max(offset, 0), maxOffset); // ограничение от 0 до maxOffset
            header.style.transform = 'translate3d(0, -' + offset + 'px, 0)';

            if (offset >= maxOffset) {
                header.style.backgroundColor = 'transparent';
            } else {
                header.style.backgroundColor = '';
            }

            cartBlokSticky.forEach(function (el) {
                el.style.top = (74 - offset) + 'px';
            });
            bgBlack.forEach(function (el) {
                el.style.height = 'calc(100vh + ' + (offset - 58) + 'px)';
            });

            lastScrollY = currentScrollY;
            ticking = false;
        };

        window.addEventListener('scroll', function () {
            if (!ticking) {
                requestAnimationFrame(onScroll);
                ticking = true;
            }
        });
    }

    qa('div.form-element input[type="file"]').forEach(function (input) {
        input.addEventListener('change', function () {
            var next = input.nextElementSibling;
            if (next) {
                next.textContent = Array.prototype.map.call(input.files, function (file) {
                    return file.name;
                }).join(', ');
            }
        });
    });

    var sub1 = document.querySelector('.sub-1');
    if (sub1) {
        var paddingTop = parseInt(sub1.getBoundingClientRect().height) + 16;
        qa('.menu-padding').forEach(function (el) {
            el.style.paddingTop = paddingTop + 'px';
        });
    }

    qa('.search-from-data').forEach(function (el) {
        el.addEventListener('click', function (event) {
            event.preventDefault();
            var url = '/search?search=' + el.getAttribute('data-search');
            if (document.documentElement.getAttribute('lang') == 'kk') {
                window.location.href = '/kk' + url;
            } else {
                window.location.href = url;
            }
        });
    });

    qa('.link-from-data').forEach(function (el) {
        el.addEventListener('click', function (event) {
            event.preventDefault();
            var url = el.getAttribute('data-url');
            if (document.documentElement.getAttribute('lang') == 'kk') {
                window.location.href = '/kk' + url;
            } else {
                window.location.href = url;
            }
        });
    });

    qa('.go-to-reviews').forEach(function (el) {
        el.addEventListener('click', function (event) {
            event.preventDefault();
            window.location.href = '/catalog?prod=' + el.getAttribute('data-id') + '#reviews';
        });
    });

    imgScroll();

    qa('#contact').forEach(function (form) {
        form.addEventListener('submit', function () {
            qa('.css-loader', form).forEach(function (el) { el.classList.remove('hide'); });
            qa('input[type="submit"]', form).forEach(function (el) { el.style.display = 'none'; });
        });
    });

    // Анимации раскрытия контакт-формы (аналог slideDown/slideUp)
    var slideDownEl = function (el, ms) {
        el.style.removeProperty('display');
        if (getComputedStyle(el).display === 'none') el.style.display = 'block';
        var target = el.scrollHeight;
        el.style.overflow = 'hidden';
        el.style.height = '0px';
        el.getBoundingClientRect();
        el.style.transition = 'height ' + ms + 'ms';
        el.style.height = target + 'px';
        setTimeout(function () {
            el.style.transition = '';
            el.style.height = '';
            el.style.overflow = '';
        }, ms + 20);
    };
    var slideUpEl = function (el, ms) {
        el.style.overflow = 'hidden';
        el.style.height = el.scrollHeight + 'px';
        el.getBoundingClientRect();
        el.style.transition = 'height ' + ms + 'ms';
        el.style.height = '0px';
        setTimeout(function () {
            el.style.display = 'none';
            el.style.transition = '';
            el.style.height = '';
            el.style.overflow = '';
        }, ms + 20);
    };

    qa('.show-contact-form').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
            event.preventDefault();
            qa('.contact-form').forEach(function (el) { slideDownEl(el, 500); });
            btn.style.display = 'none';
        });
    });
    qa('.hide-contact-form').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
            event.preventDefault();
            qa('.contact-form').forEach(function (el) { slideUpEl(el, 100); });
            qa('.show-contact-form').forEach(function (el) { el.style.display = ''; });
        });
    });

    (function () {
        var hidden = "hidden";

        // Standards:
        if (hidden in document)
            document.addEventListener("visibilitychange", onchange);
        else if ((hidden = "webkitHidden") in document)
            document.addEventListener("webkitvisibilitychange", onchange);
        else if ("onfocusin" in document)
            document.onfocusin = document.onfocusout = onchange;
        else
            window.onpageshow = window.onpagehide
                = window.onfocus = window.onblur = onchange;

        function onchange(evt) {
            var v = "visible", h = "hidden",
                evtMap = {
                    focus: v, focusin: v, pageshow: v, blur: h, focusout: h, pagehide: h
                };

            evt = evt || window.event;

            document.body.removeAttribute('data-' + h);
            document.body.removeAttribute('data-' + v);

            if (evt.type in evtMap) {
                if (evtMap[evt.type] == h) {
                    app.visible = false;
                }
                else {
                    app.visible = true;
                }

                document.body.setAttribute('data-' + evtMap[evt.type], !0);
            }
            else {
                if (this[hidden]) {
                    app.visible = false;
                }
                else {
                    app.visible = true;
                }

                document.body.setAttribute('data-' + (this[hidden] ? h : v), !0);
            }

            // Events
            window.dispatchEvent(new CustomEvent('onappchangevisibility', {detail: app.visible}));
        }

        // set the initial state (but only if browser supports the Page Visibility API)
        if (document[hidden] !== undefined)
            onchange({ type: document[hidden] ? "blur" : "focus" });
    })();

    var body = document.body;

    var userSession = body.getAttribute('data-user-session');
    var userId = body.getAttribute('data-user-id');
    var userCity = body.getAttribute('data-user-city');

    var domain_static = body.getAttribute('data-domain-static');

    if (!!(userSession)) {
        app.user.session = userSession;
    }

    if (!!(userId)) {
        app.user.id = userId;
    }

    if (!!(userCity)) {
        app.user.city = userCity.toLowerCase();
    }

    if (!!(domain_static)) {
        app.domain_static = domain_static;
    }

    if (app.user.city) {
        if (app.user.city == 'karaganda') {
            app.contacts.phone = ({
                common: false,
                number: ({
                    view: '+7 (700) 800 3547',
                    raw: '+7 (700) 800 3547',
                    note: 'круглосуточно'
                })
            });
        }
        else if (app.user.city == 'astana') {
            app.contacts.phone = ({
                common: false,
                number: ({
                    view: '8 (7172) 79 50 00',
                    raw: '+7 (7172) 79 50 00',
                    note: 'круглосуточно'
                })
            });
        }
        else if (app.user.city == 'almaty') {
            app.contacts.phone = ({
                common: false,
                number: ({
                    view: '8 (727) 330 88 66',
                    raw: '+7 (727) 330 88 66',
                    note: 'круглосуточно'
                })
            });
        }
    }

    qa('span[data-target-phone]').forEach(function (span) {
        var type = span.getAttribute('data-target-phone');
        var text = '';

        if (type == 'phone-with-note') {
            text = app.contacts.phone.number.view + (app.contacts.phone.number.note ? ' (' + app.contacts.phone.number.note + ')' : '');
        }

        span.innerHTML = text;
        var link = document.createElement('a');
        link.href = 'tel:' + app.contacts.phone.number.raw;
        span.parentNode.insertBefore(link, span);
        link.appendChild(span);
    });

    // Канонизация: номер = последние 10 цифр (у KZ две семёрки подряд, +77…)
    var preparePhoneFromPasteData = function (pasteData) {
        var digits = pasteData.replace(/\D/g, '');

        if (digits.length === 10) {
            return '+7' + digits;
        }

        if (digits.length >= 11) {
            if (digits[0] === '8') {
                digits = '7' + digits.slice(1);
            }
            while (digits.length > 11 && digits[0] === '7') {
                digits = digits.slice(1);
            }
            return '+7' + digits.slice(-10);
        }

        return pasteData;
    };

    qa('.mobile-phone-with-imask').forEach(function (field) {
        var mask = IMask(field, {
            mask: '+{7} (000) 000-00-00'
        });

        // imask в lazy-режиме не показывает даже код страны, пока не начнёшь печатать.
        // Мобильная версия давно подставляет «+7» в пустое поле — делаем так же.
        if (!field.value) {
            mask.value = '+7';
        }

        // Автозаполнение (любой inputType) ловим по содержимому: 10+ цифр разом
        field.addEventListener('beforeinput', function (event) {
            var text = event.data || (event.dataTransfer && event.dataTransfer.getData('text')) || '';
            if (text.replace(/\D/g, '').length >= 10) {
                event.preventDefault();
                mask.value = preparePhoneFromPasteData(text);
                return;
            }
            // Первая цифра при пустых слотах — в номер, не в литерал «+7»:
            // iOS-автофилл печатает номер по одной цифре, 8 в коде отбрасываем
            if (/^\d$/.test(event.data || '') && field.value.replace(/\D/g, '').length <= 1) {
                event.preventDefault();
                if (event.data !== '8') {
                    mask.value = '+7' + event.data;
                }
            }
        });

        field.addEventListener('input', function (event) {
            if (!event.inputType) {
                var pasteData = event.target.value.replace(/[^\d]/g, '');
                pasteData = preparePhoneFromPasteData(pasteData);
                // Вставляем обработанные данные в поле ввода
                mask.value = pasteData;
            }
        });

        field.addEventListener('paste', function (event) {
            event.preventDefault();
            var pasteData = (event.clipboardData || window.clipboardData).getData('text');
            // Удаляем все нечисловые символы, кроме +
            pasteData = pasteData.replace(/[^\d]/g, '');
            var currentVal = field.value.replace(/[^\d]/g, '');
            if (('' + currentVal + pasteData).length === 11) {
                pasteData = currentVal + pasteData;
            }
            pasteData = preparePhoneFromPasteData(pasteData);
            // Вставляем обработанные данные в поле ввода
            mask.value = pasteData;
        });

        field.addEventListener('keydown', function (event) {
            var cursorPosition = field.selectionStart;
            // Если пытаются удалить "+7", блокируем действие
            if (cursorPosition <= 3 && (event.key === 'Backspace' || event.key === 'Delete')) {
                event.preventDefault();
                mask.value = '+7';
            }
        });
    });

    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

// Меню каталога (десктоп): панель раздела открывает класс is-active, а не :hover.
// Пока курсор идёт к открытой панели, пункты по пути её не перехватывают (алгоритм jQuery-menu-aim).
;(function () {
    'use strict';

    var ACTIVATE_DELAY = 300;
    var CLOSE_DELAY = 200;
    var TOLERANCE = 75;

    function init() {
        var menu = document.querySelector('.subHeader .menu');
        var rowsBox = menu ? menu.querySelector('.category-list .sub-1') : null;
        if (!rowsBox) return;

        var icon = menu.querySelector('.category-list-icon');
        var activeRow = null;
        var lastTarget = null;
        var locs = [];
        var lastDelayLoc = null;
        var activateTimer = null;
        var closeTimer = null;

        var activate = function (row) {
            if (row === activeRow) return;
            if (activeRow) activeRow.classList.remove('is-active');
            activeRow = row;
            if (row) row.classList.add('is-active');
        };

        var slope = function (a, b) {
            return (b.y - a.y) / (b.x - a.x);
        };

        // Курсор идёт внутрь треугольника «курсор — правый край списка»: переключение откладываем
        var activationDelay = function (loc) {
            if (!activeRow || !activeRow.querySelector(':scope > .sub-new')) return 0;
            var prev = locs[0] || loc;
            var r = rowsBox.getBoundingClientRect();
            if (prev.x < r.left || prev.x > r.right || prev.y < r.top || prev.y > r.bottom) return 0;
            if (lastDelayLoc && loc.x === lastDelayLoc.x && loc.y === lastDelayLoc.y) return 0;
            var upper = {x: r.right, y: r.top - TOLERANCE};
            var lower = {x: r.right, y: r.bottom + TOLERANCE};
            if (slope(loc, upper) < slope(prev, upper) && slope(loc, lower) > slope(prev, lower)) {
                lastDelayLoc = loc;
                return ACTIVATE_DELAY;
            }
            lastDelayLoc = null;
            return 0;
        };

        var possiblyActivate = function (row, loc) {
            clearTimeout(activateTimer);
            var delay = loc ? activationDelay(loc) : 0;
            if (delay) {
                activateTimer = setTimeout(function () {
                    possiblyActivate(row, locs[locs.length - 1]);
                }, delay);
            } else {
                activate(row);
            }
        };

        var close = function () {
            clearTimeout(activateTimer);
            clearTimeout(closeTimer);
            menu.classList.remove('is-open');
            activate(null);
            locs = [];
            lastDelayLoc = null;
        };

        menu.classList.add('is-aim');

        menu.addEventListener('mouseenter', function () {
            clearTimeout(closeTimer);
            menu.classList.add('is-open');
        });

        // С кнопки «Каталог» уходят мимоходом — закрываем сразу, из списка и панели — с запасом на промах
        menu.addEventListener('mouseleave', function () {
            clearTimeout(activateTimer);
            clearTimeout(closeTimer);
            if (icon && icon.contains(lastTarget)) {
                close();
            } else {
                closeTimer = setTimeout(close, CLOSE_DELAY);
            }
        });

        menu.addEventListener('mousemove', function (e) {
            locs.push({x: e.clientX, y: e.clientY});
            if (locs.length > 3) locs.shift();
        });

        menu.addEventListener('mouseover', function (e) {
            lastTarget = e.target;
            // На кнопке «Каталог» выделение и панель снимаем, список остаётся открытым
            if (icon && icon.contains(e.target)) {
                clearTimeout(activateTimer);
                activate(null);
                return;
            }
            var row = e.target.closest('.sub-1 > li');
            if (row && row === activeRow && e.target.closest('.sub-new')) {
                clearTimeout(activateTimer);
                return;
            }
            // Вне пунктов (поля списка сверху и снизу) row = null: выделение снимается, кроме движения к панели
            possiblyActivate(row, {x: e.clientX, y: e.clientY});
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

// Вставка HTML со скриптами — как jQuery .html(): вложенные <script> исполняются.
// noScripts=true — скрипты вырезаются: для блоков, где их заведомо нет
// (списки товаров), чтобы подменённый по пути ответ не исполнился у нас.
var flipInsertHtml = function (target, html, noScripts) {
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    Array.prototype.slice.call(tpl.content.querySelectorAll('script')).forEach(function (old) {
        if (noScripts) {
            old.parentNode.removeChild(old);
            return;
        }
        var script = document.createElement('script');
        Array.prototype.slice.call(old.attributes).forEach(function (attr) {
            script.setAttribute(attr.name, attr.value);
        });
        script.text = old.textContent;
        old.parentNode.replaceChild(script, old);
    });
    target.appendChild(tpl.content);
};

// Универсальная вставка контента: строка HTML, DOM-узел, jQuery-набор или список узлов.
// options.noScripts=true — не исполнять <script> из вставляемого HTML
var flipSetContent = function (target, content, append, options) {
    if (!append) target.replaceChildren();
    if (content == null || content === '') return;
    if (typeof content === 'string') {
        flipInsertHtml(target, content, !!(options && options.noScripts));
    } else if (content.nodeType) {
        target.appendChild(content);
    } else if (typeof content.length === 'number') {
        Array.prototype.slice.call(content).forEach(function (node) {
            if (node && node.nodeType) target.appendChild(node);
        });
    }
};

var aff = function aff(url, title, isText) {
    if (typeof isText == 'undefined' || !isText) {
        isText = false;
    }

    document.querySelectorAll('.aff-window').forEach(function (el) { el.remove(); });

    if (typeof title === 'undefined') {
        title = '';
    }

    var width = Math.ceil(document.body.clientWidth * 0.8);
    var holder = document.createElement('div');
    holder.innerHTML = '<div class="modal-bg table aff-window"><div class="modal-cell"><div class="modal" style="max-width: ' + width + 'px"><div class="close top close_button">&times;</div><div class="loaded"></div><div class="loader"><div class="filter-preloader"></div></div></div></div></div>';
    var layer = holder.firstElementChild;
    document.body.appendChild(layer);

    var closeLayer = function (event) {
        event.preventDefault();
        event.stopPropagation();
        layer.classList.remove('modal-show');
        layer.remove();
    };

    layer.addEventListener('click', closeLayer);

    layer.querySelector('.modal').addEventListener('click', function (event) {
        event.stopPropagation();
        event.preventDefault();
    });

    layer.querySelectorAll('.close_button, .add_close a').forEach(function (el) {
        el.addEventListener('click', closeLayer, {once: true});
    });

    var loaded = layer.querySelector('div.loaded');
    var loader = layer.querySelector('div.loader');

    // Hide goods, show loader
    loaded.style.display = 'none';
    loader.style.display = '';

    // Ok, Show layer
    layer.classList.add('modal-show');

    var showContent = function (html) {
        flipSetContent(loaded, html);
        loader.style.display = 'none';
        loaded.style.display = '';
    };

    if (false === isText) {
        fetch(url, {credentials: 'same-origin', headers: {'X-Requested-With': 'XMLHttpRequest'}})
            .then(function (res) { return res.text(); })
            .then(showContent)
            ['catch'](function () {});
    }
    else {
        showContent(url);
    }
};


var cartGetId = null;
var cartGetCount = 0;
var cartGet = (function () {
    if (null !== cartGetId) {
        return;
    }

    // Add fetch
    cartGetId = setTimeout((function () {
        // Clean
        cartGetId = null;

        if (!!(cartGetCallback())) {
            // Ok
            return true;
        }
    }), 10);
});

var cartGetCallback = (function () {
    cartGetCount++;

    var byId = function (id) { return document.getElementById(id); };
    var show = function (el) { if (el) el.style.display = ''; };
    var hide = function (el) { if (el) el.style.display = 'none'; };

    if (cartGetCount <= 1) {
        show(byId('cart_loader'));
    }

    fetch('/ajax/cart.php', {credentials: 'same-origin', headers: {'X-Requested-With': 'XMLHttpRequest'}})
        .then(function (res) { return res.text(); })
        .then(function (data) {
        var goods = 0;

        if (data && data.length > 1) {
            var rows = data.split("\n");
            var cart = "";

            for (var i = 0, l = rows.length; i < l; i++) {
                var row = rows[i].trim();
                var parsed = [];

                if (row) {
                    parsed = row.split("\t");

                    if (parsed[0] == "total") {
                        if (byId('cart_sum')) byId('cart_sum').innerHTML = parsed[3];
                        if (byId('cart_cnt')) byId('cart_cnt').innerHTML = parsed[2];
                    }
                    else if (parsed[0] > 0) {
                        cart += '<div class="table"><div class="cell img-cart"><a href="/catalog?prod=' + parsed[0] + '"><img src="' + app.domain_static + '/prod/' + Math.ceil(parsed[0] / 1000) + '/' + parsed[0] + '_140.jpg"/></a></div><a class="cell text" href="/catalog?prod=' + parsed[0] + '">' + parsed[1] + '</a><div class="cell price">' + parsed[2] + ' шт.&nbsp;x&nbsp;<b>' + parsed[3] + '</b><a href="/cart?del=' + parsed[0] + '" data-cart-produce-id="' + parsed[0] + '" class="cart-delete">удалить</a></div></div>';

                        // Inc goods
                        ++goods;
                    }
                }
            }

            if (!(goods)) {
                show(byId('cart_empty'));
                hide(byId('cart_goods'));
                hide(byId('cart_loader'));
            }
            else {
                hide(byId('cart_empty'));
                if (byId('cmain')) byId('cmain').innerHTML = cart;
                show(byId('cart_goods'));
                hide(byId('cart_loader'));
            }
        }
    })['catch'](function () {});
});

;(function () {
    'use strict';

    function init() {

    var qa = function (selector, root) {
        return Array.prototype.slice.call((root || document).querySelectorAll(selector));
    };

    qa('[data-link]').forEach(function (el) {
        el.addEventListener('click', function (event) {
            event.preventDefault();
            window.location.href = el.getAttribute('data-link');
        });
    });

    function processRelatedProducts(element) {
        var overflow = element.querySelector('.overflow');
        var products = overflow ? Array.prototype.slice.call(overflow.querySelectorAll('.releted-product')) : [];
        // Полное число вариантов берём с сервера (data-total), т.к. в DOM рендерятся
        // только первые N миниатюр. Фолбэк на количество узлов — для блоков без data-total.
        var dataTotal = parseInt(element.getAttribute('data-total'), 10);
        var productCount = isNaN(dataTotal) ? products.length : dataTotal;

        // Сколько миниатюр реально помещается в первый (видимый) ряд .overflow.
        // Считаем по факту — по offsetTop первого ряда, а не по ширине: оценка
        // по ширине на дробном «влезании» ошибалась на ±1.
        var productCountVisible = 0;
        if (products.length) {
            var firstRowTop = products[0].offsetTop;
            products.forEach(function (p) {
                if (p.offsetTop === firstRowTop) {
                    productCountVisible++;
                }
            });
        }

        var productCountHide = productCount - productCountVisible;
        var more = element.querySelector('.related-products-more');
        if (!more) return;

        if (productCountHide > 0) {
            more.style.opacity = '1';
            more.textContent = productCountHide;
        } else {
            more.style.opacity = '0';
            more.innerHTML = '';
        }
    }

    qa('.related-products').forEach(processRelatedProducts);

    window.addEventListener('resize', function () {
        qa('.related-products').forEach(processRelatedProducts);
    });

    // Наведение на вариант в карточке листинга: временно показываем его фото
    // в главном изображении карточки (как на карточке товара, см. groupped.js),
    // при уходе возвращаем исходное. Исходник храним на самой картинке —
    // карточек на странице много, глобальная переменная их бы перепутала.
    var rpImgFor = function (target) {
        var product = target.closest('.product');
        return product ? product.querySelector('.img-to-scroll img.image') : null;
    };
    var rpDetachError = function (img) {
        if (img._rphoverError) {
            img.removeEventListener('error', img._rphoverError);
            img._rphoverError = null;
        }
    };
    document.addEventListener('mouseover', function (e) {
        var target = e.target && e.target.closest ? e.target.closest('.new-product .releted-product[data-main-image]') : null;
        if (!target || (e.relatedTarget && target.contains(e.relatedTarget))) return;
        var img = rpImgFor(target);
        if (!img) return;

        var preview = target.getAttribute('data-main-image');
        var current = img.getAttribute('src') || '';
        // data-main-image отдаёт мелкий размер — подгоняем под размер главной картинки
        var sizeMatch = current.match(/_(\d+)\.\w+(?:\?.*)?$/);
        if (sizeMatch) preview = preview.replace(/_\d+(\.\w+(?:\?.*)?)$/, '_' + sizeMatch[1] + '$1');

        if (img._rphoverSavedSrc === undefined) img._rphoverSavedSrc = current;
        // если крупной версии нет — откат к исходной, чтобы не мигала битая картинка
        var restore = img._rphoverSavedSrc;
        rpDetachError(img);
        img._rphoverError = function () { img.setAttribute('src', restore); };
        img.addEventListener('error', img._rphoverError, {once: true});
        img.setAttribute('src', preview);
    });
    document.addEventListener('mouseout', function (e) {
        var target = e.target && e.target.closest ? e.target.closest('.new-product .releted-product[data-main-image]') : null;
        if (!target || (e.relatedTarget && target.contains(e.relatedTarget))) return;
        var img = rpImgFor(target);
        if (img && img._rphoverSavedSrc !== undefined) {
            rpDetachError(img);
            img.setAttribute('src', img._rphoverSavedSrc);
            delete img._rphoverSavedSrc;
        }
    });

    var searchCity = document.getElementById('search_city');
    if (searchCity) {
        searchCity.addEventListener('keyup', function () {
            qa('.offices-list-city').forEach(function (element) {
                var h3 = element.querySelector('h3');
                if (h3 && h3.textContent.toLowerCase().indexOf(searchCity.value.toLowerCase()) < 0) {
                    element.style.display = 'none';
                } else {
                    element.style.display = '';
                }
            });
        });
    }

    if (!(flipCookie('re_chk'))) {
        // Set
        flipCookie('re_chk', 2, { expires: 30, domain: '.flip.kz' });
    }

    document.addEventListener('click', function (event) {
        var toggle = event.target && event.target.closest ? event.target.closest('a[data-action-toggle="help-toggle"]') : null;
        if (!toggle) return;

        // Stop event
        event.preventDefault();

        var value = toggle.getAttribute('data-target');

        if (!!value) {
            qa(value).forEach(function (el) {
                el.style.display = (getComputedStyle(el).display === 'none') ? '' : 'none';
            });
        }
    });

    var searchParam = '';

    qa('form[name=search_produce]').forEach(function (form) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            var from = form.querySelector('#from');
            if (from) from.value = (searchParam === 'suggest') ? 'suggest' : 'button';
            searchParam = '';
            form.submit();
        });
    });

    document.addEventListener('click', function (event) {
        var link = event.target && event.target.closest ? event.target.closest('#w_cart a.cart-delete') : null;
        if (!link) return;

        // Stop event
        event.preventDefault();

        var id = link.getAttribute('data-cart-produce-id');

        link.replaceChildren();

        if (!!id) {
            if (typeof gtag === 'function') {
                gtag('event', 'remove_from_cart', { items: [{ item_id: String(id) }] });
            }
            fetch('/ajax/cart.php', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'X-Requested-With': 'XMLHttpRequest'},
                body: new URLSearchParams({del: id})
            }).then(function () {
                if (location.pathname == "/cart") {
                    location = location.href;
                }
                else {
                    cartGet();
                }
            })['catch'](function () {});
        }
    });

    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

;(function () {
    'use strict';

    function init() {

    // Обработчик клика по элементам с классом .info внутри .supplier-name.
    // При клике выполняется AJAX-запрос для получения информации о поставщике
    // и динамически заполняется модальное окно с данными из ответа.

    var isAjaxInProgress = false; // Флаг, указывающий на состояние AJAX-запроса

    document.addEventListener('click', function (event) {
        var info = event.target && event.target.closest ? event.target.closest('.supplier-name .info') : null;
        if (!info) return;
        event.preventDefault();

        var modal = document.getElementById('modal-supplier');
        if (!modal) return;
        var options = modal.querySelector('.supplier-info-modal-body-options');
        if (options) options.style.display = 'none';
        modal.style.display = '';

        var supplierId = info.getAttribute('data-supplier-id');
        var lang = document.documentElement.getAttribute('lang');
        var url = '/ajax/supplier_info.php?supplier_id=' + supplierId + '&lang=' + lang;

        var loaders = document.querySelectorAll('.loader');
        if (loaders.length === 0) {
            var holder = modal.querySelector('.loader');
            if (holder) holder.insertAdjacentHTML('beforeend', '<div class="loader"><div class="filter-preloader"></div></div>');
            loaders = document.querySelectorAll('.loader');
            loaders.forEach(function (el) { el.style.display = 'none'; });
        } else {
            loaders.forEach(function (el) { el.style.display = ''; });
        }

        if (isAjaxInProgress) {
            return; // Если запрос в процессе выполнения, новые запросы не начинаются
        }

        isAjaxInProgress = true; // флаг в true для указания начала запроса

        fetch(url, {credentials: 'same-origin', headers: {'X-Requested-With': 'XMLHttpRequest'}})
            .then(function (res) { return res.json(); })
            .then(function (response) {
                var modalContent = '';
                var staticClientUrl = document.body.getAttribute('data-domain-static');
                if (response['error']) {
                    if (options) options.innerHTML = '<p class="from-ajax">Не удалось получить данные.</p>';
                }
                if (response['total_produces']) {
                    modalContent += '\
                        <div class="supplier-option from-ajax">\
                            <img src="' + staticClientUrl + '/img/supplier_info/cube-outline.svg" alt="Информация о поставщике"/>\
                            <div>\
                                ' + response['translates']['now_on_sale'] + ': ' + response['total_produces'] + ' ' + response['translates']['text_product3'] + '\
                            </div>\
                        </div>\
                    ';
                }
                if (response['total_filled_produces']) {
                    modalContent += '\
                        <div class="supplier-option from-ajax">\
                            <img src="' + staticClientUrl + '/img/supplier_info/hugeicons_truck-delivery.svg" alt="Информация о поставщике"/>\
                            <div>\
                                 ' + response['total_filled_produces'] + ' ' + response['translates']['goods_issued'] + '\
                            </div>\
                        </div>\
                    ';
                }
                if (options) {
                    options.querySelectorAll('.from-ajax').forEach(function (el) { el.remove(); });
                    options.insertAdjacentHTML('beforeend', modalContent);
                    options.style.display = '';
                }
            })
            ['catch'](function () {
                if (options) options.innerHTML = '<p class="from-ajax">Не удалось получить данные.</p>';
            })
            ['finally'](function () {
                document.querySelectorAll('.loader').forEach(function (el) { el.style.display = 'none'; });
                isAjaxInProgress = false;
            });
    });

    // Закрытие модального окна при нажатии на span.close
    document.addEventListener('click', function (event) {
        var close = event.target && event.target.closest ? event.target.closest('#modal-supplier .supplier-close') : null;
        if (!close) return;
        var modal = document.getElementById('modal-supplier');
        if (modal) modal.style.display = 'none';
    });

    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

// Resizer — страница авторов (descript/people.tpl): раскладка таблиц по ширине окна
function Resizer(b, f, e, a) {
    var width = Math.floor(document.documentElement.clientWidth - b);
    var cols = parseInt(width / f);
    var selector = (a == "" || a == null || a == " ") ? 'table[class="table-list-items"]' : 'table[class="' + a + '"]';
    document.querySelectorAll(selector).forEach(function (table) {
        var count = parseInt(table.getAttribute('item_count'));
        var d = cols > count ? count : (cols <= e ? e : cols);
        var w = Math.round(100 / d) + '%';
        table.querySelectorAll('tr').forEach(function (tr) {
            var tds = Array.prototype.slice.call(tr.querySelectorAll('td[class*=td-item]'));
            tds.forEach(function (td, index) {
                td.style.width = w;
                td.style.display = index < d ? '' : 'none';
            });
        });
    });
}

// Clickjacking
if (top != self) { flipCookie('partner', null); flipCookie('psid', null); flipCookie('actionpay', null); }

;(function () {
    'use strict';

    function init() {

    document.addEventListener('mouseover', function (e) {
        var td = e.target && e.target.closest ? e.target.closest('.size tr td.sizs') : null;
        if (!td || (e.relatedTarget && td.contains(e.relatedTarget))) return;
        var table = td.closest('table') || td.parentElement.parentElement;
        var index = Array.prototype.indexOf.call(td.parentElement.children, td);
        var ths = table ? table.querySelectorAll('th') : [];
        if (ths[index]) ths[index].classList.add('active');
    });
    document.addEventListener('mouseout', function (e) {
        var td = e.target && e.target.closest ? e.target.closest('.size tr td') : null;
        if (!td || (e.relatedTarget && td.contains(e.relatedTarget))) return;
        document.querySelectorAll('.size th').forEach(function (th) { th.classList.remove('active'); });
    });

    document.querySelectorAll('.book-covers').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var plus = btn.previousElementSibling;
            var holder = btn.parentElement;
            var table = holder ? holder.nextElementSibling : null;
            if (!table || table.tagName !== 'TABLE') return;
            var hidden = getComputedStyle(table).display === 'none';
            table.style.display = hidden ? '' : 'none';
            if (plus && plus.tagName === 'SPAN') {
                plus.textContent = hidden ? '–' : '+';
            }
        });
    });

    document.addEventListener('click', function (event) {
        var self = event.target && event.target.closest
            ? event.target.closest('a[data-button-preloader],input[data-button-preloader],button[data-button-preloader]')
            : null;
        if (!self) return;

        // Stop event
        event.preventDefault();

        var type = self.tagName;
        var action = self.getAttribute('data-button-preloader');
        var form = self.closest('form');

        if (type == 'INPUT') {
            self.value = [self.value, '...'].join(' ');
        }
        else if (type == 'BUTTON' || type == 'A') {
            self.innerHTML = '<div class="filter-preloader"></div>';
        }

        if (action == 'form' && form) {
            setTimeout((function () {
                form.submit();
            }), 1);
        }
    });

    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

// Add cart
;(function () {
    'use strict';

    function init() {

    var layer = document.getElementById('add-to-cart-modal');

    var q = function (selector) { return layer ? layer.querySelector(selector) : null; };
    var qq = function (selector) { return layer ? Array.prototype.slice.call(layer.querySelectorAll(selector)) : []; };
    var show = function (el) { if (el) el.style.display = ''; };
    var hide = function (el) { if (el) el.style.display = 'none'; };

    document.addEventListener('click', function (event) {
        if (!layer) return;
        var btn = event.target && event.target.closest ? event.target.closest('.close_button, .add_close a') : null;
        if (!btn || !layer.contains(btn)) return;

        // Close add
        event.preventDefault();
        event.stopPropagation();
        layer.classList.remove('modal-show');
    });

    document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!form || !form.matches || !form.matches('form[method=post], form[method=POST]')) return;

        var produceInput = form.querySelector('input[name=cart_id_produce]');
        if (!produceInput) return;

        var produce = produceInput.value;
        var supplierInput = form.querySelector('input[name=supplier]');
        var supplier = supplierInput ? supplierInput.value : undefined;

        // Stop event
        event.preventDefault();

        // Get layer
        var countInput = form.querySelector('[name=cart_count_produce]');
        var count = countInput ? countInput.value : '';

        if (!count) {
            count = 1;
        }

        // hide layer
        qq('div.and').forEach(hide);

        // Hide goods, show loader
        qq('.loaded').forEach(hide);
        qq('.loader').forEach(show);
        qq('.errors').forEach(hide);

        // Ok, Show layer
        if (form.classList.contains('main-suplier') && layer) {
            layer.classList.add('modal-show');
        }

        var data = { add: produce, count: count };

        if (supplier) {
            data.supplier = supplier;
        }

        fetch('/ajax/cart.php', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'X-Requested-With': 'XMLHttpRequest'},
            body: new URLSearchParams(data)
        }).then(function (res) { return res.json(); }).then(function (data) {
            form.querySelectorAll('[type=image]').forEach(function (el) { el.disabled = false; });

            if (data.error) {
                // Show error message via modal
                showModal({
                    title: 'Ошибка',
                    content: data.error,
                    onlyClose: true
                });

                // Also show in layer for backwards compatibility
                qq('.errors').forEach(function (el) { el.innerHTML = data.error; });

                // Show goods, hide loader
                qq('.loaded').forEach(hide);
                qq('.loader').forEach(hide);
                qq('.errors').forEach(show);
            }
            else {

                form.querySelectorAll('.btn-add').forEach(hide);
                form.querySelectorAll('.btn-go').forEach(show);

                form.querySelectorAll('.btn-go-to-cart').forEach(function (btn) {
                    btn.onclick = function () {
                        var href = btn.getAttribute('data-href') || '/cart';
                        window.location.href = href;
                        return false;
                    };
                });

                // Show added produce
                qq('.name a, .pic a').forEach(function (a) { a.setAttribute('href', '/catalog?prod=' + data.added.idProduce); });
                qq('.name a').forEach(function (a) { a.textContent = data.added.shortName || data.added.name; });

                // Count added
                qq('.name span').forEach(function (s) { s.textContent = count; });

                // Image added
                qq('.pic img').forEach(function (img) {
                    img.setAttribute('src', (app.domain_static ? app.domain_static : '') + (data.added.image_140 ? data.added.image_140.urli : null));
                    img.setAttribute('alt', 'Картинка');
                });
                qq('div.and div.recommended').forEach(function (el) { el.innerHTML = ''; });

                if (data.recommended && data.recommended.rows) {
                    // Show layer
                    qq('div.and').forEach(show);

                    var recommendedHtml = '';
                    for (var key in data.recommended.rows) {
                        // Аналитика принимает суммы в USD: тенге делим на курс из шапки
                        var fbUsdRate = Number(window.FLIP_USD_RATE) || 0;
                        var fbUsdVal = fbUsdRate > 0 ? Math.round(((Number(String(data.recommended.rows[key].price).replace(/\D/g, '')) || 0) / fbUsdRate) * 100) / 100 : 0;

                        recommendedHtml += '<div class="cell"><div class="table img"><div class="cell"><a href="/catalog?prod=' + data.recommended.rows[key].idProduce + '"><img alt="Картинка" src="' + (app.domain_static ? app.domain_static : '') + data.recommended.rows[key].image.urli + '" /></a></div></div><a class="link" href="/catalog?prod=' + data.recommended.rows[key].idProduce + '">' + (data.recommended.rows[key].shortName || data.recommended.rows[key].name) + '</a><span class="m-b-5">' + data.recommended.rows[key].price + '</span><form action="/cart" method="post" style="margin: 0; padding: 0;"><input type="hidden" name="cart_id_produce" value="' + data.recommended.rows[key].idProduce + '"/><input type="submit" class="nbtn yellow small" title="Добавить в корзину" value="В корзину" onClick="fbq(\'track\', \'AddToCart\', { content_ids: [\'' + data.recommended.rows[key].idProduce + '\'],content_type: \'product\', value: ' + fbUsdVal + ', currency: \'USD\' });" /></form></div>';
                    }
                    qq('div.and div.recommended').forEach(function (el) { el.innerHTML = recommendedHtml; });

                    qq('p.b').forEach(function (el) { el.textContent = data.recommended.title + ':'; });
                }

                if (data.infos) {
                    // Goods count
                    var cartCount = q('#cart-count');
                    if (cartCount) cartCount.textContent = data.infos.count;

                    // Top menu
                    var cartCnt = document.getElementById('cart_cnt');
                    if (cartCnt) cartCnt.textContent = data.infos.count;
                    var cartSum = document.getElementById('cart_sum');
                    if (cartSum) cartSum.innerHTML = data.infos.summa;

                    // Cart summa
                    var cartSumma = q('#cart-summa');
                    if (cartSumma) cartSumma.textContent = data.infos.summa;
                }

                // Show goods, hide loader
                qq('.loaded').forEach(show);
                qq('.loader').forEach(hide);
                qq('.errors').forEach(hide);
            }
        })['catch'](function () {});
    });

    document.addEventListener('click', function (event) {
        var wrap = event.target && event.target.closest ? event.target.closest('[data-add-to-cart]') : null;
        if (!wrap) return;
        var form = wrap.querySelector('form');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });

    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

;(function () {
    'use strict';

    // JSONP — спеллер Яндекса отвечает только через callback-параметр
    var jsonp = function (url, params, callback) {
        var cbName = 'flipJsonp' + Math.floor(Math.random() * 1e9);
        window[cbName] = function (data) {
            delete window[cbName];
            script.remove();
            callback(data);
        };
        var query = Object.keys(params).map(function (k) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
        }).join('&');
        var script = document.createElement('script');
        script.src = url + '?' + query + '&callback=' + cbName;
        script.onerror = function () { delete window[cbName]; script.remove(); };
        document.head.appendChild(script);
    };

    function init() {

    var request = document.getElementById('search-request-words');
    var text = null;

    if (request) {
        text = request.getAttribute('data-search-text');
    }

    if (text) {
        var textResult = null;
        var textResultRaw = null;

        var textReplace = {};
        var textReplaceIndex = 0;

        jsonp('//speller.yandex.net/services/spellservice.json/checkText', { text: text, options: (512 | 8 | 4), lang: 'ru,en', format: 'plain' }, function (data) {
            if (data) {
                if (data.length) {
                    for (var key in data) {
                        var word = data[key];
                        var wordOld = text.substr(word.pos, word.len);

                        if (wordOld && wordOld.length == word.len) {
                            // Replace
                            if (word.s && word.s.length) {
                                if (word.code == 1 || word.code == 4) {
                                    if (null === textResult) {
                                        textResult = text;
                                        textResultRaw = text;
                                    }

                                    textResult = textResult.replace(wordOld, "\x00-" + (++textReplaceIndex) + "-\x00");
                                    textResultRaw = textResultRaw.replace(wordOld, "\x00-" + (textReplaceIndex) + "-\x00");

                                    textReplace[textReplaceIndex] = ({
                                        word: word.s[0],
                                        type: 1
                                    });
                                }
                            }
                            else if (word.code == 2) {
                                if (null === textResult) {
                                    textResult = text;
                                    textResultRaw = text;
                                }

                                textResult = textResult.replace(wordOld, "");
                                textResultRaw = textResultRaw.replace(wordOld, "");
                            }
                        }
                    }
                }
            }

            if (textReplace) {
                for (var rkey in textReplace) {
                    if (textReplace[rkey].type == 1) {
                        textResult = textResult.replace("\x00-" + (rkey) + "-\x00", '<span class="spell-error">' + (textReplace[rkey].word) + '</span>');
                        textResultRaw = textResultRaw.replace("\x00-" + (rkey) + "-\x00", textReplace[rkey].word);
                    }
                }
            }

            if (textResult) {
                request.classList.remove('hidden');
                request.insertAdjacentHTML('beforeend', '<span class="text-danger">Возможно, вы имели в виду: <b><a href="/search?search=' + encodeURIComponent(textResultRaw) + '&from=spellcheck_click">' + (textResult) + '</a></b></span> <span id="search-request-words-timer" style="color:#555555"></span>');

                var urlParams = new URLSearchParams(window.location.search);

                if (document.getElementById('search-not-result') && urlParams.get('from') !== "spellcheck_click" && urlParams.get('from') !== "spellcheck_redirect") {
                    document.getElementById("search-request-words-timer").innerHTML = "исправим через 5 секунд";

                    window.setTimeout(function () {
                        document.getElementById("search-request-words-timer").innerHTML = "исправим через 4 секунды";
                    }, 1000);

                    window.setTimeout(function () {
                        document.getElementById("search-request-words-timer").innerHTML = "исправим через 3 секунды";
                    }, 2000);

                    window.setTimeout(function () {
                        document.getElementById("search-request-words-timer").innerHTML = "исправим через 2 секунды";
                    }, 3000);

                    window.setTimeout(function () {
                        document.getElementById("search-request-words-timer").innerHTML = "исправим через 1 секунду";
                    }, 4000);

                    window.setTimeout(function () {
                        document.getElementById("search-request-words-timer").innerHTML = "";
                        window.location.href = "/search?search=" + encodeURIComponent(textResultRaw) + "&from=spellcheck_redirect";
                    }, 5000);
                }
            }
        });
    }

    document.querySelectorAll('div[data-top-line-id] span.close, div[data-top-line-id] a').forEach(function (el) {
        el.addEventListener('click', function (event) {
            // Stop event
            event.stopImmediatePropagation();

            var self = el.closest('div[data-top-line-id]');
            if (!self) return;
            var id = self.getAttribute('data-top-line-id');

            var closed = event.target ? (event.target.classList && event.target.classList.contains('close')) : false;
            var close = !!self.getAttribute('data-top-line-close');

            if (closed || close) {
                if ((closed)) {
                    self.style.transition = 'opacity 0.4s';
                    self.style.opacity = '0';
                    setTimeout(function () { self.remove(); }, 420);
                }

                if (!!(id)) {
                    flipCookie('tl_' + id, new Date().getTime(), { expires: 365, domain: '.flip.kz' });
                }
            }
        });
    });

    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

// Trade area
;(function () {
    'use strict';

    function init() {

    if (!document.querySelector('body[data-ta-mode="yes"]')) return;

    var textsInputs = Array.prototype.slice.call(document.querySelectorAll('input[type=text], input[type=email], input[type=search]'));
    var acceptKeyCodes = [13];

    var barcodeInput = document.querySelector('form[name="search_produce"] input[name="search"]');

    var showKeyboardAllow = true;
    var showKeyboard = function () {
        if (showKeyboardAllow) {
            if ('AndroidWebView' in window && window.AndroidWebView) {
                window.AndroidWebView.showKeyboard();
            }
        }
    };

    textsInputs.forEach(function (input) {
        input.addEventListener('focus', function () { input.focused = true; });
        input.addEventListener('blur', function () { input.focused = false; });
    });

    if (barcodeInput) {
        document.addEventListener('keypress', function () {
            var focused = 0;

            textsInputs.forEach(function (input) {
                if (input.focused) {
                    focused = 1;
                }
            });

            if (!focused) {
                showKeyboardAllow = false;

                barcodeInput.value = '';
                barcodeInput.focus();
            }
        });

        barcodeInput.addEventListener('keyup', function (e) {
            if (acceptKeyCodes.indexOf(e.which || e.keyCode) !== -1) {
                var value = barcodeInput.value;

                if (value.length) {
                    document.location.href = '/search?search=' + encodeURIComponent(value);
                }
            }
        });

        barcodeInput.addEventListener('focus', function () {
            showKeyboard();
        });
    }

    var goBackTimeout = 300000;
    var goBackId = null;
    var goBackStart = function () {
        if (null !== goBackId) {
            clearInterval(goBackId);
            goBackId = null;
        }

        goBackId = setTimeout(function () {
            if (null !== goBackId) {
                clearInterval(goBackId);
                goBackId = null;
            }

            // Main page
            document.location.href = '/';
        }, goBackTimeout);
    };

    ['scroll', 'mousemove', 'mousedown', 'mouseup'].forEach(function (type) {
        window.addEventListener(type, function () {
            if (null !== goBackId) {
                goBackStart();
            }
        });
    });

    // Init
    setTimeout(goBackStart, 1);

    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

// Produce
;(function () {
    'use strict';

    function init() {

    var byId = function (id) { return document.getElementById(id); };
    var qa = function (selector, root) {
        return Array.prototype.slice.call((root || document).querySelectorAll(selector));
    };
    var fireChange = function (el) {
        el.dispatchEvent(new Event('change', {bubbles: true}));
    };

    // курьерская доставка
    function updateDoorOrganizationResult() {
        var orgInput = byId('doorOrganization');
        var addrInput = byId('doorLegalAddress');
        if (!orgInput || !addrInput) return;
        if (orgInput.value.length > 0 && addrInput.value.length > 0) {
            qa('.bin-result-door').forEach(function (el) {
                el.innerHTML = orgInput.value;
                el.classList.remove('error');
            });
        }
    }
    updateDoorOrganizationResult();
    ['doorOrganization', 'doorLegalAddress'].forEach(function (id) {
        var el = byId(id);
        if (el) el.addEventListener('change', updateDoorOrganizationResult);
    });

    // пункты
    function updateOrganizationResult() {
        var orgInput = byId('organization');
        var addrInput = byId('legalAddress');
        if (!orgInput || !addrInput) return;
        if (orgInput.value.length > 0 && addrInput.value.length > 0) {
            qa('.bin-result').forEach(function (el) {
                el.innerHTML = orgInput.value;
                el.classList.remove('error');
            });
        }
    }
    updateOrganizationResult();
    ['organization', 'legalAddress'].forEach(function (id) {
        var el = byId(id);
        if (el) el.addEventListener('change', updateOrganizationResult);
    });

    var bindLegalToggle = function (checkboxId) {
        var checkbox = byId(checkboxId);
        if (!checkbox) return;
        checkbox.addEventListener('change', function () {
            var toggled = null;
            var next = checkbox.nextElementSibling;
            while (next) {
                if (next.classList && next.classList.contains('toggled')) { toggled = next; break; }
                next = next.nextElementSibling;
            }
            if (!toggled) return;
            toggled.querySelectorAll('input').forEach(function (input) {
                input.disabled = !checkbox.checked;
                input.required = checkbox.checked;
            });
        });
    };
    bindLegalToggle('legalAddres');
    bindLegalToggle('doorLegalAddres');

    var bindBinInput = function (inputId, door) {
        var input = byId(inputId);
        if (!input) return;
        input.addEventListener('input', function () {
            if (input.value.length === 12) {
                getInfoByBIN(input.value, door);
            }
        });
    };
    bindBinInput('doorBin', true);
    bindBinInput('bin', false);

    function getInfoByBIN(bin, door) {
        fetch('/ajax/location.php?check=bin&bin=' + encodeURIComponent(bin), {
            credentials: 'same-origin',
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        }).then(function (res) { return res.json(); }).then(function (response) {
            var orgId = door ? 'doorOrganization' : 'organization';
            var addrId = door ? 'doorLegalAddress' : 'legalAddress';
            var resultSel = door ? '.bin-result-door' : '.bin-result';

            var orgInput = byId(orgId);
            var addrInput = byId(addrId);

            if (response && response.name && response.adres) {
                if (orgInput) { orgInput.value = response.name; fireChange(orgInput); }
                if (addrInput) { addrInput.value = response.adres; fireChange(addrInput); }
            } else {
                qa(resultSel).forEach(function (el) {
                    el.textContent = (response && response.error) ? response.error : '';
                    el.classList.add('error');
                });
                if (orgInput) { orgInput.value = ''; fireChange(orgInput); }
                if (addrInput) { addrInput.value = ''; fireChange(addrInput); }
            }
        })['catch'](function () {});
    }

    // Клик по плашке «+N» в миниатюрах — открыть все фото товара в лайтбоксе.
    // Собираем ссылки из DOM при каждом клике, чтобы переживать AJAX-смену вида.
    document.addEventListener('click', function (e) {
        if (typeof GLightbox === 'undefined') return;
        var more = e.target && e.target.closest ? e.target.closest('.add-photos-more') : null;
        if (!more) return;

        var table = more.closest('.table');
        var elements = table ? qa('.produce-gallery .produce-gallery-item', table).map(function (a) {
            return { href: a.getAttribute('href'), type: 'image' };
        }) : [];
        if (!elements.length) return;

        flipLightbox({
            elements: elements,
            startAt: parseInt(more.getAttribute('data-gallery-start'), 10) || 0
        }).open();
    });

    // Клик по главному фото в зоне ховер-зума — открыть все фото товара
    // в лайтбоксе с текущего кадра
    document.addEventListener('click', function (e) {
        if (typeof GLightbox === 'undefined') return;

        const anchor = e.target && e.target.closest ? e.target.closest('.imgbox a.cloud-zoom') : null;
        const href = anchor ? anchor.getAttribute('href') : null;
        if (!href) return;

        e.preventDefault();

        let elements = Array.from(document.querySelectorAll('.produce-gallery .produce-gallery-item'))
            .map(function (a) { return {href: a.getAttribute('href'), type: 'image'}; });
        if (!elements.length) {
            elements = Array.from(document.querySelectorAll('.add-photos .clothes-img-select'))
                .map(function (a) { return {href: a.getAttribute('href'), type: 'image'}; });
        }
        if (!elements.length) {
            elements = [{href: href, type: 'image'}];
        }

        // Дедуп по href: при единственном фото GLightbox сам прячет стрелки
        const seenHrefs = new Set();
        elements = elements.filter(function (el) {
            if (!el.href || seenHrefs.has(el.href)) return false;
            seenHrefs.add(el.href);
            return true;
        });

        let startAt = elements.findIndex(function (el) { return el.href === href; });
        if (startAt < 0) startAt = 0;

        flipLightbox({
            elements: elements,
            startAt: startAt
        }).open();
    });

    // Карточка без вариантов (produce.tpl): ховер по миниатюре — предпросмотр
    // в основном фото, клик фиксирует; на основном фото — лупа
    var prodGallery = document.querySelector('#prod .prod_gallery');
    var prodMainImg = byId('main-image-zoom');

    if (prodGallery && prodMainImg) {
        var prodZoom = null;
        var prodSavedSrc = null;

        var initProdZoom = function () {
            if (prodZoom) prodZoom.destroy();
            var anchor = prodMainImg.parentElement;
            prodZoom = anchor.classList.contains('cloud-zoom') ? flipImageZoom(anchor) : null;
        };

        var prodThumb = function (e) {
            var thumb = e.target && e.target.closest ? e.target.closest('.clothes-img-select') : null;
            if (!thumb || !prodGallery.contains(thumb)) return null;
            return e.relatedTarget && thumb.contains(e.relatedTarget) ? null : thumb;
        };

        prodGallery.addEventListener('mouseover', function (e) {
            var thumb = prodThumb(e);
            var preview = thumb ? thumb.getAttribute('href') : null;
            if (!preview) return;

            if (prodSavedSrc === null) prodSavedSrc = prodMainImg.getAttribute('src') || '';
            var restore = prodSavedSrc;
            prodMainImg.onerror = function () {
                prodMainImg.onerror = null;
                prodMainImg.setAttribute('src', restore);
            };
            prodMainImg.setAttribute('src', preview);
        });

        prodGallery.addEventListener('mouseout', function (e) {
            if (!prodThumb(e) || prodSavedSrc === null) return;
            prodMainImg.onerror = null;
            prodMainImg.setAttribute('src', prodSavedSrc);
            prodSavedSrc = null;
        });

        prodGallery.addEventListener('click', function (e) {
            var thumb = e.target && e.target.closest ? e.target.closest('.clothes-img-select') : null;
            if (!thumb || !prodGallery.contains(thumb)) return;
            e.preventDefault();

            var href = thumb.getAttribute('href');
            qa('.clothes-img-select', prodGallery).forEach(function (el) {
                el.classList.toggle('active', el === thumb);
            });

            // Уход курсора с миниатюры не должен откатить выбранное фото
            prodSavedSrc = href;
            prodMainImg.onerror = null;
            prodMainImg.setAttribute('src', href);
            if (prodMainImg.parentElement.classList.contains('cloud-zoom')) {
                prodMainImg.parentElement.setAttribute('href', href);
            }
            initProdZoom();
        });

        initProdZoom();
    }

    var contents = byId('contents');
    var contentsLayer = byId('contentsLayerNew');

    if (contents && contentsLayer) {
        var koef = 0;

        var animateImgWidth = function (img, width) {
            if (img.getAttribute('data-animated')) return;
            img.setAttribute('data-animated', 'true');
            img.style.transition = 'width 0.5s, margin-bottom 0.5s';
            img.style.width = width + 'px';
            img.style.marginBottom = (width * koef) + 'px';
            setTimeout(function () {
                img.style.transition = '';
                img.removeAttribute('data-animated');
            }, 520);
        };

        qa('.zoom.in', contentsLayer).forEach(function (btn) {
            btn.addEventListener('click', function () {
                qa('.zooming img', contentsLayer).forEach(function (img) {
                    var yScroll = contentsLayer.querySelector('.y-scroll');
                    var zoomingWidth = yScroll ? yScroll.clientWidth : 0;
                    var width = img.getBoundingClientRect().width * 2;
                    if (width > zoomingWidth) {
                        width = zoomingWidth;
                    }
                    animateImgWidth(img, width);
                });
            });
        });

        qa('.zoom.out', contentsLayer).forEach(function (btn) {
            btn.addEventListener('click', function () {
                qa('.zooming img', contentsLayer).forEach(function (img) {
                    var width = img.getBoundingClientRect().width / 2;
                    if (width < 400) {
                        width = 400;
                    }
                    animateImgWidth(img, width);
                });
            });
        });

        qa('.close_button', contentsLayer).forEach(function (btn) {
            btn.addEventListener('click', function (event) {
                // Stop event
                event.preventDefault();

                // Close contents-layer
                contentsLayer.style.display = 'none';
            });
        });

        qa('.content', contentsLayer).forEach(function (el) {
            el.addEventListener('click', function (event) {
                event.stopPropagation();
            });
        });

        qa('.bg', contentsLayer).forEach(function (el) {
            el.addEventListener('click', function () {
                contentsLayer.style.display = 'none';
            });
        });

        contents.addEventListener('click', function (event) {
            // Stop event
            event.preventDefault();

            contentsLayer.style.opacity = '0';
            contentsLayer.style.display = '';
            contentsLayer.style.transition = 'opacity 0.4s';
            requestAnimationFrame(function () {
                contentsLayer.style.opacity = '1';
            });
            setTimeout(function () {
                contentsLayer.style.transition = '';
                contentsLayer.style.opacity = '';
            }, 420);

            var img = contentsLayer.querySelector('.zooming img');
            if (img) {
                koef = parseInt(getComputedStyle(img).marginBottom) / img.getBoundingClientRect().width;
            }
        });

        contentsLayer.style.display = 'none';
    }

    var blocksFormOrderValue = null;

    document.addEventListener('change', function (event) {
        var input = event.target && event.target.closest ? event.target.closest('#formorder div.sort input[name="order"]') : null;
        if (!input) return;

        var value = input.value;

        if (!(value)) {
            value = null;
        }

        if (null === blocksFormOrderValue || blocksFormOrderValue != value) {
            blocksFormOrderValue = value;

            // Send
            var form = byId('formorder');
            if (form) form.submit();
        }
    });

    // Открытие/закрытие списка сортировки по клику (вместо hover)
    document.addEventListener('click', function (event) {
        var active = event.target && event.target.closest ? event.target.closest('#formorder div.sort div.active') : null;
        if (active) {
            event.preventDefault();
            event.stopPropagation();

            var sort = active.closest('div.sort');
            var wasOpen = sort.classList.contains('open');

            qa('#formorder div.sort').forEach(function (el) { el.classList.remove('open'); });

            if (!wasOpen) {
                sort.classList.add('open');
            }
            return;
        }

        if (!(event.target && event.target.closest && event.target.closest('#formorder div.sort'))) {
            qa('#formorder div.sort').forEach(function (el) { el.classList.remove('open'); });
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
            qa('#formorder div.sort.open').forEach(function (el) { el.classList.remove('open'); });
        }
    });

    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

;(function () {
    'use strict';

    function init() {

    // Ленивый колбэк по появлению элемента; упреждение из data-appear-top-offset
    var onAppear = function (el, callback) {
        var offset = parseInt(el.getAttribute('data-appear-top-offset'), 10) || 0;
        var observer = new IntersectionObserver(function (entries) {
            if (!entries[entries.length - 1].isIntersecting) {
                return;
            }
            if (callback() === false) {
                // вкладка в фоне — перепроверить на следующем кадре
                observer.unobserve(el);
                observer.observe(el);
                return;
            }
            observer.disconnect();
        }, {rootMargin: offset + 'px 0px ' + offset + 'px 0px'});
        observer.observe(el);
    };

    var producePartsRelations = 'produce-parts-relations';

    var defaultLimit = 30;

    var postProduce = function (params, onData) {
        var body = new URLSearchParams();
        Object.keys(params).forEach(function (key) {
            body.append(key, params[key] == null ? '' : params[key]);
        });
        fetch('/ajax/produce.php', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            body: body
        }).then(function (res) { return res.text(); }).then(onData)['catch'](function () {});
    };

    var layerParts = document.getElementById(producePartsRelations);
    if (layerParts) {
        var loadHash = null;
        var load = function () {
            var layer = layerParts.querySelector('div');

            if (!layer) {
                // Skip
                return;
            }

            var parent = layer.getAttribute('data-id-parent');
            var produce = layer.getAttribute('data-id-produce');

            var loadHashCurrent = layer.getAttribute('data-relations-hash');
            var limit = layer.getAttribute('data-limit') || defaultLimit;

            var changed = null === loadHash || loadHash !== loadHashCurrent;

            if (changed) {
                loadHash = loadHashCurrent;

                var appearedContent = document.querySelector('#' + producePartsRelations + ' ~ div.' + producePartsRelations);
                var appeared = false;

                if (!appearedContent) {
                    appearedContent = document.createElement('div');
                    appearedContent.className = producePartsRelations;
                    layerParts.insertAdjacentElement('afterend', appearedContent);
                }

                onAppear(layer, function () {
                    if (!!(appeared)) {
                        return;
                    }
                    if (!(app.visible)) {
                        return false; // вкладка в фоне — перепроверить позже
                    }
                    appeared = true;

                    postProduce({ 'relations-produce': produce, 'relations-parent': parent, 'exlude_ids_client': 1, 'limit': limit, 'images-size': 240, 'template': 'produce-relations', 'lang': document.documentElement.getAttribute('lang') }, function (data) {
                        if (data && data.length) {
                            flipSetContent(appearedContent, data, false, { noScripts: true });
                            imgScroll();
                        }
                    });
                });
            }
        };

        layerParts.addEventListener('check-changes', function () {
            load();
        });

        load();
    }

    var recommendedLayer = document.getElementById('recommended-layer');
    if (recommendedLayer) {
        (function () {
            var produce = recommendedLayer.getAttribute('data-id-produce');
            var limit = recommendedLayer.getAttribute('data-limit') || defaultLimit;
            var appeared = false;

            if (!!produce) {
                onAppear(recommendedLayer, function () {
                    if (!!(appeared)) {
                        return;
                    }
                    if (!(app.visible)) {
                        return false; // вкладка в фоне — перепроверить позже
                    }
                    appeared = true;

                    postProduce({ 'similars-keywords': produce, 'exlude_ids_client': 1, 'limit': limit, 'images-size': 240, 'template': 'produce-recommended', 'lang': document.documentElement.getAttribute('lang') }, function (data) {
                        if (data && data.length) {
                            flipSetContent(recommendedLayer, data, false, { noScripts: true });
                            imgScroll();
                        }
                    });
                });
            }
        }());
    }

    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();


// Центрированный диалог-карточка: закрывается тапом по фону, Escape
// или элементом с классом .flip-dialog-close внутри контента
var showFlipDialog = function (params) {

    var old = document.getElementById('flip-dialog');
    if (old) old.remove();

    var holder = document.createElement('div');
    holder.innerHTML = '<div class="flip-dialog" id="flip-dialog">' +
        '<div class="flip-dialog-dim"></div>' +
        '<div class="flip-dialog-body" role="dialog" aria-modal="true">' +
            '<button type="button" class="flip-dialog-x flip-dialog-close" aria-label="Закрыть">&times;</button>' +
        '</div>' +
    '</div>';
    var dialog = holder.firstElementChild;

    document.body.appendChild(dialog);
    flipSetContent(dialog.querySelector('.flip-dialog-body'), params['content'], true);

    var closed = false;

    var onKeydown = function (e) {
        if (e.key === 'Escape') {
            close();
        }
    };

    var close = function () {
        if (closed) {
            return;
        }
        closed = true;

        document.removeEventListener('keydown', onKeydown);
        dialog.classList.remove('open');

        setTimeout(function () {
            dialog.remove();

            if (params['close'] && typeof params['close'] === 'function') {
                params['close'].call();
            }
        }, 250);
    };

    dialog.querySelector('.flip-dialog-dim').addEventListener('click', close);
    dialog.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('.flip-dialog-close')) {
            close();
        }
    });
    document.addEventListener('keydown', onKeydown);

    requestAnimationFrame(function () {
        dialog.classList.add('open');
    });

    return {
        close: close
    }
};

var showModal = function (params) {

    var content = '';
    var title = '';
    var id = 'modal-default';

    if (params['content']) {
        content = params['content'];
    }

    if (params['modalId']) {
        id = params['modalId'];
    }

    if (params['title']) {
        title = '<div class="title condent">' + params['title'] + '</div>';
    }

    var buttons = '<hr noshade="" size="1" color="#FFBD00"><a class="yellow nbtn float-right">Сохранить</a><a class="gray nbtn float-left close_button">Отмена</a>';

    if (params['buttons']) {
        buttons = params['buttons'];
    }

    if (params['onlyClose']) {
        buttons = '';
    }

    var holder = document.createElement('div');
    holder.innerHTML = '<div id="' + id + '" class="modal-bg table modal-show' + (params['modalClass'] ? ' ' + params['modalClass'] : '') + '">' +
        '<div class="modal-cell"><div class="modal' + (params['modalClass'] ? ' ' + params['modalClass'] : '') + '">' +
            '<div class="close top close_button">×</div>' + title +
        '<div class="loaded" style="display: block;">' +
            '</div>' +
            '<div class="buttons">' + buttons + '</div>' +
            '</div>' +
            '</div>' +
            '</div>';
    var modal = holder.firstElementChild;

    flipSetContent(modal.querySelector('.loaded'), content, true);

    document.body.appendChild(modal);

    var removeModal = function () {
        modal.remove();
    };

    if (!params['disableEvents']) {
        modal.querySelectorAll('.yellow').forEach(function (el) {
            el.addEventListener('click', function () {
                if (params['success'] && typeof params['success'] === 'function') {
                    params['success'].call();
                }
                if (params && !params['notCloseInSuccess']) {
                    removeModal();
                }
            });
        });

        modal.querySelectorAll('.close_button').forEach(function (el) {
            el.addEventListener('click', function () {
                if (params['close'] && typeof params['close'] === 'function') {
                    params['close'].call();
                }
                removeModal();
            });
        });
    }

    if (params['afterShow'] && typeof params['afterShow'] === 'function') {
        params['afterShow'].call();
    }

    modal.classList.add('modal-show');

    return {
        close: function () {
            var btn = modal.querySelector('.close_button');
            if (btn) btn.click();
        },
        content: function (e) {
            flipSetContent(modal.querySelector('.loaded'), e);
        }
    }
};

var showMessage = function (text, type) {
    if (!type) {
        type = "m_error";
    }
    var holder = document.createElement('div');
    holder.innerHTML = '<div class="mess ' + type + '">' + text + '</div>';
    var div = holder.firstElementChild;
    document.querySelectorAll('.message-block').forEach(function (block) {
        block.replaceChildren(div);
    });
    setTimeout(function () {
        div.style.transition = 'opacity 0.5s';
        div.style.opacity = '0';
        setTimeout(function () { div.remove(); }, 520);
    }, 10000)
};

/**
 * Countdown
 */
;(function () {
    'use strict';

    function init() {

    var qa = function (selector, root) {
        return Array.prototype.slice.call((root || document).querySelectorAll(selector));
    };
    var isVisible = function (el) {
        return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    };
    var hide = function (el) {
        el.style.display = 'none';
    };
    var show = function (el) {
        el.style.display = '';
        if (getComputedStyle(el).display === 'none') {
            el.style.display = 'block';
        }
    };

    var countdown = document.querySelector('[data-countdown-date]');
    if (countdown) {
        var startDate = countdown.getAttribute('data-countdown-date');
        var daysElements = qa('[data-countdown-days]', countdown);
        var daysTitleElements = qa('[data-countdown-days-title]', countdown);
        var daysHideElements = qa('[data-countdown-days-hide]', countdown);
        var hoursElements = qa('[data-countdown-hours]', countdown);
        var hoursTitleElements = qa('[data-countdown-hours-title]', countdown);
        var minutesElements = qa('[data-countdown-minutes]', countdown);
        var minutesTitleElements = qa('[data-countdown-minutes-title]', countdown);
        var secondsElements = qa('[data-countdown-seconds]', countdown);
        var secondsHideElements = qa('[data-countdown-seconds-hide]', countdown);
        var secondsTitleElements = qa('[data-countdown-seconds-title]', countdown);

        var setText = function (elements, text) {
            elements.forEach(function (el) { el.textContent = text; });
        };

        var timeFormat = function (time) {
            if (time < 10) {
                return '0' + time;
            }

            return time;
        };

        var countdownInterval;
        var declOfNum = function (number, words) {
            return words[(number % 100 > 4 && number % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ? Math.abs(number) % 10 : 5]];
        };
        var calculationTime = function () {

            if (!countdownInterval) {
                countdownInterval = setInterval(calculationTime, 1000);
            }

            var diff = Math.ceil((new Date(startDate) - new Date()) / 1000);

            if (diff < 0) {
                clearInterval(countdownInterval);

                var successUrl = countdown.getAttribute('data-countdown-url');

                if (successUrl) {
                    window.location.href = successUrl;
                } else {
                    window.location.reload();
                }
            } else {
                var days = Math.floor(diff / (24 * 60 * 60));
                if (daysElements.length) {
                    if (days > 0) {
                        setText(daysElements, timeFormat(days));
                        setText(daysTitleElements, declOfNum(days, ['день', 'дня', 'дней']));
                        secondsHideElements.forEach(hide);
                    } else {
                        daysHideElements.forEach(hide);
                        secondsHideElements.forEach(show);
                    }
                    diff = diff - (days * 24 * 60 * 60);
                }

                var hours = Math.floor(diff / (60 * 60));
                setText(hoursElements, timeFormat(hours));
                setText(hoursTitleElements, declOfNum(hours, ['час', 'часа', 'часов']));

                diff = diff - (hours * 60 * 60);

                var minutes = Math.floor(diff / (60));
                setText(minutesElements, timeFormat(minutes));
                setText(minutesTitleElements, declOfNum(minutes, ['минута', 'минуты', 'минут']));

                diff = diff - (minutes * 60);
                setText(secondsElements, timeFormat(diff));
                setText(secondsTitleElements, declOfNum(diff, ['секунда', 'секунды', 'секунд']));

                var visibleFields = qa('.countdown-field', countdown).filter(isVisible);
                if (visibleFields.length) {
                    visibleFields[visibleFields.length - 1].classList.add('last');
                    visibleFields[0].classList.add('first');
                }
            }
        };

        calculationTime();
    }

    var selector = document.getElementById('delivery-date-selector');

    if (selector) {
        // Узлы контента живут вне DOM между открытиями модалки —
        // выбранные дата/время сохраняются
        var wrap = document.createElement('div');
        wrap.innerHTML = selector.innerHTML;
        var contentNodes = Array.prototype.slice.call(wrap.children);
        selector.innerHTML = '';

        var findIn = function (sel) {
            var out = [];
            contentNodes.forEach(function (node) {
                out.push.apply(out, node.querySelectorAll(sel));
            });
            return out;
        };

        qa('.change-delivery-date, .set-delivery-date').forEach(function (btn) {
            btn.addEventListener('click', function () {
                findIn('.delivery-error').forEach(hide);
                findIn('.date-time-select').forEach(function (el) {
                    el.addEventListener('click', function () {
                        findIn('.delivery-error').forEach(hide);
                    });
                });
                findIn('.date-select-time').forEach(function (el) {
                    el.addEventListener('click', function () {
                        findIn('.date-time:not(:checked) + .date-time .dataselect-list input').forEach(function (input) {
                            input.checked = false;
                        });
                    });
                });
                const modal = showModal({
                    notCloseInSuccess: true,
                    content: contentNodes,
                    success: function () {
                        findIn('.delivery-error').forEach(hide);
                        let isValid = true;
                        findIn('input, textarea, select').forEach(function (el) {
                            isValid = isValid && el.checkValidity();
                        });
                        if (isValid) {
                            contentNodes.forEach(function (node) {
                                if (node.tagName === 'FORM' && node.dispatchEvent(new Event('submit', {bubbles: true, cancelable: true}))) {
                                    node.submit();
                                }
                            });
                            modal.close();
                            return true;
                        } else {
                            findIn('.delivery-error').forEach(show);
                        }
                        return false;
                    }
                });

            });
        });
    }

    var nextAll = function (el, selector) {
        var out = [];
        var next = el.nextElementSibling;
        while (next) {
            if (!selector || (next.matches && next.matches(selector))) {
                out.push(next);
            }
            next = next.nextElementSibling;
        }
        return out;
    };

    qa('.send-resume').forEach(function (btn) {
        btn.addEventListener('click', function (event) {

            var fileInput = btn.previousElementSibling;
            if (!fileInput) return;

            if (fileInput._sendResumeChange) {
                fileInput.removeEventListener('change', fileInput._sendResumeChange);
            }
            fileInput._sendResumeChange = function () {
                fileInput.insertAdjacentHTML('afterend', '<p>Выбран файл: ' + fileInput.value + '</p>');
                hide(btn);
                nextAll(btn).forEach(show);
            };
            fileInput.addEventListener('change', fileInput._sendResumeChange);

            nextAll(btn, '.send-resume-cancel').forEach(function (cancel) {
                if (cancel._sendResumeCancel) {
                    cancel.removeEventListener('click', cancel._sendResumeCancel);
                }
                cancel._sendResumeCancel = function (e) {
                    fileInput.value = '';
                    var p = fileInput.nextElementSibling;
                    if (p && p.tagName === 'P') p.remove();
                    show(btn);
                    nextAll(btn).forEach(hide);

                    e.preventDefault();
                    e.stopPropagation();
                };
                cancel.addEventListener('click', cancel._sendResumeCancel);
            });

            fileInput.click();
            event.preventDefault();
            event.stopPropagation();
        });
    });

    qa('[data-toggle-element]').forEach(function (el) {
        el.addEventListener('click', function (e) {
            qa(el.getAttribute('data-toggle-element')).forEach(function (target) {
                if (isVisible(target)) {
                    hide(target);
                } else {
                    show(target);
                }
            });
            e.preventDefault();
            e.stopPropagation();
        });
    });

    qa('.unfolding-block').forEach(function (block) {
        var cs = getComputedStyle(block);
        var height = block.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
        if (height > 900) {
            var line = block.querySelector('.shadow-line');
            var controls = block.parentElement ? block.parentElement.previousElementSibling : null;
            if (line) show(line);
            if (controls) show(controls);
        }
    });

    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

;(function () {

    function flipMainInit() {

    const qa = function (selector, root) {
        return Array.prototype.slice.call((root || document).querySelectorAll(selector));
    };
    const vShow = function (el) {
        if (!el) return;
        el.style.display = '';
        if (getComputedStyle(el).display === 'none') {
            el.style.display = 'block';
        }
    };
    const vHide = function (el) {
        if (el) el.style.display = 'none';
    };
    const vIsVisible = function (el) {
        return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    };
    const vSlideDown = function (el, ms, callback) {
        el.style.removeProperty('display');
        if (getComputedStyle(el).display === 'none') el.style.display = 'block';
        const target = el.scrollHeight;
        el.style.overflow = 'hidden';
        el.style.height = '0px';
        el.getBoundingClientRect();
        el.style.transition = 'height ' + ms + 'ms';
        el.style.height = target + 'px';
        setTimeout(function () {
            el.style.transition = '';
            el.style.height = '';
            el.style.overflow = '';
            if (callback) callback();
        }, ms + 20);
    };
    const vSlideUp = function (el, ms) {
        el.style.overflow = 'hidden';
        el.style.height = el.scrollHeight + 'px';
        el.getBoundingClientRect();
        el.style.transition = 'height ' + ms + 'ms';
        el.style.height = '0px';
        setTimeout(function () {
            el.style.display = 'none';
            el.style.transition = '';
            el.style.height = '';
            el.style.overflow = '';
        }, ms + 20);
    };
    // jQuery .submit(): сначала обработчики, потом нативная отправка
    const vSubmitForm = function (form) {
        if (form && form.dispatchEvent(new Event('submit', {bubbles: true, cancelable: true}))) {
            form.submit();
        }
    };
    // Глубокая сериализация в стиле jQuery.param: массив объектов → k[0][x],
    // массив скаляров → k[], вложенный объект → k[x]; null/undefined → ''
    const flipParam = function (obj) {
        const params = new URLSearchParams();
        const add = function (key, value) {
            params.append(key, value == null ? '' : value);
        };
        const build = function (prefix, value) {
            if (Array.isArray(value)) {
                value.forEach(function (item, i) {
                    if (/\[\]$/.test(prefix)) {
                        add(prefix, item);
                    } else {
                        build(prefix + '[' + (typeof item === 'object' && item !== null ? i : '') + ']', item);
                    }
                });
            } else if (typeof value === 'object' && value !== null) {
                for (const name in value) {
                    build(prefix + '[' + name + ']', value[name]);
                }
            } else {
                add(prefix, value);
            }
        };
        for (const key in obj) {
            build(key, obj[key]);
        }
        return params;
    };

    // Семантика $.ajax dataType:'json': не-2xx статус и битый JSON уходят в fail
    const fetchJSON = function (url, opts, ok, fail) {
        fetch(url, Object.assign({ credentials: 'same-origin', headers: {'X-Requested-With': 'XMLHttpRequest'} }, opts))
            .then(function (res) {
                if (!res.ok) throw new Error('HTTP ' + res.status);
                return res.json();
            })
            .then(function (data) { if (ok) ok(data); })
            ['catch'](function (err) { if (fail) fail(err); });
    };

    // /ajax/*.php живут вне языкового роутинга: язык там берётся только из GET `lang`,
    // префикс `/kk` в пути не помогает. Для /location и прочих mod-страниц префикс пути
    // по-прежнему достаточен.
    const ajaxLangSuffix = location.pathname.indexOf('/kk') === 0 ? '&lang=kk' : '';

    const locationLayer = document.getElementById('modalLocation');
    if (locationLayer) {
        // Скролл-лок фона: пока модалка открыта, страница позади не прокручивается
        // (колесо над списком/картой уносило фон и «теряло» модалку).
        const syncLocationScrollLock = function () {
            document.body.classList.toggle('location-modal-open', vIsVisible(locationLayer));
        };
        new MutationObserver(syncLocationScrollLock)
            .observe(locationLayer, { attributes: true, attributeFilter: ['style', 'class'] });
        syncLocationScrollLock();
        let isMapShowed = false;
        let addressMap = null;
        // ymaps3 api-объект (YmapsV3.ready). Хранится, чтобы пересоздавать кластерер на pan/reload.
        let mapApi = null;
        let clusterer = null;
        // Метка "Моё местоположение" для door-режима. Создаётся один раз и переиспользуется.
        let myLocationPlacemark = null;
        // Слушатель движений карты (v3 YMapListener). Один на карту.
        let mapListener = null;
        // Собственный реестр top-level объектов карты (v3 не предоставляет geoObjects-коллекцию).
        // Все YMapMarker/clusterer, добавленные через addOnce, регистрируются здесь.
        let mapChildren = [];
        // Кэш активного режима switcher ('pick' | 'door').
        // Используется в hot-path обработчиков карты вместо jQuery DOM lookup на каждый кадр.
        let currentLocationSwitcher = 'pick';
        // Сохраняем последний zoom pick-режима — чтобы при возврате с door восстановить его.
        let lastPickZoom = null;
        // Snapshot top-level гео-объектов pick-режима (clusterer + все Flip-ПВЗ-метки).
        // При переключении на door всё снимаем с карты, при возврате — добавляем обратно.
        let pickGeoObjectsSnapshot = [];
        // Якорь расстояний: точка отсчёта подписей и сортировки списка ПВЗ.
        // Геолокация браузера приоритетнее адреса из поиска; якорь дальше 30 км
        // от центра карты неактуален (смотрят другой город) — считаем от центра.
        let anchorGeo = null;           // [lat, lng] — геолокация браузера
        let anchorSearch = null;        // [lat, lng] — найденный адрес из поля поиска
        let anchorPlacemark = null;     // маркер точки отсчёта на карте (pick-режим)
        let lastSortAnchorType = null;  // 'geo' | 'search' | null — для тултипа расстояний
        let lastSortCenter = null;      // [lat, lng] последней сортировки
        let lastSortedPointsRef = null; // массив, для которого сортировали — гасит лишние перерисовки

        // Безопасное добавление/удаление гео-объектов на addressMap:
        // - addOnce: добавляет только если объекта ещё нет на карте (защита от дубликатов).
        // - removeOnce: удаляет только если объект на карте (защита от лишних вызовов).
        // Защищают от race-условий при повторных программных кликах на switcher.
        // В v3 нет map.geoObjects — ведём собственный реестр mapChildren и используем addChild/removeChild.
        const addOnce = function (geoObj) {
            if (!addressMap || !geoObj) return;
            if (mapChildren.indexOf(geoObj) === -1) {
                addressMap.addChild(geoObj);
                mapChildren.push(geoObj);
            }
        };
        const removeOnce = function (geoObj) {
            if (!addressMap || !geoObj) return;
            const idx = mapChildren.indexOf(geoObj);
            if (idx !== -1) {
                addressMap.removeChild(geoObj);
                mapChildren.splice(idx, 1);
            }
        };
        const selectedButtons = qa('#location-selected, #address-location-selected');
        const locationLayerResult = locationLayer.querySelector('#locations-result');
        const addressCreateLayout = locationLayer.querySelector('#address-create');
        const backToAddressesEls = qa('.back-to-addresses', locationLayer);
        const myAddressesList = [];

        const addressPointSearch = locationLayer.querySelector('#locationSearch');
        const pickPointLayout = locationLayer.querySelector('.pick-point-layout');
        const deliveryToDoorLayout = locationLayer.querySelector('.delivery-to-door-layout');
        const pickPointBackLayout = locationLayer.querySelector('.pickup-point-back');
        const doorAddressBackLayout = locationLayer.querySelector('.door-address-back');
        const selectedPickPintLayout = locationLayer.querySelector('.pickup-point-selected');
        const doorAddressSelectedLayout = locationLayer.querySelector('.door-address-selected');
        const pickPointChooseButton = locationLayer.querySelector('#pick-point-choose');
        const doorAddressChooseButton = locationLayer.querySelector('#door-address-choose');
        const locationAddressSearchInput = locationLayer.querySelector('#locationAddressSearch');
        const locationAddressErrorLayout = locationLayer.querySelector('#locationAddressError');
        // Тот же случай «адрес вне зоны», но в сценарии посылок у отправителя: курьер
        // не заберёт, а не «не доставим». Оба текста лежат в разметке, переключаем видимость.
        const locationAddressErrorPickupLayout = locationLayer.querySelector('#locationAddressErrorPickup');
        const locationAddressErrorExactLayout = locationLayer.querySelector('#locationAddressErrorExact');
        const doorContinueButton = locationLayer.querySelector('#door-continue');
        const mapCenterMarker = locationLayer.querySelector('.map-center-marker');
        const staticDomain = document.body.getAttribute('data-domain-static');
        const userLatitude = document.body.getAttribute('data-latitude');
        const userLongitude = document.body.getAttribute('data-longitude');
        // Адрес, выбранный в шапке сайта, — «моя точка» клиента (main.tpl).
        const selectedLatitude = document.body.getAttribute('data-selected-latitude');
        const selectedLongitude = document.body.getAttribute('data-selected-longitude');
        // Где клиент — опора карты: точная геопозиция браузера, иначе адрес из шапки,
        // иначе GeoIP (data-latitude). [lat, lng] или null.
        const homeAnchor = function () {
            const pairs = [
                [locationLatitude, locationLongitude],
                [selectedLatitude, selectedLongitude],
                [userLatitude, userLongitude]
            ];
            for (let i = 0; i < pairs.length; i++) {
                const lat = YmapsV3.toCoord(pairs[i][0]);
                const lng = YmapsV3.toCoord(pairs[i][1]);
                if (lat !== null && lng !== null) {
                    return [lat, lng];
                }
            }
            return null;
        };
        const defaultLatitude = 43.24457377984702;
        const defaultLongitude = 76.95768646341241;
        const placeMarks = {};
        // Прямые метки flip/partner (не кластеризуются, всегда видимы). Нужны, чтобы
        // снимать прежние при повторном addPointsToMap (reload).
        let officeMarkers = [];
        let currentPoint = null;
        // Вид карты (центр+зум) до открытия карточки пункта — для возврата «Назад».
        let cardReturnView = null;
        let addressPoints = [];
        let addToOrder = null;
        let updatedAddressId = null;
        let boundleBox = null;

        let locationLatitude = null;
        let locationLongitude = null;

        let doorAddressLatitude = null;
        let doorAddressLongitude = null;
        let doorSelectedAddress = null;

        let doorAddressCountry = null;
        let doorAddressArea = null;
        let doorAddressCity = null;

        let locationCity = null;

        let isExpressAddress = false;
        let externalSelectHandler = null;
        let externalSelectMeta = null;
        let lastLocationContext = null;

        const resetExternalSelect = function () {
            externalSelectHandler = null;
            externalSelectMeta = null;
            lastLocationContext = null;
            updateTitleForMode(null);
        };

        const hasExternalSelect = function () {
            return typeof externalSelectHandler === 'function';
        };

        const handleExternalSelect = function (address) {
            if (!hasExternalSelect()) {
                return false;
            }
            externalSelectHandler(address, externalSelectMeta || {});
            resetExternalSelect();
            vHide(locationLayer);
            return true;
        };
        const isDeliveryExternal = function () {
            return hasExternalSelect() && externalSelectMeta && externalSelectMeta.mode === 'delivery';
        };

        // Выбор получателя посылки: вместо своих адресов показываем тех, кому клиент
        // отправляет чаще всего.
        const isRecipientExternal = function () {
            return isDeliveryExternal() && externalSelectMeta.target === 'destination';
        };

        // Заголовок курьерского адреса зависит от роли точки: получателю курьер везёт,
        // отправителю — приезжает забирать.
        const courierAddressTitle = function () {
            const L10n = window.__locationL10n || {};

            if (isDeliveryExternal() && externalSelectMeta && externalSelectMeta.target === 'origin') {
                return L10n.courierPickup || 'Курьерский забор';
            }

            return L10n.courierDelivery || 'Курьерская доставка';
        };

        const appendDeliveryParams = function (url) {
            if (!isDeliveryExternal()) {
                return url;
            }
            const joiner = url.indexOf('?') === -1 ? '?' : '&';
            let result = url + joiner + 'delivery=1';
            if (externalSelectMeta.target === 'origin') {
                result += '&deliveryFrom=1';
            } else if (externalSelectMeta.target === 'destination') {
                result += '&deliveryTo=1';
                // Точки получения фильтруем по наличию тарифа из выбранной точки
                // отправления: без этого клиент выбирает адрес, заполняет получателя
                // и только на расчёте узнаёт, что маршрут нерасчётный.
                if (externalSelectMeta.originPresetId) {
                    result += '&fromPreset=' + encodeURIComponent(externalSelectMeta.originPresetId);
                }
                if (externalSelectMeta.originItem) {
                    result += '&fromItem=' + encodeURIComponent(externalSelectMeta.originItem);
                }
            }
            return result;
        };

        const getLocationContextKey = function () {
            if (isDeliveryExternal()) {
                return 'delivery:' + (externalSelectMeta.target || 'unknown');
            }
            return 'global';
        };

        const findAddressById = function (id) {
            if (!id || !myAddressesList.length) {
                return null;
            }
            for (const idx in myAddressesList) {
                if (myAddressesList[idx].id == id) {
                    return myAddressesList[idx];
                }
            }
            return null;
        };

        const getLatestAddress = function (criteria, callback) {
            let url = (location.pathname.indexOf('/kk') === 0 ? '/kk' : '') + '/location?addresses';
            if (isDeliveryExternal()) {
                url += '&delivery=1';
                if (externalSelectMeta.target === 'origin') {
                    url += '&deliveryFrom=1';
                } else if (externalSelectMeta.target === 'destination') {
                    url += '&deliveryTo=1';
                }
            }
            fetchJSON(url, null, function (data) {
                let selected = null;
                if (data && data.rows && data.rows.length) {
                    if (criteria) {
                        for (var i = 0; i < data.rows.length; i++) {
                            var row = data.rows[i];
                            if (criteria.deliveryMethod && row.deliveryMethod != criteria.deliveryMethod) {
                                continue;
                            }
                            if (criteria.deliveryMethodItem && row.deliveryMethodItem != criteria.deliveryMethodItem) {
                                continue;
                            }
                            if (criteria.phone && row.phone != criteria.phone) {
                                continue;
                            }
                            if (criteria.fullName && row.fullName != criteria.fullName) {
                                continue;
                            }
                            if (criteria.address && row.address != criteria.address) {
                                continue;
                            }
                            selected = row;
                            break;
                        }
                    }
                    if (!selected) {
                        selected = data.rows[0];
                    }
                }
                if (typeof callback === 'function') {
                    callback(selected);
                }
            });
        };

        const handleBackToAddresses = function () {
            vShow(locationLayerResult);
            vHide(addressCreateLayout);
            updatedAddressId = null;
        };
        backToAddressesEls.forEach(function (el) {
            el.addEventListener('click', handleBackToAddresses);
        });
        qa('.close_button', locationLayer).forEach(function (el) {
            el.addEventListener('click', function () {
                resetExternalSelect();
            });
        });
        // Делегируем: «пункт самовывоза рядом» живёт внутри переводимой строки ошибки,
        // а её разметку мы подменяем (у посылок причина другая). Прямая подписка на
        // элементы отваливалась бы после первой же подмены.
        // Фаза перехвата — чтобы stopPropagation, как и раньше, гасил клик до всех
        // прочих обработчиков документа.
        document.addEventListener('click', function (e) {
            const btn = e.target && e.target.closest ? e.target.closest('.picks-near') : null;
            if (!btn) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            // С единой картой центр уже на месте — просто переключаем switcher.
            const doorLabel = document.querySelector('.switcher #switcher-door-1 + label');
            if (doorLabel) doorLabel.click();
        }, true);

        qa('.switcher input', locationLayer).forEach(function (switcherInput) {
        switcherInput.addEventListener('change', function () {
            currentLocationSwitcher = this.value;
            if (currentLocationSwitcher === 'door') {
                // Door-режим: одна карта, переключаем её состояние.
                // — снимаем ВСЕ pick-объекты (clusterer + все office-метки), сохраняем в snapshot
                // — показываем метку "Моё местоположение" (если есть координаты)
                // — увеличиваем zoom до 17 (улицы)
                // — показываем фиксированный центральный маркер
                // — запрашиваем геокодинг текущего центра
                if (addressMap) {
                    lastPickZoom = addressMap.zoom;
                    // Собираем snapshot всех top-level объектов карты (кроме myLocationPlacemark,
                    // если он уже есть — этого не должно быть, но на всякий случай).
                    pickGeoObjectsSnapshot = [];
                    mapChildren.forEach(function (obj) {
                        if (obj !== myLocationPlacemark) {
                            pickGeoObjectsSnapshot.push(obj);
                        }
                    });
                    pickGeoObjectsSnapshot.forEach(removeOnce);
                    addOnce(myLocationPlacemark);
                    // Получатель посылки: его карта открывается обзорной (ПВЗ всей страны),
                    // центр — случайная точка в степи, и зум до улиц давал пустую белую
                    // карту. Тогда масштаб не трогаем: маркер встаёт по центру, клиент сам
                    // приближает нужный город или ищет адрес. Адрес под случайной точкой не
                    // определяем — geocodeMapCenter пропускает обзорный зум (lastPickZoom).
                    // Отправитель и «Мой адрес» — как раньше: сразу до улиц.
                    if (!isRecipientExternal() || addressMap.zoom >= 11) {
                        addressMap.setLocation({ zoom: 17 });
                    }
                    vShow(mapCenterMarker);
                    geocodeMapCenter();
                }
                handleBackClick();
                const switcherDoor2 = document.getElementById('switcher-door-2');
                if (switcherDoor2) {
                    switcherDoor2.checked = true;
                    switcherDoor2.setAttribute('checked', 'checked');
                }
                vHide(pickPointLayout);
                vShow(deliveryToDoorLayout);
            } else {
                // Pick-режим: возвращаем все pick-объекты из snapshot, скрываем маркер,
                // восстанавливаем pick-zoom, перестраиваем список ПВЗ под текущий центр.
                // Метку «Моё местоположение» не снимаем — позиция видна в обоих режимах.
                if (addressMap) {
                    if (pickGeoObjectsSnapshot.length) {
                        // Восстанавливаем все top-level объекты, что были до перехода в door.
                        pickGeoObjectsSnapshot.forEach(addOnce);
                        pickGeoObjectsSnapshot = [];
                    } else {
                        // Snapshot пуст — это первое переключение на pick (раньше door),
                        // используем clusterer как fallback.
                        addOnce(clusterer);
                    }
                    // Восстанавливаем pick-zoom (по умолчанию 11 — городские масштабы для ПВЗ).
                    addressMap.setLocation({ zoom: lastPickZoom !== null ? lastPickZoom : 11 });
                    vHide(mapCenterMarker);

                    // map.center в v3 -> [lng,lat]; состав точек от центра не зависит —
                    // пересортировка кэша на месте вместо запроса.
                    const c = addressMap.center;
                    if (c) {
                        resortPointsAround(c[1], c[0]);
                    }
                }
                const switcherPick1 = document.getElementById('switcher-pick-1');
                if (switcherPick1) {
                    switcherPick1.checked = true;
                    switcherPick1.setAttribute('checked', 'checked');
                }
                vHide(deliveryToDoorLayout);
                vShow(pickPointLayout);
            }
        });
        });

        // Esc закрывает модалку адреса (раньше — только крестик). При открытом
        // лайтбоксе фотографий не вмешиваемся — Esc сначала закрывает его.
        document.addEventListener('keydown', function (e) {
            if (e.key !== 'Escape' && e.keyCode !== 27) return;
            if (!vIsVisible(locationLayer)) return;
            if (document.querySelector('.glightbox-container')) return;
            vHide(locationLayer);
        });

        qa('.my-location', locationLayer).forEach(function (myLocationEl) {
        myLocationEl.addEventListener('click', function () {
            // Карта одна — переменная map больше не нужна, всегда addressMap.
            const type = this.getAttribute('data-type');
            const zoom = type === 'door' ? 17 : 14;
            const map = addressMap;
            if (locationLatitude && locationLongitude) {
                setCenter(map, [
                    {
                        latitude: locationLatitude,
                        longitude: locationLongitude,
                    }
                ], zoom);
                if (type === 'pick') {
                    // Явное «от меня»: поиск сбрасывается, список — от геопозиции.
                    anchorSearch = null;
                    addressPointSearch.value = '';
                    resortPointsAround(locationLatitude, locationLongitude);
                }
            } else if (userLongitude && userLongitude) {
                setCenter(map, [
                    {
                        latitude: userLatitude,
                        longitude: userLongitude,
                    }
                ], zoom);
            }
        });
        });

        const locationSelect = function () {
            let id = this.getAttribute('data-location-id');
            fetchJSON('/location?set=' + id, null, function (data) {
                if (data) {
                    vHide(locationLayer);
                    window.location.reload();
                }
            });
        };

        const clearOrderCookie = function () {
            flipCookie("method", null);
            flipCookie("reset_address", null);
            flipCookie("change_method", null);
            flipCookie("method_item", null);
            flipCookie("change_method_item", null);
            flipCookie("address", null);
            flipCookie("delmethod", null);
            addToOrder = null;
            updatedAddressId = null;
        }

        const executeAction = function (action) {
            if (action && action['action'] === 'redirect') {
                if (action['url']) {
                    window.location.href = action['url'];
                } else {
                    window.location.reload();
                }
            } else if (action && action['action'] === 'error') {
                showModal({
                    title: 'Ошибка',
                    content: action['error'],
                    onlyClose: true
                });
            }
        }

        const addressSelect = function () {
            let id = this.getAttribute('data-address-id');
            let idDeliveryPoint = this.getAttribute('data-delivery-point-id');
            let isCourier = this.getAttribute('data-courier');
            if (id) {
                const row = findAddressById(id);
                if (row && handleExternalSelect(row)) {
                    return;
                }
                let url = '/location?setAddress=' + id;
                if (addToOrder) {
                    url += '&idOrder=' + addToOrder;
                } else if (updatedAddressId) {
                    url += '&idAddress=' + updatedAddressId;
                }
                fetchJSON(url, null, function (data) {
                    if (data) {
                        if (data['action']) {
                            executeAction(data['action']);
                        } else {
                            clearOrderCookie();
                            vHide(locationLayer);
                            window.location.reload();
                        }
                    }
                });
            } else if (idDeliveryPoint) {
                showLocationModal();
                showCreateAddressLayout(function () {
                    const point = addressPoints.find(p => p.id == idDeliveryPoint);
                    if (point) {
                        selectPoint(point);
                    }
                });
            } else if (isCourier) {
                showLocationModal();
                showCreateAddressLayout(isExpressAddress = true);
            }
        }
        
        const PIN_Z = function (mapIcon) {
            switch (mapIcon) {
                case 'flip':     return 500;
                case 'partner':  return 490;
                case 'point':    return 400;
                case 'tastamat': return 300;
                case 'kazpost':  return 200;
                default:         return 100;
            }
        };

        // Фабрика маркера кластеризуемой точки (все типы: flip/partner/tastamat/kazpost).
        const clusterMarkerFactory = function (feature) {
            const point = feature.properties.point;
            const pinEl = buildAddrPinEl(point.map_icon);
            // Восстанавливаем selected-состояние: при declutter маркер пересоздаётся,
            // и без этого выбранный пин терял бы увеличение после перестроения кластерера.
            if (currentPoint && currentPoint.id === point.id) {
                pinEl.classList.add('selected');
            }
            const marker = new mapApi.ymaps3.YMapMarker({
                coordinates: feature.geometry.coordinates,
                draggable: false,
                zIndex: PIN_Z(point.map_icon) + (currentPoint && currentPoint.id === point.id ? 1000 : 0),
                onClick: function () { selectPoint(point); }
            }, pinEl);
            // Реестр для рестайла при выборе (кластерные пины тоже выбираемы).
            placeMarks[point.id] = { marker: marker, el: pinEl, map_icon: point.map_icon, type: 'cluster' };
            return marker;
        };

        // Фабрика DOM-элемента кластера (число точек внутри).
        // Визуал — как на contacts (w.flip.kz/contacts): белый полупрозрачный круг,
        // синяя заливка, белая цифра (.ymap3-cluster / __content / __text).
        const clusterFactory = function (coordinates, features) {
            const el = document.createElement('div');
            el.className = 'ymap3-cluster';
            const inner = document.createElement('div');
            inner.className = 'ymap3-cluster__content';
            const text = document.createElement('span');
            text.className = 'ymap3-cluster__text';
            text.textContent = features.length;
            inner.appendChild(text);
            el.appendChild(inner);
            return new mapApi.ymaps3.YMapMarker({
                coordinates: coordinates,
                zIndex: Math.max.apply(null, features.map(function (f) { return PIN_Z(f.properties.point.map_icon); })),
                onClick: function () {
                    const coords = features.map(function (f) { return f.geometry.coordinates; });
                    const lngs = coords.map(function (c) { return c[0]; });
                    const lats = coords.map(function (c) { return c[1]; });
                    const rawBounds = [
                        [Math.min.apply(null, lngs), Math.min.apply(null, lats)],
                        [Math.max.apply(null, lngs), Math.max.apply(null, lats)]
                    ];
                    if (YmapsV3.isCollapsedBounds(rawBounds)) {
                        addressMap.setLocation({ center: rawBounds[0], zoom: 16, duration: 200 });
                    } else {
                        addressMap.setLocation({ bounds: YmapsV3.padBounds(rawBounds, 0.2), duration: 200 });
                    }
                }
            }, el);
        };

        // Пересоздаёт кластерер с заданным набором features (v3 — декларативный, без add/removeAll).
        // Снимает старый кластерер с карты и добавляет новый. Сохраняет gridSize 80, maxZoom 15.
        // Сигнатура набора кластеризуемых точек — чтобы не пересоздавать кластерер,
        // если набор не изменился (детект изменений вместо безусловного recreate).
        let lastClustererSig = null;
        const clustererSig = function (features) {
            if (!features || !features.length) return '';
            return features.map(function (f) { return f.id; }).sort().join(',');
        };
        const rebuildClusterer = function (features) {
            if (!addressMap || !mapApi) return;
            const sig = clustererSig(features);
            // Набор тот же и кластерер уже на карте — пересоздание не нужно.
            if (clusterer && sig === lastClustererSig) {
                return;
            }
            if (clusterer) {
                removeOnce(clusterer);
                clusterer = null;
            }
            clusterer = new mapApi.YMapClusterer({
                method: mapApi.clusterByGrid({ gridSize: 80 }),
                features: features || [],
                marker: clusterMarkerFactory,
                cluster: clusterFactory,
                maxZoom: 15
            });
            addOnce(clusterer);
            lastClustererSig = sig;
        };

        // Строит DOM-пин ПВЗ (v3 рисует кастомные маркеры из HTML, без preset-иконок).
        // Якорь — нижний центр (CSS transform). z-index задаётся классом типа.
        const buildAddrPinEl = function (mapIcon) {
            const el = document.createElement('div');
            el.className = 'addr-pin addr-pin--' + mapIcon;
            const img = document.createElement('img');
            img.src = staticDomain + '/img/map/' + mapIcon + '.png';
            img.width = 44;
            img.height = 46;
            el.appendChild(img);
            return el;
        };

        const addPointsToMap = function (points) {
            // Снимаем прежние прямые метки flip/partner — addPointsToMap вызывается
            // повторно (reload/refresh), иначе старые метки накапливались бы.
            officeMarkers.forEach(removeOnce);
            officeMarkers = [];
            const clusterFeatures = [];
            for (var p in points) {
                const point = points[p];

                if (point.latitude && point.longitude) {
                    if (point.map_icon === 'flip' || point.map_icon === 'partner') {
                        // flip/partner — отдельные метки, всегда видимы (не кластеризуются).
                        const pinEl = buildAddrPinEl(point.map_icon);
                        if (currentPoint && currentPoint.id === point.id) {
                            pinEl.classList.add('selected');
                        }
                        const marker = new mapApi.ymaps3.YMapMarker({
                            coordinates: YmapsV3.flip(point.latitude, point.longitude),
                            draggable: false,
                            zIndex: PIN_Z(point.map_icon) + (currentPoint && currentPoint.id === point.id ? 1000 : 0),
                            onClick: (function (pt) { return function () { selectPoint(pt); }; })(point)
                        }, pinEl);
                        placeMarks[point.id] = { marker: marker, el: pinEl, map_icon: point.map_icon, type: 'marker' };
                        officeMarkers.push(marker);
                    } else {
                        // tastamat/kazpost — кластеризуются через YMapClusterer.
                        clusterFeatures.push({
                            type: 'Feature',
                            id: String(point.id),
                            geometry: { type: 'Point', coordinates: YmapsV3.flip(point.latitude, point.longitude) },
                            properties: { point: point }
                        });
                    }
                }
            }

            officeMarkers.forEach(addOnce);
            // Кластеризуемые точки: пересоздаём кластерер с новым набором features.
            rebuildClusterer(clusterFeatures);

            if (isDeliveryExternal() && externalSelectMeta && externalSelectMeta.target === 'destination' && points.length > 0) {
                // Для адреса получателя — показать все доступные пункты
                setCenter(addressMap, points);
            } else {
                // Остальные окна — вокруг клиента: геопозиция, адрес из шапки, GeoIP.
                const home = homeAnchor();
                if (home) {
                    setCenter(addressMap, [{ latitude: home[0], longitude: home[1] }]);
                }
            }
        }

        const handleBackClick = function () {
            // Возврат из карточки: карта возвращается к виду до открытия — список
            // остаётся согласованным с ней и не перестраивается (программный
            // setLocation не порождает action-событий).
            if (cardReturnView && addressMap && currentLocationSwitcher === 'pick') {
                addressMap.setLocation({ center: cardReturnView.center, zoom: cardReturnView.zoom, duration: 300 });
            }
            cardReturnView = null;
            clearSelectedOnMap();
            currentPoint = null;
            vHide(selectedPickPintLayout);
            vShow(pickPointLayout);

            const fullNameInput = document.getElementById('fullName');
            if (fullNameInput && fullNameInput.parentElement && fullNameInput.parentElement.classList.contains('form-element')) {
                fullNameInput.parentElement.classList.remove('error');
            }
            qa('.full-name-error').forEach(vHide);
            qa('.full-name-error-2').forEach(vHide);
        }

        if (pickPointBackLayout) pickPointBackLayout.addEventListener('click', handleBackClick);

        const clearSelectedOnMap = function () {
            if (addressPoints && addressPoints.length) {
                for (const p of addressPoints) {
                    const reg = placeMarks[p.id];
                    if (reg && reg.el) {
                        reg.el.classList.remove('selected');
                    }
                }
            }
        }

        const selectPoint = function (point) {

            clearSelectedOnMap();

            if (point && point.id) {
                currentPoint = point;
                const reg = placeMarks[point.id];
                if (reg && reg.el) {
                    reg.el.classList.add('selected');
                }
                const address = point.titleShort ? point.titleShort : point.title;
                const titleImg = selectedPickPintLayout.querySelector('.title img');
                if (point.icon && titleImg) {
                    titleImg.setAttribute('src', staticDomain + point.icon);
                }
                const toggles = qa('.toggle', selectedPickPintLayout);
                if (isDeliveryExternal()) {
                    toggles.forEach(vHide);
                } else if (point.map_icon && point.map_icon == 'flip') {
                    toggles.forEach(vShow);
                } else {
                    toggles.forEach(vHide);
                }
                const photosLayout = selectedPickPintLayout.querySelector('.photos');
                if (photosLayout) photosLayout.replaceChildren();
                if (point.photos && point.photos.length && photosLayout) {
                    let photosBlock = '<div class="map-img">';
                    for (var i in point.photos) {
                        photosBlock += '<a rel="nofollow" href="' + staticDomain + point.photos[i].url + '" class="gallery">' +
                            '<img src="' + staticDomain + point.photos[i].url + '" />' +
                            '</a>';
                    }
                    photosBlock += '<div>';
                    photosLayout.insertAdjacentHTML('beforeend', photosBlock);
                }
                const titleDiv = selectedPickPintLayout.querySelector('.title div');
                if (titleDiv) titleDiv.textContent = point.title;
                qa('.address', selectedPickPintLayout).forEach(function (el) { el.textContent = address; });
                qa('.info', selectedPickPintLayout).forEach(function (el) { el.textContent = point.workTime == null ? '' : point.workTime; });
                vHide(pickPointLayout);
                vShow(selectedPickPintLayout);

                if (point.photos && point.photos.length) {
                    // Инициализация GLightbox для фото пунктов выдачи
                    if (typeof GLightbox !== 'undefined') {
                        flipLightbox({
                            selector: '.gallery'
                        });
                    }
                }

                cardReturnView = addressMap && addressMap.center
                    ? { center: addressMap.center.slice(), zoom: addressMap.zoom }
                    : null;
                setCenter(addressMap, [point], 18);
            }
        }

        // «850 м» / «1,2 км» / «12 км»; узкий неразрывный пробел перед единицей.
        const formatPointDistance = function (m) {
            if (m < 1000) return Math.max(10, Math.round(m / 10) * 10) + ' м';
            if (m < 10000) return String(Math.round(m / 100) / 10).replace('.', ',') + ' км';
            return Math.round(m / 1000) + ' км';
        };

        const showPointsAsBlocks = function (name) {
            qa('.address-points-loader', addressCreateLayout).forEach(vHide);
            const pointsList = addressCreateLayout.querySelector('.address-points');
            if (!pointsList) return;
            pointsList.replaceChildren();
            // Новый список — с начала, а не с прежней позиции скролла.
            pointsList.scrollTop = 0;
            // Строка над списком: от чего считали расстояния (гео / поиск / центр карты).
            const distanceNote = addressCreateLayout.querySelector('.points-distance-note');
            vHide(distanceNote);
            const distanceNoteText = !distanceNote ? null
                : lastSortAnchorType === 'geo' ? distanceNote.getAttribute('data-tip-geo')
                : lastSortAnchorType === 'search' ? distanceNote.getAttribute('data-tip-search')
                : distanceNote.getAttribute('data-tip-center');
            let hasDistance = false;
            let showed = 0;
            for (const point of addressPoints) {
                if (point && point.title) {
                    const title = point.title;
                    const adress = point.titleShort;
                    const searchIndex = point.title + ' ' + point.titleShort;
                    let result = true;
                    if (name) {
                        const searchQueries = name.split(' ');
                        for (const _q in searchQueries) {
                            if (!result || searchIndex.toLowerCase().indexOf(searchQueries[_q].toLowerCase()) === -1) {
                                result = false;
                            }
                        }
                    }
                    if (
                        !name ||
                        result
                    ) {
                        if (point.latitude && point.longitude) {
                            const sourceTemplate = document.querySelector('.address-choose .address-create-point');
                            if (!sourceTemplate) break;
                            const template = sourceTemplate.cloneNode(true);
                            const titleSpan = template.querySelector('.title span');
                            if (titleSpan) titleSpan.textContent = title;
                            const pointDistance = template.querySelector('.point-distance');
                            if (point.distanceM != null) {
                                if (pointDistance) pointDistance.textContent = formatPointDistance(point.distanceM);
                                hasDistance = true;
                            } else {
                                vHide(pointDistance);
                            }
                            const adressEl = template.querySelector('.adress');
                            if (adress) {
                                if (adressEl) adressEl.textContent = adress;
                            } else {
                                vHide(adressEl);
                            }
                            const icon = template.querySelector('.title img');
                            if (icon) icon.setAttribute('src', staticDomain + point.icon);

                            template.addEventListener('click', function () {
                                selectPoint(point);
                            });

                            // Каскад: первые ~12 пунктов появляются с шагом 50 мс.
                            template.style.animationDelay = (Math.min(showed, 12) * 50) + 'ms';
                            pointsList.appendChild(template);
                            showed++;

                            if (showed >= 100) {
                                break;
                            }
                        }
                    }
                }
            }
            if (hasDistance && distanceNoteText) {
                distanceNote.textContent = distanceNoteText;
                vShow(distanceNote);
            }
        }

        // Штрафы ранжирования точек — зеркало SQL CASE в Location::list():
        // Казпочта +10 км, Tastamat и партнёрские ПВЗ +500 м, свои flip-пункты без
        // штрафа. map_icon приходит с сервера и однозначно кодирует тип точки.
        const POINT_RANK_PENALTY = { kazpost: 10000, tastamat: 500, partner: 500, flip: 0 };

        // Haversine, радиус — как у MySQL ST_Distance_Sphere (паритет с сервером).
        const distanceBetweenM = function (aLat, aLng, bLat, bLng) {
            const RAD = Math.PI / 180;
            const sLat = Math.sin((bLat - aLat) * RAD / 2);
            const sLng = Math.sin((bLng - aLng) * RAD / 2);
            const a = sLat * sLat + Math.cos(aLat * RAD) * Math.cos(bLat * RAD) * sLng * sLng;
            return 2 * 6370986 * Math.asin(Math.sqrt(a));
        };

        // Выбор точки отсчёта расстояний: адрес из поиска → гео → центр карты.
        // Поиск главнее гео (искали адрес — расстояния от него); клик по
        // самолётику сбрасывает поиск и возвращает отсчёт «от меня».
        const resolveDistanceAnchor = function (centerLat, centerLng) {
            if (anchorSearch && distanceBetweenM(anchorSearch[0], anchorSearch[1], centerLat, centerLng) <= 30000) {
                return { lat: anchorSearch[0], lng: anchorSearch[1], type: 'search' };
            }
            if (anchorGeo && distanceBetweenM(anchorGeo[0], anchorGeo[1], centerLat, centerLng) <= 30000) {
                return { lat: anchorGeo[0], lng: anchorGeo[1], type: 'geo' };
            }
            return { lat: centerLat, lng: centerLng, type: null };
        };

        // Маркер точки отсчёта: виден только когда отсчёт идёт от адреса из поиска.
        // Гео-якорь показывает метка-человечек, кружок рядом был бы дублем.
        // В door-режиме не добавляем: switcher снимет его вместе с pick-объектами.
        const updateAnchorPlacemark = function (anchor) {
            if (!addressMap || !mapApi) return;
            if (!anchor || anchor.type !== 'search') {
                if (anchorPlacemark) removeOnce(anchorPlacemark);
                return;
            }
            const coords = YmapsV3.flip(anchor.lat, anchor.lng);
            if (!anchorPlacemark) {
                const el = document.createElement('div');
                el.className = 'addr-anchor';
                anchorPlacemark = new mapApi.ymaps3.YMapMarker({ coordinates: coords }, el);
            } else {
                anchorPlacemark.update({ coordinates: coords });
            }
            if (currentLocationSwitcher === 'pick') {
                addOnce(anchorPlacemark);
            }
        };

        // Метка «Моё местоположение»: создаётся по первым известным координатам
        // (возможно серверным — центр города), поэтому каждый свежий ответ гео
        // передвигает её на настоящую позицию.
        const updateMyLocationPlacemark = function (lat, lng) {
            if (!addressMap || !mapApi) return;
            const coords = YmapsV3.flip(parseFloat(lat), parseFloat(lng));
            if (myLocationPlacemark) {
                myLocationPlacemark.update({ coordinates: coords });
                return;
            }
            const myLocEl = document.createElement('div');
            myLocEl.className = 'addr-pin addr-pin--mylocation';
            const myLocImg = document.createElement('img');
            myLocImg.src = staticDomain + '/img/map/myLocation.png';
            myLocImg.width = 38;
            myLocImg.height = 40;
            myLocEl.appendChild(myLocImg);
            myLocationPlacemark = new mapApi.ymaps3.YMapMarker({
                coordinates: coords,
                draggable: false
            }, myLocEl);
            addOnce(myLocationPlacemark);
        };

        // Доступность точных координат: null — браузер ещё не отвечал.
        let geoAvailable = null;
        let geoToastTimeoutId = null;
        const setGeoAvailable = function (ok) {
            geoAvailable = ok;
            const addressMapEl = document.getElementById('address-map');
            if (addressMapEl) addressMapEl.classList.toggle('geo-denied', ok === false);
        };
        const showGeoToast = function () {
            const toast = locationLayer.querySelector('.geo-toast');
            if (!toast) return;
            vShow(toast);
            if (geoToastTimeoutId) {
                clearTimeout(geoToastTimeoutId);
            }
            geoToastTimeoutId = setTimeout(function () { vHide(toast); }, 5000);
        };
        // Гео запрещена — гасим клик по контролу в capture-фазе, иначе ymaps
        // тихо подставляет IP-геолокацию (для Казахстана это часто Алматы)
        // и уносит карту в чужой город. Вместо прыжка — пояснение.
        document.getElementById('address-map') && document.getElementById('address-map').addEventListener('click', function (e) {
            if (geoAvailable === false && e.target.closest && e.target.closest('[class*="geolocation"]')) {
                e.stopPropagation();
                e.preventDefault();
                showGeoToast();
            }
        }, true);

        // Локальная пересортировка кэша точек — замена сетевой перезагрузки: состав
        // набора от центра не зависит (сервер всегда возвращает полный список,
        // координаты влияют только на ORDER BY). Аргументы — fallback-центр (обычно
        // центр карты); фактическую точку отсчёта выбирает resolveDistanceAnchor.
        const resortPointsAround = function (latitude, longitude) {
            const fallbackLat = parseFloat(latitude);
            const fallbackLng = parseFloat(longitude);
            if (!isFinite(fallbackLat) || !isFinite(fallbackLng)) {
                return;
            }
            if (!addressPoints.length) {
                // Пустой набор (например, после смены контекста) — очищаем список.
                showPointsAsBlocks();
                return;
            }
            const anchor = resolveDistanceAnchor(fallbackLat, fallbackLng);
            updateAnchorPlacemark(anchor);
            // Точка отсчёта сместилась меньше 150 м при том же типе и наборе —
            // список не трогаем, чтобы он не дёргался под рукой при каждом жесте.
            // Скип только когда список реально отображён: ввод в поиск очищает
            // его и включает спиннер — выход без перерисовки оставил бы спиннер
            // крутиться вечно.
            const renderedPointsList = addressCreateLayout.querySelector('.address-points');
            if (lastSortedPointsRef === addressPoints &&
                lastSortAnchorType === anchor.type &&
                lastSortCenter &&
                renderedPointsList && renderedPointsList.children.length &&
                distanceBetweenM(lastSortCenter[0], lastSortCenter[1], anchor.lat, anchor.lng) < 150) {
                return;
            }
            lastSortAnchorType = anchor.type;
            lastSortCenter = [anchor.lat, anchor.lng];
            const centerLat = anchor.lat;
            const centerLng = anchor.lng;
            const R = 6370986;
            const RAD = Math.PI / 180;
            const cosCLat = Math.cos(centerLat * RAD);
            // Ключ считается один раз на точку (не в компараторе): сортировка
            // нескольких тысяч точек укладывается в единицы миллисекунд. Haversine
            // (в отличие от теоремы косинусов) численно стабилен на метровых
            // расстояниях — порядок соседних точек совпадает с серверным.
            const keyed = [];
            for (const point of addressPoints) {
                const lat = parseFloat(point.latitude);
                const lng = parseFloat(point.longitude);
                // Точки без координат — в конец (в списке они всё равно скрыты).
                let key = Infinity;
                if (isFinite(lat) && isFinite(lng)) {
                    const sinLat = Math.sin((lat - centerLat) * RAD / 2);
                    const sinLng = Math.sin((lng - centerLng) * RAD / 2);
                    const a = sinLat * sinLat + cosCLat * Math.cos(lat * RAD) * sinLng * sinLng;
                    const distance = 2 * R * Math.asin(Math.sqrt(a));
                    // Честное расстояние (без штрафов) — подпись в списке.
                    point.distanceM = distance;
                    key = distance + (POINT_RANK_PENALTY[point.map_icon] || 0);
                } else {
                    point.distanceM = null;
                }
                keyed.push({ point: point, key: key });
            }
            keyed.sort(function (a, b) { return a.key - b.key; });
            addressPoints = keyed.map(function (item) { return item.point; });
            lastSortedPointsRef = addressPoints;
            showPointsAsBlocks();
        };

        let pickupGeoSearchTimeoutId = null;
        if (addressPointSearch) addressPointSearch.addEventListener('input', function () {
            const query = this.value.trim();
            if (!query) {
                // Поиск очищен — забываем его якорь и переcчитываем от гео/центра.
                anchorSearch = null;
                if (addressMap && addressMap.center) {
                    resortPointsAround(addressMap.center[1], addressMap.center[0]);
                } else {
                    showPointsAsBlocks('');
                }
                return;
            }
            // Мгновенная реакция на ввод: список исчезает, спиннер до перестроения.
            const pointsListToClear = addressCreateLayout.querySelector('.address-points');
            if (pointsListToClear) pointsListToClear.replaceChildren();
            qa('.address-points-loader', addressCreateLayout).forEach(vShow);
            if (pickupGeoSearchTimeoutId) {
                clearTimeout(pickupGeoSearchTimeoutId);
            }
            pickupGeoSearchTimeoutId = setTimeout(function () {
                let geocodeUrl = '/location?geocodeByLocation&address=' + encodeURIComponent(query);
                if (locationLatitude && locationLongitude) {
                    geocodeUrl += '&latitude=' + locationLatitude + '&longitude=' + locationLongitude;
                } else if (addressMap) {
                    // map.center в v3 -> [lng,lat]; backend ждёт latitude/longitude -> флипаем.
                    var center = addressMap.center;
                    geocodeUrl += '&latitude=' + center[1] + '&longitude=' + center[0];
                }
                fetchJSON(appendDeliveryParams(geocodeUrl), null, function (data) {
                    if (data && data.location && addressMap) {
                        const lat = parseFloat(data.location.latitude);
                        const lon = parseFloat(data.location.longitude);
                        addressMap.setLocation({ center: YmapsV3.flip(lat, lon), zoom: data.zoom || 13 });
                        // Найденный адрес — новый якорь расстояний; пересортировка кэша
                        // вокруг него (setLocation выше дополнительно триггернёт onActionEnd).
                        anchorSearch = [lat, lon];
                        resortPointsAround(lat, lon);
                    } else {
                        // Адрес не найден — вернуть список, снять спиннер.
                        showPointsAsBlocks();
                    }
                }, function () {
                    showPointsAsBlocks();
                });
            }, 600);
        });

        // Сброс класса error на родителе-«.form-element» (замена jQuery .parent('.form-element'))
        const setFormElementError = function (input, hasError) {
            if (!input || !input.parentElement || !input.parentElement.classList.contains('form-element')) return;
            input.parentElement.classList.toggle('error', !!hasError);
        };

        if (doorAddressChooseButton) doorAddressChooseButton.addEventListener('click', function (e) {
            e.preventDefault();
            const phoneInput = doorAddressSelectedLayout.querySelector('#doorPhone');
            const fullNameInput = doorAddressSelectedLayout.querySelector('#doorFullName');
            const address = doorAddressSelectedLayout.querySelector('input[name=address]');
            const legalAddresCheckbox = document.getElementById('doorLegalAddres');
            const organizationInput = doorAddressSelectedLayout.querySelector('#doorOrganization');
            const legalAddressInput = doorAddressSelectedLayout.querySelector('#doorLegalAddress');
            const binInput = doorAddressSelectedLayout.querySelector('#doorBin');

            const binErrors = qa('.bin-error', doorAddressSelectedLayout);

            const flatInput = doorAddressSelectedLayout.querySelector('input[name=flat]');
            const entranceInput = doorAddressSelectedLayout.querySelector('input[name=entrance]');
            const floorInput = doorAddressSelectedLayout.querySelector('input[name=floor]');
            const buzzerInput = doorAddressSelectedLayout.querySelector('input[name=buzzer]');

            const fullNameErrors = qa('.full-name-error');
            const fullNameErrors2 = qa('.full-name-error-2');

            setFormElementError(fullNameInput, false);
            fullNameErrors.forEach(vHide);
            fullNameErrors2.forEach(vHide);

            setFormElementError(binInput, false);
            binErrors.forEach(vHide);

            if (!fullNameInput.value) {
                fullNameErrors.forEach(vShow);
                setFormElementError(fullNameInput, true);
                return;
            }
            function chekPhone(phone) {
                let cleanPhone = phone.replace(/\D/g, "");
                if (cleanPhone.length !== 11) {
                    setFormElementError(phoneInput, true);
                } else {
                    setFormElementError(phoneInput, false);
                    return true;
                }
            }

            phoneInput.addEventListener('keyup', function () {
                chekPhone(phoneInput.value);
            });

            if (!phoneInput.value) {
                phoneInput.reportValidity();
                return;
            }
            if (!address.value) {
                address.reportValidity();
                return;
            } else {
                if (!chekPhone(phoneInput.value)) {
                    return;
                }
            }

            if (legalAddresCheckbox && legalAddresCheckbox.checked) {
                if (!organizationInput.value) {
                    organizationInput.reportValidity();
                    return;
                }
                if (!legalAddressInput.value) {
                    legalAddressInput.reportValidity();
                    return;
                }
                if (!binInput.value) {
                    binInput.reportValidity();
                    setFormElementError(binInput, true);
                    return;
                } else {
                    var binPattern = /^\d{12}$/;
                    if (!binPattern.test(binInput.value)) {
                        binErrors.forEach(vShow);
                        setFormElementError(binInput, true);
                        return;
                    }
                }
            }

            if (!doorAddressLatitude || !doorAddressLongitude) {
                return;
            }

            const data = new URLSearchParams({
                address: address.value,
                latitude: doorAddressLatitude,
                longitude: doorAddressLongitude,
                phone: phoneInput.value,
                fullName: fullNameInput.value,
                flat: flatInput ? flatInput.value : '',
                entrance: entranceInput ? entranceInput.value : '',
                floor: floorInput ? floorInput.value : '',
                buzzer: buzzerInput ? buzzerInput.value : ''
            });

            if (legalAddresCheckbox && legalAddresCheckbox.checked) {
                data.append('organization', organizationInput.value);
                data.append('legalAddress', legalAddressInput.value);
                data.append('bin', binInput.value);
            }

            if (doorAddressCountry) {
                data.append('countryName', doorAddressCountry);
            }

            if (doorAddressArea) {
                data.append('area', doorAddressArea);
            }

            if (doorAddressCity) {
                data.append('city', doorAddressCity);
            }

            if (addToOrder) {
                data.append('idOrder', addToOrder);
            }
            else if (updatedAddressId) {
                data.append('idAddress', updatedAddressId);
            }

            if ((externalSelectMeta && externalSelectMeta.clearContact) || new URLSearchParams(window.location.search).get('isRecipient') === '1') {
                data.append('isRecipient', 1);
            }

            fetchJSON(appendDeliveryParams('/location?setToDoor=1'), { method: 'POST', body: data }, function (data) {
                if (data) {
                    if (data['action']) {
                        executeAction(data['action']);
                    } else {
                        if (hasExternalSelect()) {
                            if (data.guestAddress) {
                                var doorCity = doorAddressCity || '';
                                handleExternalSelect({
                                    id: 'guest_' + data.guestAddress.deliveryMethodItem,
                                    deliveryTitle: courierAddressTitle(),
                                    address: (doorCity ? doorCity + ', ' : '') + address.value,
                                    contactName: fullNameInput.value,
                                    phone: phoneInput.value,
                                    guestData: data.guestAddress
                                });
                                return;
                            }
                            if (data.id) {
                                var doorCity = doorAddressCity || '';
                                handleExternalSelect({
                                    id: data.id,
                                    deliveryTitle: courierAddressTitle(),
                                    address: (doorCity ? doorCity + ', ' : '') + address.value,
                                    contactName: fullNameInput.value,
                                    phone: phoneInput.value
                                });
                                return;
                            }
                            getLatestAddress({
                                deliveryMethod: 1,
                                phone: phoneInput.value,
                                fullName: fullNameInput.value,
                                address: address.value
                            }, function (selected) {
                                if (selected) {
                                    handleExternalSelect(selected);
                                }
                            });
                            return;
                        }
                        if (updatedAddressId) {
                            searchLocation('');
                            handleDoorAddressBackClick();
                            handleBackClick();
                            vHide(deliveryToDoorLayout);
                            vShow(pickPointLayout);
                            handleBackToAddresses();
                            updatedAddressId = null;
                        } else {
                            clearOrderCookie();
                            vHide(locationLayer);
                            window.location.reload();
                        }
                    }
                }
            });
        });





        if (pickPointChooseButton) pickPointChooseButton.addEventListener('click', function (e) {
            e.preventDefault();
            const phoneInput = selectedPickPintLayout.querySelector('#phone');
            const fullNameInput = selectedPickPintLayout.querySelector('#fullName');
            const legalAddresCheckbox = document.getElementById('legalAddres');
            const organizationInput = selectedPickPintLayout.querySelector('#organization');
            const legalAddressInput = selectedPickPintLayout.querySelector('#legalAddress');
            const binInput = selectedPickPintLayout.querySelector('#bin');

            const fullNameErrors = qa('.full-name-error');
            const fullNameErrors2 = qa('.full-name-error-2');
            const binErrors = qa('.bin-error');

            setFormElementError(fullNameInput, false);
            setFormElementError(binInput, false);
            binErrors.forEach(vHide);
            fullNameErrors.forEach(vHide);
            fullNameErrors2.forEach(vHide);

            function chekName(name) {
                if (currentPoint.idDelivery == 2) {
                    var pattern = /^(?!.*[\u{1F600}-\u{1F64F}])^[A-ZА-ЯӘІҢҒҮҰҚӨҺЁ][a-zа-яәіңғүұқөһё]*\s[A-ZА-ЯӘІҢҒҮҰҚӨҺЁ][a-zа-яәіңғүұқөһё]*(\s[A-ZА-ЯӘІҢҒҮҰҚӨҺЁ][a-zа-яәіңғүұқөһё]*)?\s*$/iu;

                    if (!pattern.test(name)) {
                        fullNameErrors2.forEach(vShow);
                        fullNameErrors.forEach(vHide);
                        setFormElementError(fullNameInput, true);
                    } else {
                        fullNameErrors2.forEach(vHide);
                        fullNameErrors.forEach(vHide);
                        setFormElementError(fullNameInput, false);
                        return true;
                    }
                } else {
                    fullNameErrors2.forEach(vHide);
                    fullNameErrors.forEach(vHide);
                    setFormElementError(fullNameInput, false);
                    return true;
                }
            }

            function chekPhone(phone) {
                let cleanPhone = phone.replace(/\D/g, "");
                if (cleanPhone.length !== 11) {
                    setFormElementError(phoneInput, true);
                } else {
                    setFormElementError(phoneInput, false);
                    return true;
                }
            }

            phoneInput.addEventListener('keyup', function () {
                chekPhone(phoneInput.value);
            });

            fullNameInput.addEventListener('keyup', function () {
                chekName(fullNameInput.value);
            });

            if (!fullNameInput.value) {
                fullNameErrors.forEach(vShow);
                setFormElementError(fullNameInput, true);
                return;
            }
            if (fullNameInput.value && currentPoint.idDelivery == 2) {
                if (!chekName(fullNameInput.value)) {
                    return;
                }
            }
            if (!phoneInput.value) {
                phoneInput.reportValidity();
                return;
            } else {
                if (!chekPhone(phoneInput.value)) {
                    return;
                }
            }

            if (legalAddresCheckbox && legalAddresCheckbox.checked) {
                if (!organizationInput.value) {
                    organizationInput.reportValidity();
                    return;
                }
                if (!legalAddressInput.value) {
                    legalAddressInput.reportValidity();
                    return;
                }
                if (!binInput.value) {
                    binInput.reportValidity();
                    setFormElementError(binInput, true);
                    return;
                } else {
                    var binPattern = /^\d{12}$/;
                    if (!binPattern.test(binInput.value)) {
                        binErrors.forEach(vShow);
                        setFormElementError(binInput, true);
                        return;
                    }
                }
            }

            if (!currentPoint || !currentPoint.id) {
                return;
            }

            const data = new URLSearchParams({
                id: currentPoint.id,
                phone: phoneInput.value,
                fullName: fullNameInput.value,
            });

            if (legalAddresCheckbox && legalAddresCheckbox.checked) {
                data.append('organization', organizationInput.value);
                data.append('legalAddress', legalAddressInput.value);
                data.append('bin', binInput.value);
            }

            if (addToOrder) {
                data.append('idOrder', addToOrder);
            }
            else if (updatedAddressId) {
                data.append('idAddress', updatedAddressId);
            }

            if ((externalSelectMeta && externalSelectMeta.clearContact) || new URLSearchParams(window.location.search).get('isRecipient') === '1') {
                data.append('isRecipient', 1);
            }

            fetchJSON(appendDeliveryParams('/location?setPoint=1'), { method: 'POST', body: data }, function (data) {
                if (data) {
                    if (data['action']) {
                        executeAction(data['action']);
                    } else {
                        if (hasExternalSelect()) {
                            if (data.guestAddress) {
                                handleExternalSelect({
                                    id: 'guest_' + data.guestAddress.deliveryMethodItem,
                                    deliveryTitle: currentPoint.title,
                                    address: currentPoint.titleShort || currentPoint.title,
                                    contactName: fullNameInput.value,
                                    phone: phoneInput.value,
                                    guestData: data.guestAddress
                                });
                                return;
                            }
                            if (data.id) {
                                handleExternalSelect({
                                    id: data.id,
                                    deliveryTitle: currentPoint.title,
                                    address: currentPoint.titleShort || currentPoint.title,
                                    contactName: fullNameInput.value,
                                    phone: phoneInput.value
                                });
                                return;
                            }
                            getLatestAddress({
                                deliveryMethodItem: currentPoint.id,
                                phone: phoneInput.value,
                                fullName: fullNameInput.value
                            }, function (selected) {
                                if (selected) {
                                    handleExternalSelect(selected);
                                }
                            });
                            return;
                        }
                        if (updatedAddressId) {
                            searchLocation('');
                            handleDoorAddressBackClick();
                            handleBackClick();
                            vHide(deliveryToDoorLayout);
                            vShow(pickPointLayout);
                            handleBackToAddresses();
                            updatedAddressId = null;
                        } else {
                            clearOrderCookie();
                            vHide(locationLayer);
                            window.location.reload();
                        }
                    }
                }
            });
        });

        const getBbox = function (latitude, longitude) {
            const radiusSize = 50;
            let bboxLatitude = locationLatitude;
            let bboxLongitude = locationLongitude;

            if (latitude && longitude) {
                bboxLatitude = latitude;
                bboxLongitude = longitude;
            }

            if (bboxLatitude && bboxLongitude) {
                // Расчет bounding box в радиусе 50 километров
                const R = 6371; // Радиус Земли в километрах
                const kmInDeg = 1 / (2 * Math.PI / 360 * R); // Километры в градусах

                const deltaLat = radiusSize * kmInDeg;
                const deltaLon = radiusSize * kmInDeg / Math.cos(bboxLatitude * Math.PI / 180);

                const bbox = [
                    [bboxLatitude - deltaLat, bboxLongitude - deltaLon],
                    [bboxLatitude + deltaLat, bboxLongitude + deltaLon]
                ];

                return bbox;
            } else {
                // Возвращаем координаты казахстана
                return [
                    [40.5684, 46.4915], [55.4413, 87.3237]
                ]
            }
        }

        boundleBox = getBbox();

        // Номер геокод-запроса: поздний ответ устаревшего не перезаписывает
        // состояние нового жеста (инкремент также в onActionStart/onClick).
        let updateAddressSeq = 0;
        const updateAddressImpl = function (coords) {
            const seq = ++updateAddressSeq;
            if (coords && coords.length === 2) {
                boundleBox = getBbox(coords[0], coords[1]);
            }
            hideAddressChooseError();
            fetchJSON(appendDeliveryParams('/location?geocodeByLocation&address=' + coords.join(',')), null, function (data) {
                if (seq !== updateAddressSeq) return;
                if (data) {
                    if (data.components) {
                        const addressWithoutCity = detectAddressByComponent(data.components);
                        let displayAddress = addressWithoutCity || (doorAddressCity ? (doorAddressCity + ', ') : '') + (data.address || '');
                        if (isDeliveryExternal() && externalSelectMeta && externalSelectMeta.target === 'destination') {
                            if (data.address) {
                                displayAddress = data.address;
                            } else if (locationAddressSearchInput.value) {
                                displayAddress = locationAddressSearchInput.value;
                            }
                        }
                        if (displayAddress) {
                            locationAddressSearchInput.value = displayAddress;
                            qa('input[name=address]', locationLayer).forEach(function (el) { el.value = displayAddress; });
                        }
                    }
                    if (data.isDelivery && data.isExact) {
                        doorAddressLatitude = coords[0];
                        doorAddressLongitude = coords[1];
                        enableDoorContinue();
                    } else {
                        if (!data.isDelivery) {
                            showAddressChooseError();
                        } else {
                            showAddressChooseError(true);
                            renderAddressSuggests(data.nearHouses);
                        }
                    }
                } else {
                    // Пустой ответ геокодера — вернуть подсказку, а не пустую форму.
                    showAddressChooseError(true);
                }
            }, function () {
                if (seq !== updateAddressSeq) return;
                showAddressChooseError(true);
            });
        }

        // Дебаунс 250 мс схлопывает дубли geocode. Программный setLocation
        // action-событий не даёт — после него updateAddress зовётся явно.
        let updateAddressDebounceTimer = null;
        // Координаты, для которых адрес в режиме «Курьером» уже резолвили. Карта живёт
        // между открытиями модалки, поэтому совпадение с её центром означает «это тот же
        // адрес», а не точка, куда карту увели в режиме ПВЗ.
        let lastDoorCoords = null;

        const updateAddress = function (coords) {
            lastDoorCoords = coords;
            if (updateAddressDebounceTimer) clearTimeout(updateAddressDebounceTimer);
            updateAddressDebounceTimer = setTimeout(function () { updateAddressImpl(coords); }, 250);
        };

        const isSameCoords = function (a, b) {
            return !!a && !!b && Math.abs(a[0] - b[0]) < 1e-5 && Math.abs(a[1] - b[1]) < 1e-5;
        };

        // Вход в режим «Курьером»: маркер уже стоит в центре карты, но адрес под ним
        // не запрашивался — поле оставалось пустым, зона непроверенной, и всё оживало
        // только после сдвига карты. Резолвим центр сразу.
        //
        // Кроме случая, когда пользователь ещё не прицелился (обзорный зум) и центр не
        // совпадает с уже отрезолвленным адресом: там это случайная точка города, и
        // мгновенная красная ошибка пугала до первого действия пользователя.
        const geocodeMapCenter = function () {
            if (!addressMap || !addressMap.center) {
                return;
            }
            // map.center в v3 -> [lng, lat]; updateAddress ждёт [lat, lng].
            const c = addressMap.center;
            const coords = [c[1], c[0]];
            if (!(lastPickZoom >= 15) && !isSameCoords(coords, lastDoorCoords)) {
                return;
            }
            updateAddress(coords);
        };

        const detectAddressByComponent = function (addressComponents) {
            let addressWithoutCity = '';
            addressComponents.forEach(function (component) {
                if (component.kind !== 'country' && component.kind !== 'province' && component.kind !== 'area' && component.kind !== "locality") {
                    addressWithoutCity += (addressWithoutCity ? ', ' : '') + component.name;
                }
                if (component.kind === 'country') {
                    doorAddressCountry = component.name;
                }
                if (component.kind === 'province') {
                    doorAddressArea = component.name;
                }
                if (component.kind === 'locality') {
                    doorAddressCity = component.name;
                }
            });

            return addressWithoutCity;
        }

        // showCreateDoorAddressMap удалена — door-режим теперь использует ту же карту addressMap.
        // Логика создания myLocationPlacemark и door-обработчиков перенесена в initYmaps.

        let loadPointsTimeoutId = null;

        // Прямой запрос точек самовывоза, без дебаунса — для первой загрузки при
        // открытии модалки, где каждая миллисекунда на критическом пути.
        const requestPoints = function (latitude, longitude, callback) {
            // delivery-параметры (направление + фильтр по тарифу) собирает общий
            // appendDeliveryParams — раньше здесь была своя копия и фильтр шёл мимо.
            let url = appendDeliveryParams((location.pathname.indexOf('/kk') === 0 ? '/kk' : '') + '/location?pickup-pints=1');

            if (latitude && longitude) {
                url += '&latitude=' + latitude;
                url += '&longitude=' + longitude;
            }

            fetchJSON(url, null, function (data) {
                const points = Array.isArray(data) ? data : [];
                if (callback) {
                    callback(points);
                }
            });
        }

        // Дебаунс-обёртка над requestPoints: гасит очереди запросов при
        // передвижении карты (onActionEnd) и серии программных вызовов.
        const loadPoints = function (latitude, longitude, callback) {
            if (loadPointsTimeoutId) {
                clearTimeout(loadPointsTimeoutId);
            }
            loadPointsTimeoutId = setTimeout(function () {
                requestPoints(latitude, longitude, callback);
            }, 600);
        }

        const clearPointsCache = function () {
            if (addressMap) {
                // Снимаем все top-level объекты карты (office-маркеры + кластерер),
                // кроме myLocationPlacemark — он управляется switcher'ом отдельно.
                const toRemove = mapChildren.filter(function (obj) {
                    return obj !== myLocationPlacemark;
                });
                toRemove.forEach(removeOnce);
                clusterer = null;
                // Пустой кластерер обратно на карту (как раньше — clusterer всегда присутствовал).
                rebuildClusterer([]);
            }
            for (const key in placeMarks) {
                if (Object.prototype.hasOwnProperty.call(placeMarks, key)) {
                    delete placeMarks[key];
                }
            }
            addressPoints = [];
            currentPoint = null;
            vHide(selectedPickPintLayout);
            vShow(pickPointLayout);
        };

        const refreshPointsByContext = function () {
            if (!isMapShowed) {
                return;
            }
            clearPointsCache();
            // Состав набора зависит от контекста (delivery-параметры в URL), но не от
            // координат — запрашиваем без них (стабильный URL кэшируется браузером),
            // порядок наводит клиентская сортировка вокруг текущего центра.
            let center;
            if (addressMap && addressMap.center) {
                // map.center в v3 -> [lng,lat] -> флипаем в (lat, lng).
                center = [addressMap.center[1], addressMap.center[0]];
            } else {
                center = homeAnchor() || [43.240385, 76.915506];
            }
            loadPoints(null, null, function (data) {
                addressPoints = data;
                addPointsToMap(data);
                resortPointsAround(center[0], center[1]);
            });
        };

        const refreshAddressListByContext = function () {
            myAddressesList.length = 0;
            searchLocation('');
        };

        // Дефолтные подписи контактных полей и исходные значения (замена jQuery .data()-хранилища)
        let savedContactDefaults = null;
        // Окно на странице посылки работает в двух режимах: выбор адреса посылки и
        // обычный «Мой адрес» из шапки. Флаг — прошлое открытие было в режиме посылки,
        // и обычному окну нужно вернуть своё состояние.
        let wasDeliveryExternal = false;

        // .closest('.form-control').prev('.title') — заголовок блока контактов перед form-control
        const contactTitleFor = function (input) {
            if (!input) return null;
            const formControl = input.closest('.form-control');
            const prev = formControl ? formControl.previousElementSibling : null;
            return (prev && prev.classList.contains('title')) ? prev : null;
        };

        const setInputsPlaceholder = function (inputs, text) {
            inputs.forEach(function (input) {
                if (!input) return;
                input.setAttribute('placeholder', text);
                // .siblings('label') — плавающая метка рядом с input
                Array.prototype.forEach.call(input.parentElement ? input.parentElement.children : [], function (sibling) {
                    if (sibling !== input && sibling.tagName === 'LABEL') {
                        sibling.textContent = text;
                    }
                });
            });
        };

        const resetCreateAddressLayoutForContext = function () {
            vHide(deliveryToDoorLayout);
            vHide(pickPointLayout);
            vHide(doorAddressSelectedLayout);
            vHide(selectedPickPintLayout);
            const fullNameEl = document.getElementById('fullName');
            const phoneEl = document.getElementById('phone');
            const doorFullNameEl = document.getElementById('doorFullName');
            const doorPhoneEl = document.getElementById('doorPhone');
            const nameInputs = [fullNameEl, doorFullNameEl];
            const phoneInputs = [phoneEl, doorPhoneEl];
            const switcherPick2 = document.getElementById('switcher-pick-2');
            const switcherDoor2 = document.getElementById('switcher-door-2');
            const labelPick2 = document.querySelector('label[for="switcher-pick-2"]');
            const labelDoor2 = document.querySelector('label[for="switcher-door-2"]');

            // Красный текст «вне зоны» оставался видимым после закрытия карты и
            // встречал уже в другом сценарии. Гасим при смене контекста.
            vHide(locationAddressErrorLayout);
            vHide(locationAddressErrorPickupLayout);
            vHide(locationAddressErrorExactLayout);
            // Новый адрес — всегда с нуля: форма одна на отправителя, получателя посылки
            // и «Мой адрес», и без сброса адрес, квартира и контакт переезжали из одного
            // сценария в другой. Контакт: у получателя пустой, у отправителя и «Моего
            // адреса» — из профиля (исходные значения полей, которые сервер подставляет из
            // аккаунта). Редактирование сохранённого адреса (updatedAddressId) не трогаем:
            // editAddress сам заполнил имя и телефон.
            if (!updatedAddressId) {
                ['flat', 'entrance', 'floor', 'buzzer'].forEach(function (name) {
                    qa('input[name=' + name + ']', doorAddressSelectedLayout).forEach(function (el) { el.value = ''; });
                });
                ['locationAddressSearch', 'doorAddressSelected', 'locationSearch'].forEach(function (id) {
                    const input = document.getElementById(id);
                    if (input) input.value = '';
                });
                // Поле очищено программно — событие input не стреляет, и «Продолжить»
                // оставалась включённой от прошлого адреса: пустой адрес уходил дальше.
                doorAddressLatitude = null;
                doorAddressLongitude = null;
                doorSelectedAddress = null;
                if (doorContinueButton) {
                    doorContinueButton.disabled = true;
                    vHide(doorContinueButton);
                }
                const isRecipientForm = isDeliveryExternal() && !!externalSelectMeta.clearContact;
                nameInputs.forEach(function (input) {
                    if (input) input.value = isRecipientForm ? '' : input.defaultValue;
                });
                // Телефон чистим до кода страны: маска уже инициализирована и «+7» сама
                // обратно не подставит.
                phoneInputs.forEach(function (input) {
                    if (input) input.value = isRecipientForm ? '+7' : (input.defaultValue || '+7');
                });
                const resetPick1 = document.getElementById('switcher-pick-1');
                const resetDoor1 = document.getElementById('switcher-door-1');
                if (resetPick1) resetPick1.checked = true;
                if (resetDoor1) resetDoor1.checked = true;
                // change программно не стреляет, а именно он возвращает карту в режим
                // самовывоза (метки ПВЗ, зум, скрытый центральный маркер).
                if (currentLocationSwitcher === 'door' && resetPick1) {
                    resetPick1.dispatchEvent(new Event('change', { bubbles: true }));
                }
                // Карта одна на все окна: у получателя посылки она показывает ПВЗ всей
                // страны, и центр уезжал в середину Казахстана — следующее окно (забор,
                // «Мой адрес») открывалось оттуда, а «Курьером» приближал в степь.
                // Отправитель и «Мой адрес» снова начинают с клиента (homeAnchor:
                // геопозиция, адрес из шапки, GeoIP), масштаб как при старте карты.
                if (addressMap && !isRecipientExternal()) {
                    const home = homeAnchor();
                    const homeLat = home ? home[0] : null;
                    const homeLng = home ? home[1] : null;
                    if (home) {
                        addressMap.setLocation({ center: YmapsV3.flip(homeLat, homeLng), zoom: 12 });
                        lastPickZoom = 12;
                        // Программный сдвиг не даёт onActionEnd — список ПВЗ сортируем сами.
                        resortPointsAround(homeLat, homeLng);
                    }
                }
            }
            if (isDeliveryExternal()) {
                wasDeliveryExternal = true;
                // Сохранить дефолтные label контактных полей при первом вызове
                if (!savedContactDefaults) {
                    const contactTitle = contactTitleFor(fullNameEl);
                    savedContactDefaults = {
                        name: (fullNameEl && fullNameEl.getAttribute('placeholder')) || '',
                        phone: (phoneEl && phoneEl.getAttribute('placeholder')) || '',
                        title: (contactTitle && contactTitle.textContent) || ''
                    };
                }
                // Курьерскую вкладку для точки отправления (забор у отправителя) раньше
                // гасили жёстко по target === 'origin'. Теперь решает вызывающая страница:
                // она знает, работает ли забор (см. hasCourierPickup в delivery/sent.tpl).
                const noCourier = externalSelectMeta && externalSelectMeta.noCourier;
                const switcherPick1 = document.getElementById('switcher-pick-1');
                const switcherDoor1 = document.getElementById('switcher-door-1');
                if (switcherPick1) switcherPick1.checked = true;
                if (switcherDoor1) switcherDoor1.checked = true;
                // Радио переставляем программно, а change сам не стреляет — именно его
                // обработчик возвращает карту в pick-состояние (метки ПВЗ из snapshot,
                // прежний зум, скрытый центральный маркер). Без этого «открыл → курьер →
                // закрыл → открыл» показывало карту курьера под вкладкой «Самовывоз».
                if (currentLocationSwitcher === 'door' && switcherPick1) {
                    switcherPick1.dispatchEvent(new Event('change', { bubbles: true }));
                }
                // Карта одна (#address-map), контейнер всегда виден — show/hide старых ID не нужно.
                // Смена label контактных полей (отправитель / получатель)
                const contactLabels = externalSelectMeta && externalSelectMeta.contactLabels;
                const contactTitles = [contactTitleFor(fullNameEl), contactTitleFor(doorFullNameEl)].filter(Boolean);
                if (contactLabels) {
                    setInputsPlaceholder(nameInputs, contactLabels.name);
                    setInputsPlaceholder(phoneInputs, contactLabels.phone);
                    if (contactLabels.title) {
                        contactTitles.forEach(function (el) { el.textContent = contactLabels.title; });
                    }
                } else {
                    // Восстановить дефолтные label
                    if (savedContactDefaults && savedContactDefaults.name) {
                        setInputsPlaceholder(nameInputs, savedContactDefaults.name);
                        setInputsPlaceholder(phoneInputs, savedContactDefaults.phone);
                        contactTitles.forEach(function (el) { el.textContent = savedContactDefaults.title; });
                    }
                }
                if (noCourier) {
                    if (switcherPick2) { switcherPick2.checked = false; switcherPick2.disabled = true; }
                    vHide(labelPick2);
                    if (switcherDoor2) { switcherDoor2.checked = false; switcherDoor2.disabled = true; }
                    vHide(labelDoor2);
                    vHide(deliveryToDoorLayout);
                } else {
                    if (switcherPick2) switcherPick2.disabled = false;
                    vShow(labelPick2);
                    if (switcherDoor2) switcherDoor2.disabled = false;
                    vShow(labelDoor2);
                }
                vShow(pickPointLayout);
                // Скрыть переключатель "Заказ на организацию" при доставке посылок
                qa('.toggle', doorAddressSelectedLayout).forEach(vHide);
                qa('.toggle', selectedPickPintLayout).forEach(vHide);
            } else {
                if (wasDeliveryExternal) {
                    wasDeliveryExternal = false;
                    // Подписи «отправителя» / «получателя» возвращаем к обычным.
                    if (savedContactDefaults && savedContactDefaults.name) {
                        setInputsPlaceholder(nameInputs, savedContactDefaults.name);
                        setInputsPlaceholder(phoneInputs, savedContactDefaults.phone);
                        [contactTitleFor(fullNameEl), contactTitleFor(doorFullNameEl)].filter(Boolean)
                            .forEach(function (el) { el.textContent = savedContactDefaults.title; });
                    }
                }
                qa('.toggle', doorAddressSelectedLayout).forEach(vShow);
                qa('.toggle', selectedPickPintLayout).forEach(vShow);
                if (switcherPick2) switcherPick2.disabled = false;
                vShow(labelPick2);
                if (switcherDoor2) switcherDoor2.disabled = false;
                vShow(labelDoor2);
                const checkedDoor = document.querySelector('.switcher input[name=switcher-door]:checked');
                const checkedPick = document.querySelector('.switcher input[name=switcher-pick]:checked');
                const doorMode = !!checkedDoor && checkedDoor.value === 'door';
                const pickMode = !!checkedPick && checkedPick.value === 'pick';
                if (doorMode) {
                    vShow(deliveryToDoorLayout);
                    // Карта одна — show/hide контейнеров не нужен.
                    // Открылись сразу в режиме двери (состояние с прошлого раза) —
                    // обработчик переключателя не сработает, резолвим центр сами.
                    geocodeMapCenter();
                } else if (pickMode) {
                    vShow(pickPointLayout);
                } else {
                    vShow(pickPointLayout);
                }
            }
        };

        var isMapLoading = false;
        const showCreateAddressLayout = function (callback) {
            vHide(locationLayerResult);
            vShow(addressCreateLayout);
            resetCreateAddressLayoutForContext();
            // Повторный вход на экран карты: прошлый поиск не должен переживать
            // закрытие — поле очищается, якорь и список приводятся к фактическому
            // центру карты (иначе поле и список залипали на прежнем городе).
            if (isMapShowed) {
                if (addressPointSearch && addressPointSearch.value) {
                    addressPointSearch.value = '';
                    anchorSearch = null;
                }
                if (addressMap && addressMap.center) {
                    resortPointsAround(addressMap.center[1], addressMap.center[0]);
                }
            }
            if (!isMapShowed && !isMapLoading) {
                isMapLoading = true;

                // Точки самовывоза не зависят от карты — запрашиваем сразу, параллельно
                // с инициализацией ymaps (раньше запрос ждал полной готовности карты и
                // ещё 600 мс дебаунса). Список слева рендерится по приходу точек, не
                // дожидаясь карты; метки вешает applyPointsToMap — его выставляет
                // инициализация карты, и join срабатывает у того, кто готов последним.
                var pendingPoints = null;
                var applyPointsToMap = null;
                // Центр, вокруг которого пользователь ждёт сортировку (например, точная
                // геолокация ответила раньше, чем пришли точки, запрошенные по серверным
                // координатам) — deliverPoints пересортирует ответ по нему локально.
                var preferredSortCenter = null;
                var deliverPoints = function (data) {
                    addressPoints = data;
                    if (preferredSortCenter) {
                        resortPointsAround(preferredSortCenter[0], preferredSortCenter[1]);
                    } else {
                        showPointsAsBlocks();
                    }
                    if (applyPointsToMap) {
                        applyPointsToMap(addressPoints);
                    } else {
                        pendingPoints = addressPoints;
                    }
                };
                // Координаты в запрос не передаём: состав набора от них не зависит,
                // а без них URL стабилен (браузер кэширует ответ) и сервер не считает
                // ST_Distance_Sphere. Порядок наводит клиентская сортировка — стартовый
                // центр кладём в preferredSortCenter, deliverPoints отсортирует всегда.
                preferredSortCenter = homeAnchor() || [43.240385, 76.915506];
                requestPoints(null, null, deliverPoints);

                // Гайдовый запуск геолокации: системный промпт при открытии модалки
                // не показываем. granted — тихо получаем позицию (согласие уже дано);
                // prompt — диалог появится по клику самолётика; denied — приглушаем
                // самолётик и блокируем его клик (см. capture-обработчик), иначе
                // ymaps улетит по IP-гео. onchange оживляет всё на лету.
                const GEO_OPTIONS = { enableHighAccuracy: true, timeout: 10000, maximumAge: 30000 };
                const requestStartPosition = function () {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        locationLatitude = position.coords.latitude;
                        locationLongitude = position.coords.longitude;
                        setGeoAvailable(true);
                        // Ссылка «Определить моё местоположение» скрыта в разметке и
                        // показывается только при полученном разрешении — без мигания.
                        qa('.my-location').forEach(vShow);
                        if (addressMap) {
                            setCenter(addressMap, [position.coords]);
                        }
                        // Пересортировка кэша точек вокруг точной позиции; если точки
                        // ещё в пути — порядок применит deliverPoints.
                        anchorGeo = [locationLatitude, locationLongitude];
                        preferredSortCenter = [locationLatitude, locationLongitude];
                        updateMyLocationPlacemark(locationLatitude, locationLongitude);
                        resortPointsAround(locationLatitude, locationLongitude);
                    }, function () {
                        setGeoAvailable(false);
                    }, GEO_OPTIONS);
                };
                if (navigator.geolocation && navigator.permissions && navigator.permissions.query) {
                    navigator.permissions.query({ name: 'geolocation' }).then(function (status) {
                        const applyPermissionState = function () {
                            if (status.state === 'granted') {
                                requestStartPosition();
                            } else if (status.state === 'denied') {
                                setGeoAvailable(false);
                            } else {
                                // prompt: снять возможное приглушение, пользователя не дёргать.
                                setGeoAvailable(null);
                            }
                        };
                        applyPermissionState();
                        status.onchange = applyPermissionState;
                    });
                }

                var initYmaps = function () {
                    YmapsV3.ready().then(function (api) {
                        mapApi = api;
                        // Единая карта для обоих режимов (Самовывоз и Курьерская).
                        // Состояние карты переключается через change-handler switcher:
                        //   pick: clusterer + zoom 11–14, маркер скрыт
                        //   door: myLocationPlacemark + zoom 17, маркер по центру
                        // makeMap создаёт scheme-слой с скрытыми POI и features-слой, без контролов.
                        // Старт сразу с города пользователя (зум как у setCenter после
                        // загрузки точек) — без прыжка со всего Казахстана.
                        var initHome = homeAnchor();
                        var initLat = initHome ? initHome[0] : null;
                        var initLng = initHome ? initHome[1] : null;
                        addressMap = api.makeMap('address-map', {
                            center: initLat !== null && initLng !== null
                                ? YmapsV3.flip(initLat, initLng)
                                : YmapsV3.flip(43.240385, 76.915506),
                            zoom: initLat !== null && initLng !== null ? 12 : 4,
                            minZoom: 4,
                            maxZoom: 18,
                            hidePoi: true,
                            zoomControl: true,
                            geolocationControl: true,
                            // Зум стрелки позиции: виден дом и район.
                            geolocationZoom: 16,
                            // Стрелка двигает карту программно (без action-событий) —
                            // список/адрес обновляем сами по полученной позиции.
                            onGeolocatePosition: function (pos) {
                                updateMyLocationPlacemark(pos[1], pos[0]);
                                if (currentLocationSwitcher === 'door') {
                                    updateAddressSeq++;
                                    locationAddressSearchInput.value = '';
                                    qa('input[name=address]', locationLayer).forEach(function (el) { el.value = ''; });
                                    hideAddressChooseError();
                                    updateAddress([pos[1], pos[0]]);
                                } else {
                                    // Явное «от меня»: поиск сбрасывается, иначе его
                                    // якорь остался бы главнее геопозиции.
                                    anchorGeo = [pos[1], pos[0]];
                                    anchorSearch = null;
                                    if (addressPointSearch) addressPointSearch.value = '';
                                    resortPointsAround(pos[1], pos[0]);
                                }
                            }
                        });

                        // Пустой кластерер для tastamat/kazpost (gridSize 80, maxZoom 15).
                        // На pan/reload пересоздаётся через rebuildClusterer.
                        rebuildClusterer([]);

                        // Геолокация могла ответить раньше создания карты — ставим
                        // маркер точки отсчёта сразу, не дожидаясь первого жеста.
                        if (lastSortCenter) {
                            updateAnchorPlacemark(resolveDistanceAnchor(lastSortCenter[0], lastSortCenter[1]));
                        }

                        // Слушатель движений карты (v3 — YMapListener вместо v2 events).
                        mapListener = new api.ymaps3.YMapListener({
                            // Клик переносит маркер. Программный setLocation не даёт
                            // action-событий — сброс и геокодинг явно.
                            onClick: function (object, event) {
                                if (currentLocationSwitcher !== 'door') return;
                                if (!event || !event.coordinates || !addressMap) return;
                                updateAddressSeq++;
                                locationAddressSearchInput.value = '';
                                qa('input[name=address]', locationLayer).forEach(function (el) { el.value = ''; });
                                hideAddressChooseError();
                                addressMap.setLocation({ center: event.coordinates, duration: 300 });
                                // event.coordinates -> [lng,lat]; updateAddress ждёт [lat,lng].
                                updateAddress([event.coordinates[1], event.coordinates[0]]);
                            },
                            // onActionStart ~ v2 actionbegin: нужен только в door-режиме
                            // (сбросить адрес, чтобы пользователь видел что карта движется).
                            onActionStart: function () {
                                if (currentLocationSwitcher !== 'door') return;
                                updateAddressSeq++;
                                locationAddressSearchInput.value = '';
                                qa('input[name=address]', locationLayer).forEach(function (el) { el.value = ''; });
                                hideAddressChooseError();
                                if (mapCenterMarker) mapCenterMarker.classList.add('moved');
                            },
                            // onActionEnd ~ v2 actionend: для pick перестраиваем список ПВЗ по новому центру,
                            // для door — геокодим центр ON SETTLE (drag end) и убираем класс .moved.
                            onActionEnd: function () {
                                if (currentLocationSwitcher === 'pick') {
                                    if (!addressMap.center) return;
                                    // map.center -> [lng,lat]; пересортировка кэша без запроса.
                                    resortPointsAround(addressMap.center[1], addressMap.center[0]);
                                } else if (currentLocationSwitcher === 'door') {
                                    // Геокодинг по центру выполняется на settle (а не каждый кадр).
                                    // map.center -> [lng,lat]; updateAddress ждёт [lat,lng].
                                    if (addressMap.center) {
                                        updateAddress([addressMap.center[1], addressMap.center[0]]);
                                    }
                                    if (mapCenterMarker) mapCenterMarker.classList.remove('moved');
                                }
                            }
                        });
                        addressMap.addChild(mapListener);

                        // Метка "Моё местоположение" — только по точным координатам
                        // браузера: серверные (по IP) могут показать чужой город.
                        if (locationLatitude && locationLongitude) {
                            updateMyLocationPlacemark(locationLatitude, locationLongitude);
                        }

                        // Точки запрошены параллельно с инициализацией карты (см.
                        // showCreateAddressLayout). Если уже пришли — вешаем на карту
                        // сразу, иначе deliverPoints сделает это по их приходу.
                        // callback вызывается один раз, когда готовы и карта, и точки —
                        // как и раньше. Повторные вызовы (перезагрузка по геолокации)
                        // безопасны: addPointsToMap идемпотентен.
                        var initialCallbackFired = false;
                        applyPointsToMap = function (data) {
                            addPointsToMap(data);
                            if (!initialCallbackFired) {
                                initialCallbackFired = true;
                                if (typeof callback === 'function') {
                                    callback();
                                }
                            }
                        };
                        if (pendingPoints) {
                            applyPointsToMap(pendingPoints);
                            pendingPoints = null;
                        }

                        isMapShowed = true;

                        let searchUrl = '/location?geocode';

                        locationAddressSearchInput.addEventListener('input', function () {
                            if (this.value != doorSelectedAddress) {
                                doorAddressLatitude = null;
                                doorAddressLongitude = null;
                                doorContinueButton.disabled = true;
                            }
                        });

                        flipAutocomplete(locationAddressSearchInput, searchUrl, {
                            selectFirst: true,
                            minChars: 1,
                            cellSeparator: "|",
                            delay: 500,
                            resultsClass: 'loc_ac_results',
                            onItemSelect: (function (item) {
                                hideAddressChooseError();
                                const div = item.querySelector('div');
                                if (!div) return;
                                let latitude = div.getAttribute('data-latitude');
                                let longitude = div.getAttribute('data-longitude');
                                const exact = parseInt(div.getAttribute('data-exact'));
                                if (!latitude || !longitude) {

                                    fetchJSON(appendDeliveryParams('/location?geocodeByLocation&address=' + div.textContent), null, function (data) {
                                        if (data) {
                                            if (data.components) {
                                                detectAddressByComponent(data.components);
                                            }

                                            if (data.location) {
                                                latitude = data.location.latitude;
                                                longitude = data.location.longitude;
                                                addressMap.setLocation({ center: YmapsV3.flip(latitude, longitude), zoom: 17 });
                                            }

                                            let displayAddress = data.address || div.textContent;
                                            if (isDeliveryExternal() && externalSelectMeta && externalSelectMeta.target === 'destination') {
                                                if (data.address) {
                                                    displayAddress = data.address;
                                                }
                                            }
                                            locationAddressSearchInput.value = displayAddress;
                                            qa('input[name=address]', locationLayer).forEach(function (el) { el.value = displayAddress; });
                                            if (data.isDelivery && data.isExact) {
                                                doorAddressLatitude = latitude;
                                                doorAddressLongitude = longitude;
                                                enableDoorContinue();
                                            } else {
                                                showAddressChooseError();
                                            }
                                        }
                                    });
                                }
                                else if (latitude && longitude && exact) {
                                    const displayAddress = div.textContent;
                                    locationAddressSearchInput.value = displayAddress;
                                    qa('input[name=address]', locationLayer).forEach(function (el) { el.value = displayAddress; });
                                    checkLocation(latitude, longitude, true);
                                } else {
                                    showAddressChooseError(true);
                                }
                            }),
                            formatItem: (function (item) {
                                return '<div data-latitude="' + item[1] + '" data-longitude="' + item[2] + '" data-exact="' + item[3] + '">' + item[0] + '</div>'
                            }),
                            extraParams: ({
                                bbox: function () {
                                    let bboxStr = '';
                                    if (boundleBox) {
                                        bboxStr = `${boundleBox[0][1]},${boundleBox[0][0]}~${boundleBox[1][1]},${boundleBox[1][0]}`;
                                    }
                                    return bboxStr;
                                }
                            })
                        });

                        if (isExpressAddress) {
                            const expressLabel = document.querySelector('.switcher #switcher-pick-2 + label');
                            if (expressLabel) expressLabel.click();
                        }
                    }).catch(function (err) {
                        if (window.console && console.error) {
                            console.error('ymaps3 address map init failed', err);
                        }
                    });
                };
                // YmapsV3.ready() сам лениво подгружает <script> v3 по ключу из <body data-ymaps-v3-key>.
                // Хардкод v2-скрипта и apikey больше не нужен.
                initYmaps();
            } else {
                if (typeof callback === 'function') {
                    callback();
                }
            }
        }

        // Подсказки «Возможно, вы имели в виду» под ошибкой неточного адреса:
        // ближайшие дома из ответа геокодера (nearHouses), клик — готовый точный адрес.
        const addressSuggestsLayer = locationLayer.querySelector('#locationAddressSuggests');
        const renderAddressSuggests = function (houses) {
            if (!addressSuggestsLayer) return;
            const list = addressSuggestsLayer.querySelector('.address-suggests-list');
            if (!list) return;
            list.replaceChildren();
            if (!houses || !houses.length) {
                vHide(addressSuggestsLayer);
                return;
            }
            houses.forEach(function (house) {
                const chip = document.createElement('a');
                chip.className = 'address-suggest-chip';
                chip.textContent = house.address;
                chip.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    updateAddressSeq++;
                    hideAddressChooseError();
                    locationAddressSearchInput.value = house.address;
                    qa('input[name=address]', locationLayer).forEach(function (el) { el.value = house.address; });
                    checkLocation(house.latitude, house.longitude, true);
                });
                list.appendChild(chip);
            });
            vShow(addressSuggestsLayer);
        };

        const checkLocation = function (latitude, longitude, isSetCenter) {
            fetchJSON(appendDeliveryParams('/location?check&latitude=' + latitude + '&longitude=' + longitude), null, function (data) {
                if (data) {
                    doorAddressLatitude = latitude;
                    doorAddressLongitude = longitude;
                    enableDoorContinue();
                    if (isSetCenter) {
                        addressMap.setLocation({ center: YmapsV3.flip(latitude, longitude), zoom: 17 });
                    }
                } else {
                    showAddressChooseError();
                }
            });
        }

        const showAddressChooseError = function (exact) {
            const checkedDoor = document.querySelector('.switcher input[name=switcher-door]:checked');
            if (checkedDoor && checkedDoor.value === 'door') {
                handleDoorAddressBackClick();
            }
            // Ненажимаемую кнопку прячем (как на мобильной): каркасный стиль
            // .nbtn:disabled сбрасывает жёлтый фон, и кнопка выглядела белой и сломанной.
            doorContinueButton.disabled = true;
            vHide(doorContinueButton);
            if (exact) {
                vShow(locationAddressErrorExactLayout);
            } else if (locationAddressErrorPickupLayout && isDeliveryExternal()
                && externalSelectMeta && externalSelectMeta.target === 'origin') {
                vShow(locationAddressErrorPickupLayout);
            } else {
                vShow(locationAddressErrorLayout);
            }
        }

        const hideAddressChooseError = function () {
            doorContinueButton.disabled = true;
            vHide(doorContinueButton);
            vHide(locationAddressErrorLayout);
            vHide(locationAddressErrorPickupLayout);
            vHide(locationAddressErrorExactLayout);
            vHide(addressSuggestsLayer);
        }

        const enableDoorContinue = function () {
            doorSelectedAddress = locationAddressSearchInput.value;
            doorContinueButton.disabled = false;
            doorContinueButton.removeAttribute('disabled');
            vShow(doorContinueButton);
            vHide(locationAddressErrorLayout);
            vHide(locationAddressErrorPickupLayout);
        }

        if (doorContinueButton) doorContinueButton.addEventListener('click', function (e) {
            e.preventDefault();
            const address = locationAddressSearchInput.value;
            // Без адреса и точки на карте дальше не пускаем, как бы кнопка ни оказалась
            // включённой: форма «Уточните адрес» сохранила бы пустой адрес.
            if (!address.trim() || !doorAddressLatitude || !doorAddressLongitude) {
                doorContinueButton.disabled = true;
                vHide(doorContinueButton);
                locationAddressSearchInput.focus();
                return;
            }
            vHide(deliveryToDoorLayout);
            qa('input[name=address]', doorAddressSelectedLayout).forEach(function (el) { el.value = address; });
            vShow(doorAddressSelectedLayout);
        });

        const handleDoorAddressBackClick = function () {
            vShow(deliveryToDoorLayout);
            vHide(doorAddressSelectedLayout);

            const fullNameInput = document.getElementById('doorFullName');
            setFormElementError(fullNameInput, false);
            qa('.full-name-error').forEach(vHide);
            qa('.full-name-error-2').forEach(vHide);
            return false;
        }

        if (doorAddressBackLayout) doorAddressBackLayout.addEventListener('click', handleDoorAddressBackClick);

        const deleteAddress = function (e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            const id = this.getAttribute('data-id')
            if (id) {
                showModal({
                    title: 'Удаление адреса',
                    content: 'Вы действительно желаете удалить адрес?',
                    buttons: '<a class="yellow nbtn m-r-16">Да</a><a class="gray nbtn close_button">Нет</a>',
                    success: function () {
                        fetchJSON('/location?removeAddress=' + id, { method: 'POST', body: new URLSearchParams() }, function (data) {
                            if (data.error) {
                                showModal({
                                    title: 'Ошибка',
                                    content: data.error,
                                    onlyClose: true
                                });
                            } else {
                                searchLocation('');
                            }
                        });
                    }
                });

            }
        }


        const editAddress = function (e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            updatedAddressId = this.getAttribute('data-id');
            if (myAddressesList && myAddressesList.length) {
                for (const a in myAddressesList) {
                    if (myAddressesList[a].id == updatedAddressId) {
                        const row = myAddressesList[a];
                        qa('input[name=fullName]', locationLayer).forEach(function (el) { el.value = row.fullName == null ? '' : row.fullName; });
                        qa('input[name=phone]', locationLayer).forEach(function (el) { el.value = row.phone == null ? '' : row.phone; });
                        if (row.organization) {
                            qa('input[name=organization]', locationLayer).forEach(function (el) { el.value = row.organization; });
                            qa('input[name=legalAddress]', locationLayer).forEach(function (el) { el.value = row.legalAddress == null ? '' : row.legalAddress; });
                            qa('input[name=bin]', locationLayer).forEach(function (el) { el.value = row.bin == null ? '' : row.bin; });
                        }
                    }
                }
            }
            qa('.title span.title-create', deliveryToDoorLayout).forEach(vHide);
            qa('.title span.title-create', pickPointLayout).forEach(vHide);

            qa('.title span.title-edit', deliveryToDoorLayout).forEach(vShow);
            qa('.title span.title-edit', pickPointLayout).forEach(vShow);

            showCreateAddressLayout();
        }


        // Скрытый эталон карточки из разметки (вне #locations-result, поэтому очистка
        // списка его не трогает). Лежит в DOM статически — ищем один раз.
        const addressItemTemplate = document.querySelector('.address-choose li.address-choose-item');

        // Карточка адреса в списке. Вынесена из searchLocation: тем же шаблоном
        // рисуются подсказки получателей (избранные / частые) в режиме посылок.
        const buildAddressListItem = function (row, options) {
            if (!addressItemTemplate) {
                return null;
            }

            const opts = options || {};
            const __subL10n = window.__locationL10n || {};
            const template = addressItemTemplate.cloneNode(true);

            let subAddress = [];
            if (row.flat) {
                subAddress.push((__subL10n.apartment || 'Квартира') + ' ' + row.flat);
            }
            if (row.entrance) {
                subAddress.push((__subL10n.entrance || 'Подъезд') + ' ' + row.entrance);
            }
            if (row.buzzer) {
                subAddress.push((__subL10n.intercom || 'Домофон') + ' ' + row.buzzer);
            }
            if (row.floor) {
                subAddress.push((__subL10n.floor || 'Этаж') + ' ' + row.floor);
            }

            const setTplText = function (selector, value) {
                const el = template.querySelector(selector);
                if (el && value !== undefined) el.textContent = value == null ? '' : value;
                return el;
            };

            const iconImg = template.querySelector('.address-choose-icon img');
            if (iconImg) iconImg.setAttribute('src', staticDomain + row.icon);
            setTplText('.address-choose-title', row.deliveryTitle);
            setTplText('.address-choose-address', row.address);
            setTplText('.address-choose-phone', row.phoneView || row.phone);
            const organizationEl = template.querySelector('.address-choose-organization');
            if (row.organization) {
                if (organizationEl) {
                    organizationEl.textContent = row.organization;
                    organizationEl.classList.add('red-text');
                }
            } else {
                vHide(organizationEl);
            }
            setTplText('.address-choose-name', row.fullName);
            const editBtn = template.querySelector('[data-location-address-edit]');
            if (editBtn) editBtn.setAttribute('data-id', row.id);
            const deleteBtn = template.querySelector('[data-location-address-delete]');
            if (deleteBtn) deleteBtn.setAttribute('data-id', row.id);
            if (subAddress && subAddress.length) {
                setTplText('.address-choose-subAddress', subAddress.join(", "));
            }
            template.setAttribute('data-address-id', row.id);
            if (row.isSelected) {
                template.classList.add('selected');
            }

            // Клоны создаются заново на каждую перерисовку — вешаем
            // обработчики сразу (unbind/bind больше не нужен)
            template.addEventListener('click', addressSelect);
            if (opts.hideActions) {
                // Частые получатели собраны по истории отправлений — удалять нечего.
                vHide(template.querySelector('.address-choose-actions'));
            } else {
                if (deleteBtn) deleteBtn.addEventListener('click', deleteAddress);
                if (editBtn) editBtn.addEventListener('click', editAddress);
            }

            return template;
        };

        const appendAddressRows = function (listUl, rows, options) {
            if (!listUl || !rows || !rows.length) {
                return;
            }

            rows.forEach(function (row) {
                myAddressesList.push(row);
                const item = buildAddressListItem(row, options);
                if (item) listUl.appendChild(item);
            });
        };

        // Список подсказок получателя: частые (топ за год).
        // Пустой ответ — сразу форма создания, как и у обычного списка адресов.
        const loadRecipientSuggestions = function () {
            const listUl = locationLayerResult.querySelector('ul.list');
            const createItem = locationLayerResult.querySelector('li.address-choose-item-create');

            const showCreateForm = function () {
                if (listUl) listUl.replaceChildren();
                vShow(createItem);
                showCreateAddressLayout();
                qa('.back-to-addresses').forEach(vHide);
            };

            const renderRows = function (data) {
                const frequent = (data && data.frequent) || [];

                if (!frequent.length) {
                    showCreateForm();
                    return;
                }

                if (listUl) listUl.replaceChildren();
                appendAddressRows(listUl, frequent, { hideActions: true });
                vShow(createItem);
            };

            // Обычный путь: страница отправки прогревает подсказки заранее и передаёт их
            // сюда готовыми — список рисуется в том же кадре, что и открытие модалки.
            if (externalSelectMeta && externalSelectMeta.recipientsData) {
                renderRows(externalSelectMeta.recipientsData);
                return;
            }

            // Запасной путь (прогрев не успел): лоадер вместо пустого списка.
            vHide(createItem);
            if (listUl) {
                const loader = document.createElement('li');
                loader.className = 'address-choose-loading';
                loader.appendChild(Object.assign(document.createElement('div'), { className: 'css-loader' }));
                listUl.replaceChildren(loader);
            }

            // Точку отправки передаём в обоих видах — как и на карту: по ней сервер
            // отсеивает направления без тарифа. `lang` обязателен: /ajax/*.php берёт
            // язык только из GET, префикса `/kk` в этом пути нет.
            const originPresetId = parseInt((externalSelectMeta && externalSelectMeta.originPresetId) || 0, 10) || 0;
            const originItem = parseInt((externalSelectMeta && externalSelectMeta.originItem) || 0, 10) || 0;
            const url = '/ajax/delivery.php?action=recipients'
                + '&origin_preset_id=' + originPresetId
                + '&origin_delivery_item=' + originItem
                + ajaxLangSuffix;
            fetchJSON(url, null, renderRows, showCreateForm);
        };

        const searchLocation = function (query) {
            if (isRecipientExternal()) {
                loadRecipientSuggestions();
                return;
            }

            if (query === '' || query.length > 1) {

                let url = (location.pathname.indexOf('/kk') === 0 ? '/kk' : '') + '/location?addresses' + (isExpressAddress ? '&express=true' : '');
                if (isDeliveryExternal()) {
                    url += '&delivery=1';
                    if (externalSelectMeta.target === 'origin') {
                        url += '&deliveryFrom=1';
                    } else if (externalSelectMeta.target === 'destination') {
                        url += '&deliveryTo=1';
                    }
                }

                fetchJSON(url, null, function (data) {

                    const listUl = locationLayerResult.querySelector('ul.list');
                    if (listUl) listUl.replaceChildren();

                    if (data.rows && data.rows.length) {
                        appendAddressRows(listUl, data.rows, {});
                    } else {
                        showCreateAddressLayout();
                        qa('.back-to-addresses').forEach(vHide);
                    }
                });
            }
        };

        // Пункт «Выбрать другой…» статичен (живёт вне ul.list) — обработчик вешается один раз
        qa('li.address-choose-item-create', locationLayerResult).forEach(function (createItem) {
            createItem.addEventListener('click', function () {
                qa('.title span.title-edit', deliveryToDoorLayout).forEach(vHide);
                qa('.title span.title-edit', pickPointLayout).forEach(vHide);
                qa('.title span.title-create', deliveryToDoorLayout).forEach(vShow);
                qa('.title span.title-create', pickPointLayout).forEach(vShow);
                // «Добавить адрес» — всегда новый, даже если до этого редактировали другой.
                updatedAddressId = null;
                showCreateAddressLayout();
            });
        });

        qa('.closestPoint').forEach(function (el) {
            el.addEventListener('click', addressSelect);
        });

        // v3-версия setCenter: строит bounds через YmapsV3.getBoundsFromPoints (формат v3 [lng,lat])
        // и применяет map.setLocation. FLIP координат уже внутри хелпера.
        const setCenter = function (map, points, zoom) {
            if (!map) return;
            // points может быть массивом или объектом с числовыми ключами (как и раньше).
            const list = Array.isArray(points) ? points : Object.values(points);
            const bounds = YmapsV3.getBoundsFromPoints(list); // [[minLng,minLat],[maxLng,maxLat]] | null
            if (!bounds) return;

            const collapsed = YmapsV3.isCollapsedBounds(bounds);
            // Сколько валидных точек реально вошло в bounds (для сохранения старого поведения points.length==1).
            const validCount = list.filter(function (pt) {
                return YmapsV3.toCoord(pt.latitude) !== null && YmapsV3.toCoord(pt.longitude) !== null;
            }).length;

            if (zoom) {
                // Явный zoom: центрируем на середине bounds с этим зумом (v2 делал setBounds+setZoom,
                // где итоговый zoom = заданному; для collapsed центр совпадает с единственной точкой).
                const centerLng = (bounds[0][0] + bounds[1][0]) / 2;
                const centerLat = (bounds[0][1] + bounds[1][1]) / 2;
                map.setLocation({ center: [centerLng, centerLat], zoom: zoom });
            } else if (validCount === 1 || collapsed) {
                map.setLocation({ center: bounds[0], zoom: 12 });
            } else {
                map.setLocation({ bounds: bounds });
            }
        }

        const showLocationModal = function () {
            const showModal = function () {
                vShow(locationLayer);

                vShow(locationLayerResult);
                vHide(addressCreateLayout);
                vHide(deliveryToDoorLayout);
                vHide(pickPointLayout);
                vHide(doorAddressSelectedLayout);
                vHide(selectedPickPintLayout);

                resetCreateAddressLayoutForContext();

                if (isDeliveryExternal()) {
                    locationLayer.classList.add('dlv-no-legal');
                    qa('.toggle input[type="checkbox"]', locationLayer).forEach(function (el) { el.checked = false; });
                    qa('.toggle .toggled input', locationLayer).forEach(function (el) {
                        el.disabled = true;
                        el.value = '';
                    });
                } else {
                    locationLayer.classList.remove('dlv-no-legal');
                }

                const contextKey = getLocationContextKey();
                const forceRefresh = isDeliveryExternal();
                if (forceRefresh || lastLocationContext !== contextKey) {
                    lastLocationContext = contextKey;
                    refreshPointsByContext();
                }
                refreshAddressListByContext();
            };

            showModal();
        };

        // Одна и та же карта адресов обслуживает три сценария, и подписи у них разные:
        //   • доставка ЗАКАЗА (касса)            — «Куда доставить заказ?»
        //   • отправка ПОСЫЛКИ (target=origin)   — «Откуда забрать посылку?»
        //   • получение ПОСЫЛКИ (target=dest.)   — «Куда доставить посылку?»
        // Раньше менялся только заголовок и подписи ПВЗ-режима, а курьерский оставался
        // с текстами заказа («Куда доставить заказ?» над картой отправки посылки).
        // Дефолты снимаем с разметки — она написана под заказ; посылочные варианты
        // приходят из переводов (__locationL10n), а не хардкодом по языку.
        const doorCreateTitleEl = deliveryToDoorLayout.querySelector('.title span.title-create');
        const pickCreateTitleEl = pickPointLayout.querySelector('.title span.title-create');
        const doorTitleEl = deliveryToDoorLayout.querySelector('.gap-8 > .title');
        const pickupTitleEl = pickPointLayout.querySelector('.gap-8 > .title');
        const pickupSubtitleEl = pickPointLayout.querySelector('.gap-8 > .light');
        const addressSearchLabelEl = deliveryToDoorLayout.querySelector('label[for="locationAddressSearch"]');
        const textOf = function (el) { return el ? el.textContent : ''; };
        const defaultTitles = {
            create: textOf(doorCreateTitleEl),
            door: textOf(doorTitleEl),
            pick: textOf(pickupTitleEl),
            pickHint: textOf(pickupSubtitleEl),
            address: locationAddressSearchInput ? (locationAddressSearchInput.getAttribute('placeholder') || '') : ''
        };
        // «Сюда не возим» у посылки значит и «адрес вне зоны», и «из выбранного пункта
        // отправки тарифа нет» — текст обязан покрывать оба случая. Подменяем разметкой,
        // а не текстом: внутри строки есть ссылка «пункт самовывоза рядом».
        const defaultCantDeliverHtml = locationAddressErrorLayout ? locationAddressErrorLayout.innerHTML : '';
        const applyCantDeliver = function (html) {
            if (locationAddressErrorLayout) {
                locationAddressErrorLayout.innerHTML = html || defaultCantDeliverHtml;
            }
        };
        const applyTitles = function (t) {
            const set = function (el, value) { if (el && value) el.textContent = value; };
            set(doorCreateTitleEl, t.create);
            set(pickCreateTitleEl, t.create);
            set(doorTitleEl, t.door);
            set(pickupTitleEl, t.pick);
            set(pickupSubtitleEl, t.pickHint);
            if (locationAddressSearchInput && t.address) {
                locationAddressSearchInput.setAttribute('placeholder', t.address);
            }
            set(addressSearchLabelEl, t.address);
        };
        const updateTitleForMode = function (options) {
            const L = window.__locationL10n || {};
            const isParcel = !!(options && options.mode === 'delivery');
            const isParcelRecipient = isParcel && options.target !== 'origin';
            document.querySelectorAll('.parcel-phone-hint').forEach(function (el) {
                el.style.display = isParcelRecipient ? 'block' : 'none';
            });
            if (isParcel && options.target === 'origin') {
                applyTitles({
                    create: ' ' + (L.parcelMethodSend || defaultTitles.create),
                    door: L.parcelWhereFromDoor || defaultTitles.door,
                    pick: L.parcelWhereFromPoint || defaultTitles.pick,
                    pickHint: L.parcelHintPointFrom || defaultTitles.pickHint,
                    address: L.parcelAddressFrom || defaultTitles.address
                });
                applyCantDeliver(null);
            } else if (isParcel) {
                applyTitles({
                    create: ' ' + (L.parcelMethodReceive || defaultTitles.create),
                    door: L.parcelWhereToDoor || defaultTitles.door,
                    pick: L.parcelWhereToPoint || defaultTitles.pick,
                    pickHint: L.parcelHintPointTo || defaultTitles.pickHint,
                    address: defaultTitles.address
                });
                applyCantDeliver(L.parcelCantDeliverTo);
            } else {
                applyTitles(defaultTitles);
                applyCantDeliver(null);
            }
        };

        window.locationAddressPicker = {
            open: function (options) {
                externalSelectHandler = options && options.onSelect ? options.onSelect : null;
                externalSelectMeta = options || null;
                lastLocationContext = null;
                updateTitleForMode(options);
                showLocationModal();
            },
            openCreate: function (options) {
                externalSelectHandler = options && options.onSelect ? options.onSelect : null;
                externalSelectMeta = options || null;
                lastLocationContext = null;
                updateTitleForMode(options);
                showLocationModal();
                showCreateAddressLayout();
            },
            clear: function () {
                resetExternalSelect();
            }
        };

        qa('li a', locationLayerResult).forEach(function (el) {
            el.addEventListener('click', locationSelect);
        });

        selectedButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                resetExternalSelect();
                showLocationModal();
            });
        });

        qa('.forceChangeLocationAddress, .forceChangeLocationExpressAddress').forEach(function (el) {
            el.addEventListener('click', function () {
                resetExternalSelect();
                isExpressAddress = this.classList.contains('forceChangeLocationExpressAddress');
                addToOrder = null;
                if (this.getAttribute('data-order-id')) {
                    addToOrder = parseInt(this.getAttribute('data-order-id'));
                }
                showLocationModal();
            });
        });

        // v3: контейнера-обёртки с fitToViewport нет. Карта создаётся уже при открытой модалке
        // (контейнер виден и имеет размеры), а v3 сам следит за ресайзом контейнера через
        // ResizeObserver, поэтому ручной reflow при переключении switcher больше не нужен.
    }

    let url_prefix_url = '';

    if (window.location.href.includes("/kk")) {
        url_prefix_url = '/kk';
    }

    qa('.forceChangePayMethod').forEach(function (payMethodBtn) {
    payMethodBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const modalTemplate = document.querySelector('.choose-payment-templates .modal-layout-template');
        const modalLayout = modalTemplate ? modalTemplate.cloneNode(true) : null;

        showModal({
            content: modalLayout,
            onlyClose: true,
            afterShow: function () {
                fetchJSON(url_prefix_url + '/order?form=pay&format=json', null, function (data) {
                    const blocks = document.createElement('div');
                    const sourceBlock = document.querySelector('.choose-payment-templates .element-block');
                    for (const i in data) {
                        if (!sourceBlock) break;
                        const template = sourceBlock.cloneNode(true);
                        template.setAttribute('data-id', data[i].id);
                        const nameEl = template.querySelector('[data-name]');
                        if (nameEl) nameEl.textContent = data[i].name;
                        const infoEl = template.querySelector('[data-info]');
                        if (infoEl) flipSetContent(infoEl, data[i].info);
                        if (data[i].noSelectedError && data[i].noSelectedError.text) {
                            const errorsEl = template.querySelector('[data-errors]');
                            if (errorsEl) {
                                errorsEl.textContent = data[i].noSelectedError.text;
                                vShow(errorsEl);
                            }
                        }
                        blocks.appendChild(template);
                        if (data[i].selected) {
                            template.classList.add('selected');
                        }
                        if (data[i].noSelectedError) {
                            template.classList.add('no-select')
                        }
                    }
                    qa('.orderPayMethodsLayout', modalLayout).forEach(function (layout) {
                        flipSetContent(layout, blocks.innerHTML);
                    });
                    qa('.orderPayMethodsLayout .element-block').forEach(function (block) {
                        block.addEventListener('click', function () {
                            const id = parseInt(this.getAttribute('data-id'));
                            if (id) {
                                const form = document.createElement('form');
                                form.style.display = 'none';
                                form.setAttribute('action', url_prefix_url + '/order?form=pay');
                                form.setAttribute('method', 'post');
                                form.insertAdjacentHTML('beforeend', '<input type="hidden" name="order_delmethod" value="' + id + '"/>');
                                form.insertAdjacentHTML('beforeend', '<input type="hidden" name="order_self" value="" />');
                                form.insertAdjacentHTML('beforeend', '<input type="hidden" name="order_step3" value="Далее" />');
                                form.insertAdjacentHTML('beforeend', '<input type="submit" class="nbtn yellow accepted_mark" value="Выбрать" />');
                                document.body.appendChild(form);
                                form.querySelector('.nbtn').click();
                            }
                        });
                    });
                });
            }
        });
    });
    });

    const cartBlocks = qa('.cart-block');
    if (cartBlocks.length) {

        // Аналог jQuery-контекста $(sel, layerCart) — поиск по всем .cart-block
        const qaCart = function (selector) {
            const found = [];
            cartBlocks.forEach(function (block) {
                qa(selector, block).forEach(function (el) { found.push(el); });
            });
            return found;
        };

        const setCheckedWithAttr = function (el, value) {
            el.checked = value;
            if (value) {
                el.setAttribute('checked', 'checked');
            } else {
                el.removeAttribute('checked');
            }
        };

        const updateTotalOfCart = function (total) {
            if (total.inCart.totalSelectedPriceFormat) {
                qa('.mclpriceDisc').forEach(function (el) { el.textContent = total.inCart.totalSelectedPriceFormat; });
            }

            if (total.inCart.maxDeliveryDay) {
                qa('.delivery-day-text .delivery-day').forEach(function (el) { el.textContent = total.inCart.maxDeliveryDay; });
                qa('.delivery-day-text').forEach(vShow);
            }

            if (total.inCart.totalCountFormat) {
                const cartCnt = document.getElementById('cart_cnt');
                if (cartCnt) cartCnt.textContent = total.inCart.totalCountFormat;
            }

            qa('.cart-tab-count').forEach(function (el) { el.textContent = total.inCart.totalSelectedCount; });

            if (total.inCart.deliveryDate) {
                qa('.delivery-day-text').forEach(vShow);
                qa('.delivery-day').forEach(function (el) { el.textContent = total.inCart.deliveryDate; });
            }

            if (total.inCart.totalSelectedCount > 0) {
                qa('input[name=order_button], .add_to_order').forEach(function (el) { el.disabled = false; el.removeAttribute('disabled'); });
            } else {
                qa('input[name=order_button], .add_to_order').forEach(function (el) { el.disabled = true; });
                qa('.delivery-day-text').forEach(vHide);
            }
        };

        const updateOrdersForm = function (orders) {
            // Блок с формой «Добавить в заказ»: .title с этим текстом, его родитель-div
            const ordersFormBlocks = [];
            qaCart('.title').forEach(function (titleEl) {
                if (titleEl.textContent.indexOf('Добавить в заказ') !== -1 &&
                    titleEl.parentElement && titleEl.parentElement.tagName === 'DIV') {
                    ordersFormBlocks.push(titleEl.parentElement);
                }
            });

            if (orders && orders.length > 0) {
                ordersFormBlocks.forEach(function (block) {
                    vShow(block);
                    const ordersSelect = block.querySelector('select[name="prod"]');
                    if (ordersSelect) {
                        ordersSelect.replaceChildren();
                        orders.forEach(function (order) {
                            const orderText = '№' + order.orderNum +
                                (order.orderSub ? '/' + order.orderSub : '') +
                                ' от ' + order.date;
                            const option = document.createElement('option');
                            option.value = order.id;
                            option.textContent = orderText;
                            ordersSelect.appendChild(option);
                        });
                    }
                });
            } else {
                ordersFormBlocks.forEach(vHide);
            }
        };

        const updateCartInfo = (function () {
            let controller = null;

            return (function () {
                if (controller !== null) {
                    // Отмена предыдущего запроса (как request.abort() у $.ajax)
                    controller.abort();
                }

                controller = new AbortController();
                fetch('/ajax/cart.php', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {'X-Requested-With': 'XMLHttpRequest'},
                    body: new URLSearchParams({ calculate: 'yes' }),
                    signal: controller.signal
                }).then(function (res) {
                    if (!res.ok) throw new Error('HTTP ' + res.status);
                    return res.json();
                }).then(function (data) {
                    controller = null;

                    const recommendationLayer = document.getElementById('recommendation-summa-layer');
                    if (recommendationLayer) recommendationLayer.replaceChildren();

                    if (data.count) {
                        if (!(data.count.cart)) {
                            // Пустая корзина — перезагрузка
                            return location.reload(true);
                        }

                        qa('.cart_cnt').forEach(function (el) { el.textContent = data.count.cart; });
                    }

                    if ('recommendation' in data) {
                        if (('summa' in data['recommendation']) && data['recommendation']['summa']['content'] && recommendationLayer) {
                            flipSetContent(recommendationLayer, data['recommendation']['summa']['content']);
                        }
                    }

                    if (data.summa) {
                        qa('.cart_sum').forEach(function (el) { el.textContent = data.summa.show; });
                    }
                })['catch'](function () {});
            });
        }());

        const isAllSelectedChecked = function (layout) {
            let checked = true;
            let hasEligible = false;
            qa('input[name*=selected]', layout).forEach(function (input) {
                if (input.getAttribute('name') === 'selected[]' && !input.disabled) {
                    hasEligible = true;
                    if (!input.checked) {
                        checked = false;
                    }
                }
            });

            qa('input[name=selectedAll]', layout).forEach(function (input) {
                setCheckedWithAttr(input, hasEligible && checked);
            });
        };

        const saveSelected = function (layout) {
            let selected = [];
            let unselected = [];

            qa('input[name=order_button], .add_to_order').forEach(function (el) { el.disabled = true; });

            qa('input[name="selected[]"]', layout).forEach(function (input) {
                if (!input.disabled) {
                    if (input.checked) {
                        selected.push(input.value);
                    } else {
                        unselected.push(input.value);
                    }
                }
            });

            if (selected.length || unselected.length) {
                const body = new URLSearchParams();
                selected.forEach(function (v) { body.append('selected[]', v); });
                unselected.forEach(function (v) { body.append('unselected[]', v); });
                fetchJSON('/ajax/cart.php', { method: 'POST', body: body }, function (data) {

                    if (data.result) {
                        updateTotalOfCart(data.data);
                        updateOrdersForm(data.orders);

                        // «Доставим: …» пересчитан сервером под новый состав выбранных
                        if (typeof data.maxDeliveryClient !== 'undefined' && data.maxDeliveryClient) {
                            qa('.cart-blok-sticky .delivery-day').forEach(function (el) {
                                el.textContent = data.maxDeliveryClient;
                                const dayText = el.closest('.delivery-day-text');
                                if (dayText) vShow(dayText);
                            });
                        }
                    }
                    qaCart('input[name*=selected]').forEach(function (el) { el.disabled = false; el.removeAttribute('disabled'); });
                });
            } else {
                qa('.delivery-day-text').forEach(vHide);
            }
        };

        // Замена .live(): делегирование change на document, включая динамические инпуты
        document.addEventListener('change', function (e) {
            const target = e.target;
            if (!target.matches) return;

            if (target.matches('.cart-block input[name*=selected]') && target.getAttribute('name') === 'selected[]') {
                const block = target.closest('.cart-block');
                isAllSelectedChecked(block);
                if (block && block.getAttribute('data-available')) {
                    saveSelected(block);
                }
            }

            if (target.matches('.cart-block input[name=selectedAll]')) {
                const block = target.closest('.cart-block');
                qa('input[name*=selected]', block).forEach(function (input) {
                    if (input.getAttribute('name') === 'selected[]' && !input.disabled) {
                        setCheckedWithAttr(input, target.checked);
                    }
                });
                if (block && block.getAttribute('data-available')) {
                    saveSelected(block);
                }
            }
        });

        // Замена .live(): делегированный click для кнопок массовых действий
        document.addEventListener('click', function (e) {
            const removeBtn = e.target.closest ? e.target.closest('.action_btn[data-cart-remove]') : null;
            if (removeBtn) {
                e.preventDefault();
                e.stopPropagation();
                const block = removeBtn.closest('.cart-block');
                const selectedItems = [];
                const selectedProduceIds = [];
                qa('input[name="selected[]"]:checked', block).forEach(function (input) {
                    if (!input.disabled) {
                        selectedItems.push(input.value);
                        const flexRow = input.closest('.cart-flex');
                        const fav = flexRow ? flexRow.querySelector('input[data-favorite-checker]') : null;
                        const pid = fav ? fav.getAttribute('data-id') : null;
                        if (pid) selectedProduceIds.push(String(pid));
                    }
                });

                if (selectedItems.length === 0) {
                    return;
                }

                showModal({
                    title: 'Удаление товаров',
                    content: 'Вы действительно хотите удалить выбранные товары (' + selectedItems.length + ' шт.)?',
                    buttons: '<a class="yellow nbtn m-r-16">Удалить</a><a class="gray nbtn close_button">Отмена</a>',
                    success: function () {
                        // Блокируем кнопку на время удаления
                        removeBtn.disabled = true;
                        removeBtn.setAttribute('disabled', 'disabled');

                        const body = new URLSearchParams({ massDelete: 'true' });
                        selectedItems.forEach(function (v) { body.append('items[]', v); });
                        fetchJSON('/ajax/cart.php', { method: 'POST', body: body }, function (data) {
                            if (data.result) {
                                if (typeof gtag === 'function' && selectedProduceIds.length) {
                                    gtag('event', 'remove_from_cart', {
                                        items: selectedProduceIds.map(function (pid) { return { item_id: pid }; })
                                    });
                                }
                                // Перезагружаем страницу для обновления корзины
                                location.reload();
                            } else {
                                showModal({
                                    title: 'Ошибка',
                                    content: data.error || 'Произошла ошибка при удалении товаров',
                                    onlyClose: true
                                });
                                removeBtn.disabled = false;
                                removeBtn.removeAttribute('disabled');
                            }
                        }, function () {
                            showModal({
                                title: 'Ошибка',
                                content: 'Произошла ошибка при удалении товаров',
                                onlyClose: true
                            });
                            removeBtn.disabled = false;
                            removeBtn.removeAttribute('disabled');
                        });
                    }
                });
                return;
            }

            const favBtn = e.target.closest ? e.target.closest('.action_btn[data-cart-add-favorite]') : null;
            if (favBtn) {
                e.preventDefault();
                e.stopPropagation();
                const block = favBtn.closest('.cart-block');
                const produceIdMap = {};
                qa('input[name="selected[]"]:checked', block).forEach(function (input) {
                    if (!input.disabled) {
                        // .parent().next('.cart-prod-flex') — строка товара за чекбоксом
                        const parent = input.parentElement;
                        const row = parent && parent.nextElementSibling && parent.nextElementSibling.classList.contains('cart-prod-flex')
                            ? parent.nextElementSibling : null;
                        const fav = row ? row.querySelector('input[data-favorite-checker]') : null;
                        const pid = fav ? fav.getAttribute('data-id') : null;
                        if (pid) {
                            produceIdMap[pid] = true;
                        }
                    }
                });
                const ids = Object.keys(produceIdMap);
                if (ids.length === 0) {
                    return;
                }

                const addMultipleFav = (typeof window.addMultipleToFavorites === 'function')
                    ? window.addMultipleToFavorites
                    : null;

                if (!addMultipleFav) {
                    showModal({
                        title: 'Избранное',
                        content: 'Функция избранного недоступна. Попробуйте позже.',
                        onlyClose: true
                    });
                    return;
                }

                favBtn.disabled = true;
                favBtn.setAttribute('disabled', 'disabled');

                // Массовое добавление одним запросом
                addMultipleFav(ids, function (result) {
                    // Помечаем все чекбоксы как отмеченные
                    ids.forEach(function (id) {
                        qa('input[data-favorite-checker][data-id="' + id + '"]').forEach(function (input) {
                            setCheckedWithAttr(input, true);
                        });
                    });

                    // Подтверждение - вспышка красного сердечка на кнопке
                    favBtn.classList.add('fav-flash');
                    setTimeout(function () {
                        favBtn.classList.remove('fav-flash');
                    }, 1000);
                    favBtn.disabled = false;
                    favBtn.removeAttribute('disabled');
                }, function () {
                    favBtn.disabled = false;
                    favBtn.removeAttribute('disabled');
                });
            }
        });

        let timeoutCartChange = null;

        // Блокировка контролов количества на время запроса
        const setSteppersDisabled = function (disabled) {
            const controls = qaCart('.cart-stepper__input, .cart-stepper__btn');
            if (disabled) {
                controls.forEach(function (el) { el.disabled = true; });
            } else {
                controls.forEach(function (el) { el.disabled = false; el.removeAttribute('disabled'); });
                syncStepperLimits();
            }
        };

        // Кнопка «+» недоступна, когда достигнут максимум
        const syncStepperLimits = function () {
            qaCart('input.cart-stepper__input').forEach(function (input) {
                const max = parseInt(input.getAttribute('max'), 10) || 0;
                const val = parseInt(input.value, 10) || 0;
                const stepper = input.closest('.cart-stepper');
                const plus = stepper ? stepper.querySelector('[data-step="1"]') : null;
                if (!plus) return;
                if (max > 0 && val >= max) {
                    plus.disabled = true;
                } else {
                    plus.disabled = false;
                    plus.removeAttribute('disabled');
                }
            });
        };

        const updateCartCount = function (id, count) {

            setSteppersDisabled(true);
            let oldCount = count;

            const body = new URLSearchParams({ changeCnt: 'true' });
            body.append('products[0][id]', id);
            body.append('products[0][count]', count);
            fetchJSON('/ajax/cart.php', { method: 'POST', body: body }, function (data) {

                if (data.result) {

                    data = data.data;

                    if (data.counts) {
                        for (let c in data.counts) {
                            let count = data.counts[c];
                            let input = null;
                            for (const block of cartBlocks) {
                                input = block.querySelector('input.cart-stepper__input[data-id="' + count.id + '"]');
                                if (input) break;
                            }

                            if (input) {

                                if (oldCount > count.count) {
                                    input.classList.add('text-danger');
                                }

                                input.value = count.count;

                                const row = input.closest('.cart-flex');
                                if (row) {
                                    const setRowText = function (selector, value) {
                                        row.querySelectorAll(selector).forEach(function (el) {
                                            if (value !== undefined) el.textContent = value == null ? '' : value;
                                        });
                                    };
                                    setRowText('[data-price]', count.price);
                                    setRowText('[data-price-not-disc]', count.priceWithoutDisc);
                                    setRowText('[data-summa-saving]', count.saving);
                                    setRowText('[data-summa-total]', count.summa);
                                    setRowText('[data-summa-total-not-disc]', count.summaWithoutDisc);

                                    // Срок зависит от количества: сверх складского
                                    // остатка позиция уезжает поставкой
                                    if (typeof count.deliveryInStore === 'boolean') {
                                        row.querySelectorAll('[data-delivery-type]').forEach(function (el) {
                                            el.classList.toggle('in-stock', count.deliveryInStore);
                                            el.classList.toggle('to-order', !count.deliveryInStore);
                                            if (count.deliveryTypeText) el.textContent = count.deliveryTypeText;
                                        });
                                    }

                                    if (typeof count.deliveryText === 'string') {
                                        setRowText('[data-delivery-date]', count.deliveryText);
                                    }
                                }
                            }
                        }
                    }

                    if (data.total && data.total.inCart) {
                        updateTotalOfCart(data.total);
                        updateOrdersForm(data.orders);
                    }

                    // «Доставим: …» пересчитан сервером под новое количество
                    if (data.maxDeliveryClient) {
                        qa('.cart-blok-sticky .delivery-day').forEach(function (el) {
                            el.textContent = data.maxDeliveryClient;
                            const dayText = el.closest('.delivery-day-text');
                            if (dayText) vShow(dayText);
                        });
                    }
                }

                setSteppersDisabled(false);
            }, function () {
                setSteppersDisabled(false);
            });
        };

        // Количество «0» — удаление позиции из корзины
        const deleteCartRow = function (id) {
            setSteppersDisabled(true);

            fetchJSON('/ajax/cart.php', { method: 'POST', body: new URLSearchParams({ 'delete': id }) }, function (data) {
                if (data && data.delete) {
                    location.reload();
                } else {
                    setSteppersDisabled(false);
                    showModal({
                        title: 'Ошибка',
                        content: (data && data.error) || 'Не удалось удалить товар из корзины',
                        onlyClose: true
                    });
                }
            }, function () {
                setSteppersDisabled(false);
            });
        };

        // Делегирование внутри каждого cart-block (замена layerCart.on(selector))
        cartBlocks.forEach(function (block) {
            block.addEventListener('click', function (e) {
                const btn = e.target.closest ? e.target.closest('.cart-stepper__btn') : null;
                if (!btn || !block.contains(btn)) return;
                e.preventDefault();
                e.stopPropagation();
                if (btn.disabled) {
                    return;
                }

                const stepper = btn.closest('.cart-stepper');
                const input = stepper ? stepper.querySelector('input.cart-stepper__input') : null;
                if (!input) return;
                const dir = parseInt(btn.getAttribute('data-step'), 10) || 0;
                const max = parseInt(input.getAttribute('max'), 10) || 0;

                let next = (parseInt(input.value, 10) || 0) + dir;
                if (next < 0) next = 0;
                if (max > 0 && next > max) next = max;

                input.value = next;
                syncStepperLimits();
                input.dispatchEvent(new Event('change', {bubbles: true}));
            });

            const onStepperInputChange = function (e) {
                const input = e.target.closest ? e.target.closest('input.cart-stepper__input') : null;
                if (!input || !block.contains(input)) return;

                input.classList.remove('text-danger');
                syncStepperLimits();

                if (timeoutCartChange) {
                    clearTimeout(timeoutCartChange);
                }

                timeoutCartChange = setTimeout(function () {

                    const value = parseInt(input.value, 10);

                    if (isNaN(value)) {
                        return;
                    }

                    if (value <= 0) {
                        deleteCartRow(input.getAttribute('data-id'));
                        return;
                    }

                    const max = parseInt(input.getAttribute('max'), 10) || 0;
                    if (max > 0 && value > max) {
                        input.value = max;
                    }

                    updateCartCount(input.getAttribute('data-id'), input.value);

                }, 600);
            };
            block.addEventListener('keyup', onStepperInputChange);
            block.addEventListener('change', onStepperInputChange);
        });

        syncStepperLimits();
    }

    const orderViewLayer = document.getElementById('order-view-layer');
    if (orderViewLayer) {

        let changeGoodsType = 'cancel';

        let cancelGoodsChange = orderViewLayer.querySelector('.cancel-goods-change');
        let cancelGoodsReturn = orderViewLayer.querySelector('.cancel-goods-return');
        let cancelGoodsButton = orderViewLayer.querySelector('.cancel-goods-button');
        let cancelGoodsBlock = orderViewLayer.querySelector('.cancel-goods-block');
        let cancelOrderReasonId = orderViewLayer.querySelector('#cancelOrderReasonId');
        let cancelGoodsReason = orderViewLayer.querySelector('select[name=cancelGoodsReason]');
        let cancelGoodsCustomReason = orderViewLayer.querySelector('textarea[name=cancelGoodsReasonCustom]');
        let cancelGoodsGoods = orderViewLayer.querySelector('.cancel-goods-goods');

        let splitGoodsChange = orderViewLayer.querySelector('.split-goods-change');
        let splitGoodsGoods = orderViewLayer.querySelector('.split-goods-goods');
        let splitGoodsButton = orderViewLayer.querySelector('.split-goods-button');
        let splitGoodsBlock = orderViewLayer.querySelector('.split-goods-block');
        let changeGoodsTitle = orderViewLayer.querySelector('#change-goods-title');

        const getReasonAndGoods = function () {
            let reason = {
                "id": cancelGoodsReason ? cancelGoodsReason.value : undefined,
                "text": null
            };

            if (cancelGoodsReason && cancelGoodsReason.value === '-1') {
                reason.text = cancelGoodsCustomReason ? cancelGoodsCustomReason.value : null;
            }

            let goods = [];

            let inputName = '';

            if (changeGoodsType === 'cancel') {
                inputName = 'cancelGoods';
            }

            if (changeGoodsType === 'split') {
                inputName = 'splitGoods';
            }

            qa('.cancel-checkbox input[type=checkbox][name=' + inputName + ']:checked', orderViewLayer).forEach(function (input) {
                goods.push({
                    'idGoods': input.getAttribute('data-id'),
                    'count': input.value
                });
            });

            if (changeGoodsType === 'cancel') {
                return { 'reason': reason, 'cancelGoods': goods };
            }

            if (changeGoodsType === 'split') {
                return { 'splitGoods': goods };
            }
        };

        const isCanCancelGoods = function () {
            // Кнопки не блокируются (логика давно закомментирована в оригинале) —
            // оставлена только валидация данных на месте вызова
        };

        const checkCanceled = function () {

            const data = getReasonAndGoods();

            if (data && data.reason && data.cancelGoods.length > 0) {
                isCanCancelGoods();
            } else {
                if (cancelGoodsBlock) qa('.title-black', cancelGoodsBlock).forEach(vHide);
                if (cancelGoodsGoods) cancelGoodsGoods.replaceChildren();

                qa('.cancel-checkbox input', orderViewLayer).forEach(function (el) { el.disabled = false; el.removeAttribute('disabled'); });
            }
        };

        const checkSplited = function () {

            const data = getReasonAndGoods();

            if (data && data.splitGoods.length > 0) {
                isCanCancelGoods();
            } else {
                if (splitGoodsBlock) qa('.title-black', splitGoodsBlock).forEach(vHide);
                if (splitGoodsGoods) splitGoodsGoods.replaceChildren();

                qa('.cancel-checkbox input', orderViewLayer).forEach(function (el) { el.disabled = false; el.removeAttribute('disabled'); });
            }
        };

        if (cancelOrderReasonId) {
            cancelOrderReasonId.addEventListener('change', function () {
                let value = this.value;

                const reasonLayer = document.getElementById('cancelOrderReasonLayer');
                if (value == -1) {
                    vShow(reasonLayer);
                } else {
                    vHide(reasonLayer);
                }
                const reasonField = document.getElementById('cancelOrderReason');
                if (reasonField) {
                    if (value == -1) {
                        reasonField.setAttribute('required', 'yes');
                    } else {
                        reasonField.removeAttribute('required');
                    }
                }
            });
        }

        qa('.cancel-checkbox input', orderViewLayer).forEach(function (input) {
            input.addEventListener('change', function () {
                if (changeGoodsType === 'cancel') {
                    checkCanceled();
                }

                if (changeGoodsType === 'split') {
                    checkSplited();
                }
            });
        });

        if (cancelGoodsChange) cancelGoodsChange.addEventListener('click', function () {
            changeGoodsType = 'cancel';
            vHide(cancelGoodsChange);
            vHide(splitGoodsChange);
            qa('.goods-count-text', orderViewLayer).forEach(vHide);
            qa('.hide-on-edit').forEach(vHide);
            vShow(cancelGoodsReturn);
            vShow(cancelGoodsBlock);

            qa('.cancel-checkbox input[name=cancelGoods]', orderViewLayer).forEach(function (el) {
                el.disabled = false;
                el.removeAttribute('disabled');
                vShow(el);
            });
            qa('.cancel-checkbox input[name=splitGoods]', orderViewLayer).forEach(function (el) {
                el.disabled = true;
                vHide(el);
            });

            qa('.cancel-checkbox', orderViewLayer).forEach(vShow);
            qa('.goods-count-select', orderViewLayer).forEach(vShow);

            if (changeGoodsTitle) changeGoodsTitle.textContent = 'Выбрать товары для отмены';

            isCanCancelGoods();
        });

        if (splitGoodsChange) splitGoodsChange.addEventListener('click', function () {
            changeGoodsType = 'split';
            vHide(cancelGoodsChange);
            vHide(splitGoodsChange);
            qa('.goods-count-text', orderViewLayer).forEach(vHide);
            qa('.hide-on-edit').forEach(vHide);

            vShow(cancelGoodsReturn);
            vShow(splitGoodsBlock);

            qa('.cancel-checkbox input[name=cancelGoods]', orderViewLayer).forEach(function (el) {
                el.disabled = true;
                vHide(el);
            });
            qa('.cancel-checkbox input[name=splitGoods]', orderViewLayer).forEach(function (el) {
                el.disabled = false;
                el.removeAttribute('disabled');
                vShow(el);
            });

            qa('.cancel-checkbox', orderViewLayer).forEach(vShow);
            qa('.goods-count-select', orderViewLayer).forEach(vShow);
            if (changeGoodsTitle) changeGoodsTitle.textContent = 'Выбрать товары для деления';
            isCanCancelGoods();
        });

        if (cancelGoodsReturn) cancelGoodsReturn.addEventListener('click', function () {
            vHide(cancelGoodsReturn);
            vHide(cancelGoodsBlock);
            vHide(splitGoodsBlock);
            qa('.cancel-checkbox', orderViewLayer).forEach(vHide);
            qa('.goods-count-select', orderViewLayer).forEach(vHide);
            qa('.hide-on-edit').forEach(vShow);

            qa('.cancel-checkbox input[name=cancelGoods], .cancel-checkbox input[name=splitGoods]', orderViewLayer).forEach(function (el) {
                el.disabled = true;
                vHide(el);
            });

            vShow(cancelGoodsChange);
            vShow(splitGoodsChange);
            if (changeGoodsTitle) changeGoodsTitle.textContent = 'Заказанные товары';
            qa('.goods-count-text', orderViewLayer).forEach(vShow);
        });

        if (cancelGoodsCustomReason) cancelGoodsCustomReason.addEventListener('keyup', function () {
            isCanCancelGoods();
        });

        qa('.cancelGoodsCnt', orderViewLayer).forEach(function (cntInput) {
            const syncCountToCheckbox = function () {
                const row = cntInput.closest('.row');
                if (!row) return;
                row.querySelectorAll('.cancel-checkbox input[type=checkbox]').forEach(function (checkbox) {
                    checkbox.value = cntInput.value;
                });
            };
            cntInput.addEventListener('change', syncCountToCheckbox);
            cntInput.addEventListener('keyup', syncCountToCheckbox);
        });

        if (cancelGoodsReason) cancelGoodsReason.addEventListener('change', function () {
            if (this.value === '-1') {
                vShow(cancelGoodsCustomReason);
            } else {
                vHide(cancelGoodsCustomReason);
            }

            isCanCancelGoods();
        });

        if (cancelGoodsButton) cancelGoodsButton.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const data = getReasonAndGoods();

            if (!data || !data.cancelGoods || data.cancelGoods.length === 0) {
                showModal({
                    title: 'Ошибка',
                    content: 'Отметьте товары, которые необходимо отменить',
                    onlyClose: true
                });
            } else {
                cancelGoodsButton.disabled = true;

                fetchJSON(window.location.href, { method: 'POST', body: flipParam(data) }, function (result) {

                    cancelGoodsButton.disabled = false;

                    if (result.data.accept) {

                        // Шаблон подтверждения приходит HTML-строкой — парсим во wrapper,
                        // чтобы найти поля до вставки в модалку (как $(result.data.template))
                        const wrapper = document.createElement('div');
                        flipSetContent(wrapper, result.data.template);
                        const modalNodes = Array.prototype.slice.call(wrapper.childNodes);

                        const modalReason = wrapper.querySelector('select[name=cancelGoodsReason]');
                        const modalCustomReason = wrapper.querySelector('textarea[name=cancelGoodsReasonCustom]');

                        if (modalReason) modalReason.addEventListener('change', function () {
                            if (this.value === '-1') {
                                vShow(modalCustomReason);
                            } else {
                                vHide(modalCustomReason);
                            }
                        });

                        showModal({
                            title: 'Подтвердите отмену',
                            content: modalNodes,
                            notCloseInSuccess: true,
                            buttons: '<a class="yellow nbtn m-r-16">Отменить товары</a>',
                            success: function () {

                                let isValid = false;

                                if (result && result.data && result.data.template && modalReason) {
                                    if (modalReason.reportValidity()) {
                                        isValid = true;
                                        if (modalReason.value == -1) {
                                            isValid = !!(modalCustomReason && modalCustomReason.reportValidity());
                                        }
                                    } else {
                                        isValid = false;
                                    }
                                }

                                if (isValid) {
                                    data.reason.id = modalReason.value;
                                    if (data.reason.id == -1) {
                                        data.reason.text = modalCustomReason ? modalCustomReason.value : null;
                                    }

                                    cancelGoodsButton.disabled = false;
                                    cancelGoodsButton.removeAttribute('disabled');

                                    data['accept'] = true;

                                    const defaultModal = document.getElementById('modal-default');
                                    if (defaultModal) defaultModal.remove();

                                    fetchJSON(window.location.href, { method: 'POST', body: flipParam(data) }, function (data) {
                                        if (data.data.success) {
                                            window.location.reload();
                                        } else {
                                            showModal({
                                                title: 'Ошибка',
                                                content: ((data.data.errorMessage) ? data.data.errorMessage : data.data.error),
                                                onlyClose: true
                                            });
                                        }
                                    });
                                }
                            },
                        });

                    } else {

                        showModal({
                            title: 'Ошибка',
                            content: ((result.data.errorMessage) ? result.data.errorMessage : result.data.error),
                            onlyClose: true
                        });
                    }

                    qa('.cancel-checkbox input', orderViewLayer).forEach(function (el) { el.disabled = false; el.removeAttribute('disabled'); });
                }, function () {

                    cancelGoodsButton.disabled = false;

                    showModal({
                        title: 'Ошибка',
                        content: ((data.errorMessage) ? data.errorMessage : data.error),
                        onlyClose: true
                    });

                    if (cancelGoodsGoods) cancelGoodsGoods.replaceChildren();

                    qa('.cancel-checkbox input', orderViewLayer).forEach(function (el) { el.disabled = false; el.removeAttribute('disabled'); });
                });
            }
        });

        if (splitGoodsButton) splitGoodsButton.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const data = getReasonAndGoods();

            if (!data || !data.splitGoods || data.splitGoods.length === 0) {
                showModal({
                    title: 'Ошибка',
                    content: 'Отметьте товары, которые необходимо отделить в другую часть заказа',
                    onlyClose: true
                });
            } else {

                splitGoodsButton.disabled = true;

                fetchJSON(window.location.href, { method: 'POST', body: flipParam(data) }, function (result) {
                    splitGoodsButton.disabled = false;
                    if (result.data.accept) {

                        showModal({
                            title: 'Деление заказа',
                            content: result.data.template,
                            buttons: '<a class="yellow nbtn m-r-16">Подтвердить деление заказа</a>',
                            success: function () {
                                splitGoodsButton.disabled = false;
                                splitGoodsButton.removeAttribute('disabled');

                                data['accept'] = true;

                                fetchJSON(window.location.href, { method: 'POST', body: flipParam(data) }, function (data) {

                                    if (data.data.success) {
                                        window.location.reload();
                                    } else {
                                        showModal({
                                            title: 'Ошибка',
                                            content: ((data.data.errorMessage) ? data.data.errorMessage : data.data.error),
                                            onlyClose: true
                                        });
                                    }

                                });
                            },
                        });

                    } else {

                        showModal({
                            title: 'Ошибка',
                            content: ((result.data.errorMessage) ? result.data.errorMessage : result.data.error),
                            onlyClose: true
                        });
                    }

                    qa('.cancel-checkbox input', orderViewLayer).forEach(function (el) { el.disabled = false; el.removeAttribute('disabled'); });
                }, function () {

                    splitGoodsButton.disabled = false;

                    showModal({
                        title: 'Ошибка',
                        content: ((data.errorMessage) ? data.errorMessage : data.error),
                        onlyClose: true
                    });

                    if (splitGoodsGoods) splitGoodsGoods.replaceChildren();

                    qa('.cancel-checkbox input', orderViewLayer).forEach(function (el) { el.disabled = false; el.removeAttribute('disabled'); });
                });
            }
        });

        isCanCancelGoods();
    }

    // страница вакансий
    const vacancyLayout = document.getElementById('vacancy');
    if (vacancyLayout) {
        const citySelect = vacancyLayout.querySelector('select[name=city]');
        const departmentSelect = vacancyLayout.querySelector('select[name=department]');
        const fileSelect = vacancyLayout.querySelector('#file');
        const vacanciesList = vacancyLayout.querySelector('.vacancies-list');
        const form = vacancyLayout.querySelector('form');

        const loadData = function () {

            if (vacanciesList) {
                vacanciesList.innerHTML = '<div id="loader" class="text-center" style="padding: 20px;">\n' +
                    '    <div class="css-loader"></div>\n' +
                    '</div>';
            }

            const params = new URLSearchParams();
            params.append('search', 'true');

            if (citySelect && citySelect.value) {
                params.append('city', citySelect.value);
            }

            if (departmentSelect && departmentSelect.value) {
                params.append('department', departmentSelect.value);
            }

            fetch('/vacancies', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {'X-Requested-With': 'XMLHttpRequest'},
                body: params
            }).then(function (res) { return res.json(); }).then(function (data) {
                if (data.html && vacanciesList) {
                    flipSetContent(vacanciesList, data.html);
                }
            })['catch'](function () {});
        };

        if (citySelect) citySelect.addEventListener('change', loadData);
        if (departmentSelect) departmentSelect.addEventListener('change', loadData);

        if (fileSelect) {
            fileSelect.addEventListener('change', function () {
                const next = fileSelect.nextElementSibling;
                if (next && fileSelect.files.length) {
                    next.textContent = 'Выбран файл:' + fileSelect.files[0].name;
                }
            });
        }

        if (form) {
            form.addEventListener('submit', function (e) {
                e.stopPropagation();
                e.preventDefault();

                const submitButtons = Array.prototype.slice.call(form.querySelectorAll('.btn-primary'));
                submitButtons.forEach(function (btn) { btn.disabled = true; vHide(btn); });
                const formLoader = form.querySelector('#form-loader');
                if (formLoader) vShow(formLoader);

                fetch(form.getAttribute('action') || window.location.href, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {'X-Requested-With': 'XMLHttpRequest'},
                    body: new FormData(form)
                }).then(function (res) { return res.json(); }).then(function (data) {
                    if (data.status) {
                        showMessage('Ваше сообщение успешно отправлено. В ближайшее время мы свяжемся с Вами.', 'm_message');
                    }
                    else if (data.error) {
                        showMessage(data.error);
                    }
                    else if (data.errors) {
                        showMessage(data.errors.join('<br/>'));
                    }
                    else {
                        showMessage('Не удалось отправить сообщение');
                    }

                    if (formLoader) vHide(formLoader);
                    submitButtons.forEach(function (btn) { btn.removeAttribute('disabled'); vShow(btn); });
                })['catch'](function () {});
            });
        }
    }

    document.querySelectorAll('#orders-list-form select').forEach(function (select) {
        select.addEventListener('change', function () {
            vSubmitForm(select.closest('form'));
        });
    });

    const tabsLayer = document.querySelector('.tabs');
    if (tabsLayer) {

        const tabHeaders = Array.prototype.slice.call(document.querySelectorAll('.tabs .tab-header'));
        const tabContents = Array.prototype.slice.call(document.querySelectorAll('.tabs .tab-content'));

        let isEnableHistory = false;
        if (document.querySelector('.tabs input[name=auth_history]')) {
            isEnableHistory = true;
        }

        const regInfoToggle = document.getElementById('reg-info');
        if (regInfoToggle) {
            regInfoToggle.addEventListener('click', function () {
                document.querySelectorAll('.reg-info').forEach(function (el) {
                    if (getComputedStyle(el).display === 'block') {
                        vSlideUp(el, 200);
                    } else {
                        vSlideDown(el, 200);
                    }
                });
            });
        }

        const toRecovery = document.getElementById('to-recovery-password');
        if (toRecovery) {
            toRecovery.addEventListener('click', function () {
                document.querySelectorAll('.login_block').forEach(vHide);
                document.querySelectorAll('.recovery_password_block').forEach(function (el) {
                    vSlideDown(el, 200, function () {
                        const value = document.getElementById('value');
                        if (value) value.focus();
                    });
                });
                if (isEnableHistory) {
                    window.history.pushState({ showRecoveryPassword: true, changeTab: true, tabIndex: 0 }, 'Восстановление пароля', '/user?forgotpassword');
                }
            });
        }

        const toLogin = document.getElementById('to-login');
        if (toLogin) {
            toLogin.addEventListener('click', function () {
                document.querySelectorAll('.recovery_password_block').forEach(vHide);
                document.querySelectorAll('.login_block').forEach(function (el) {
                    vSlideDown(el, 200, function () {
                        const username = document.getElementById('username');
                        if (username) username.focus();
                    });
                });
                if (isEnableHistory) {
                    window.history.pushState({ showLogin: true, changeTab: true, tabIndex: 0 }, 'Вход', '/user?entry');
                }
            });
        }

        const showTab = function (count) {
            tabHeaders.forEach(function (header) { header.classList.remove('active'); });
            tabContents.forEach(vHide);
            const content = tabContents[count];
            if (content) {
                vSlideDown(content, 300, function () {
                    if (content.querySelector('.recovery_password_block')) {
                        content.querySelectorAll('.recovery_password_block, .login_block').forEach(function (block) {
                            if (getComputedStyle(block).display != 'none') {
                                const input = block.querySelector('input');
                                if (input) input.focus();
                            }
                        });
                    } else {
                        const input = content.querySelector('input');
                        if (input) input.focus();
                    }
                });
            }
            if (tabHeaders[count]) tabHeaders[count].classList.add('active');
        }

        window.onpopstate = function (event) {
            if (event.state) {
                if (event.state.changeTab) {
                    showTab(event.state.tabIndex);
                }

                if (event.state.showRecoveryPassword) {
                    document.querySelectorAll('.login_block').forEach(vHide);
                    document.querySelectorAll('.recovery_password_block').forEach(function (el) {
                        vSlideDown(el, 200);
                    });
                }

                if (event.state.showLogin) {
                    document.querySelectorAll('.recovery_password_block').forEach(vHide);
                    document.querySelectorAll('.login_block').forEach(function (el) {
                        vSlideDown(el, 200);
                    });
                }
            }
        }

        tabHeaders.forEach(function (header) {
            header.addEventListener('click', function () {
                if (!header.classList.contains('active')) {
                    let count = 0;
                    let prev = header.previousElementSibling;
                    while (prev) { count++; prev = prev.previousElementSibling; }
                    showTab(count);
                    if (isEnableHistory && header.getAttribute('data-url')) {
                        window.history.pushState({ changeTab: true, tabIndex: count }, header.getAttribute('data-title'), header.getAttribute('data-url'));
                    }
                }
            });
        });
    }
    document.querySelectorAll('.s-h-password').forEach(function (eye) {
        eye.addEventListener('click', function () {
            const inputs = eye.parentElement ? eye.parentElement.querySelectorAll('input') : [];
            if (!inputs.length) return;
            const newType = inputs[0].type === 'password' ? 'text' : 'password';
            inputs.forEach(function (input) { input.type = newType; });
        });
    });

    const orderPursePayment = document.getElementById('order_purse_payment');
    if (orderPursePayment) {
        orderPursePayment.querySelectorAll('input[name=pay_client_purse]').forEach(function (payCheckbox) {
            payCheckbox.addEventListener('click', function () {
                const bonuses = Number(payCheckbox.getAttribute('data-bonuses'));
                const purse = Number(payCheckbox.getAttribute('data-purse'));
                const format = (num) => num.toLocaleString('ru-RU');
                let title_ru = '';
                let title_kk = '';

                let lang = document.documentElement.getAttribute('lang');

                if (bonuses > 0 && purse > 0) {
                    title_ru = 'Оплатить бонусами ' + format(bonuses) + '<span class="font-flipIcons">Б</span> и ' + format(purse) + '₸ с личного счета?';
                    title_kk = 'Бонустармен ' + format(bonuses) + '<span class="font-flipIcons">Б</span> және жеке шоттан ' + format(purse) + '₸ төлеу керек пе?';
                } else if (bonuses > 0) {
                    title_ru = 'Оплатить бонусами ' + format(bonuses) + '<span class="font-flipIcons">Б</span>?';
                    title_kk = 'Бонустармен ' + format(bonuses) + '<span class="font-flipIcons">Б</span> төлеу керек пе?';
                } else if (purse > 0) {
                    title_ru = 'Оплатить ' + format(purse) + '₸ с личного счета?';
                    title_kk = 'Жеке шоттан ' + format(purse) + '₸ төлеу керек пе?';
                }

                const uncheck = function () {
                    payCheckbox.checked = false;
                    payCheckbox.removeAttribute('checked');
                };

                showModal({
                    title: (lang == 'kk' ? title_kk : title_ru),
                    buttons: (lang == 'kk' ? '<a class="yellow nbtn m-r-16">Иә</a><a class="gray nbtn close_button">Жоқ</a>' : '<a class="yellow nbtn m-r-16">Да</a><a class="gray nbtn close_button">Нет</a>'),
                    success: function () {
                        fetch(window.location.href, {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: {'X-Requested-With': 'XMLHttpRequest'},
                            body: new URLSearchParams({payOrderByPurse: 'true'})
                        }).then(function (res) { return res.json(); }).then(function (data) {

                            if (data.data) {
                                window.location.reload();
                            } else {
                                uncheck();
                                showModal({
                                    title: (lang == 'kk' ? 'Қате' : 'Ошибка'),
                                    content: (lang == 'kk' ? 'Жеке шотыңыздан төлем жасалмады, кейінірек әрекеттеніңіз' : 'Не удалось произвести оплату с личного счета, попробуйте позже'),
                                    onlyClose: true
                                });
                            }

                        })['catch'](function () {});
                    },
                    close: function () {
                        uncheck();
                    }
                });
            });
        });
    }

    const helpBlockMenu = document.querySelector('.help-search');
    if (helpBlockMenu) {
        const inputSearch = helpBlockMenu.querySelector('input[name=query]');

        const removeResults = function () {
            document.querySelectorAll('.help-search-result').forEach(function (el) { el.remove(); });
        };

        const clearAll = function () {
            removeResults();
            if (inputSearch) {
                inputSearch.value = '';
                inputSearch.focus();
            }
        }

        helpBlockMenu.querySelectorAll('.e-icon').forEach(function (icon) {
            icon.addEventListener('click', function () {
                clearAll();
            });
        });

        if (inputSearch) {
            inputSearch.addEventListener('blur', function () {
                setTimeout(function () {
                    document.querySelectorAll('.help-search-result').forEach(vHide);
                }, 200);
            });

            inputSearch.addEventListener('focus', function () {
                document.querySelectorAll('.help-search-result').forEach(vShow);
            });
        }

        const showSearchResult = function (data) {
            const div = document.createElement('div');
            div.className = 'help-search-result';
            for (let i = 0; i < data.length; i++) {
                const itemBlock = document.createElement('div');
                itemBlock.className = 'help-item';
                itemBlock.setAttribute('data-id', data[i].id);
                itemBlock.setAttribute('data-block-id', data[i].blockId);
                itemBlock.insertAdjacentHTML('beforeend', '<div class="title">' + data[i].blockTitle + '</div>');
                itemBlock.insertAdjacentHTML('beforeend', '<div class="block-title">' + data[i].name + '</div>');
                div.appendChild(itemBlock);
                itemBlock.addEventListener('click', function () {
                    const id = itemBlock.getAttribute('data-id');
                    const blockId = itemBlock.getAttribute('data-block-id');
                    if (id && blockId) {
                        window.location.href = "/helpdocs?id=" + id + "#" + blockId;
                    }
                });
            }
            if (inputSearch) {
                const style = getComputedStyle(inputSearch);
                const width = inputSearch.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
                div.style.width = (width - 10) + 'px';
                inputSearch.insertAdjacentElement('afterend', div);
            }
        }

        let timeoutId = null;
        if (inputSearch) {
            inputSearch.addEventListener('keyup', function (event) {
                if (event.keyCode === 27) {
                    clearAll();
                } else {
                    const query = inputSearch.value;
                    const startInputSearch = function () {
                        fetch('/helpdocs?q=' + encodeURIComponent(query), {
                            credentials: 'same-origin',
                            headers: {'X-Requested-With': 'XMLHttpRequest'}
                        }).then(function (res) { return res.json(); }).then(function (data) {
                            removeResults();
                            if (data && data.length) {
                                showSearchResult(data);
                            }
                        })['catch'](function () {});
                    };
                    if (timeoutId) {
                        clearTimeout(timeoutId);
                    }
                    timeoutId = setTimeout(startInputSearch, 400);
                }
            });
        }
    }

    document.querySelectorAll('a[data-increase-order-storage-expire]').forEach(function (link) {
        link.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            const orderId = link.getAttribute('data-order-id');
            if (orderId) {
                vHide(link);
                link.insertAdjacentHTML('afterend', '<span class="css-loader"></span>');
                fetch('/ajax/orders.php', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {'X-Requested-With': 'XMLHttpRequest'},
                    body: new URLSearchParams({'increase-order-storage-expire': orderId})
                }).then(function (res) { return res.json(); }).then(function (data) {
                    if (data['success']) {
                        window.location.reload();
                    } else if (data['error']) {
                        showModal({
                            title: 'Ошибка',
                            content: data['error'],
                            onlyClose: true
                        });
                    }
                })['catch'](function () {
                    showModal({
                        title: 'Ошибка',
                        content: 'Произошла ошибка, попробуйте повторить операцию позже',
                        onlyClose: true
                    });
                });
            }
        });
    });

    const initTimedown = function (layout, callback) {
        const root = layout ? (layout.jquery ? layout[0] : layout) : document;
        if (!root) return;
        root.querySelectorAll('.timedown').forEach(function (el) {
            if (!el.getAttribute('data-initialized') && el.getAttribute('data-seconds')) {
                el.setAttribute('data-initialized', 'true');
                const str_pad_left = function (string, pad, length) {
                    return (new Array(length + 1).join(pad) + string).slice(-length);
                }
                let time = el.getAttribute('data-seconds');
                let showLayout = el.getAttribute('data-show-layout');
                let hideLayout = el.getAttribute('data-hide-layout');
                const startTimedown = function () {
                    const minutes = Math.floor(time / 60);
                    const seconds = time - minutes * 60;
                    el.textContent = str_pad_left(minutes, '0', 2) + ':' + str_pad_left(seconds, '0', 2);
                    time--;
                    if (time > 0) {
                        setTimeout(function () {
                            startTimedown();
                        }, 1000);
                    } else {
                        if (showLayout) {
                            document.querySelectorAll(showLayout).forEach(vShow);
                        }

                        if (hideLayout) {
                            document.querySelectorAll(hideLayout).forEach(vHide);
                        }

                        if (callback) {
                            callback();
                        }
                    }
                }
                startTimedown();
            }
        });
    }

    document.querySelectorAll('[data-toggle-show]').forEach(function (toggler) {
        toggler.addEventListener('click', function () {
            const dataLayout = toggler.getAttribute('data-layout');
            if (dataLayout) {
                document.querySelectorAll(dataLayout).forEach(function (el) {
                    if (vIsVisible(el)) {
                        vHide(el);
                    } else {
                        vShow(el);
                    }
                });
            }
        });
    });

    initTimedown();

    const authLayout = document.getElementById('auth-form');
    if (authLayout) {
        let codeLength = 6;
        const sendCodeBlock = document.querySelector('.send-code-block');
        const confirmCodeBlock = document.querySelector('.confirm-code-block');
        const returnUrlInput = authLayout.querySelector('input[name=entry_url]');
        const returnUrl = returnUrlInput ? returnUrlInput.value : undefined;

        const loginWithCodeLayout = authLayout.querySelector('.login-with-code');
        const loginWithPasswordLayout = authLayout.querySelector('.login-with-password');
        const enterNameLayout = authLayout.querySelector('.enter-name');
        const wrongPhoneLayout = authLayout.querySelector('.wrong-phone-layout');

        const passwordFormLayout = loginWithPasswordLayout ? loginWithPasswordLayout.querySelector('.password-form') : null;
        const recoveryPasswordFormLayout = loginWithPasswordLayout ? loginWithPasswordLayout.querySelector('.recovery-password-form') : null;
        const recoveryPasswordConfirmFormLayout = loginWithPasswordLayout ? loginWithPasswordLayout.querySelector('.recovery-password-confirm-form') : null;

        const disabledAll = function (layout) {
            if (layout) {
                qa('input[type=submit], button', layout).forEach(function (el) { el.disabled = true; });
            }
        }
        const enabledAll = function (layout) {
            if (layout) {
                qa('input[type=submit], button', layout).forEach(function (el) { el.disabled = false; el.removeAttribute('disabled'); });
            }
        }

        const createRecaptcha = function (layout, captchaElement) {
            if (!layout) return;
            if (!captchaElement) {
                captchaElement = '.captcha';
            }
            const captcha = layout.querySelector(captchaElement);
            if (captcha) {
                qa('.g-recaptcha', layout).forEach(function (el) { el.remove(); });
                captcha.insertAdjacentHTML('afterend', '<div class="g-recaptcha filter-preloader p-b-16" data-sitekey="' + captcha.getAttribute('data-key') + '"></div>');
                initRecaptcha(layout);
            }
        }

        const initRecaptcha = function (layout) {
            try {
                if (grecaptcha) {
                    const newGcaptcha = layout.querySelector('.g-recaptcha');
                    if (newGcaptcha) {
                        grecaptcha.render(newGcaptcha, {
                            'sitekey': newGcaptcha.getAttribute('data-sitekey')
                        });
                    }
                }
            } catch (e) { }
        }

        const clearErrors = function () {
            qa('[data-error]').forEach(function (block) {
                if (block.parentElement && block.parentElement.classList.contains('form-element')) {
                    block.parentElement.classList.remove('error');
                }
                block.innerHTML = '';
                vHide(block);
            });
        }

        window.onpopstate = function (event) {
            if (event.state) {
                if (event.state.showPassword) {
                    showEnterWithPasswordLayout(true);
                } else if (event.state.showRecoveryPassword) {
                    showEnterWithPasswordLayout(true);
                    showRecoveryPasswordLayout(true);
                } else {
                    showEnterWithCodeLayout(true);
                }
            }
        }

        const showEnterWithPasswordLayout = function (disabledHistory) {
            vHide(loginWithCodeLayout);
            vHide(wrongPhoneLayout);
            vHide(recoveryPasswordFormLayout);
            vHide(recoveryPasswordConfirmFormLayout);
            vShow(passwordFormLayout);
            vShow(loginWithPasswordLayout);
            const usernamePass = document.getElementById('username-pass');
            if (usernamePass) {
                usernamePass.focus();
                usernamePass.value = '';
            }
            if (!disabledHistory) {
                window.history.pushState({ showPassword: true }, 'Авторизация используя пароль', '/user?password');
            }
            createRecaptcha(passwordFormLayout);
        }

        const showEnterWithCodeLayout = function (disabledHistory) {
            vShow(loginWithCodeLayout);
            vHide(loginWithPasswordLayout);
            const username = document.getElementById('username');
            if (username) username.focus();
            if (!disabledHistory) {
                window.history.pushState({ showCode: true }, 'Авторизация', '/user?enter');
            }
            createRecaptcha(loginWithCodeLayout);
        }

        const showRecoveryPasswordLayout = function (disabledHistory) {
            vHide(passwordFormLayout);
            qa('.enter-code', recoveryPasswordFormLayout).forEach(vHide);
            qa('.enter-username', recoveryPasswordFormLayout).forEach(vShow);
            vShow(recoveryPasswordFormLayout);
            const recoveryUsername = document.getElementById('recovery-username');
            if (recoveryUsername) {
                recoveryUsername.focus();
                recoveryUsername.value = '';
            }
            if (!disabledHistory) {
                window.history.pushState({ showRecoveryPassword: true }, 'Восстановление пароля', '/user?forgotpassword');
            }
            createRecaptcha(recoveryPasswordFormLayout ? recoveryPasswordFormLayout.querySelector('.enter-username') : null);
        }

        if (window.location.search === '?password') {
            showEnterWithPasswordLayout();
        } else if (window.location.search === '?forgotpassword') {
            showEnterWithPasswordLayout(true);
            showRecoveryPasswordLayout();
        } else {
            showEnterWithCodeLayout();
        }

        qa('.enter-with-password', authLayout).forEach(function (el) {
            el.addEventListener('click', function () {
                showEnterWithPasswordLayout();
            });
        });

        qa('.enter-with-code', authLayout).forEach(function (el) {
            el.addEventListener('click', function () {
                showEnterWithCodeLayout();
            });
        });

        qa('.recovery_password', loginWithPasswordLayout).forEach(function (el) {
            el.addEventListener('click', function () {
                showRecoveryPasswordLayout();
            });
        });

        qa('a[data-change-number]', loginWithCodeLayout).forEach(function (el) {
            el.addEventListener('click', function () {
                vShow(sendCodeBlock);
                vHide(confirmCodeBlock);
                showEnterWithCodeLayout();
            });
        });

        // Спиннер в кнопке на время запроса отправки кода (запрос может идти долго)
        const sendCodeButton = sendCodeBlock ? sendCodeBlock.querySelector('button[type=submit]') : null;
        const sendCodeButtonHtml = sendCodeButton ? sendCodeButton.innerHTML : '';
        const showSendCodeLoading = function () {
            if (sendCodeButton) sendCodeButton.innerHTML = '<span class="btn-spinner"></span>' + sendCodeButtonHtml;
        };
        const hideSendCodeLoading = function () {
            if (sendCodeButton) sendCodeButton.innerHTML = sendCodeButtonHtml;
        };

        const sendCode = function (body, showError) {
            fetchJSON(sendCodeBlock.getAttribute('action'), { method: 'POST', body: body }, function (data) {
                if (data.result) {
                    vHide(sendCodeBlock);
                    if (data.resendTime) {
                        qa('.code-timer', confirmCodeBlock).forEach(vShow);
                        qa('.code-resend', confirmCodeBlock).forEach(vHide);
                        qa('.timedown', confirmCodeBlock).forEach(function (el) {
                            el.insertAdjacentHTML('beforebegin', '<span class="timedown" data-show-layout=".login-with-code .code-resend" data-hide-layout=".login-with-code .code-timer" data-seconds="' + data.resendTime + '"></span>');
                            el.remove();
                        });
                        initTimedown(confirmCodeBlock, function () {
                            createRecaptcha(confirmCodeBlock.querySelector('.code-resend'), '.captcha-resend');
                        });
                    }
                    if (data.codeLength) {
                        codeLength = data.codeLength;
                        qa('input[name=code]', confirmCodeBlock).forEach(function (el) { el.setAttribute('maxlength', codeLength); });
                    }
                    const phoneInput = sendCodeBlock.querySelector('input[name=phone]');
                    const username = phoneInput ? phoneInput.value : '';
                    qa('[data-username-block]', confirmCodeBlock).forEach(function (el) { el.textContent = username; });
                    qa('input[name=phone]', confirmCodeBlock).forEach(function (el) { el.value = username; });

                    // Текст «куда отправили код» по фактическому каналу из ответа
                    const sentChannel = data.channel === 'whatsapp' ? 'whatsapp' : 'sms';
                    qa('[data-sent-channel]', confirmCodeBlock).forEach(vHide);
                    qa('[data-sent-channel=' + sentChannel + ']', confirmCodeBlock).forEach(vShow);

                    vShow(confirmCodeBlock);
                    const codeInput = document.getElementById('code');
                    if (codeInput) {
                        codeInput.focus();
                        codeInput.value = '';
                    }
                    hideSendCodeLoading();
                    enabledAll(loginWithCodeLayout);
                } else if (data.error) {
                    if (data.error === 'Wrong phone') {
                        vHide(loginWithCodeLayout);
                        vShow(wrongPhoneLayout);
                    } else {
                        showError(data.error);
                        createRecaptcha(loginWithCodeLayout);
                    }
                    hideSendCodeLoading();
                    enabledAll(loginWithCodeLayout);
                }
            }, function (error) {
                showError(error);
                hideSendCodeLoading();
                enabledAll(loginWithCodeLayout);
            });
        }

        if (sendCodeBlock) sendCodeBlock.addEventListener('submit', function (event) {
            event.preventDefault();
            event.stopPropagation();
            disabledAll(sendCodeBlock);
            showSendCodeLoading();

            clearErrors();

            const showError = function (error) {
                qa('[data-error]', sendCodeBlock).forEach(function (block) {
                    if (block.parentElement && block.parentElement.classList.contains('form-element')) {
                        block.parentElement.classList.add('error');
                    }
                    block.innerHTML = error;
                    vShow(block);
                });
            }

            sendCode(new URLSearchParams(new FormData(sendCodeBlock)), showError);
        });

        // Общий показ ошибок в [data-error] внутри layout
        const showErrorIn = function (layout, error) {
            qa('[data-error]', layout).forEach(function (block) {
                if (block.parentElement && block.parentElement.classList.contains('form-element')) {
                    block.parentElement.classList.add('error');
                }
                block.innerHTML = error;
                vShow(block);
            });
        }

        const showErrorConfirmBlock = function (error) {
            showErrorIn(confirmCodeBlock, error);
        }

        const showConfirmLoading = function () {
            qa('input[name=code]', confirmCodeBlock).forEach(function (el) { el.disabled = true; });
            qa('[data-confirm-loading]', confirmCodeBlock).forEach(vShow);
        }

        const hideConfirmLoading = function () {
            qa('input[name=code]', confirmCodeBlock).forEach(function (el) { el.disabled = false; el.removeAttribute('disabled'); });
            qa('[data-confirm-loading]', confirmCodeBlock).forEach(vHide);
        }

        qa('input[name=code]', confirmCodeBlock).forEach(function (codeInput) {
            codeInput.addEventListener('input', function () {
                if (this.value.replace('_', '').length === codeLength) {
                    vSubmitForm(confirmCodeBlock);
                }
            });
        });

        qa('.resend-confirm-code', confirmCodeBlock).forEach(function (resendEl) {
            resendEl.addEventListener('click', function () {
                qa('.m_error', confirmCodeBlock).forEach(function (el) { el.innerHTML = ''; vHide(el); });
                qa('input[name=code]', confirmCodeBlock).forEach(function (el) { el.value = ''; });
                const recaptchaInput = confirmCodeBlock.querySelector('[name=g-recaptcha-response]');
                const recaptcha = recaptchaInput ? recaptchaInput.value : undefined;
                const sendData = new URLSearchParams({
                    phone: (confirmCodeBlock.querySelector('input[name=phone]') || {}).value || ''
                });
                if (recaptcha) {
                    sendData.append('g-recaptcha-response', recaptcha);
                }
                sendCode(sendData, showErrorConfirmBlock);
            });
        });

        if (confirmCodeBlock) confirmCodeBlock.addEventListener('submit', function (event) {
            event.preventDefault();
            event.stopPropagation();
            qa('.m_error', confirmCodeBlock).forEach(function (el) { el.innerHTML = ''; vHide(el); });
            const form = confirmCodeBlock;
            disabledAll(form);
            const data = new URLSearchParams(new FormData(form));
            showConfirmLoading();
            fetchJSON(form.getAttribute('action'), { method: 'POST', body: data }, function (data) {
                if (data.result) {
                    if (data.client && !data.isNeedName) {
                        window.location.href = returnUrl;
                    }
                    if (data.isNeedName) {
                        vHide(loginWithCodeLayout);
                        vShow(enterNameLayout);
                    }
                } else if (data.error) {
                    showErrorConfirmBlock(data.error);
                    qa('input[name=code]', confirmCodeBlock).forEach(function (el) { el.value = ''; });
                }
                hideConfirmLoading();
                enabledAll(form)
            }, function (error) {
                showErrorConfirmBlock(error);
                hideConfirmLoading();
                enabledAll(form)
            });
        });

        qa('form', enterNameLayout).forEach(function (form) {
            form.addEventListener('submit', function (event) {
                event.preventDefault();
                event.stopPropagation();

                disabledAll(form);

                clearErrors();

                const data = new URLSearchParams(new FormData(form));

                fetchJSON(form.getAttribute('action'), { method: 'POST', body: data }, function (data) {
                    if (data.result) {
                        window.location.href = returnUrl;
                    }
                    enabledAll(form);
                }, function (error) {
                    showErrorIn(form, error);
                    enabledAll(form);
                });
            });
        });

        if (passwordFormLayout) passwordFormLayout.addEventListener('submit', function (event) {
            event.preventDefault();
            event.stopPropagation();

            const form = passwordFormLayout;
            disabledAll(form);

            clearErrors();

            const data = new URLSearchParams(new FormData(form));

            fetchJSON(form.getAttribute('action'), { method: 'POST', body: data }, function (data) {
                if (data.result) {
                    window.location.href = returnUrl;
                } else if (data.error) {
                    createRecaptcha(passwordFormLayout);
                    showErrorIn(form, data.error);
                }
                enabledAll(form);
            }, function (error) {
                showErrorIn(form, error);
                enabledAll(form);
            });
        });

        qa('input[name=code]', recoveryPasswordFormLayout).forEach(function (codeInput) {
            codeInput.addEventListener('keyup', function () {
                if (this.value.replace('_', '').length === +this.getAttribute('maxlength')) {
                    qa('[data-confirm-loading]', recoveryPasswordFormLayout).forEach(vShow);
                    vSubmitForm(recoveryPasswordFormLayout);
                }
            });
        });

        qa('.resend-confirm-code', recoveryPasswordFormLayout).forEach(function (resendEl) {
            resendEl.addEventListener('click', function () {
                qa('input[name=code]', recoveryPasswordFormLayout).forEach(function (el) { el.value = ''; });
                vSubmitForm(recoveryPasswordFormLayout);
            });
        });

        if (recoveryPasswordFormLayout) recoveryPasswordFormLayout.addEventListener('submit', function (event) {
            event.preventDefault();
            event.stopPropagation();

            const form = recoveryPasswordFormLayout;
            disabledAll(form);

            clearErrors();

            const data = new URLSearchParams(new FormData(form));

            fetchJSON(form.getAttribute('action'), { method: 'POST', body: data }, function (data) {
                if (data.result) {
                    if (data.resendTime) {
                        qa('.enter-username', recoveryPasswordFormLayout).forEach(vHide);
                        qa('.enter-code', recoveryPasswordFormLayout).forEach(vShow);
                        qa('.code-timer', recoveryPasswordFormLayout).forEach(vShow);
                        qa('.code-resend', recoveryPasswordFormLayout).forEach(vHide);
                        qa('.timedown', recoveryPasswordFormLayout).forEach(function (el) {
                            el.insertAdjacentHTML('beforebegin', '<span class="timedown" data-show-layout=".recovery-password-form .code-resend" data-hide-layout=".recovery-password-form .code-timer" data-seconds="' + data.resendTime + '"></span>');
                            el.remove();
                        });

                        initTimedown(recoveryPasswordFormLayout, function () {
                            createRecaptcha(recoveryPasswordFormLayout.querySelector('.code-resend'));
                        });

                        if (data.codeLength) {
                            qa('input[name=code]', recoveryPasswordFormLayout).forEach(function (el) { el.setAttribute('maxlength', data.codeLength); });
                        }

                        const usernameInput = recoveryPasswordFormLayout.querySelector('input[name=username]');
                        const username = usernameInput ? usernameInput.value : '';
                        qa('[data-username-block]', recoveryPasswordFormLayout).forEach(function (el) { el.textContent = username; });
                    } else {
                        vHide(recoveryPasswordFormLayout);
                        const srcUsername = recoveryPasswordFormLayout.querySelector('input[name=username]');
                        const srcCode = recoveryPasswordFormLayout.querySelector('input[name=code]');
                        qa('input[name=username]', recoveryPasswordConfirmFormLayout).forEach(function (el) {
                            el.value = srcUsername ? srcUsername.value : '';
                        });
                        qa('input[name=code]', recoveryPasswordConfirmFormLayout).forEach(function (el) {
                            el.value = srcCode ? srcCode.value : '';
                        });
                        vShow(recoveryPasswordConfirmFormLayout);
                    }
                } else if (data.error) {
                    showErrorIn(form, data.error);
                }
                enabledAll(form);
                qa('[data-confirm-loading]', recoveryPasswordFormLayout).forEach(vHide);
            }, function (error) {
                showErrorIn(form, error);
                enabledAll(form);
                qa('[data-confirm-loading]', recoveryPasswordFormLayout).forEach(vHide);
            });
        });

        if (recoveryPasswordConfirmFormLayout) recoveryPasswordConfirmFormLayout.addEventListener('submit', function (event) {
            event.preventDefault();
            event.stopPropagation();

            const form = recoveryPasswordConfirmFormLayout;
            disabledAll(form);

            clearErrors();

            const data = new URLSearchParams(new FormData(form));

            fetchJSON(form.getAttribute('action'), { method: 'POST', body: data }, function (data) {
                if (data.result) {
                    window.location.href = returnUrl;
                } else if (data.error) {
                    showErrorIn(form, data.error);
                }
                enabledAll(form);
            }, function (error) {
                showErrorIn(form, error);
                enabledAll(form);
            });
        });
    }

    document.querySelectorAll('.lang-switcher input').forEach(function (langInput) {
        langInput.addEventListener('change', function () {
        let url = window.location.href;
        let selectedLang = langInput.value;
        if (selectedLang === 'kk') {
            if (url.match(/\/[a-z]{2}\//)) {
                url = url.replace(/\/[a-z]{2}\//, '/' + selectedLang + '/');
            } else {
                url = url.replace(window.location.origin, window.location.origin + '/' + selectedLang);
            }
        } else {
            if (url.match(/\/[a-z]{2}\//)) {
                url = url.replace(/\/[a-z]{2}\//, '/');
            }
        }

        window.location.href = url;
        });
    });

    let exitLink = document.getElementById('exit-link');

    if (exitLink) {
        exitLink.addEventListener('click', function (event) {
            event.preventDefault();

            let url = this.href;
            url = url.replace(/\/[a-z]{2}\//, '/');

            window.location.href = url;
        });
    }

    document.querySelectorAll('.confirm-order').forEach(function (button) {
        button.addEventListener('click', function () {
            vSubmitForm(document.getElementById('accept_form'));
            button.disabled = true;
            setTimeout(function () {
                button.disabled = false;
            }, 1500);
        });
    });


    document.querySelectorAll('.show-qr-code').forEach(function (button) {
        button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        let lang = document.documentElement.getAttribute('lang');
        let code = (button.getAttribute('data-receive-code') || '').replace(/[^\d-]/g, '');
        // Заголовок/подзаголовок задаёт шаблон (код отправки vs код получения).
        // Без атрибутов — прежний текст: обработчик общий для заказов и ЛК.
        let title = button.getAttribute('data-qr-title') || (lang == 'kk' ? 'Алу коды' : 'Код получения');
        let sub = button.getAttribute('data-qr-sub') || (lang == 'kk' ? 'QR кодты қабылдау пунктінің менеджеріне көрсетіңіз' : 'Покажите QR-код менеджеру пункта выдачи');

        showFlipDialog({
            content: '<p class="flip-dialog-title">' + title + '</p>' +
                '<p class="flip-dialog-sub">' + sub + '</p>' +
                '<img class="flip-dialog-qr" src="/qrgenerator?code=' + code.replace(/\D/g, '') + '" alt="QR"/>' +
                '<p class="flip-dialog-code">' + code + '</p>' +
                '<p class="flip-dialog-hint">' + (lang == 'kk' ? 'Сондай-ақ кодты менеджерге айтуға болады' : 'Также можно продиктовать код менеджеру') + '</p>' +
                '<button type="button" class="flip-dialog-done flip-dialog-close">' + (lang == 'kk' ? 'Дайын' : 'Готово') + '</button>'
        });
        });
    });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', flipMainInit);
    } else {
        flipMainInit();
    }
})();

/* Всплывушка для анализа поиска */

;(function () {
    'use strict';

    document.addEventListener('click', function (e) {
        const show = e.target && e.target.closest ? e.target.closest('.show-explain-documents') : null;
        if (show && show.parentElement) {
            Array.prototype.forEach.call(show.parentElement.children, function (sibling) {
                if (sibling !== show && sibling.classList.contains('explain-documents')) {
                    sibling.classList.toggle('d-none');
                }
            });
        }

        if (e.target && e.target.closest && e.target.closest('.close-explain-documents')) {
            document.querySelectorAll('.explain-documents').forEach(function (el) {
                el.classList.add('d-none');
            });
        }
    });
})();

;(function () {
  'use strict';

  function assign(target) {
    for (var i = 1; i < arguments.length; i++) {
      var src = arguments[i];
      if (src) {
        for (var k in src) {
          if (Object.prototype.hasOwnProperty.call(src, k)) target[k] = src[k];
        }
      }
    }
    return target;
  }

  function encodeForm(params) {
    var parts = [];
    for (var k in params) {
      if (Object.prototype.hasOwnProperty.call(params, k)) {
        parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(params[k]));
      }
    }
    return parts.join('&');
  }

  function createStore(initial) {
    initial = initial || {};
    var state = {
      items: assign({}, initial.items || {}),
      count: initial.count || 0,
      summaText: initial.summaText || ''
    };
    var subscribers = [];
    function notify() {
      for (var i = 0; i < subscribers.length; i++) subscribers[i](state);
    }
    function patch(next) {
      state = assign({}, state, next);
      notify();
    }
    return {
      get: function () { return state; },
      subscribe: function (fn) {
        subscribers.push(fn);
        return function () {
          var idx = subscribers.indexOf(fn);
          if (idx >= 0) subscribers.splice(idx, 1);
        };
      },
      setItem: function (idProduce, cnt) {
        var items = assign({}, state.items);
        if (cnt > 0) items[String(idProduce)] = cnt;
        else delete items[String(idProduce)];
        patch({ items: items });
      },
      getCnt: function (idProduce) { return state.items[String(idProduce)] || 0; },
      adjustCount: function (delta) { patch({ count: Math.max(0, state.count + delta) }); },
      setCount: function (n) { patch({ count: Math.max(0, Number(n) || 0) }); },
      setSummaText: function (s) { patch({ summaText: String(s == null ? '' : s) }); }
    };
  }

  function pluralRu(n, forms) {
    var abs = Math.abs(Number(n) || 0);
    var m10 = abs % 10;
    var m100 = abs % 100;
    if (m100 >= 11 && m100 <= 14) return forms[2];
    if (m10 === 1) return forms[0];
    if (m10 >= 2 && m10 <= 4) return forms[1];
    return forms[2];
  }

  function cartCountText(n) {
    var count = Number(n) || 0;
    if (count === 0) return 'Нет товаров';
    return count + ' ' + pluralRu(count, ['товар', 'товара', 'товаров']);
  }

  function stepQuantity(current, dir, opts) {
    opts = opts || {};
    var s = opts.step > 0 ? opts.step : 1;
    var lo = opts.min > 0 ? opts.min : 1;
    var max = opts.max || 0;
    var v = (Number(current) || 0) + (dir > 0 ? s : -s);
    if (v < lo) return 0;
    if (max > 0 && v > max) v = max;
    return v;
  }

  function createApi(base) {
    base = base || '/ajax/cart.php';
    function post(params) {
      return fetch(base, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: encodeForm(params)
      }).then(function (res) { return res.json(); })['catch'](function () {
        var e = new Error('network');
        e.network = true;
        throw e;
      });
    }
    return {
      add: function (o) {
        o = o || {};
        var params = { add: o.idProduce, count: (typeof o.count === 'number' ? o.count : 1) };
        if (o.supplier) params.supplier = o.supplier;
        return post(params);
      },
      changeCnt: function (cartRowId, count) {
        return post({ changeCnt: 1, 'products[0][id]': cartRowId, 'products[0][count]': count });
      },
      remove: function (cartRowId) {
        return post({ 'delete': cartRowId });
      }
    };
  }

  // Аналитика принимает суммы в USD: тенге делим на курс из шапки (FLIP_USD_RATE)
  function toUsd(amount) {
    var rate = Number(window.FLIP_USD_RATE) || 0;
    return rate > 0 ? Math.round((amount / rate) * 100) / 100 : 0;
  }

  function trackAddToCart(o) {
    o = o || {};
    var id = String(o.idProduce);
    var price = Number(o.price) || 0;
    var listName = o.listName || 'ProducePage';
    var quantity = o.quantity || 1;
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', { content_ids: [id], content_type: 'product', value: toUsd(price * quantity), currency: 'USD' });
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'add_to_cart', {
        currency: 'USD',
        value: toUsd(price),
        items: [{ item_id: id, item_list_name: listName, price: toUsd(price), quantity: quantity }]
      });
    }
  }

  function trackRemoveFromCart(o) {
    o = o || {};
    var id = String(o.idProduce);
    var price = Number(o.price) || 0;
    var quantity = o.quantity || 1;
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'remove_from_cart', {
        currency: 'USD',
        value: toUsd(price * quantity),
        items: [{ item_id: id, price: toUsd(price), quantity: quantity }]
      });
    }
  }

  function createStepper(root, opts) {
    opts = opts || {};
    var valueEl = root.querySelector('[data-stepper-value]');
    var bounds = opts.bounds || {};
    var onChange = opts.onChange;
    var current = opts.value || 1;
    function render() { if (valueEl) valueEl.textContent = String(current); }
    function onClick(event) {
      var btn = event.target.closest('[data-step]');
      if (!btn || !root.contains(btn)) return;
      var dir = Number(btn.getAttribute('data-step')) || 0;
      var next = stepQuantity(current, dir, bounds);
      if (typeof onChange === 'function') onChange(next, dir);
    }
    root.addEventListener('click', onClick);
    render();
    return {
      setValue: function (n) { current = Number(n) || 0; render(); },
      getValue: function () { return current; },
      destroy: function () { root.removeEventListener('click', onClick); }
    };
  }

  function initAddButton(root, ctx) {
    var api = ctx.api;
    var store = ctx.store;
    var idProduce = root.getAttribute('data-id-produce');
    var supplier = root.getAttribute('data-supplier') || undefined;
    var price = Number(root.getAttribute('data-price')) || 0;
    var bounds = {
      min: Number(root.getAttribute('data-min')) || 1,
      max: Number(root.getAttribute('data-max')) || 0,
      step: Number(root.getAttribute('data-step')) || 1
    };
    var addEl = root.querySelector('[data-cart-add]');
    var incartEl = root.querySelector('[data-cart-incart]');
    var stepperRoot = root.querySelector('[data-cart-stepper]');
    var errorEl = root.querySelector('[data-cart-error]');
    var cartRowId = root.getAttribute('data-cart-row-id') || null;
    var busy = false;
    var initialCnt = Number(root.getAttribute('data-cnt')) || 0;
    var stepper;

    if (initialCnt > 0) store.setItem(idProduce, initialCnt);

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }

    function renderMorph() {
      var cnt = store.getCnt(idProduce);
      var inCart = cnt > 0;
      if (addEl) addEl.hidden = inCart;
      if (incartEl) incartEl.hidden = !inCart;
      if (inCart && stepper) stepper.setValue(cnt);
    }

    function commit(targetCnt) {
      if (busy) return;
      showError('');
      var prevCnt = store.getCnt(idProduce);
      var delta = targetCnt - prevCnt;
      store.setItem(idProduce, targetCnt);
      store.adjustCount(delta);
      renderMorph();
      busy = true;
      if (addEl) addEl.setAttribute('aria-busy', 'true');

      var isFirstAdd = (prevCnt === 0 && targetCnt > 0);
      var request;
      if (targetCnt === 0) {
        request = cartRowId
          ? api.remove(cartRowId)
          : api.add({ idProduce: idProduce, count: 0, supplier: supplier });
      } else if (isFirstAdd || !cartRowId) {
        request = api.add({ idProduce: idProduce, count: targetCnt, supplier: supplier });
      } else {
        request = api.changeCnt(cartRowId, targetCnt);
      }

      request.then(function (resp) {
        if (resp && resp.error) throw new Error(resp.error);
        if (resp && resp.added && resp.added.cartRowId) cartRowId = resp.added.cartRowId;
        if (isFirstAdd) {
          if (resp && resp.added && typeof resp.added.cnt === 'number') store.setItem(idProduce, resp.added.cnt);
          trackAddToCart({ idProduce: idProduce, price: price, quantity: targetCnt });
        }
        if (targetCnt === 0) {
          cartRowId = null;
          if (prevCnt > 0) trackRemoveFromCart({ idProduce: idProduce, price: price, quantity: prevCnt });
        }
        var infos = resp && resp.infos;
        if (infos) {
          if (typeof infos.countRaw === 'number') store.setCount(infos.countRaw);
          if (infos.summa) store.setSummaText(infos.summa);
        }
      })['catch'](function (err) {
        store.setItem(idProduce, prevCnt);
        store.adjustCount(-delta);
        renderMorph();
        var msg;
        if (err && err.network) {
          msg = 'Нет соединения с интернетом. Попробуйте ещё раз.';
        } else if (err && typeof err.message === 'string' && err.message) {
          msg = err.message;
        } else {
          msg = 'Не удалось обновить корзину.';
        }
        showError(msg);
      }).then(function () {
        busy = false;
        if (addEl) addEl.removeAttribute('aria-busy');
      });
    }

    stepper = createStepper(stepperRoot, {
      value: Math.max(1, initialCnt),
      bounds: bounds,
      onChange: function (next) { commit(next); }
    });

    if (addEl) {
      addEl.addEventListener('click', function () {
        if (root.getAttribute('data-cart-gate') && typeof window.flipCartGate === 'function' && !window.flipCartGate()) return;
        commit(Math.max(bounds.min, bounds.step));
      });
    }

    var unsubscribe = store.subscribe(function () {
      if (!document.documentElement.contains(root)) { unsubscribe(); return; }
      renderMorph();
    });
    renderMorph();
  }

  function readInitialCount() {
    var el = document.getElementById('cart_cnt') || document.querySelector('[data-cart-count]');
    if (!el) return 0;
    var m = (el.textContent || '').match(/\d+/);
    return m ? Number(m[0]) : 0;
  }

  var sharedStore = null;
  var sharedApi = null;

  function ensureContext() {
    if (sharedStore) return;
    sharedStore = createStore({ count: readInitialCount() });
    sharedApi = createApi();
    sharedStore.subscribe(function (state) {
      var deskEl = document.getElementById('cart_cnt');            // десктоп: «N товаров»
      if (deskEl) deskEl.textContent = cartCountText(state.count);
      var mobEls = document.querySelectorAll('[data-cart-count]'); // мобила: число в бейдже
      for (var i = 0; i < mobEls.length; i++) {
        mobEls[i].textContent = state.count;
        mobEls[i].style.display = state.count > 0 ? '' : 'none';
      }
    });
  }

  function initMorphs(scope) {
    ensureContext();
    var root = scope && scope.querySelectorAll ? scope : document;
    var morphs = root.querySelectorAll('[data-cart-morph]');
    for (var i = 0; i < morphs.length; i++) {
      if (morphs[i].getAttribute('data-cart-morph-ready')) continue;
      morphs[i].setAttribute('data-cart-morph-ready', '1');
      initAddButton(morphs[i], { api: sharedApi, store: sharedStore });
    }
  }

  // Публичный хук: повторная инициализация морфов в свежевставленном блоке
  // (вызывается после AJAX-перерисовки части cart-buttons при смене варианта).
  window.cartMorphInit = function (scope) { initMorphs(scope); };

  // Окно с готовой ссылкой на подборку. Живёт здесь, потому что cart.js есть на
  // всех страницах и десктопа, и мобильной версии; showModal у них свой, но
  // параметры совпадают. Вызывать только через window.flipShareLinkModal и в
  // момент клика: на мобильной вёрстке favorites.js грузится раньше этого файла.
  window.flipShareLinkModal = function (url, title) {
    var lang = document.documentElement.getAttribute('lang');
    var texts = lang === 'kk' ? {
      title: 'Сілтемемен бөлісу',
      hint: 'Сілтемені жіберіңіз\u00a0— оны ашқан адам осы таңдауды көреді.',
      copy: 'Көшіру',
      copied: 'Көшірілді'
    } : {
      title: 'Поделиться ссылкой',
      hint: 'Отправьте ссылку\u00a0— тот, кто её откроет, увидит эту подборку.',
      copy: 'Скопировать',
      copied: 'Скопировано'
    };

    if (typeof window.showModal !== 'function') {
      prompt(texts.title, url);
      return;
    }

    // Название приходит из данных пользователя (в api теги не вырезаются) — только как текст
    var escapeHtml = function (value) {
      var node = document.createElement('div');
      node.textContent = value;
      return node.innerHTML;
    };

    var id = 'share-link-' + Date.now();
    // Раскладку строки держим инлайном: стили модалки лежат в общем css-файле,
    // который отдаётся с версией, и до пользователя со старым кэшем ещё не доехал —
    // но ссылка с кнопкой не должны разъезжаться в любом случае
    var content = '<div class="share-link">' +
      (title ? '<div class="share-link__title">' + escapeHtml(title) + '</div>' : '') +
      '<div class="share-link__hint">' + texts.hint + '</div>' +
      '<div class="share-link__row" style="display:flex;flex-wrap:wrap;align-items:center;gap:8px">' +
      '<input type="text" class="share-link__input" id="' + id + '-url" readonly value="' + url.replace(/"/g, '&quot;') + '" style="flex:1 1 220px;min-width:0;width:auto" />' +
      '<button type="button" class="f-btn blue share-link__copy btn btn-primary" id="' + id + '-copy" style="flex:0 0 auto;white-space:nowrap">' + texts.copy + '</button>' +
      '</div>' +
      '</div>';

    window.showModal({
      title: texts.title,
      content: content,
      onlyClose: true,
      modalClass: 'share-link-modal'
    });

    var input = document.getElementById(id + '-url');
    var copyButton = document.getElementById(id + '-copy');

    if (!input || !copyButton) return;

    copyButton.addEventListener('click', function () {
      var done = function () {
        copyButton.textContent = texts.copied;
        copyButton.classList.add('is-copied');
      };

      // execCommand — запасной путь: clipboard недоступен на http и в старых браузерах
      var fallback = function () {
        input.focus();
        input.setSelectionRange(0, input.value.length);
        try {
          if (document.execCommand('copy')) done();
        } catch (e) {}
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(input.value).then(done).catch(fallback);
        return;
      }

      fallback();
    });

    input.addEventListener('focus', function () {
      input.setSelectionRange(0, input.value.length);
    });
  };

  // «Поделиться корзиной»: сервер снимает состав корзины во временную подборку
  // и возвращает ссылку на неё. Сама корзина получателю не передаётся.
  function shareCart(button) {
    if (button.getAttribute('data-processing')) return;
    button.setAttribute('data-processing', '1');

    var lang = document.documentElement.getAttribute('lang');
    var failed = lang === 'kk' ? 'Сілтеме жасау мүмкін болмады' : 'Не\u00a0удалось создать ссылку';

    fetch('/favorites', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: 'shareCart=1'
    }).then(function (res) {
      return res.json();
    }).then(function (data) {
      button.removeAttribute('data-processing');

      if (!data || !data.url) {
        if (typeof window.showMessage === 'function') {
          window.showMessage(data && data.error ? data.error : failed);
        }
        return;
      }

      window.flipShareLinkModal(data.url, data.title);
    }).catch(function () {
      button.removeAttribute('data-processing');
      if (typeof window.showMessage === 'function') window.showMessage(failed);
    });
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest ? e.target.closest('[data-cart-share]') : null;
    if (!button) return;

    e.preventDefault();
    shareCart(button);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initMorphs(document); });
  } else {
    initMorphs(document);
  }
})();(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.IMask = {}));
})(this, (function (exports) { 'use strict';

  /** Checks if value is string */
  function isString(str) {
    return typeof str === 'string' || str instanceof String;
  }

  /** Checks if value is object */
  function isObject(obj) {
    var _obj$constructor;
    return typeof obj === 'object' && obj != null && (obj == null || (_obj$constructor = obj.constructor) == null ? void 0 : _obj$constructor.name) === 'Object';
  }
  function pick(obj, keys) {
    if (Array.isArray(keys)) return pick(obj, (_, k) => keys.includes(k));
    return Object.entries(obj).reduce((acc, _ref) => {
      let [k, v] = _ref;
      if (keys(v, k)) acc[k] = v;
      return acc;
    }, {});
  }

  /** Direction */
  const DIRECTION = {
    NONE: 'NONE',
    LEFT: 'LEFT',
    FORCE_LEFT: 'FORCE_LEFT',
    RIGHT: 'RIGHT',
    FORCE_RIGHT: 'FORCE_RIGHT'
  };

  /** Direction */

  function forceDirection(direction) {
    switch (direction) {
      case DIRECTION.LEFT:
        return DIRECTION.FORCE_LEFT;
      case DIRECTION.RIGHT:
        return DIRECTION.FORCE_RIGHT;
      default:
        return direction;
    }
  }

  /** Escapes regular expression control chars */
  function escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
  }

  // cloned from https://github.com/epoberezkin/fast-deep-equal with small changes
  function objectIncludes(b, a) {
    if (a === b) return true;
    const arrA = Array.isArray(a),
      arrB = Array.isArray(b);
    let i;
    if (arrA && arrB) {
      if (a.length != b.length) return false;
      for (i = 0; i < a.length; i++) if (!objectIncludes(a[i], b[i])) return false;
      return true;
    }
    if (arrA != arrB) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') {
      const dateA = a instanceof Date,
        dateB = b instanceof Date;
      if (dateA && dateB) return a.getTime() == b.getTime();
      if (dateA != dateB) return false;
      const regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
      if (regexpA && regexpB) return a.toString() == b.toString();
      if (regexpA != regexpB) return false;
      const keys = Object.keys(a);
      // if (keys.length !== Object.keys(b).length) return false;

      for (i = 0; i < keys.length; i++) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
      for (i = 0; i < keys.length; i++) if (!objectIncludes(b[keys[i]], a[keys[i]])) return false;
      return true;
    } else if (a && b && typeof a === 'function' && typeof b === 'function') {
      return a.toString() === b.toString();
    }
    return false;
  }

  /** Selection range */

  /** Provides details of changing input */
  class ActionDetails {
    /** Current input value */

    /** Current cursor position */

    /** Old input value */

    /** Old selection */

    constructor(opts) {
      Object.assign(this, opts);

      // double check if left part was changed (autofilling, other non-standard input triggers)
      while (this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos)) {
        --this.oldSelection.start;
      }
      if (this.insertedCount) {
        // double check right part
        while (this.value.slice(this.cursorPos) !== this.oldValue.slice(this.oldSelection.end)) {
          if (this.value.length - this.cursorPos < this.oldValue.length - this.oldSelection.end) ++this.oldSelection.end;else ++this.cursorPos;
        }
      }
    }

    /** Start changing position */
    get startChangePos() {
      return Math.min(this.cursorPos, this.oldSelection.start);
    }

    /** Inserted symbols count */
    get insertedCount() {
      return this.cursorPos - this.startChangePos;
    }

    /** Inserted symbols */
    get inserted() {
      return this.value.substr(this.startChangePos, this.insertedCount);
    }

    /** Removed symbols count */
    get removedCount() {
      // Math.max for opposite operation
      return Math.max(this.oldSelection.end - this.startChangePos ||
      // for Delete
      this.oldValue.length - this.value.length, 0);
    }

    /** Removed symbols */
    get removed() {
      return this.oldValue.substr(this.startChangePos, this.removedCount);
    }

    /** Unchanged head symbols */
    get head() {
      return this.value.substring(0, this.startChangePos);
    }

    /** Unchanged tail symbols */
    get tail() {
      return this.value.substring(this.startChangePos + this.insertedCount);
    }

    /** Remove direction */
    get removeDirection() {
      if (!this.removedCount || this.insertedCount) return DIRECTION.NONE;

      // align right if delete at right
      return (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) &&
      // if not range removed (event with backspace)
      this.oldSelection.end === this.oldSelection.start ? DIRECTION.RIGHT : DIRECTION.LEFT;
    }
  }

  /** Applies mask on element */
  function IMask(el, opts) {
    // currently available only for input-like elements
    return new IMask.InputMask(el, opts);
  }

  // TODO can't use overloads here because of https://github.com/microsoft/TypeScript/issues/50754
  // export function maskedClass(mask: string): typeof MaskedPattern;
  // export function maskedClass(mask: DateConstructor): typeof MaskedDate;
  // export function maskedClass(mask: NumberConstructor): typeof MaskedNumber;
  // export function maskedClass(mask: Array<any> | ArrayConstructor): typeof MaskedDynamic;
  // export function maskedClass(mask: MaskedDate): typeof MaskedDate;
  // export function maskedClass(mask: MaskedNumber): typeof MaskedNumber;
  // export function maskedClass(mask: MaskedEnum): typeof MaskedEnum;
  // export function maskedClass(mask: MaskedRange): typeof MaskedRange;
  // export function maskedClass(mask: MaskedRegExp): typeof MaskedRegExp;
  // export function maskedClass(mask: MaskedFunction): typeof MaskedFunction;
  // export function maskedClass(mask: MaskedPattern): typeof MaskedPattern;
  // export function maskedClass(mask: MaskedDynamic): typeof MaskedDynamic;
  // export function maskedClass(mask: Masked): typeof Masked;
  // export function maskedClass(mask: typeof Masked): typeof Masked;
  // export function maskedClass(mask: typeof MaskedDate): typeof MaskedDate;
  // export function maskedClass(mask: typeof MaskedNumber): typeof MaskedNumber;
  // export function maskedClass(mask: typeof MaskedEnum): typeof MaskedEnum;
  // export function maskedClass(mask: typeof MaskedRange): typeof MaskedRange;
  // export function maskedClass(mask: typeof MaskedRegExp): typeof MaskedRegExp;
  // export function maskedClass(mask: typeof MaskedFunction): typeof MaskedFunction;
  // export function maskedClass(mask: typeof MaskedPattern): typeof MaskedPattern;
  // export function maskedClass(mask: typeof MaskedDynamic): typeof MaskedDynamic;
  // export function maskedClass<Mask extends typeof Masked> (mask: Mask): Mask;
  // export function maskedClass(mask: RegExp): typeof MaskedRegExp;
  // export function maskedClass(mask: (value: string, ...args: any[]) => boolean): typeof MaskedFunction;

  /** Get Masked class by mask type */
  function maskedClass(mask) /* TODO */{
    if (mask == null) throw new Error('mask property should be defined');
    if (mask instanceof RegExp) return IMask.MaskedRegExp;
    if (isString(mask)) return IMask.MaskedPattern;
    if (mask === Date) return IMask.MaskedDate;
    if (mask === Number) return IMask.MaskedNumber;
    if (Array.isArray(mask) || mask === Array) return IMask.MaskedDynamic;
    if (IMask.Masked && mask.prototype instanceof IMask.Masked) return mask;
    if (IMask.Masked && mask instanceof IMask.Masked) return mask.constructor;
    if (mask instanceof Function) return IMask.MaskedFunction;
    console.warn('Mask not found for mask', mask); // eslint-disable-line no-console
    return IMask.Masked;
  }
  function normalizeOpts(opts) {
    if (!opts) throw new Error('Options in not defined');
    if (IMask.Masked) {
      if (opts.prototype instanceof IMask.Masked) return {
        mask: opts
      };

      /*
        handle cases like:
        1) opts = Masked
        2) opts = { mask: Masked, ...instanceOpts }
      */
      const {
        mask = undefined,
        ...instanceOpts
      } = opts instanceof IMask.Masked ? {
        mask: opts
      } : isObject(opts) && opts.mask instanceof IMask.Masked ? opts : {};
      if (mask) {
        const _mask = mask.mask;
        return {
          ...pick(mask, (_, k) => !k.startsWith('_')),
          mask: mask.constructor,
          _mask,
          ...instanceOpts
        };
      }
    }
    if (!isObject(opts)) return {
      mask: opts
    };
    return {
      ...opts
    };
  }

  // TODO can't use overloads here because of https://github.com/microsoft/TypeScript/issues/50754

  // From masked
  // export default function createMask<Opts extends Masked, ReturnMasked=Opts> (opts: Opts): ReturnMasked;
  // // From masked class
  // export default function createMask<Opts extends MaskedOptions<typeof Masked>, ReturnMasked extends Masked=InstanceType<Opts['mask']>> (opts: Opts): ReturnMasked;
  // export default function createMask<Opts extends MaskedOptions<typeof MaskedDate>, ReturnMasked extends MaskedDate=MaskedDate<Opts['parent']>> (opts: Opts): ReturnMasked;
  // export default function createMask<Opts extends MaskedOptions<typeof MaskedNumber>, ReturnMasked extends MaskedNumber=MaskedNumber<Opts['parent']>> (opts: Opts): ReturnMasked;
  // export default function createMask<Opts extends MaskedOptions<typeof MaskedEnum>, ReturnMasked extends MaskedEnum=MaskedEnum<Opts['parent']>> (opts: Opts): ReturnMasked;
  // export default function createMask<Opts extends MaskedOptions<typeof MaskedRange>, ReturnMasked extends MaskedRange=MaskedRange<Opts['parent']>> (opts: Opts): ReturnMasked;
  // export default function createMask<Opts extends MaskedOptions<typeof MaskedRegExp>, ReturnMasked extends MaskedRegExp=MaskedRegExp<Opts['parent']>> (opts: Opts): ReturnMasked;
  // export default function createMask<Opts extends MaskedOptions<typeof MaskedFunction>, ReturnMasked extends MaskedFunction=MaskedFunction<Opts['parent']>> (opts: Opts): ReturnMasked;
  // export default function createMask<Opts extends MaskedOptions<typeof MaskedPattern>, ReturnMasked extends MaskedPattern=MaskedPattern<Opts['parent']>> (opts: Opts): ReturnMasked;
  // export default function createMask<Opts extends MaskedOptions<typeof MaskedDynamic>, ReturnMasked extends MaskedDynamic=MaskedDynamic<Opts['parent']>> (opts: Opts): ReturnMasked;
  // // From mask opts
  // export default function createMask<Opts extends MaskedOptions<Masked>, ReturnMasked=Opts extends MaskedOptions<infer M> ? M : never> (opts: Opts): ReturnMasked;
  // export default function createMask<Opts extends MaskedNumberOptions, ReturnMasked extends MaskedNumber=MaskedNumber<Opts['parent']>> (opts: Opts): ReturnMasked;
  // export default function createMask<Opts extends MaskedDateFactoryOptions, ReturnMasked extends MaskedDate=MaskedDate<Opts['parent']>> (opts: Opts): ReturnMasked;
  // export default function createMask<Opts extends MaskedEnumOptions, ReturnMasked extends MaskedEnum=MaskedEnum<Opts['parent']>> (opts: Opts): ReturnMasked;
  // export default function createMask<Opts extends MaskedRangeOptions, ReturnMasked extends MaskedRange=MaskedRange<Opts['parent']>> (opts: Opts): ReturnMasked;
  // export default function createMask<Opts extends MaskedPatternOptions, ReturnMasked extends MaskedPattern=MaskedPattern<Opts['parent']>> (opts: Opts): ReturnMasked;
  // export default function createMask<Opts extends MaskedDynamicOptions, ReturnMasked extends MaskedDynamic=MaskedDynamic<Opts['parent']>> (opts: Opts): ReturnMasked;
  // export default function createMask<Opts extends MaskedOptions<RegExp>, ReturnMasked extends MaskedRegExp=MaskedRegExp<Opts['parent']>> (opts: Opts): ReturnMasked;
  // export default function createMask<Opts extends MaskedOptions<Function>, ReturnMasked extends MaskedFunction=MaskedFunction<Opts['parent']>> (opts: Opts): ReturnMasked;

  /** Creates new {@link Masked} depending on mask type */
  function createMask(opts) {
    if (IMask.Masked && opts instanceof IMask.Masked) return opts;
    const nOpts = normalizeOpts(opts);
    const MaskedClass = maskedClass(nOpts.mask);
    if (!MaskedClass) throw new Error("Masked class is not found for provided mask " + nOpts.mask + ", appropriate module needs to be imported manually before creating mask.");
    if (nOpts.mask === MaskedClass) delete nOpts.mask;
    if (nOpts._mask) {
      nOpts.mask = nOpts._mask;
      delete nOpts._mask;
    }
    return new MaskedClass(nOpts);
  }
  IMask.createMask = createMask;

  /**  Generic element API to use with mask */
  class MaskElement {
    /** */

    /** */

    /** */

    /** Safely returns selection start */
    get selectionStart() {
      let start;
      try {
        start = this._unsafeSelectionStart;
      } catch {}
      return start != null ? start : this.value.length;
    }

    /** Safely returns selection end */
    get selectionEnd() {
      let end;
      try {
        end = this._unsafeSelectionEnd;
      } catch {}
      return end != null ? end : this.value.length;
    }

    /** Safely sets element selection */
    select(start, end) {
      if (start == null || end == null || start === this.selectionStart && end === this.selectionEnd) return;
      try {
        this._unsafeSelect(start, end);
      } catch {}
    }

    /** */
    get isActive() {
      return false;
    }
    /** */

    /** */

    /** */
  }
  IMask.MaskElement = MaskElement;

  const KEY_Z = 90;
  const KEY_Y = 89;

  /** Bridge between HTMLElement and {@link Masked} */
  class HTMLMaskElement extends MaskElement {
    /** HTMLElement to use mask on */

    constructor(input) {
      super();
      this.input = input;
      this._onKeydown = this._onKeydown.bind(this);
      this._onInput = this._onInput.bind(this);
      this._onBeforeinput = this._onBeforeinput.bind(this);
      this._onCompositionEnd = this._onCompositionEnd.bind(this);
    }
    get rootElement() {
      var _this$input$getRootNo, _this$input$getRootNo2, _this$input;
      return (_this$input$getRootNo = (_this$input$getRootNo2 = (_this$input = this.input).getRootNode) == null ? void 0 : _this$input$getRootNo2.call(_this$input)) != null ? _this$input$getRootNo : document;
    }

    /** Is element in focus */
    get isActive() {
      return this.input === this.rootElement.activeElement;
    }

    /** Binds HTMLElement events to mask internal events */
    bindEvents(handlers) {
      this.input.addEventListener('keydown', this._onKeydown);
      this.input.addEventListener('input', this._onInput);
      this.input.addEventListener('beforeinput', this._onBeforeinput);
      this.input.addEventListener('compositionend', this._onCompositionEnd);
      this.input.addEventListener('drop', handlers.drop);
      this.input.addEventListener('click', handlers.click);
      this.input.addEventListener('focus', handlers.focus);
      this.input.addEventListener('blur', handlers.commit);
      this._handlers = handlers;
    }
    _onKeydown(e) {
      if (this._handlers.redo && (e.keyCode === KEY_Z && e.shiftKey && (e.metaKey || e.ctrlKey) || e.keyCode === KEY_Y && e.ctrlKey)) {
        e.preventDefault();
        return this._handlers.redo(e);
      }
      if (this._handlers.undo && e.keyCode === KEY_Z && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        return this._handlers.undo(e);
      }
      if (!e.isComposing) this._handlers.selectionChange(e);
    }
    _onBeforeinput(e) {
      if (e.inputType === 'historyUndo' && this._handlers.undo) {
        e.preventDefault();
        return this._handlers.undo(e);
      }
      if (e.inputType === 'historyRedo' && this._handlers.redo) {
        e.preventDefault();
        return this._handlers.redo(e);
      }
    }
    _onCompositionEnd(e) {
      this._handlers.input(e);
    }
    _onInput(e) {
      if (!e.isComposing) this._handlers.input(e);
    }

    /** Unbinds HTMLElement events to mask internal events */
    unbindEvents() {
      this.input.removeEventListener('keydown', this._onKeydown);
      this.input.removeEventListener('input', this._onInput);
      this.input.removeEventListener('beforeinput', this._onBeforeinput);
      this.input.removeEventListener('compositionend', this._onCompositionEnd);
      this.input.removeEventListener('drop', this._handlers.drop);
      this.input.removeEventListener('click', this._handlers.click);
      this.input.removeEventListener('focus', this._handlers.focus);
      this.input.removeEventListener('blur', this._handlers.commit);
      this._handlers = {};
    }
  }
  IMask.HTMLMaskElement = HTMLMaskElement;

  /** Bridge between InputElement and {@link Masked} */
  class HTMLInputMaskElement extends HTMLMaskElement {
    /** InputElement to use mask on */

    constructor(input) {
      super(input);
      this.input = input;
    }

    /** Returns InputElement selection start */
    get _unsafeSelectionStart() {
      return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
    }

    /** Returns InputElement selection end */
    get _unsafeSelectionEnd() {
      return this.input.selectionEnd;
    }

    /** Sets InputElement selection */
    _unsafeSelect(start, end) {
      this.input.setSelectionRange(start, end);
    }
    get value() {
      return this.input.value;
    }
    set value(value) {
      this.input.value = value;
    }
  }
  IMask.HTMLMaskElement = HTMLMaskElement;

  class HTMLContenteditableMaskElement extends HTMLMaskElement {
    /** Returns HTMLElement selection start */
    get _unsafeSelectionStart() {
      const root = this.rootElement;
      const selection = root.getSelection && root.getSelection();
      const anchorOffset = selection && selection.anchorOffset;
      const focusOffset = selection && selection.focusOffset;
      if (focusOffset == null || anchorOffset == null || anchorOffset < focusOffset) {
        return anchorOffset;
      }
      return focusOffset;
    }

    /** Returns HTMLElement selection end */
    get _unsafeSelectionEnd() {
      const root = this.rootElement;
      const selection = root.getSelection && root.getSelection();
      const anchorOffset = selection && selection.anchorOffset;
      const focusOffset = selection && selection.focusOffset;
      if (focusOffset == null || anchorOffset == null || anchorOffset > focusOffset) {
        return anchorOffset;
      }
      return focusOffset;
    }

    /** Sets HTMLElement selection */
    _unsafeSelect(start, end) {
      if (!this.rootElement.createRange) return;
      const range = this.rootElement.createRange();
      range.setStart(this.input.firstChild || this.input, start);
      range.setEnd(this.input.lastChild || this.input, end);
      const root = this.rootElement;
      const selection = root.getSelection && root.getSelection();
      if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }

    /** HTMLElement value */
    get value() {
      return this.input.textContent || '';
    }
    set value(value) {
      this.input.textContent = value;
    }
  }
  IMask.HTMLContenteditableMaskElement = HTMLContenteditableMaskElement;

  class InputHistory {
    constructor() {
      this.states = [];
      this.currentIndex = 0;
    }
    get currentState() {
      return this.states[this.currentIndex];
    }
    get isEmpty() {
      return this.states.length === 0;
    }
    push(state) {
      // if current index points before the last element then remove the future
      if (this.currentIndex < this.states.length - 1) this.states.length = this.currentIndex + 1;
      this.states.push(state);
      if (this.states.length > InputHistory.MAX_LENGTH) this.states.shift();
      this.currentIndex = this.states.length - 1;
    }
    go(steps) {
      this.currentIndex = Math.min(Math.max(this.currentIndex + steps, 0), this.states.length - 1);
      return this.currentState;
    }
    undo() {
      return this.go(-1);
    }
    redo() {
      return this.go(+1);
    }
    clear() {
      this.states.length = 0;
      this.currentIndex = 0;
    }
  }
  InputHistory.MAX_LENGTH = 100;

  /** Listens to element events and controls changes between element and {@link Masked} */
  class InputMask {
    /**
      View element
    */

    /** Internal {@link Masked} model */

    constructor(el, opts) {
      this.el = el instanceof MaskElement ? el : el.isContentEditable && el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA' ? new HTMLContenteditableMaskElement(el) : new HTMLInputMaskElement(el);
      this.masked = createMask(opts);
      this._listeners = {};
      this._value = '';
      this._unmaskedValue = '';
      this._rawInputValue = '';
      this.history = new InputHistory();
      this._saveSelection = this._saveSelection.bind(this);
      this._onInput = this._onInput.bind(this);
      this._onChange = this._onChange.bind(this);
      this._onDrop = this._onDrop.bind(this);
      this._onFocus = this._onFocus.bind(this);
      this._onClick = this._onClick.bind(this);
      this._onUndo = this._onUndo.bind(this);
      this._onRedo = this._onRedo.bind(this);
      this.alignCursor = this.alignCursor.bind(this);
      this.alignCursorFriendly = this.alignCursorFriendly.bind(this);
      this._bindEvents();

      // refresh
      this.updateValue();
      this._onChange();
    }
    maskEquals(mask) {
      var _this$masked;
      return mask == null || ((_this$masked = this.masked) == null ? void 0 : _this$masked.maskEquals(mask));
    }

    /** Masked */
    get mask() {
      return this.masked.mask;
    }
    set mask(mask) {
      if (this.maskEquals(mask)) return;
      if (!(mask instanceof IMask.Masked) && this.masked.constructor === maskedClass(mask)) {
        // TODO "any" no idea
        this.masked.updateOptions({
          mask
        });
        return;
      }
      const masked = mask instanceof IMask.Masked ? mask : createMask({
        mask
      });
      masked.unmaskedValue = this.masked.unmaskedValue;
      this.masked = masked;
    }

    /** Raw value */
    get value() {
      return this._value;
    }
    set value(str) {
      if (this.value === str) return;
      this.masked.value = str;
      this.updateControl('auto');
    }

    /** Unmasked value */
    get unmaskedValue() {
      return this._unmaskedValue;
    }
    set unmaskedValue(str) {
      if (this.unmaskedValue === str) return;
      this.masked.unmaskedValue = str;
      this.updateControl('auto');
    }

    /** Raw input value */
    get rawInputValue() {
      return this._rawInputValue;
    }
    set rawInputValue(str) {
      if (this.rawInputValue === str) return;
      this.masked.rawInputValue = str;
      this.updateControl();
      this.alignCursor();
    }

    /** Typed unmasked value */
    get typedValue() {
      return this.masked.typedValue;
    }
    set typedValue(val) {
      if (this.masked.typedValueEquals(val)) return;
      this.masked.typedValue = val;
      this.updateControl('auto');
    }

    /** Display value */
    get displayValue() {
      return this.masked.displayValue;
    }

    /** Starts listening to element events */
    _bindEvents() {
      this.el.bindEvents({
        selectionChange: this._saveSelection,
        input: this._onInput,
        drop: this._onDrop,
        click: this._onClick,
        focus: this._onFocus,
        commit: this._onChange,
        undo: this._onUndo,
        redo: this._onRedo
      });
    }

    /** Stops listening to element events */
    _unbindEvents() {
      if (this.el) this.el.unbindEvents();
    }

    /** Fires custom event */
    _fireEvent(ev, e) {
      const listeners = this._listeners[ev];
      if (!listeners) return;
      listeners.forEach(l => l(e));
    }

    /** Current selection start */
    get selectionStart() {
      return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
    }

    /** Current cursor position */
    get cursorPos() {
      return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
    }
    set cursorPos(pos) {
      if (!this.el || !this.el.isActive) return;
      this.el.select(pos, pos);
      this._saveSelection();
    }

    /** Stores current selection */
    _saveSelection( /* ev */
    ) {
      if (this.displayValue !== this.el.value) {
        console.warn('Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly.'); // eslint-disable-line no-console
      }
      this._selection = {
        start: this.selectionStart,
        end: this.cursorPos
      };
    }

    /** Syncronizes model value from view */
    updateValue() {
      this.masked.value = this.el.value;
      this._value = this.masked.value;
      this._unmaskedValue = this.masked.unmaskedValue;
      this._rawInputValue = this.masked.rawInputValue;
    }

    /** Syncronizes view from model value, fires change events */
    updateControl(cursorPos) {
      const newUnmaskedValue = this.masked.unmaskedValue;
      const newValue = this.masked.value;
      const newRawInputValue = this.masked.rawInputValue;
      const newDisplayValue = this.displayValue;
      const isChanged = this.unmaskedValue !== newUnmaskedValue || this.value !== newValue || this._rawInputValue !== newRawInputValue;
      this._unmaskedValue = newUnmaskedValue;
      this._value = newValue;
      this._rawInputValue = newRawInputValue;
      if (this.el.value !== newDisplayValue) this.el.value = newDisplayValue;
      if (cursorPos === 'auto') this.alignCursor();else if (cursorPos != null) this.cursorPos = cursorPos;
      if (isChanged) this._fireChangeEvents();
      if (!this._historyChanging && (isChanged || this.history.isEmpty)) this.history.push({
        unmaskedValue: newUnmaskedValue,
        selection: {
          start: this.selectionStart,
          end: this.cursorPos
        }
      });
    }

    /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */
    updateOptions(opts) {
      const {
        mask,
        ...restOpts
      } = opts; // TODO types, yes, mask is optional

      const updateMask = !this.maskEquals(mask);
      const updateOpts = this.masked.optionsIsChanged(restOpts);
      if (updateMask) this.mask = mask;
      if (updateOpts) this.masked.updateOptions(restOpts); // TODO

      if (updateMask || updateOpts) this.updateControl();
    }

    /** Updates cursor */
    updateCursor(cursorPos) {
      if (cursorPos == null) return;
      this.cursorPos = cursorPos;

      // also queue change cursor for mobile browsers
      this._delayUpdateCursor(cursorPos);
    }

    /** Delays cursor update to support mobile browsers */
    _delayUpdateCursor(cursorPos) {
      this._abortUpdateCursor();
      this._changingCursorPos = cursorPos;
      this._cursorChanging = setTimeout(() => {
        if (!this.el) return; // if was destroyed
        this.cursorPos = this._changingCursorPos;
        this._abortUpdateCursor();
      }, 10);
    }

    /** Fires custom events */
    _fireChangeEvents() {
      this._fireEvent('accept', this._inputEvent);
      if (this.masked.isComplete) this._fireEvent('complete', this._inputEvent);
    }

    /** Aborts delayed cursor update */
    _abortUpdateCursor() {
      if (this._cursorChanging) {
        clearTimeout(this._cursorChanging);
        delete this._cursorChanging;
      }
    }

    /** Aligns cursor to nearest available position */
    alignCursor() {
      this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, DIRECTION.LEFT));
    }

    /** Aligns cursor only if selection is empty */
    alignCursorFriendly() {
      if (this.selectionStart !== this.cursorPos) return; // skip if range is selected
      this.alignCursor();
    }

    /** Adds listener on custom event */
    on(ev, handler) {
      if (!this._listeners[ev]) this._listeners[ev] = [];
      this._listeners[ev].push(handler);
      return this;
    }

    /** Removes custom event listener */
    off(ev, handler) {
      if (!this._listeners[ev]) return this;
      if (!handler) {
        delete this._listeners[ev];
        return this;
      }
      const hIndex = this._listeners[ev].indexOf(handler);
      if (hIndex >= 0) this._listeners[ev].splice(hIndex, 1);
      return this;
    }

    /** Handles view input event */
    _onInput(e) {
      this._inputEvent = e;
      this._abortUpdateCursor();
      const details = new ActionDetails({
        // new state
        value: this.el.value,
        cursorPos: this.cursorPos,
        // old state
        oldValue: this.displayValue,
        oldSelection: this._selection
      });
      const oldRawValue = this.masked.rawInputValue;
      const offset = this.masked.splice(details.startChangePos, details.removed.length, details.inserted, details.removeDirection, {
        input: true,
        raw: true
      }).offset;

      // force align in remove direction only if no input chars were removed
      // otherwise we still need to align with NONE (to get out from fixed symbols for instance)
      const removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : DIRECTION.NONE;
      let cursorPos = this.masked.nearestInputPos(details.startChangePos + offset, removeDirection);
      if (removeDirection !== DIRECTION.NONE) cursorPos = this.masked.nearestInputPos(cursorPos, DIRECTION.NONE);
      this.updateControl(cursorPos);
      delete this._inputEvent;
    }

    /** Handles view change event and commits model value */
    _onChange() {
      if (this.displayValue !== this.el.value) this.updateValue();
      this.masked.doCommit();
      this.updateControl();
      this._saveSelection();
    }

    /** Handles view drop event, prevents by default */
    _onDrop(ev) {
      ev.preventDefault();
      ev.stopPropagation();
    }

    /** Restore last selection on focus */
    _onFocus(ev) {
      this.alignCursorFriendly();
    }

    /** Restore last selection on focus */
    _onClick(ev) {
      this.alignCursorFriendly();
    }
    _onUndo() {
      this._applyHistoryState(this.history.undo());
    }
    _onRedo() {
      this._applyHistoryState(this.history.redo());
    }
    _applyHistoryState(state) {
      if (!state) return;
      this._historyChanging = true;
      this.unmaskedValue = state.unmaskedValue;
      this.el.select(state.selection.start, state.selection.end);
      this._saveSelection();
      this._historyChanging = false;
    }

    /** Unbind view events and removes element reference */
    destroy() {
      this._unbindEvents();
      this._listeners.length = 0;
      delete this.el;
    }
  }
  IMask.InputMask = InputMask;

  /** Provides details of changing model value */
  class ChangeDetails {
    /** Inserted symbols */

    /** Additional offset if any changes occurred before tail */

    /** Raw inserted is used by dynamic mask */

    /** Can skip chars */

    static normalize(prep) {
      return Array.isArray(prep) ? prep : [prep, new ChangeDetails()];
    }
    constructor(details) {
      Object.assign(this, {
        inserted: '',
        rawInserted: '',
        tailShift: 0,
        skip: false
      }, details);
    }

    /** Aggregate changes */
    aggregate(details) {
      this.inserted += details.inserted;
      this.rawInserted += details.rawInserted;
      this.tailShift += details.tailShift;
      this.skip = this.skip || details.skip;
      return this;
    }

    /** Total offset considering all changes */
    get offset() {
      return this.tailShift + this.inserted.length;
    }
    get consumed() {
      return Boolean(this.rawInserted) || this.skip;
    }
    equals(details) {
      return this.inserted === details.inserted && this.tailShift === details.tailShift && this.rawInserted === details.rawInserted && this.skip === details.skip;
    }
  }
  IMask.ChangeDetails = ChangeDetails;

  /** Provides details of continuous extracted tail */
  class ContinuousTailDetails {
    /** Tail value as string */

    /** Tail start position */

    /** Start position */

    constructor(value, from, stop) {
      if (value === void 0) {
        value = '';
      }
      if (from === void 0) {
        from = 0;
      }
      this.value = value;
      this.from = from;
      this.stop = stop;
    }
    toString() {
      return this.value;
    }
    extend(tail) {
      this.value += String(tail);
    }
    appendTo(masked) {
      return masked.append(this.toString(), {
        tail: true
      }).aggregate(masked._appendPlaceholder());
    }
    get state() {
      return {
        value: this.value,
        from: this.from,
        stop: this.stop
      };
    }
    set state(state) {
      Object.assign(this, state);
    }
    unshift(beforePos) {
      if (!this.value.length || beforePos != null && this.from >= beforePos) return '';
      const shiftChar = this.value[0];
      this.value = this.value.slice(1);
      return shiftChar;
    }
    shift() {
      if (!this.value.length) return '';
      const shiftChar = this.value[this.value.length - 1];
      this.value = this.value.slice(0, -1);
      return shiftChar;
    }
  }

  /** Append flags */

  /** Extract flags */

  // see https://github.com/microsoft/TypeScript/issues/6223

  /** Provides common masking stuff */
  class Masked {
    /** */

    /** */

    /** Transforms value before mask processing */

    /** Transforms each char before mask processing */

    /** Validates if value is acceptable */

    /** Does additional processing at the end of editing */

    /** Format typed value to string */

    /** Parse string to get typed value */

    /** Enable characters overwriting */

    /** */

    /** */

    /** */

    /** */

    constructor(opts) {
      this._value = '';
      this._update({
        ...Masked.DEFAULTS,
        ...opts
      });
      this._initialized = true;
    }

    /** Sets and applies new options */
    updateOptions(opts) {
      if (!this.optionsIsChanged(opts)) return;
      this.withValueRefresh(this._update.bind(this, opts));
    }

    /** Sets new options */
    _update(opts) {
      Object.assign(this, opts);
    }

    /** Mask state */
    get state() {
      return {
        _value: this.value,
        _rawInputValue: this.rawInputValue
      };
    }
    set state(state) {
      this._value = state._value;
    }

    /** Resets value */
    reset() {
      this._value = '';
    }
    get value() {
      return this._value;
    }
    set value(value) {
      this.resolve(value, {
        input: true
      });
    }

    /** Resolve new value */
    resolve(value, flags) {
      if (flags === void 0) {
        flags = {
          input: true
        };
      }
      this.reset();
      this.append(value, flags, '');
      this.doCommit();
    }
    get unmaskedValue() {
      return this.value;
    }
    set unmaskedValue(value) {
      this.resolve(value, {});
    }
    get typedValue() {
      return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
    }
    set typedValue(value) {
      if (this.format) {
        this.value = this.format(value, this);
      } else {
        this.unmaskedValue = String(value);
      }
    }

    /** Value that includes raw user input */
    get rawInputValue() {
      return this.extractInput(0, this.displayValue.length, {
        raw: true
      });
    }
    set rawInputValue(value) {
      this.resolve(value, {
        raw: true
      });
    }
    get displayValue() {
      return this.value;
    }
    get isComplete() {
      return true;
    }
    get isFilled() {
      return this.isComplete;
    }

    /** Finds nearest input position in direction */
    nearestInputPos(cursorPos, direction) {
      return cursorPos;
    }
    totalInputPositions(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      return Math.min(this.displayValue.length, toPos - fromPos);
    }

    /** Extracts value in range considering flags */
    extractInput(fromPos, toPos, flags) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      return this.displayValue.slice(fromPos, toPos);
    }

    /** Extracts tail in range */
    extractTail(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      return new ContinuousTailDetails(this.extractInput(fromPos, toPos), fromPos);
    }

    /** Appends tail */
    appendTail(tail) {
      if (isString(tail)) tail = new ContinuousTailDetails(String(tail));
      return tail.appendTo(this);
    }

    /** Appends char */
    _appendCharRaw(ch, flags) {
      if (!ch) return new ChangeDetails();
      this._value += ch;
      return new ChangeDetails({
        inserted: ch,
        rawInserted: ch
      });
    }

    /** Appends char */
    _appendChar(ch, flags, checkTail) {
      if (flags === void 0) {
        flags = {};
      }
      const consistentState = this.state;
      let details;
      [ch, details] = this.doPrepareChar(ch, flags);
      if (ch) {
        details = details.aggregate(this._appendCharRaw(ch, flags));

        // TODO handle `skip`?

        // try `autofix` lookahead
        if (!details.rawInserted && this.autofix === 'pad') {
          const noFixState = this.state;
          this.state = consistentState;
          let fixDetails = this.pad(flags);
          const chDetails = this._appendCharRaw(ch, flags);
          fixDetails = fixDetails.aggregate(chDetails);

          // if fix was applied or
          // if details are equal use skip restoring state optimization
          if (chDetails.rawInserted || fixDetails.equals(details)) {
            details = fixDetails;
          } else {
            this.state = noFixState;
          }
        }
      }
      if (details.inserted) {
        let consistentTail;
        let appended = this.doValidate(flags) !== false;
        if (appended && checkTail != null) {
          // validation ok, check tail
          const beforeTailState = this.state;
          if (this.overwrite === true) {
            consistentTail = checkTail.state;
            for (let i = 0; i < details.rawInserted.length; ++i) {
              checkTail.unshift(this.displayValue.length - details.tailShift);
            }
          }
          let tailDetails = this.appendTail(checkTail);
          appended = tailDetails.rawInserted.length === checkTail.toString().length;

          // not ok, try shift
          if (!(appended && tailDetails.inserted) && this.overwrite === 'shift') {
            this.state = beforeTailState;
            consistentTail = checkTail.state;
            for (let i = 0; i < details.rawInserted.length; ++i) {
              checkTail.shift();
            }
            tailDetails = this.appendTail(checkTail);
            appended = tailDetails.rawInserted.length === checkTail.toString().length;
          }

          // if ok, rollback state after tail
          if (appended && tailDetails.inserted) this.state = beforeTailState;
        }

        // revert all if something went wrong
        if (!appended) {
          details = new ChangeDetails();
          this.state = consistentState;
          if (checkTail && consistentTail) checkTail.state = consistentTail;
        }
      }
      return details;
    }

    /** Appends optional placeholder at the end */
    _appendPlaceholder() {
      return new ChangeDetails();
    }

    /** Appends optional eager placeholder at the end */
    _appendEager() {
      return new ChangeDetails();
    }

    /** Appends symbols considering flags */
    append(str, flags, tail) {
      if (!isString(str)) throw new Error('value should be string');
      const checkTail = isString(tail) ? new ContinuousTailDetails(String(tail)) : tail;
      if (flags != null && flags.tail) flags._beforeTailState = this.state;
      let details;
      [str, details] = this.doPrepare(str, flags);
      for (let ci = 0; ci < str.length; ++ci) {
        const d = this._appendChar(str[ci], flags, checkTail);
        if (!d.rawInserted && !this.doSkipInvalid(str[ci], flags, checkTail)) break;
        details.aggregate(d);
      }
      if ((this.eager === true || this.eager === 'append') && flags != null && flags.input && str) {
        details.aggregate(this._appendEager());
      }

      // append tail but aggregate only tailShift
      if (checkTail != null) {
        details.tailShift += this.appendTail(checkTail).tailShift;
        // TODO it's a good idea to clear state after appending ends
        // but it causes bugs when one append calls another (when dynamic dispatch set rawInputValue)
        // this._resetBeforeTailState();
      }
      return details;
    }
    remove(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      this._value = this.displayValue.slice(0, fromPos) + this.displayValue.slice(toPos);
      return new ChangeDetails();
    }

    /** Calls function and reapplies current value */
    withValueRefresh(fn) {
      if (this._refreshing || !this._initialized) return fn();
      this._refreshing = true;
      const rawInput = this.rawInputValue;
      const value = this.value;
      const ret = fn();
      this.rawInputValue = rawInput;
      // append lost trailing chars at the end
      if (this.value && this.value !== value && value.indexOf(this.value) === 0) {
        this.append(value.slice(this.displayValue.length), {}, '');
        this.doCommit();
      }
      delete this._refreshing;
      return ret;
    }
    runIsolated(fn) {
      if (this._isolated || !this._initialized) return fn(this);
      this._isolated = true;
      const state = this.state;
      const ret = fn(this);
      this.state = state;
      delete this._isolated;
      return ret;
    }
    doSkipInvalid(ch, flags, checkTail) {
      return Boolean(this.skipInvalid);
    }

    /** Prepares string before mask processing */
    doPrepare(str, flags) {
      if (flags === void 0) {
        flags = {};
      }
      return ChangeDetails.normalize(this.prepare ? this.prepare(str, this, flags) : str);
    }

    /** Prepares each char before mask processing */
    doPrepareChar(str, flags) {
      if (flags === void 0) {
        flags = {};
      }
      return ChangeDetails.normalize(this.prepareChar ? this.prepareChar(str, this, flags) : str);
    }

    /** Validates if value is acceptable */
    doValidate(flags) {
      return (!this.validate || this.validate(this.value, this, flags)) && (!this.parent || this.parent.doValidate(flags));
    }

    /** Does additional processing at the end of editing */
    doCommit() {
      if (this.commit) this.commit(this.value, this);
    }
    splice(start, deleteCount, inserted, removeDirection, flags) {
      if (inserted === void 0) {
        inserted = '';
      }
      if (removeDirection === void 0) {
        removeDirection = DIRECTION.NONE;
      }
      if (flags === void 0) {
        flags = {
          input: true
        };
      }
      const tailPos = start + deleteCount;
      const tail = this.extractTail(tailPos);
      const eagerRemove = this.eager === true || this.eager === 'remove';
      let oldRawValue;
      if (eagerRemove) {
        removeDirection = forceDirection(removeDirection);
        oldRawValue = this.extractInput(0, tailPos, {
          raw: true
        });
      }
      let startChangePos = start;
      const details = new ChangeDetails();

      // if it is just deletion without insertion
      if (removeDirection !== DIRECTION.NONE) {
        startChangePos = this.nearestInputPos(start, deleteCount > 1 && start !== 0 && !eagerRemove ? DIRECTION.NONE : removeDirection);

        // adjust tailShift if start was aligned
        details.tailShift = startChangePos - start;
      }
      details.aggregate(this.remove(startChangePos));
      if (eagerRemove && removeDirection !== DIRECTION.NONE && oldRawValue === this.rawInputValue) {
        if (removeDirection === DIRECTION.FORCE_LEFT) {
          let valLength;
          while (oldRawValue === this.rawInputValue && (valLength = this.displayValue.length)) {
            details.aggregate(new ChangeDetails({
              tailShift: -1
            })).aggregate(this.remove(valLength - 1));
          }
        } else if (removeDirection === DIRECTION.FORCE_RIGHT) {
          tail.unshift();
        }
      }
      return details.aggregate(this.append(inserted, flags, tail));
    }
    maskEquals(mask) {
      return this.mask === mask;
    }
    optionsIsChanged(opts) {
      return !objectIncludes(this, opts);
    }
    typedValueEquals(value) {
      const tval = this.typedValue;
      return value === tval || Masked.EMPTY_VALUES.includes(value) && Masked.EMPTY_VALUES.includes(tval) || (this.format ? this.format(value, this) === this.format(this.typedValue, this) : false);
    }
    pad(flags) {
      return new ChangeDetails();
    }
  }
  Masked.DEFAULTS = {
    skipInvalid: true
  };
  Masked.EMPTY_VALUES = [undefined, null, ''];
  IMask.Masked = Masked;

  class ChunksTailDetails {
    /** */

    constructor(chunks, from) {
      if (chunks === void 0) {
        chunks = [];
      }
      if (from === void 0) {
        from = 0;
      }
      this.chunks = chunks;
      this.from = from;
    }
    toString() {
      return this.chunks.map(String).join('');
    }
    extend(tailChunk) {
      if (!String(tailChunk)) return;
      tailChunk = isString(tailChunk) ? new ContinuousTailDetails(String(tailChunk)) : tailChunk;
      const lastChunk = this.chunks[this.chunks.length - 1];
      const extendLast = lastChunk && (
      // if stops are same or tail has no stop
      lastChunk.stop === tailChunk.stop || tailChunk.stop == null) &&
      // if tail chunk goes just after last chunk
      tailChunk.from === lastChunk.from + lastChunk.toString().length;
      if (tailChunk instanceof ContinuousTailDetails) {
        // check the ability to extend previous chunk
        if (extendLast) {
          // extend previous chunk
          lastChunk.extend(tailChunk.toString());
        } else {
          // append new chunk
          this.chunks.push(tailChunk);
        }
      } else if (tailChunk instanceof ChunksTailDetails) {
        if (tailChunk.stop == null) {
          // unwrap floating chunks to parent, keeping `from` pos
          let firstTailChunk;
          while (tailChunk.chunks.length && tailChunk.chunks[0].stop == null) {
            firstTailChunk = tailChunk.chunks.shift(); // not possible to be `undefined` because length was checked above
            firstTailChunk.from += tailChunk.from;
            this.extend(firstTailChunk);
          }
        }

        // if tail chunk still has value
        if (tailChunk.toString()) {
          // if chunks contains stops, then popup stop to container
          tailChunk.stop = tailChunk.blockIndex;
          this.chunks.push(tailChunk);
        }
      }
    }
    appendTo(masked) {
      if (!(masked instanceof IMask.MaskedPattern)) {
        const tail = new ContinuousTailDetails(this.toString());
        return tail.appendTo(masked);
      }
      const details = new ChangeDetails();
      for (let ci = 0; ci < this.chunks.length; ++ci) {
        const chunk = this.chunks[ci];
        const lastBlockIter = masked._mapPosToBlock(masked.displayValue.length);
        const stop = chunk.stop;
        let chunkBlock;
        if (stop != null && (
        // if block not found or stop is behind lastBlock
        !lastBlockIter || lastBlockIter.index <= stop)) {
          if (chunk instanceof ChunksTailDetails ||
          // for continuous block also check if stop is exist
          masked._stops.indexOf(stop) >= 0) {
            details.aggregate(masked._appendPlaceholder(stop));
          }
          chunkBlock = chunk instanceof ChunksTailDetails && masked._blocks[stop];
        }
        if (chunkBlock) {
          const tailDetails = chunkBlock.appendTail(chunk);
          details.aggregate(tailDetails);

          // get not inserted chars
          const remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
          if (remainChars) details.aggregate(masked.append(remainChars, {
            tail: true
          }));
        } else {
          details.aggregate(masked.append(chunk.toString(), {
            tail: true
          }));
        }
      }
      return details;
    }
    get state() {
      return {
        chunks: this.chunks.map(c => c.state),
        from: this.from,
        stop: this.stop,
        blockIndex: this.blockIndex
      };
    }
    set state(state) {
      const {
        chunks,
        ...props
      } = state;
      Object.assign(this, props);
      this.chunks = chunks.map(cstate => {
        const chunk = "chunks" in cstate ? new ChunksTailDetails() : new ContinuousTailDetails();
        chunk.state = cstate;
        return chunk;
      });
    }
    unshift(beforePos) {
      if (!this.chunks.length || beforePos != null && this.from >= beforePos) return '';
      const chunkShiftPos = beforePos != null ? beforePos - this.from : beforePos;
      let ci = 0;
      while (ci < this.chunks.length) {
        const chunk = this.chunks[ci];
        const shiftChar = chunk.unshift(chunkShiftPos);
        if (chunk.toString()) {
          // chunk still contains value
          // but not shifted - means no more available chars to shift
          if (!shiftChar) break;
          ++ci;
        } else {
          // clean if chunk has no value
          this.chunks.splice(ci, 1);
        }
        if (shiftChar) return shiftChar;
      }
      return '';
    }
    shift() {
      if (!this.chunks.length) return '';
      let ci = this.chunks.length - 1;
      while (0 <= ci) {
        const chunk = this.chunks[ci];
        const shiftChar = chunk.shift();
        if (chunk.toString()) {
          // chunk still contains value
          // but not shifted - means no more available chars to shift
          if (!shiftChar) break;
          --ci;
        } else {
          // clean if chunk has no value
          this.chunks.splice(ci, 1);
        }
        if (shiftChar) return shiftChar;
      }
      return '';
    }
  }

  class PatternCursor {
    constructor(masked, pos) {
      this.masked = masked;
      this._log = [];
      const {
        offset,
        index
      } = masked._mapPosToBlock(pos) || (pos < 0 ?
      // first
      {
        index: 0,
        offset: 0
      } :
      // last
      {
        index: this.masked._blocks.length,
        offset: 0
      });
      this.offset = offset;
      this.index = index;
      this.ok = false;
    }
    get block() {
      return this.masked._blocks[this.index];
    }
    get pos() {
      return this.masked._blockStartPos(this.index) + this.offset;
    }
    get state() {
      return {
        index: this.index,
        offset: this.offset,
        ok: this.ok
      };
    }
    set state(s) {
      Object.assign(this, s);
    }
    pushState() {
      this._log.push(this.state);
    }
    popState() {
      const s = this._log.pop();
      if (s) this.state = s;
      return s;
    }
    bindBlock() {
      if (this.block) return;
      if (this.index < 0) {
        this.index = 0;
        this.offset = 0;
      }
      if (this.index >= this.masked._blocks.length) {
        this.index = this.masked._blocks.length - 1;
        this.offset = this.block.displayValue.length; // TODO this is stupid type error, `block` depends on index that was changed above
      }
    }
    _pushLeft(fn) {
      this.pushState();
      for (this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((_this$block = this.block) == null ? void 0 : _this$block.displayValue.length) || 0) {
        var _this$block;
        if (fn()) return this.ok = true;
      }
      return this.ok = false;
    }
    _pushRight(fn) {
      this.pushState();
      for (this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0) {
        if (fn()) return this.ok = true;
      }
      return this.ok = false;
    }
    pushLeftBeforeFilled() {
      return this._pushLeft(() => {
        if (this.block.isFixed || !this.block.value) return;
        this.offset = this.block.nearestInputPos(this.offset, DIRECTION.FORCE_LEFT);
        if (this.offset !== 0) return true;
      });
    }
    pushLeftBeforeInput() {
      // cases:
      // filled input: 00|
      // optional empty input: 00[]|
      // nested block: XX<[]>|
      return this._pushLeft(() => {
        if (this.block.isFixed) return;
        this.offset = this.block.nearestInputPos(this.offset, DIRECTION.LEFT);
        return true;
      });
    }
    pushLeftBeforeRequired() {
      return this._pushLeft(() => {
        if (this.block.isFixed || this.block.isOptional && !this.block.value) return;
        this.offset = this.block.nearestInputPos(this.offset, DIRECTION.LEFT);
        return true;
      });
    }
    pushRightBeforeFilled() {
      return this._pushRight(() => {
        if (this.block.isFixed || !this.block.value) return;
        this.offset = this.block.nearestInputPos(this.offset, DIRECTION.FORCE_RIGHT);
        if (this.offset !== this.block.value.length) return true;
      });
    }
    pushRightBeforeInput() {
      return this._pushRight(() => {
        if (this.block.isFixed) return;

        // const o = this.offset;
        this.offset = this.block.nearestInputPos(this.offset, DIRECTION.NONE);
        // HACK cases like (STILL DOES NOT WORK FOR NESTED)
        // aa|X
        // aa<X|[]>X_    - this will not work
        // if (o && o === this.offset && this.block instanceof PatternInputDefinition) continue;
        return true;
      });
    }
    pushRightBeforeRequired() {
      return this._pushRight(() => {
        if (this.block.isFixed || this.block.isOptional && !this.block.value) return;

        // TODO check |[*]XX_
        this.offset = this.block.nearestInputPos(this.offset, DIRECTION.NONE);
        return true;
      });
    }
  }

  class PatternFixedDefinition {
    /** */

    /** */

    /** */

    /** */

    /** */

    /** */

    constructor(opts) {
      Object.assign(this, opts);
      this._value = '';
      this.isFixed = true;
    }
    get value() {
      return this._value;
    }
    get unmaskedValue() {
      return this.isUnmasking ? this.value : '';
    }
    get rawInputValue() {
      return this._isRawInput ? this.value : '';
    }
    get displayValue() {
      return this.value;
    }
    reset() {
      this._isRawInput = false;
      this._value = '';
    }
    remove(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this._value.length;
      }
      this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
      if (!this._value) this._isRawInput = false;
      return new ChangeDetails();
    }
    nearestInputPos(cursorPos, direction) {
      if (direction === void 0) {
        direction = DIRECTION.NONE;
      }
      const minPos = 0;
      const maxPos = this._value.length;
      switch (direction) {
        case DIRECTION.LEFT:
        case DIRECTION.FORCE_LEFT:
          return minPos;
        case DIRECTION.NONE:
        case DIRECTION.RIGHT:
        case DIRECTION.FORCE_RIGHT:
        default:
          return maxPos;
      }
    }
    totalInputPositions(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this._value.length;
      }
      return this._isRawInput ? toPos - fromPos : 0;
    }
    extractInput(fromPos, toPos, flags) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this._value.length;
      }
      if (flags === void 0) {
        flags = {};
      }
      return flags.raw && this._isRawInput && this._value.slice(fromPos, toPos) || '';
    }
    get isComplete() {
      return true;
    }
    get isFilled() {
      return Boolean(this._value);
    }
    _appendChar(ch, flags) {
      if (flags === void 0) {
        flags = {};
      }
      if (this.isFilled) return new ChangeDetails();
      const appendEager = this.eager === true || this.eager === 'append';
      const appended = this.char === ch;
      const isResolved = appended && (this.isUnmasking || flags.input || flags.raw) && (!flags.raw || !appendEager) && !flags.tail;
      const details = new ChangeDetails({
        inserted: this.char,
        rawInserted: isResolved ? this.char : ''
      });
      this._value = this.char;
      this._isRawInput = isResolved && (flags.raw || flags.input);
      return details;
    }
    _appendEager() {
      return this._appendChar(this.char, {
        tail: true
      });
    }
    _appendPlaceholder() {
      const details = new ChangeDetails();
      if (this.isFilled) return details;
      this._value = details.inserted = this.char;
      return details;
    }
    extractTail() {
      return new ContinuousTailDetails('');
    }
    appendTail(tail) {
      if (isString(tail)) tail = new ContinuousTailDetails(String(tail));
      return tail.appendTo(this);
    }
    append(str, flags, tail) {
      const details = this._appendChar(str[0], flags);
      if (tail != null) {
        details.tailShift += this.appendTail(tail).tailShift;
      }
      return details;
    }
    doCommit() {}
    get state() {
      return {
        _value: this._value,
        _rawInputValue: this.rawInputValue
      };
    }
    set state(state) {
      this._value = state._value;
      this._isRawInput = Boolean(state._rawInputValue);
    }
    pad(flags) {
      return this._appendPlaceholder();
    }
  }

  class PatternInputDefinition {
    /** */

    /** */

    /** */

    /** */

    /** */

    /** */

    /** */

    /** */

    constructor(opts) {
      const {
        parent,
        isOptional,
        placeholderChar,
        displayChar,
        lazy,
        eager,
        ...maskOpts
      } = opts;
      this.masked = createMask(maskOpts);
      Object.assign(this, {
        parent,
        isOptional,
        placeholderChar,
        displayChar,
        lazy,
        eager
      });
    }
    reset() {
      this.isFilled = false;
      this.masked.reset();
    }
    remove(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.value.length;
      }
      if (fromPos === 0 && toPos >= 1) {
        this.isFilled = false;
        return this.masked.remove(fromPos, toPos);
      }
      return new ChangeDetails();
    }
    get value() {
      return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : '');
    }
    get unmaskedValue() {
      return this.masked.unmaskedValue;
    }
    get rawInputValue() {
      return this.masked.rawInputValue;
    }
    get displayValue() {
      return this.masked.value && this.displayChar || this.value;
    }
    get isComplete() {
      return Boolean(this.masked.value) || this.isOptional;
    }
    _appendChar(ch, flags) {
      if (flags === void 0) {
        flags = {};
      }
      if (this.isFilled) return new ChangeDetails();
      const state = this.masked.state;
      // simulate input
      let details = this.masked._appendChar(ch, this.currentMaskFlags(flags));
      if (details.inserted && this.doValidate(flags) === false) {
        details = new ChangeDetails();
        this.masked.state = state;
      }
      if (!details.inserted && !this.isOptional && !this.lazy && !flags.input) {
        details.inserted = this.placeholderChar;
      }
      details.skip = !details.inserted && !this.isOptional;
      this.isFilled = Boolean(details.inserted);
      return details;
    }
    append(str, flags, tail) {
      // TODO probably should be done via _appendChar
      return this.masked.append(str, this.currentMaskFlags(flags), tail);
    }
    _appendPlaceholder() {
      if (this.isFilled || this.isOptional) return new ChangeDetails();
      this.isFilled = true;
      return new ChangeDetails({
        inserted: this.placeholderChar
      });
    }
    _appendEager() {
      return new ChangeDetails();
    }
    extractTail(fromPos, toPos) {
      return this.masked.extractTail(fromPos, toPos);
    }
    appendTail(tail) {
      return this.masked.appendTail(tail);
    }
    extractInput(fromPos, toPos, flags) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.value.length;
      }
      return this.masked.extractInput(fromPos, toPos, flags);
    }
    nearestInputPos(cursorPos, direction) {
      if (direction === void 0) {
        direction = DIRECTION.NONE;
      }
      const minPos = 0;
      const maxPos = this.value.length;
      const boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);
      switch (direction) {
        case DIRECTION.LEFT:
        case DIRECTION.FORCE_LEFT:
          return this.isComplete ? boundPos : minPos;
        case DIRECTION.RIGHT:
        case DIRECTION.FORCE_RIGHT:
          return this.isComplete ? boundPos : maxPos;
        case DIRECTION.NONE:
        default:
          return boundPos;
      }
    }
    totalInputPositions(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.value.length;
      }
      return this.value.slice(fromPos, toPos).length;
    }
    doValidate(flags) {
      return this.masked.doValidate(this.currentMaskFlags(flags)) && (!this.parent || this.parent.doValidate(this.currentMaskFlags(flags)));
    }
    doCommit() {
      this.masked.doCommit();
    }
    get state() {
      return {
        _value: this.value,
        _rawInputValue: this.rawInputValue,
        masked: this.masked.state,
        isFilled: this.isFilled
      };
    }
    set state(state) {
      this.masked.state = state.masked;
      this.isFilled = state.isFilled;
    }
    currentMaskFlags(flags) {
      var _flags$_beforeTailSta;
      return {
        ...flags,
        _beforeTailState: (flags == null || (_flags$_beforeTailSta = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta.masked) || (flags == null ? void 0 : flags._beforeTailState)
      };
    }
    pad(flags) {
      return new ChangeDetails();
    }
  }
  PatternInputDefinition.DEFAULT_DEFINITIONS = {
    '0': /\d/,
    'a': /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
    // http://stackoverflow.com/a/22075070
    '*': /./
  };

  /** Masking by RegExp */
  class MaskedRegExp extends Masked {
    /** */

    /** Enable characters overwriting */

    /** */

    /** */

    /** */

    updateOptions(opts) {
      super.updateOptions(opts);
    }
    _update(opts) {
      const mask = opts.mask;
      if (mask) opts.validate = value => value.search(mask) >= 0;
      super._update(opts);
    }
  }
  IMask.MaskedRegExp = MaskedRegExp;

  /** Pattern mask */
  class MaskedPattern extends Masked {
    /** */

    /** */

    /** Single char for empty input */

    /** Single char for filled input */

    /** Show placeholder only when needed */

    /** Enable characters overwriting */

    /** */

    /** */

    /** */

    constructor(opts) {
      super({
        ...MaskedPattern.DEFAULTS,
        ...opts,
        definitions: Object.assign({}, PatternInputDefinition.DEFAULT_DEFINITIONS, opts == null ? void 0 : opts.definitions)
      });
    }
    updateOptions(opts) {
      super.updateOptions(opts);
    }
    _update(opts) {
      opts.definitions = Object.assign({}, this.definitions, opts.definitions);
      super._update(opts);
      this._rebuildMask();
    }
    _rebuildMask() {
      const defs = this.definitions;
      this._blocks = [];
      this.exposeBlock = undefined;
      this._stops = [];
      this._maskedBlocks = {};
      const pattern = this.mask;
      if (!pattern || !defs) return;
      let unmaskingBlock = false;
      let optionalBlock = false;
      for (let i = 0; i < pattern.length; ++i) {
        if (this.blocks) {
          const p = pattern.slice(i);
          const bNames = Object.keys(this.blocks).filter(bName => p.indexOf(bName) === 0);
          // order by key length
          bNames.sort((a, b) => b.length - a.length);
          // use block name with max length
          const bName = bNames[0];
          if (bName) {
            const {
              expose,
              repeat,
              ...bOpts
            } = normalizeOpts(this.blocks[bName]); // TODO type Opts<Arg & Extra>
            const blockOpts = {
              lazy: this.lazy,
              eager: this.eager,
              placeholderChar: this.placeholderChar,
              displayChar: this.displayChar,
              overwrite: this.overwrite,
              autofix: this.autofix,
              ...bOpts,
              repeat,
              parent: this
            };
            const maskedBlock = repeat != null ? new IMask.RepeatBlock(blockOpts /* TODO */) : createMask(blockOpts);
            if (maskedBlock) {
              this._blocks.push(maskedBlock);
              if (expose) this.exposeBlock = maskedBlock;

              // store block index
              if (!this._maskedBlocks[bName]) this._maskedBlocks[bName] = [];
              this._maskedBlocks[bName].push(this._blocks.length - 1);
            }
            i += bName.length - 1;
            continue;
          }
        }
        let char = pattern[i];
        let isInput = (char in defs);
        if (char === MaskedPattern.STOP_CHAR) {
          this._stops.push(this._blocks.length);
          continue;
        }
        if (char === '{' || char === '}') {
          unmaskingBlock = !unmaskingBlock;
          continue;
        }
        if (char === '[' || char === ']') {
          optionalBlock = !optionalBlock;
          continue;
        }
        if (char === MaskedPattern.ESCAPE_CHAR) {
          ++i;
          char = pattern[i];
          if (!char) break;
          isInput = false;
        }
        const def = isInput ? new PatternInputDefinition({
          isOptional: optionalBlock,
          lazy: this.lazy,
          eager: this.eager,
          placeholderChar: this.placeholderChar,
          displayChar: this.displayChar,
          ...normalizeOpts(defs[char]),
          parent: this
        }) : new PatternFixedDefinition({
          char,
          eager: this.eager,
          isUnmasking: unmaskingBlock
        });
        this._blocks.push(def);
      }
    }
    get state() {
      return {
        ...super.state,
        _blocks: this._blocks.map(b => b.state)
      };
    }
    set state(state) {
      if (!state) {
        this.reset();
        return;
      }
      const {
        _blocks,
        ...maskedState
      } = state;
      this._blocks.forEach((b, bi) => b.state = _blocks[bi]);
      super.state = maskedState;
    }
    reset() {
      super.reset();
      this._blocks.forEach(b => b.reset());
    }
    get isComplete() {
      return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every(b => b.isComplete);
    }
    get isFilled() {
      return this._blocks.every(b => b.isFilled);
    }
    get isFixed() {
      return this._blocks.every(b => b.isFixed);
    }
    get isOptional() {
      return this._blocks.every(b => b.isOptional);
    }
    doCommit() {
      this._blocks.forEach(b => b.doCommit());
      super.doCommit();
    }
    get unmaskedValue() {
      return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((str, b) => str += b.unmaskedValue, '');
    }
    set unmaskedValue(unmaskedValue) {
      if (this.exposeBlock) {
        const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
        this.exposeBlock.unmaskedValue = unmaskedValue;
        this.appendTail(tail);
        this.doCommit();
      } else super.unmaskedValue = unmaskedValue;
    }
    get value() {
      return this.exposeBlock ? this.exposeBlock.value :
      // TODO return _value when not in change?
      this._blocks.reduce((str, b) => str += b.value, '');
    }
    set value(value) {
      if (this.exposeBlock) {
        const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
        this.exposeBlock.value = value;
        this.appendTail(tail);
        this.doCommit();
      } else super.value = value;
    }
    get typedValue() {
      return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
    }
    set typedValue(value) {
      if (this.exposeBlock) {
        const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
        this.exposeBlock.typedValue = value;
        this.appendTail(tail);
        this.doCommit();
      } else super.typedValue = value;
    }
    get displayValue() {
      return this._blocks.reduce((str, b) => str += b.displayValue, '');
    }
    appendTail(tail) {
      return super.appendTail(tail).aggregate(this._appendPlaceholder());
    }
    _appendEager() {
      var _this$_mapPosToBlock;
      const details = new ChangeDetails();
      let startBlockIndex = (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : _this$_mapPosToBlock.index;
      if (startBlockIndex == null) return details;

      // TODO test if it works for nested pattern masks
      if (this._blocks[startBlockIndex].isFilled) ++startBlockIndex;
      for (let bi = startBlockIndex; bi < this._blocks.length; ++bi) {
        const d = this._blocks[bi]._appendEager();
        if (!d.inserted) break;
        details.aggregate(d);
      }
      return details;
    }
    _appendCharRaw(ch, flags) {
      if (flags === void 0) {
        flags = {};
      }
      const blockIter = this._mapPosToBlock(this.displayValue.length);
      const details = new ChangeDetails();
      if (!blockIter) return details;
      for (let bi = blockIter.index, block; block = this._blocks[bi]; ++bi) {
        var _flags$_beforeTailSta;
        const blockDetails = block._appendChar(ch, {
          ...flags,
          _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) == null || (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null ? void 0 : _flags$_beforeTailSta[bi]
        });
        details.aggregate(blockDetails);
        if (blockDetails.consumed) break; // go next char
      }
      return details;
    }
    extractTail(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      const chunkTail = new ChunksTailDetails();
      if (fromPos === toPos) return chunkTail;
      this._forEachBlocksInRange(fromPos, toPos, (b, bi, bFromPos, bToPos) => {
        const blockChunk = b.extractTail(bFromPos, bToPos);
        blockChunk.stop = this._findStopBefore(bi);
        blockChunk.from = this._blockStartPos(bi);
        if (blockChunk instanceof ChunksTailDetails) blockChunk.blockIndex = bi;
        chunkTail.extend(blockChunk);
      });
      return chunkTail;
    }
    extractInput(fromPos, toPos, flags) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      if (flags === void 0) {
        flags = {};
      }
      if (fromPos === toPos) return '';
      let input = '';
      this._forEachBlocksInRange(fromPos, toPos, (b, _, fromPos, toPos) => {
        input += b.extractInput(fromPos, toPos, flags);
      });
      return input;
    }
    _findStopBefore(blockIndex) {
      let stopBefore;
      for (let si = 0; si < this._stops.length; ++si) {
        const stop = this._stops[si];
        if (stop <= blockIndex) stopBefore = stop;else break;
      }
      return stopBefore;
    }

    /** Appends placeholder depending on laziness */
    _appendPlaceholder(toBlockIndex) {
      const details = new ChangeDetails();
      if (this.lazy && toBlockIndex == null) return details;
      const startBlockIter = this._mapPosToBlock(this.displayValue.length);
      if (!startBlockIter) return details;
      const startBlockIndex = startBlockIter.index;
      const endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;
      this._blocks.slice(startBlockIndex, endBlockIndex).forEach(b => {
        if (!b.lazy || toBlockIndex != null) {
          var _blocks2;
          details.aggregate(b._appendPlaceholder((_blocks2 = b._blocks) == null ? void 0 : _blocks2.length));
        }
      });
      return details;
    }

    /** Finds block in pos */
    _mapPosToBlock(pos) {
      let accVal = '';
      for (let bi = 0; bi < this._blocks.length; ++bi) {
        const block = this._blocks[bi];
        const blockStartPos = accVal.length;
        accVal += block.displayValue;
        if (pos <= accVal.length) {
          return {
            index: bi,
            offset: pos - blockStartPos
          };
        }
      }
    }
    _blockStartPos(blockIndex) {
      return this._blocks.slice(0, blockIndex).reduce((pos, b) => pos += b.displayValue.length, 0);
    }
    _forEachBlocksInRange(fromPos, toPos, fn) {
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      const fromBlockIter = this._mapPosToBlock(fromPos);
      if (fromBlockIter) {
        const toBlockIter = this._mapPosToBlock(toPos);
        // process first block
        const isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
        const fromBlockStartPos = fromBlockIter.offset;
        const fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].displayValue.length;
        fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);
        if (toBlockIter && !isSameBlock) {
          // process intermediate blocks
          for (let bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi) {
            fn(this._blocks[bi], bi, 0, this._blocks[bi].displayValue.length);
          }

          // process last block
          fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
        }
      }
    }
    remove(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      const removeDetails = super.remove(fromPos, toPos);
      this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos) => {
        removeDetails.aggregate(b.remove(bFromPos, bToPos));
      });
      return removeDetails;
    }
    nearestInputPos(cursorPos, direction) {
      if (direction === void 0) {
        direction = DIRECTION.NONE;
      }
      if (!this._blocks.length) return 0;
      const cursor = new PatternCursor(this, cursorPos);
      if (direction === DIRECTION.NONE) {
        // -------------------------------------------------
        // NONE should only go out from fixed to the right!
        // -------------------------------------------------
        if (cursor.pushRightBeforeInput()) return cursor.pos;
        cursor.popState();
        if (cursor.pushLeftBeforeInput()) return cursor.pos;
        return this.displayValue.length;
      }

      // FORCE is only about a|* otherwise is 0
      if (direction === DIRECTION.LEFT || direction === DIRECTION.FORCE_LEFT) {
        // try to break fast when *|a
        if (direction === DIRECTION.LEFT) {
          cursor.pushRightBeforeFilled();
          if (cursor.ok && cursor.pos === cursorPos) return cursorPos;
          cursor.popState();
        }

        // forward flow
        cursor.pushLeftBeforeInput();
        cursor.pushLeftBeforeRequired();
        cursor.pushLeftBeforeFilled();

        // backward flow
        if (direction === DIRECTION.LEFT) {
          cursor.pushRightBeforeInput();
          cursor.pushRightBeforeRequired();
          if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
          cursor.popState();
          if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
          cursor.popState();
        }
        if (cursor.ok) return cursor.pos;
        if (direction === DIRECTION.FORCE_LEFT) return 0;
        cursor.popState();
        if (cursor.ok) return cursor.pos;
        cursor.popState();
        if (cursor.ok) return cursor.pos;
        return 0;
      }
      if (direction === DIRECTION.RIGHT || direction === DIRECTION.FORCE_RIGHT) {
        // forward flow
        cursor.pushRightBeforeInput();
        cursor.pushRightBeforeRequired();
        if (cursor.pushRightBeforeFilled()) return cursor.pos;
        if (direction === DIRECTION.FORCE_RIGHT) return this.displayValue.length;

        // backward flow
        cursor.popState();
        if (cursor.ok) return cursor.pos;
        cursor.popState();
        if (cursor.ok) return cursor.pos;
        return this.nearestInputPos(cursorPos, DIRECTION.LEFT);
      }
      return cursorPos;
    }
    totalInputPositions(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      let total = 0;
      this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos) => {
        total += b.totalInputPositions(bFromPos, bToPos);
      });
      return total;
    }

    /** Get block by name */
    maskedBlock(name) {
      return this.maskedBlocks(name)[0];
    }

    /** Get all blocks by name */
    maskedBlocks(name) {
      const indices = this._maskedBlocks[name];
      if (!indices) return [];
      return indices.map(gi => this._blocks[gi]);
    }
    pad(flags) {
      const details = new ChangeDetails();
      this._forEachBlocksInRange(0, this.displayValue.length, b => details.aggregate(b.pad(flags)));
      return details;
    }
  }
  MaskedPattern.DEFAULTS = {
    ...Masked.DEFAULTS,
    lazy: true,
    placeholderChar: '_'
  };
  MaskedPattern.STOP_CHAR = '`';
  MaskedPattern.ESCAPE_CHAR = '\\';
  MaskedPattern.InputDefinition = PatternInputDefinition;
  MaskedPattern.FixedDefinition = PatternFixedDefinition;
  IMask.MaskedPattern = MaskedPattern;

  /** Pattern which accepts ranges */
  class MaskedRange extends MaskedPattern {
    /**
      Optionally sets max length of pattern.
      Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
    */

    /** Min bound */

    /** Max bound */

    get _matchFrom() {
      return this.maxLength - String(this.from).length;
    }
    constructor(opts) {
      super(opts); // mask will be created in _update
    }
    updateOptions(opts) {
      super.updateOptions(opts);
    }
    _update(opts) {
      const {
        to = this.to || 0,
        from = this.from || 0,
        maxLength = this.maxLength || 0,
        autofix = this.autofix,
        ...patternOpts
      } = opts;
      this.to = to;
      this.from = from;
      this.maxLength = Math.max(String(to).length, maxLength);
      this.autofix = autofix;
      const fromStr = String(this.from).padStart(this.maxLength, '0');
      const toStr = String(this.to).padStart(this.maxLength, '0');
      let sameCharsCount = 0;
      while (sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount]) ++sameCharsCount;
      patternOpts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, '\\0') + '0'.repeat(this.maxLength - sameCharsCount);
      super._update(patternOpts);
    }
    get isComplete() {
      return super.isComplete && Boolean(this.value);
    }
    boundaries(str) {
      let minstr = '';
      let maxstr = '';
      const [, placeholder, num] = str.match(/^(\D*)(\d*)(\D*)/) || [];
      if (num) {
        minstr = '0'.repeat(placeholder.length) + num;
        maxstr = '9'.repeat(placeholder.length) + num;
      }
      minstr = minstr.padEnd(this.maxLength, '0');
      maxstr = maxstr.padEnd(this.maxLength, '9');
      return [minstr, maxstr];
    }
    doPrepareChar(ch, flags) {
      if (flags === void 0) {
        flags = {};
      }
      let details;
      [ch, details] = super.doPrepareChar(ch.replace(/\D/g, ''), flags);
      if (!ch) details.skip = !this.isComplete;
      return [ch, details];
    }
    _appendCharRaw(ch, flags) {
      if (flags === void 0) {
        flags = {};
      }
      if (!this.autofix || this.value.length + 1 > this.maxLength) return super._appendCharRaw(ch, flags);
      const fromStr = String(this.from).padStart(this.maxLength, '0');
      const toStr = String(this.to).padStart(this.maxLength, '0');
      const [minstr, maxstr] = this.boundaries(this.value + ch);
      if (Number(maxstr) < this.from) return super._appendCharRaw(fromStr[this.value.length], flags);
      if (Number(minstr) > this.to) {
        if (!flags.tail && this.autofix === 'pad' && this.value.length + 1 < this.maxLength) {
          return super._appendCharRaw(fromStr[this.value.length], flags).aggregate(this._appendCharRaw(ch, flags));
        }
        return super._appendCharRaw(toStr[this.value.length], flags);
      }
      return super._appendCharRaw(ch, flags);
    }
    doValidate(flags) {
      const str = this.value;
      const firstNonZero = str.search(/[^0]/);
      if (firstNonZero === -1 && str.length <= this._matchFrom) return true;
      const [minstr, maxstr] = this.boundaries(str);
      return this.from <= Number(maxstr) && Number(minstr) <= this.to && super.doValidate(flags);
    }
    pad(flags) {
      const details = new ChangeDetails();
      if (this.value.length === this.maxLength) return details;
      const value = this.value;
      const padLength = this.maxLength - this.value.length;
      if (padLength) {
        this.reset();
        for (let i = 0; i < padLength; ++i) {
          details.aggregate(super._appendCharRaw('0', flags));
        }

        // append tail
        value.split('').forEach(ch => this._appendCharRaw(ch));
      }
      return details;
    }
  }
  IMask.MaskedRange = MaskedRange;

  const DefaultPattern = 'd{.}`m{.}`Y';

  // Make format and parse required when pattern is provided

  /** Date mask */
  class MaskedDate extends MaskedPattern {
    static extractPatternOptions(opts) {
      const {
        mask,
        pattern,
        ...patternOpts
      } = opts;
      return {
        ...patternOpts,
        mask: isString(mask) ? mask : pattern
      };
    }

    /** Pattern mask for date according to {@link MaskedDate#format} */

    /** Start date */

    /** End date */

    /** Format typed value to string */

    /** Parse string to get typed value */

    constructor(opts) {
      super(MaskedDate.extractPatternOptions({
        ...MaskedDate.DEFAULTS,
        ...opts
      }));
    }
    updateOptions(opts) {
      super.updateOptions(opts);
    }
    _update(opts) {
      const {
        mask,
        pattern,
        blocks,
        ...patternOpts
      } = {
        ...MaskedDate.DEFAULTS,
        ...opts
      };
      const patternBlocks = Object.assign({}, MaskedDate.GET_DEFAULT_BLOCKS());
      // adjust year block
      if (opts.min) patternBlocks.Y.from = opts.min.getFullYear();
      if (opts.max) patternBlocks.Y.to = opts.max.getFullYear();
      if (opts.min && opts.max && patternBlocks.Y.from === patternBlocks.Y.to) {
        patternBlocks.m.from = opts.min.getMonth() + 1;
        patternBlocks.m.to = opts.max.getMonth() + 1;
        if (patternBlocks.m.from === patternBlocks.m.to) {
          patternBlocks.d.from = opts.min.getDate();
          patternBlocks.d.to = opts.max.getDate();
        }
      }
      Object.assign(patternBlocks, this.blocks, blocks);
      super._update({
        ...patternOpts,
        mask: isString(mask) ? mask : pattern,
        blocks: patternBlocks
      });
    }
    doValidate(flags) {
      const date = this.date;
      return super.doValidate(flags) && (!this.isComplete || this.isDateExist(this.value) && date != null && (this.min == null || this.min <= date) && (this.max == null || date <= this.max));
    }

    /** Checks if date is exists */
    isDateExist(str) {
      return this.format(this.parse(str, this), this).indexOf(str) >= 0;
    }

    /** Parsed Date */
    get date() {
      return this.typedValue;
    }
    set date(date) {
      this.typedValue = date;
    }
    get typedValue() {
      return this.isComplete ? super.typedValue : null;
    }
    set typedValue(value) {
      super.typedValue = value;
    }
    maskEquals(mask) {
      return mask === Date || super.maskEquals(mask);
    }
    optionsIsChanged(opts) {
      return super.optionsIsChanged(MaskedDate.extractPatternOptions(opts));
    }
  }
  MaskedDate.GET_DEFAULT_BLOCKS = () => ({
    d: {
      mask: MaskedRange,
      from: 1,
      to: 31,
      maxLength: 2
    },
    m: {
      mask: MaskedRange,
      from: 1,
      to: 12,
      maxLength: 2
    },
    Y: {
      mask: MaskedRange,
      from: 1900,
      to: 9999
    }
  });
  MaskedDate.DEFAULTS = {
    ...MaskedPattern.DEFAULTS,
    mask: Date,
    pattern: DefaultPattern,
    format: (date, masked) => {
      if (!date) return '';
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return [day, month, year].join('.');
    },
    parse: (str, masked) => {
      const [day, month, year] = str.split('.').map(Number);
      return new Date(year, month - 1, day);
    }
  };
  IMask.MaskedDate = MaskedDate;

  /** Dynamic mask for choosing appropriate mask in run-time */
  class MaskedDynamic extends Masked {
    constructor(opts) {
      super({
        ...MaskedDynamic.DEFAULTS,
        ...opts
      });
      this.currentMask = undefined;
    }
    updateOptions(opts) {
      super.updateOptions(opts);
    }
    _update(opts) {
      super._update(opts);
      if ('mask' in opts) {
        this.exposeMask = undefined;
        // mask could be totally dynamic with only `dispatch` option
        this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map(m => {
          const {
            expose,
            ...maskOpts
          } = normalizeOpts(m);
          const masked = createMask({
            overwrite: this._overwrite,
            eager: this._eager,
            skipInvalid: this._skipInvalid,
            ...maskOpts
          });
          if (expose) this.exposeMask = masked;
          return masked;
        }) : [];

        // this.currentMask = this.doDispatch(''); // probably not needed but lets see
      }
    }
    _appendCharRaw(ch, flags) {
      if (flags === void 0) {
        flags = {};
      }
      const details = this._applyDispatch(ch, flags);
      if (this.currentMask) {
        details.aggregate(this.currentMask._appendChar(ch, this.currentMaskFlags(flags)));
      }
      return details;
    }
    _applyDispatch(appended, flags, tail) {
      if (appended === void 0) {
        appended = '';
      }
      if (flags === void 0) {
        flags = {};
      }
      if (tail === void 0) {
        tail = '';
      }
      const prevValueBeforeTail = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
      const inputValue = this.rawInputValue;
      const insertValue = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._rawInputValue : inputValue;
      const tailValue = inputValue.slice(insertValue.length);
      const prevMask = this.currentMask;
      const details = new ChangeDetails();
      const prevMaskState = prevMask == null ? void 0 : prevMask.state;

      // clone flags to prevent overwriting `_beforeTailState`
      this.currentMask = this.doDispatch(appended, {
        ...flags
      }, tail);

      // restore state after dispatch
      if (this.currentMask) {
        if (this.currentMask !== prevMask) {
          // if mask changed reapply input
          this.currentMask.reset();
          if (insertValue) {
            this.currentMask.append(insertValue, {
              raw: true
            });
            details.tailShift = this.currentMask.value.length - prevValueBeforeTail.length;
          }
          if (tailValue) {
            details.tailShift += this.currentMask.append(tailValue, {
              raw: true,
              tail: true
            }).tailShift;
          }
        } else if (prevMaskState) {
          // Dispatch can do something bad with state, so
          // restore prev mask state
          this.currentMask.state = prevMaskState;
        }
      }
      return details;
    }
    _appendPlaceholder() {
      const details = this._applyDispatch();
      if (this.currentMask) {
        details.aggregate(this.currentMask._appendPlaceholder());
      }
      return details;
    }
    _appendEager() {
      const details = this._applyDispatch();
      if (this.currentMask) {
        details.aggregate(this.currentMask._appendEager());
      }
      return details;
    }
    appendTail(tail) {
      const details = new ChangeDetails();
      if (tail) details.aggregate(this._applyDispatch('', {}, tail));
      return details.aggregate(this.currentMask ? this.currentMask.appendTail(tail) : super.appendTail(tail));
    }
    currentMaskFlags(flags) {
      var _flags$_beforeTailSta, _flags$_beforeTailSta2;
      return {
        ...flags,
        _beforeTailState: ((_flags$_beforeTailSta = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta.currentMaskRef) === this.currentMask && ((_flags$_beforeTailSta2 = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta2.currentMask) || flags._beforeTailState
      };
    }
    doDispatch(appended, flags, tail) {
      if (flags === void 0) {
        flags = {};
      }
      if (tail === void 0) {
        tail = '';
      }
      return this.dispatch(appended, this, flags, tail);
    }
    doValidate(flags) {
      return super.doValidate(flags) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(flags)));
    }
    doPrepare(str, flags) {
      if (flags === void 0) {
        flags = {};
      }
      let [s, details] = super.doPrepare(str, flags);
      if (this.currentMask) {
        let currentDetails;
        [s, currentDetails] = super.doPrepare(s, this.currentMaskFlags(flags));
        details = details.aggregate(currentDetails);
      }
      return [s, details];
    }
    doPrepareChar(str, flags) {
      if (flags === void 0) {
        flags = {};
      }
      let [s, details] = super.doPrepareChar(str, flags);
      if (this.currentMask) {
        let currentDetails;
        [s, currentDetails] = super.doPrepareChar(s, this.currentMaskFlags(flags));
        details = details.aggregate(currentDetails);
      }
      return [s, details];
    }
    reset() {
      var _this$currentMask;
      (_this$currentMask = this.currentMask) == null || _this$currentMask.reset();
      this.compiledMasks.forEach(m => m.reset());
    }
    get value() {
      return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : '';
    }
    set value(value) {
      if (this.exposeMask) {
        this.exposeMask.value = value;
        this.currentMask = this.exposeMask;
        this._applyDispatch();
      } else super.value = value;
    }
    get unmaskedValue() {
      return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : '';
    }
    set unmaskedValue(unmaskedValue) {
      if (this.exposeMask) {
        this.exposeMask.unmaskedValue = unmaskedValue;
        this.currentMask = this.exposeMask;
        this._applyDispatch();
      } else super.unmaskedValue = unmaskedValue;
    }
    get typedValue() {
      return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : '';
    }
    set typedValue(typedValue) {
      if (this.exposeMask) {
        this.exposeMask.typedValue = typedValue;
        this.currentMask = this.exposeMask;
        this._applyDispatch();
        return;
      }
      let unmaskedValue = String(typedValue);

      // double check it
      if (this.currentMask) {
        this.currentMask.typedValue = typedValue;
        unmaskedValue = this.currentMask.unmaskedValue;
      }
      this.unmaskedValue = unmaskedValue;
    }
    get displayValue() {
      return this.currentMask ? this.currentMask.displayValue : '';
    }
    get isComplete() {
      var _this$currentMask2;
      return Boolean((_this$currentMask2 = this.currentMask) == null ? void 0 : _this$currentMask2.isComplete);
    }
    get isFilled() {
      var _this$currentMask3;
      return Boolean((_this$currentMask3 = this.currentMask) == null ? void 0 : _this$currentMask3.isFilled);
    }
    remove(fromPos, toPos) {
      const details = new ChangeDetails();
      if (this.currentMask) {
        details.aggregate(this.currentMask.remove(fromPos, toPos))
        // update with dispatch
        .aggregate(this._applyDispatch());
      }
      return details;
    }
    get state() {
      var _this$currentMask4;
      return {
        ...super.state,
        _rawInputValue: this.rawInputValue,
        compiledMasks: this.compiledMasks.map(m => m.state),
        currentMaskRef: this.currentMask,
        currentMask: (_this$currentMask4 = this.currentMask) == null ? void 0 : _this$currentMask4.state
      };
    }
    set state(state) {
      const {
        compiledMasks,
        currentMaskRef,
        currentMask,
        ...maskedState
      } = state;
      if (compiledMasks) this.compiledMasks.forEach((m, mi) => m.state = compiledMasks[mi]);
      if (currentMaskRef != null) {
        this.currentMask = currentMaskRef;
        this.currentMask.state = currentMask;
      }
      super.state = maskedState;
    }
    extractInput(fromPos, toPos, flags) {
      return this.currentMask ? this.currentMask.extractInput(fromPos, toPos, flags) : '';
    }
    extractTail(fromPos, toPos) {
      return this.currentMask ? this.currentMask.extractTail(fromPos, toPos) : super.extractTail(fromPos, toPos);
    }
    doCommit() {
      if (this.currentMask) this.currentMask.doCommit();
      super.doCommit();
    }
    nearestInputPos(cursorPos, direction) {
      return this.currentMask ? this.currentMask.nearestInputPos(cursorPos, direction) : super.nearestInputPos(cursorPos, direction);
    }
    get overwrite() {
      return this.currentMask ? this.currentMask.overwrite : this._overwrite;
    }
    set overwrite(overwrite) {
      this._overwrite = overwrite;
    }
    get eager() {
      return this.currentMask ? this.currentMask.eager : this._eager;
    }
    set eager(eager) {
      this._eager = eager;
    }
    get skipInvalid() {
      return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
    }
    set skipInvalid(skipInvalid) {
      this._skipInvalid = skipInvalid;
    }
    get autofix() {
      return this.currentMask ? this.currentMask.autofix : this._autofix;
    }
    set autofix(autofix) {
      this._autofix = autofix;
    }
    maskEquals(mask) {
      return Array.isArray(mask) ? this.compiledMasks.every((m, mi) => {
        if (!mask[mi]) return;
        const {
          mask: oldMask,
          ...restOpts
        } = mask[mi];
        return objectIncludes(m, restOpts) && m.maskEquals(oldMask);
      }) : super.maskEquals(mask);
    }
    typedValueEquals(value) {
      var _this$currentMask5;
      return Boolean((_this$currentMask5 = this.currentMask) == null ? void 0 : _this$currentMask5.typedValueEquals(value));
    }
  }
  /** Currently chosen mask */
  /** Currently chosen mask */
  /** Compliled {@link Masked} options */
  /** Chooses {@link Masked} depending on input value */
  MaskedDynamic.DEFAULTS = {
    ...Masked.DEFAULTS,
    dispatch: (appended, masked, flags, tail) => {
      if (!masked.compiledMasks.length) return;
      const inputValue = masked.rawInputValue;

      // simulate input
      const inputs = masked.compiledMasks.map((m, index) => {
        const isCurrent = masked.currentMask === m;
        const startInputPos = isCurrent ? m.displayValue.length : m.nearestInputPos(m.displayValue.length, DIRECTION.FORCE_LEFT);
        if (m.rawInputValue !== inputValue) {
          m.reset();
          m.append(inputValue, {
            raw: true
          });
        } else if (!isCurrent) {
          m.remove(startInputPos);
        }
        m.append(appended, masked.currentMaskFlags(flags));
        m.appendTail(tail);
        return {
          index,
          weight: m.rawInputValue.length,
          totalInputPositions: m.totalInputPositions(0, Math.max(startInputPos, m.nearestInputPos(m.displayValue.length, DIRECTION.FORCE_LEFT)))
        };
      });

      // pop masks with longer values first
      inputs.sort((i1, i2) => i2.weight - i1.weight || i2.totalInputPositions - i1.totalInputPositions);
      return masked.compiledMasks[inputs[0].index];
    }
  };
  IMask.MaskedDynamic = MaskedDynamic;

  /** Pattern which validates enum values */
  class MaskedEnum extends MaskedPattern {
    constructor(opts) {
      super({
        ...MaskedEnum.DEFAULTS,
        ...opts
      }); // mask will be created in _update
    }
    updateOptions(opts) {
      super.updateOptions(opts);
    }
    _update(opts) {
      const {
        enum: enum_,
        ...eopts
      } = opts;
      if (enum_) {
        const lengths = enum_.map(e => e.length);
        const requiredLength = Math.min(...lengths);
        const optionalLength = Math.max(...lengths) - requiredLength;
        eopts.mask = '*'.repeat(requiredLength);
        if (optionalLength) eopts.mask += '[' + '*'.repeat(optionalLength) + ']';
        this.enum = enum_;
      }
      super._update(eopts);
    }
    _appendCharRaw(ch, flags) {
      if (flags === void 0) {
        flags = {};
      }
      const matchFrom = Math.min(this.nearestInputPos(0, DIRECTION.FORCE_RIGHT), this.value.length);
      const matches = this.enum.filter(e => this.matchValue(e, this.unmaskedValue + ch, matchFrom));
      if (matches.length) {
        if (matches.length === 1) {
          this._forEachBlocksInRange(0, this.value.length, (b, bi) => {
            const mch = matches[0][bi];
            if (bi >= this.value.length || mch === b.value) return;
            b.reset();
            b._appendChar(mch, flags);
          });
        }
        const d = super._appendCharRaw(matches[0][this.value.length], flags);
        if (matches.length === 1) {
          matches[0].slice(this.unmaskedValue.length).split('').forEach(mch => d.aggregate(super._appendCharRaw(mch)));
        }
        return d;
      }
      return new ChangeDetails({
        skip: !this.isComplete
      });
    }
    extractTail(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      // just drop tail
      return new ContinuousTailDetails('', fromPos);
    }
    remove(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      if (fromPos === toPos) return new ChangeDetails();
      const matchFrom = Math.min(super.nearestInputPos(0, DIRECTION.FORCE_RIGHT), this.value.length);
      let pos;
      for (pos = fromPos; pos >= 0; --pos) {
        const matches = this.enum.filter(e => this.matchValue(e, this.value.slice(matchFrom, pos), matchFrom));
        if (matches.length > 1) break;
      }
      const details = super.remove(pos, toPos);
      details.tailShift += pos - fromPos;
      return details;
    }
    get isComplete() {
      return this.enum.indexOf(this.value) >= 0;
    }
  }
  /** Match enum value */
  MaskedEnum.DEFAULTS = {
    ...MaskedPattern.DEFAULTS,
    matchValue: (estr, istr, matchFrom) => estr.indexOf(istr, matchFrom) === matchFrom
  };
  IMask.MaskedEnum = MaskedEnum;

  /** Masking by custom Function */
  class MaskedFunction extends Masked {
    /** */

    /** Enable characters overwriting */

    /** */

    /** */

    /** */

    updateOptions(opts) {
      super.updateOptions(opts);
    }
    _update(opts) {
      super._update({
        ...opts,
        validate: opts.mask
      });
    }
  }
  IMask.MaskedFunction = MaskedFunction;

  var _MaskedNumber;
  /** Number mask */
  class MaskedNumber extends Masked {
    /** Single char */

    /** Single char */

    /** Array of single chars */

    /** */

    /** */

    /** Digits after point */

    /** Flag to remove leading and trailing zeros in the end of editing */

    /** Flag to pad trailing zeros after point in the end of editing */

    /** Enable characters overwriting */

    /** */

    /** */

    /** */

    /** Format typed value to string */

    /** Parse string to get typed value */

    constructor(opts) {
      super({
        ...MaskedNumber.DEFAULTS,
        ...opts
      });
    }
    updateOptions(opts) {
      super.updateOptions(opts);
    }
    _update(opts) {
      super._update(opts);
      this._updateRegExps();
    }
    _updateRegExps() {
      const start = '^' + (this.allowNegative ? '[+|\\-]?' : '');
      const mid = '\\d*';
      const end = (this.scale ? "(" + escapeRegExp(this.radix) + "\\d{0," + this.scale + "})?" : '') + '$';
      this._numberRegExp = new RegExp(start + mid + end);
      this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map(escapeRegExp).join('') + "]", 'g');
      this._thousandsSeparatorRegExp = new RegExp(escapeRegExp(this.thousandsSeparator), 'g');
    }
    _removeThousandsSeparators(value) {
      return value.replace(this._thousandsSeparatorRegExp, '');
    }
    _insertThousandsSeparators(value) {
      // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
      const parts = value.split(this.radix);
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
      return parts.join(this.radix);
    }
    doPrepareChar(ch, flags) {
      if (flags === void 0) {
        flags = {};
      }
      const [prepCh, details] = super.doPrepareChar(this._removeThousandsSeparators(this.scale && this.mapToRadix.length && (
      /*
        radix should be mapped when
        1) input is done from keyboard = flags.input && flags.raw
        2) unmasked value is set = !flags.input && !flags.raw
        and should not be mapped when
        1) value is set = flags.input && !flags.raw
        2) raw value is set = !flags.input && flags.raw
      */
      flags.input && flags.raw || !flags.input && !flags.raw) ? ch.replace(this._mapToRadixRegExp, this.radix) : ch), flags);
      if (ch && !prepCh) details.skip = true;
      if (prepCh && !this.allowPositive && !this.value && prepCh !== '-') details.aggregate(this._appendChar('-'));
      return [prepCh, details];
    }
    _separatorsCount(to, extendOnSeparators) {
      if (extendOnSeparators === void 0) {
        extendOnSeparators = false;
      }
      let count = 0;
      for (let pos = 0; pos < to; ++pos) {
        if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
          ++count;
          if (extendOnSeparators) to += this.thousandsSeparator.length;
        }
      }
      return count;
    }
    _separatorsCountFromSlice(slice) {
      if (slice === void 0) {
        slice = this._value;
      }
      return this._separatorsCount(this._removeThousandsSeparators(slice).length, true);
    }
    extractInput(fromPos, toPos, flags) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
      return this._removeThousandsSeparators(super.extractInput(fromPos, toPos, flags));
    }
    _appendCharRaw(ch, flags) {
      if (flags === void 0) {
        flags = {};
      }
      const prevBeforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
      const prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);
      this._value = this._removeThousandsSeparators(this.value);
      const oldValue = this._value;
      this._value += ch;
      const num = this.number;
      let accepted = !isNaN(num);
      let skip = false;
      if (accepted) {
        let fixedNum;
        if (this.min != null && this.min < 0 && this.number < this.min) fixedNum = this.min;
        if (this.max != null && this.max > 0 && this.number > this.max) fixedNum = this.max;
        if (fixedNum != null) {
          if (this.autofix) {
            this._value = this.format(fixedNum, this).replace(MaskedNumber.UNMASKED_RADIX, this.radix);
            skip || (skip = oldValue === this._value && !flags.tail); // if not changed on tail it's still ok to proceed
          } else {
            accepted = false;
          }
        }
        accepted && (accepted = Boolean(this._value.match(this._numberRegExp)));
      }
      let appendDetails;
      if (!accepted) {
        this._value = oldValue;
        appendDetails = new ChangeDetails();
      } else {
        appendDetails = new ChangeDetails({
          inserted: this._value.slice(oldValue.length),
          rawInserted: skip ? '' : ch,
          skip
        });
      }
      this._value = this._insertThousandsSeparators(this._value);
      const beforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
      const beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);
      appendDetails.tailShift += (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
      return appendDetails;
    }
    _findSeparatorAround(pos) {
      if (this.thousandsSeparator) {
        const searchFrom = pos - this.thousandsSeparator.length + 1;
        const separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
        if (separatorPos <= pos) return separatorPos;
      }
      return -1;
    }
    _adjustRangeWithSeparators(from, to) {
      const separatorAroundFromPos = this._findSeparatorAround(from);
      if (separatorAroundFromPos >= 0) from = separatorAroundFromPos;
      const separatorAroundToPos = this._findSeparatorAround(to);
      if (separatorAroundToPos >= 0) to = separatorAroundToPos + this.thousandsSeparator.length;
      return [from, to];
    }
    remove(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
      const valueBeforePos = this.value.slice(0, fromPos);
      const valueAfterPos = this.value.slice(toPos);
      const prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);
      this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));
      const beforeTailSeparatorsCount = this._separatorsCountFromSlice(valueBeforePos);
      return new ChangeDetails({
        tailShift: (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length
      });
    }
    nearestInputPos(cursorPos, direction) {
      if (!this.thousandsSeparator) return cursorPos;
      switch (direction) {
        case DIRECTION.NONE:
        case DIRECTION.LEFT:
        case DIRECTION.FORCE_LEFT:
          {
            const separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);
            if (separatorAtLeftPos >= 0) {
              const separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;
              if (cursorPos < separatorAtLeftEndPos || this.value.length <= separatorAtLeftEndPos || direction === DIRECTION.FORCE_LEFT) {
                return separatorAtLeftPos;
              }
            }
            break;
          }
        case DIRECTION.RIGHT:
        case DIRECTION.FORCE_RIGHT:
          {
            const separatorAtRightPos = this._findSeparatorAround(cursorPos);
            if (separatorAtRightPos >= 0) {
              return separatorAtRightPos + this.thousandsSeparator.length;
            }
          }
      }
      return cursorPos;
    }
    doCommit() {
      if (this.value) {
        const number = this.number;
        let validnum = number;

        // check bounds
        if (this.min != null) validnum = Math.max(validnum, this.min);
        if (this.max != null) validnum = Math.min(validnum, this.max);
        if (validnum !== number) this.unmaskedValue = this.format(validnum, this);
        let formatted = this.value;
        if (this.normalizeZeros) formatted = this._normalizeZeros(formatted);
        if (this.padFractionalZeros && this.scale > 0) formatted = this._padFractionalZeros(formatted);
        this._value = formatted;
      }
      super.doCommit();
    }
    _normalizeZeros(value) {
      const parts = this._removeThousandsSeparators(value).split(this.radix);

      // remove leading zeros
      parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, (match, sign, zeros, num) => sign + num);
      // add leading zero
      if (value.length && !/\d$/.test(parts[0])) parts[0] = parts[0] + '0';
      if (parts.length > 1) {
        parts[1] = parts[1].replace(/0*$/, ''); // remove trailing zeros
        if (!parts[1].length) parts.length = 1; // remove fractional
      }
      return this._insertThousandsSeparators(parts.join(this.radix));
    }
    _padFractionalZeros(value) {
      if (!value) return value;
      const parts = value.split(this.radix);
      if (parts.length < 2) parts.push('');
      parts[1] = parts[1].padEnd(this.scale, '0');
      return parts.join(this.radix);
    }
    doSkipInvalid(ch, flags, checkTail) {
      if (flags === void 0) {
        flags = {};
      }
      const dropFractional = this.scale === 0 && ch !== this.thousandsSeparator && (ch === this.radix || ch === MaskedNumber.UNMASKED_RADIX || this.mapToRadix.includes(ch));
      return super.doSkipInvalid(ch, flags, checkTail) && !dropFractional;
    }
    get unmaskedValue() {
      return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, MaskedNumber.UNMASKED_RADIX);
    }
    set unmaskedValue(unmaskedValue) {
      super.unmaskedValue = unmaskedValue;
    }
    get typedValue() {
      return this.parse(this.unmaskedValue, this);
    }
    set typedValue(n) {
      this.rawInputValue = this.format(n, this).replace(MaskedNumber.UNMASKED_RADIX, this.radix);
    }

    /** Parsed Number */
    get number() {
      return this.typedValue;
    }
    set number(number) {
      this.typedValue = number;
    }
    get allowNegative() {
      return this.min != null && this.min < 0 || this.max != null && this.max < 0;
    }
    get allowPositive() {
      return this.min != null && this.min > 0 || this.max != null && this.max > 0;
    }
    typedValueEquals(value) {
      // handle  0 -> '' case (typed = 0 even if value = '')
      // for details see https://github.com/uNmAnNeR/imaskjs/issues/134
      return (super.typedValueEquals(value) || MaskedNumber.EMPTY_VALUES.includes(value) && MaskedNumber.EMPTY_VALUES.includes(this.typedValue)) && !(value === 0 && this.value === '');
    }
  }
  _MaskedNumber = MaskedNumber;
  MaskedNumber.UNMASKED_RADIX = '.';
  MaskedNumber.EMPTY_VALUES = [...Masked.EMPTY_VALUES, 0];
  MaskedNumber.DEFAULTS = {
    ...Masked.DEFAULTS,
    mask: Number,
    radix: ',',
    thousandsSeparator: '',
    mapToRadix: [_MaskedNumber.UNMASKED_RADIX],
    min: Number.MIN_SAFE_INTEGER,
    max: Number.MAX_SAFE_INTEGER,
    scale: 2,
    normalizeZeros: true,
    padFractionalZeros: false,
    parse: Number,
    format: n => n.toLocaleString('en-US', {
      useGrouping: false,
      maximumFractionDigits: 20
    })
  };
  IMask.MaskedNumber = MaskedNumber;

  /** Mask pipe source and destination types */
  const PIPE_TYPE = {
    MASKED: 'value',
    UNMASKED: 'unmaskedValue',
    TYPED: 'typedValue'
  };
  /** Creates new pipe function depending on mask type, source and destination options */
  function createPipe(arg, from, to) {
    if (from === void 0) {
      from = PIPE_TYPE.MASKED;
    }
    if (to === void 0) {
      to = PIPE_TYPE.MASKED;
    }
    const masked = createMask(arg);
    return value => masked.runIsolated(m => {
      m[from] = value;
      return m[to];
    });
  }

  /** Pipes value through mask depending on mask type, source and destination options */
  function pipe(value, mask, from, to) {
    return createPipe(mask, from, to)(value);
  }
  IMask.PIPE_TYPE = PIPE_TYPE;
  IMask.createPipe = createPipe;
  IMask.pipe = pipe;

  /** Pattern mask */
  class RepeatBlock extends MaskedPattern {
    get repeatFrom() {
      var _ref;
      return (_ref = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === Infinity ? 0 : this.repeat) != null ? _ref : 0;
    }
    get repeatTo() {
      var _ref2;
      return (_ref2 = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? _ref2 : Infinity;
    }
    constructor(opts) {
      super(opts);
    }
    updateOptions(opts) {
      super.updateOptions(opts);
    }
    _update(opts) {
      var _ref3, _ref4, _this$_blocks;
      const {
        repeat,
        ...blockOpts
      } = normalizeOpts(opts); // TODO type
      this._blockOpts = Object.assign({}, this._blockOpts, blockOpts);
      const block = createMask(this._blockOpts);
      this.repeat = (_ref3 = (_ref4 = repeat != null ? repeat : block.repeat) != null ? _ref4 : this.repeat) != null ? _ref3 : Infinity; // TODO type

      super._update({
        mask: 'm'.repeat(Math.max(this.repeatTo === Infinity && ((_this$_blocks = this._blocks) == null ? void 0 : _this$_blocks.length) || 0, this.repeatFrom)),
        blocks: {
          m: block
        },
        eager: block.eager,
        overwrite: block.overwrite,
        skipInvalid: block.skipInvalid,
        lazy: block.lazy,
        placeholderChar: block.placeholderChar,
        displayChar: block.displayChar
      });
    }
    _allocateBlock(bi) {
      if (bi < this._blocks.length) return this._blocks[bi];
      if (this.repeatTo === Infinity || this._blocks.length < this.repeatTo) {
        this._blocks.push(createMask(this._blockOpts));
        this.mask += 'm';
        return this._blocks[this._blocks.length - 1];
      }
    }
    _appendCharRaw(ch, flags) {
      if (flags === void 0) {
        flags = {};
      }
      const details = new ChangeDetails();
      for (let bi = (_this$_mapPosToBlock$ = (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : _this$_mapPosToBlock.index) != null ? _this$_mapPosToBlock$ : Math.max(this._blocks.length - 1, 0), block, allocated;
      // try to get a block or
      // try to allocate a new block if not allocated already
      block = (_this$_blocks$bi = this._blocks[bi]) != null ? _this$_blocks$bi : allocated = !allocated && this._allocateBlock(bi); ++bi) {
        var _this$_mapPosToBlock$, _this$_mapPosToBlock, _this$_blocks$bi, _flags$_beforeTailSta;
        const blockDetails = block._appendChar(ch, {
          ...flags,
          _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) == null || (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null ? void 0 : _flags$_beforeTailSta[bi]
        });
        if (blockDetails.skip && allocated) {
          // remove the last allocated block and break
          this._blocks.pop();
          this.mask = this.mask.slice(1);
          break;
        }
        details.aggregate(blockDetails);
        if (blockDetails.consumed) break; // go next char
      }
      return details;
    }
    _trimEmptyTail(fromPos, toPos) {
      var _this$_mapPosToBlock2, _this$_mapPosToBlock3;
      if (fromPos === void 0) {
        fromPos = 0;
      }
      const firstBlockIndex = Math.max(((_this$_mapPosToBlock2 = this._mapPosToBlock(fromPos)) == null ? void 0 : _this$_mapPosToBlock2.index) || 0, this.repeatFrom, 0);
      let lastBlockIndex;
      if (toPos != null) lastBlockIndex = (_this$_mapPosToBlock3 = this._mapPosToBlock(toPos)) == null ? void 0 : _this$_mapPosToBlock3.index;
      if (lastBlockIndex == null) lastBlockIndex = this._blocks.length - 1;
      let removeCount = 0;
      for (let blockIndex = lastBlockIndex; firstBlockIndex <= blockIndex; --blockIndex, ++removeCount) {
        if (this._blocks[blockIndex].unmaskedValue) break;
      }
      if (removeCount) {
        this._blocks.splice(lastBlockIndex - removeCount + 1, removeCount);
        this.mask = this.mask.slice(removeCount);
      }
    }
    reset() {
      super.reset();
      this._trimEmptyTail();
    }
    remove(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      const removeDetails = super.remove(fromPos, toPos);
      this._trimEmptyTail(fromPos, toPos);
      return removeDetails;
    }
    totalInputPositions(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos == null && this.repeatTo === Infinity) return Infinity;
      return super.totalInputPositions(fromPos, toPos);
    }
    get state() {
      return super.state;
    }
    set state(state) {
      this._blocks.length = state._blocks.length;
      this.mask = this.mask.slice(0, this._blocks.length);
      super.state = state;
    }
  }
  IMask.RepeatBlock = RepeatBlock;

  try {
    globalThis.IMask = IMask;
  } catch {}

  exports.ChangeDetails = ChangeDetails;
  exports.ChunksTailDetails = ChunksTailDetails;
  exports.DIRECTION = DIRECTION;
  exports.HTMLContenteditableMaskElement = HTMLContenteditableMaskElement;
  exports.HTMLInputMaskElement = HTMLInputMaskElement;
  exports.HTMLMaskElement = HTMLMaskElement;
  exports.InputMask = InputMask;
  exports.MaskElement = MaskElement;
  exports.Masked = Masked;
  exports.MaskedDate = MaskedDate;
  exports.MaskedDynamic = MaskedDynamic;
  exports.MaskedEnum = MaskedEnum;
  exports.MaskedFunction = MaskedFunction;
  exports.MaskedNumber = MaskedNumber;
  exports.MaskedPattern = MaskedPattern;
  exports.MaskedRange = MaskedRange;
  exports.MaskedRegExp = MaskedRegExp;
  exports.PIPE_TYPE = PIPE_TYPE;
  exports.PatternFixedDefinition = PatternFixedDefinition;
  exports.PatternInputDefinition = PatternInputDefinition;
  exports.RepeatBlock = RepeatBlock;
  exports.createMask = createMask;
  exports.createPipe = createPipe;
  exports.default = IMask;
  exports.forceDirection = forceDirection;
  exports.normalizeOpts = normalizeOpts;
  exports.pipe = pipe;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
!function(n){"use strict";function d(n,t){var r=(65535&n)+(65535&t);return(n>>16)+(t>>16)+(r>>16)<<16|65535&r}function f(n,t,r,e,o,u){return d((u=d(d(t,n),d(e,u)))<<o|u>>>32-o,r)}function l(n,t,r,e,o,u,c){return f(t&r|~t&e,n,t,o,u,c)}function g(n,t,r,e,o,u,c){return f(t&e|r&~e,n,t,o,u,c)}function v(n,t,r,e,o,u,c){return f(t^r^e,n,t,o,u,c)}function m(n,t,r,e,o,u,c){return f(r^(t|~e),n,t,o,u,c)}function c(n,t){var r,e,o,u;n[t>>5]|=128<<t%32,n[14+(t+64>>>9<<4)]=t;for(var c=1732584193,f=-271733879,i=-1732584194,a=271733878,h=0;h<n.length;h+=16)c=l(r=c,e=f,o=i,u=a,n[h],7,-680876936),a=l(a,c,f,i,n[h+1],12,-389564586),i=l(i,a,c,f,n[h+2],17,606105819),f=l(f,i,a,c,n[h+3],22,-1044525330),c=l(c,f,i,a,n[h+4],7,-176418897),a=l(a,c,f,i,n[h+5],12,1200080426),i=l(i,a,c,f,n[h+6],17,-1473231341),f=l(f,i,a,c,n[h+7],22,-45705983),c=l(c,f,i,a,n[h+8],7,1770035416),a=l(a,c,f,i,n[h+9],12,-1958414417),i=l(i,a,c,f,n[h+10],17,-42063),f=l(f,i,a,c,n[h+11],22,-1990404162),c=l(c,f,i,a,n[h+12],7,1804603682),a=l(a,c,f,i,n[h+13],12,-40341101),i=l(i,a,c,f,n[h+14],17,-1502002290),c=g(c,f=l(f,i,a,c,n[h+15],22,1236535329),i,a,n[h+1],5,-165796510),a=g(a,c,f,i,n[h+6],9,-1069501632),i=g(i,a,c,f,n[h+11],14,643717713),f=g(f,i,a,c,n[h],20,-373897302),c=g(c,f,i,a,n[h+5],5,-701558691),a=g(a,c,f,i,n[h+10],9,38016083),i=g(i,a,c,f,n[h+15],14,-660478335),f=g(f,i,a,c,n[h+4],20,-405537848),c=g(c,f,i,a,n[h+9],5,568446438),a=g(a,c,f,i,n[h+14],9,-1019803690),i=g(i,a,c,f,n[h+3],14,-187363961),f=g(f,i,a,c,n[h+8],20,1163531501),c=g(c,f,i,a,n[h+13],5,-1444681467),a=g(a,c,f,i,n[h+2],9,-51403784),i=g(i,a,c,f,n[h+7],14,1735328473),c=v(c,f=g(f,i,a,c,n[h+12],20,-1926607734),i,a,n[h+5],4,-378558),a=v(a,c,f,i,n[h+8],11,-2022574463),i=v(i,a,c,f,n[h+11],16,1839030562),f=v(f,i,a,c,n[h+14],23,-35309556),c=v(c,f,i,a,n[h+1],4,-1530992060),a=v(a,c,f,i,n[h+4],11,1272893353),i=v(i,a,c,f,n[h+7],16,-155497632),f=v(f,i,a,c,n[h+10],23,-1094730640),c=v(c,f,i,a,n[h+13],4,681279174),a=v(a,c,f,i,n[h],11,-358537222),i=v(i,a,c,f,n[h+3],16,-722521979),f=v(f,i,a,c,n[h+6],23,76029189),c=v(c,f,i,a,n[h+9],4,-640364487),a=v(a,c,f,i,n[h+12],11,-421815835),i=v(i,a,c,f,n[h+15],16,530742520),c=m(c,f=v(f,i,a,c,n[h+2],23,-995338651),i,a,n[h],6,-198630844),a=m(a,c,f,i,n[h+7],10,1126891415),i=m(i,a,c,f,n[h+14],15,-1416354905),f=m(f,i,a,c,n[h+5],21,-57434055),c=m(c,f,i,a,n[h+12],6,1700485571),a=m(a,c,f,i,n[h+3],10,-1894986606),i=m(i,a,c,f,n[h+10],15,-1051523),f=m(f,i,a,c,n[h+1],21,-2054922799),c=m(c,f,i,a,n[h+8],6,1873313359),a=m(a,c,f,i,n[h+15],10,-30611744),i=m(i,a,c,f,n[h+6],15,-1560198380),f=m(f,i,a,c,n[h+13],21,1309151649),c=m(c,f,i,a,n[h+4],6,-145523070),a=m(a,c,f,i,n[h+11],10,-1120210379),i=m(i,a,c,f,n[h+2],15,718787259),f=m(f,i,a,c,n[h+9],21,-343485551),c=d(c,r),f=d(f,e),i=d(i,o),a=d(a,u);return[c,f,i,a]}function i(n){for(var t="",r=32*n.length,e=0;e<r;e+=8)t+=String.fromCharCode(n[e>>5]>>>e%32&255);return t}function a(n){var t=[];for(t[(n.length>>2)-1]=void 0,e=0;e<t.length;e+=1)t[e]=0;for(var r=8*n.length,e=0;e<r;e+=8)t[e>>5]|=(255&n.charCodeAt(e/8))<<e%32;return t}function e(n){for(var t,r="0123456789abcdef",e="",o=0;o<n.length;o+=1)t=n.charCodeAt(o),e+=r.charAt(t>>>4&15)+r.charAt(15&t);return e}function r(n){return unescape(encodeURIComponent(n))}function o(n){return i(c(a(n=r(n)),8*n.length))}function u(n,t){return function(n,t){var r,e=a(n),o=[],u=[];for(o[15]=u[15]=void 0,16<e.length&&(e=c(e,8*n.length)),r=0;r<16;r+=1)o[r]=909522486^e[r],u[r]=1549556828^e[r];return t=c(o.concat(a(t)),512+8*t.length),i(c(u.concat(t),640))}(r(n),r(t))}function t(n,t,r){return t?r?u(t,n):e(u(t,n)):r?o(n):e(o(n))}"function"==typeof define&&define.amd?define(function(){return t}):"object"==typeof module&&module.exports?module.exports=t:n.md5=t}(this);

(function() {
	'use strict';

	function qa(selector, root) {
		return Array.from((root || document).querySelectorAll(selector));
	}

	function delegate(type, selector, handler) {
		document.addEventListener(type, function(e) {
			var target = e.target && e.target.closest ? e.target.closest(selector) : null;
			if (!target) return;
			handler.call(target, e, target);
		});
	}

	// Сериализация формы как jQuery serializeArray
	function serializeForm(form) {
		var out = [];
		Array.prototype.forEach.call(form.elements, function(el) {
			if (!el.name || el.disabled) return;
			var type = (el.type || '').toLowerCase();
			if (type === 'submit' || type === 'button' || type === 'reset' || type === 'file') return;
			if ((type === 'checkbox' || type === 'radio') && !el.checked) return;
			if (el.tagName === 'SELECT' && el.multiple) {
				Array.prototype.forEach.call(el.selectedOptions, function(o) {
					out.push({name: el.name, value: o.value});
				});
				return;
			}
			out.push({name: el.name, value: el.value});
		});
		return out;
	}

	// Тело POST как jQuery.param: массив → key[]=v; ключ с [] не дублируется
	function encodeParams(data) {
		var parts = [];
		for (var key in data) {
			if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
			var value = data[key];
			var arrayKey = /\[\]$/.test(key) ? key : key + '[]';
			if (Array.isArray(value)) {
				for (var i = 0; i < value.length; i++) {
					parts.push(encodeURIComponent(arrayKey) + '=' + encodeURIComponent(value[i] == null ? '' : value[i]));
				}
			} else {
				parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value == null ? '' : value));
			}
		}
		return parts.join('&');
	}

	function postJson(url, data, controller) {
		return fetch(url, {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				'X-Requested-With': 'XMLHttpRequest'
			},
			body: encodeParams(data),
			signal: controller ? controller.signal : undefined
		}).then(function(res) {
			return res.text().then(function(text) {
				var parsed = null;
				try { parsed = JSON.parse(text); } catch (e) {}
				if (!res.ok || parsed === null) {
					var err = new Error('request failed');
					err.data = parsed;
					throw err;
				}
				return parsed;
			});
		});
	}

	function requestErrorAlert(err) {
		if (err && err.name === 'AbortError') return;
		if (err && err.data && err.data.error) {
			alert(err.data.error);
		} else {
			alert('Произошла неизвестная ошибка. Обновите страницу чтобы продолжить.');
		}
	}

	function fadeTo(el, value, ms) {
		el.style.transition = 'opacity ' + ms + 'ms';
		el.style.opacity = value;
	}

	// Анимация раскрытия/сворачивания (аналог slideDown/slideUp 'normal')
	function slideDown(el) {
		el.style.removeProperty('display');
		if (getComputedStyle(el).display === 'none') el.style.display = 'block';
		var target = el.scrollHeight;
		el.style.overflow = 'hidden';
		el.style.height = '0px';
		el.getBoundingClientRect();
		el.style.transition = 'height 0.4s';
		el.style.height = target + 'px';
		setTimeout(function() {
			el.style.transition = '';
			el.style.height = '';
			el.style.overflow = '';
		}, 420);
	}

	function slideUp(el) {
		el.style.overflow = 'hidden';
		el.style.height = el.scrollHeight + 'px';
		el.getBoundingClientRect();
		el.style.transition = 'height 0.4s';
		el.style.height = '0px';
		setTimeout(function() {
			el.style.display = 'none';
			el.style.transition = '';
			el.style.height = '';
			el.style.overflow = '';
		}, 420);
	}

	// Ванильный range-слайдер в разметке jQuery UI (классы стилизует style.css)
	function flipRangeSlider(root, options) {
		var min = options.min || 0;
		var max = options.max || 0;
		var step = options.step || 1;
		// Стартовые значения — в пределах шкалы: «до» цены выше её конца (шкала
		// обрезана по перцентилю) иначе уводило ручку за край трека
		var values = [
			clamp(typeof options.values[0] === 'number' ? options.values[0] : min),
			clamp(typeof options.values[1] === 'number' ? options.values[1] : max)
		];

		root.classList.add('ui-slider', 'ui-slider-horizontal');
		root.innerHTML = '';

		var range = document.createElement('div');
		range.className = 'ui-slider-range';
		root.appendChild(range);

		var handles = [0, 1].map(function() {
			var handle = document.createElement('span');
			handle.className = 'ui-slider-handle';
			root.appendChild(handle);
			return handle;
		});

		function toPercent(value) {
			return max > min ? ((value - min) * 100 / (max - min)) : 0;
		}

		function clamp(value) {
			if (value < min) value = min;
			if (value > max) value = max;
			return Math.round((value - min) / step) * step + min;
		}

		function render() {
			var p0 = toPercent(values[0]);
			var p1 = toPercent(values[1]);
			handles[0].style.left = p0 + '%';
			handles[1].style.left = p1 + '%';
			range.style.left = p0 + '%';
			range.style.width = (p1 - p0) + '%';
		}

		function setValue(index, value, fireSlide) {
			value = clamp(Number(value) || 0);
			if (index === 0 && value > values[1]) value = values[1];
			if (index === 1 && value < values[0]) value = values[0];
			values[index] = value;
			render();
			if (fireSlide && typeof options.slide === 'function') {
				options.slide(null, {values: values.slice(), handleIndex: index});
			}
		}

		function valueFromEvent(e) {
			var rect = root.getBoundingClientRect();
			var ratio = (e.clientX - rect.left) / rect.width;
			if (ratio < 0) ratio = 0;
			if (ratio > 1) ratio = 1;
			return min + ratio * (max - min);
		}

		handles.forEach(function(handle, index) {
			handle.addEventListener('pointerdown', function(e) {
				e.preventDefault();
				try { handle.setPointerCapture(e.pointerId); } catch (err) {}

				var onMove = function(e) {
					setValue(index, valueFromEvent(e), true);
				};
				var onUp = function() {
					handle.removeEventListener('pointermove', onMove);
					handle.removeEventListener('pointerup', onUp);
					handle.removeEventListener('pointercancel', onUp);
				};
				handle.addEventListener('pointermove', onMove);
				handle.addEventListener('pointerup', onUp);
				handle.addEventListener('pointercancel', onUp);
			});
		});

		// Клик по треку двигает ближайший ползунок
		root.addEventListener('pointerdown', function(e) {
			if (e.target !== root && e.target !== range) return;
			var value = valueFromEvent(e);
			var index = Math.abs(value - values[0]) <= Math.abs(value - values[1]) ? 0 : 1;
			setValue(index, value, true);
		});

		render();

		return {
			setValue: function(index, value) { setValue(index, value, false); }
		};
	}

	document.addEventListener('DOMContentLoaded', function() {
		// Endpoint для AJAX-запросов фильтров. Конфигурируется через window.FLIP.filtersEndpoint
		// в шаблоне, чтобы не хардкодить путь в JS (см. NOTES-filters-audit.md, Quick Win #4).
		var filtersEndpoint = (window.FLIP && window.FLIP.filtersEndpoint) || '/ajax/catalog.php';

		var filterUseAjaxRequest = (!!(window.history && window.history.pushState && window.history.replaceState));
		var filterCountRequests = 0;

		var filterContentLayer = document.getElementById('content');
		var filterMenuLayer = document.getElementById('main-catalog-filter-layer');
		var filterLeftLayer = document.getElementById('content_left');
		var filterRightLayer = document.getElementById('content_right');
		var fitlerChangeLayers = [filterContentLayer, filterLeftLayer, filterRightLayer].filter(Boolean);

		var filterAjaxScroll = false;
		var filterAjaxScrollDefault = false;

		if (!filterMenuLayer) return;

		var filterLayer = null;

		var filterForm = null;
		var filterFrom = null;
		var filterRequest = null;

		var filterInit = (function() {
			filterLayer = document.getElementById('main-catalog-filter');

			filterForm = document.getElementById('send-filter-form');
			var fromInput = filterForm ? filterForm.querySelector('input[name="filter-from"]') : null;
			filterFrom = fromInput ? fromInput.value : undefined;

			filterRequest = null;

			// Slider
			qa('div.slider', filterLayer).forEach(function(sliderEl) {
				var layer = sliderEl.closest('[data-filter-field-layer]');

				if (!layer) return;

				var step = parseInt(layer.getAttribute('data-filter-range-step'));

				var min = parseInt(layer.getAttribute('data-filter-range-min'));
				var max = parseInt(layer.getAttribute('data-filter-range-max'));

				var inputs = qa('input', layer);
				var layerMin = inputs[0];
				var layerMax = inputs[1];

				var slider = flipRangeSlider(sliderEl, {
					min: min || 0,
					step: step || 1,
					max: max || 0,
					values: [parseInt(layerMin && layerMin.value) || (min || 0), parseInt(layerMax && layerMax.value) || (max || 0)],

					// Поле переписываем только у сдвинутой ручки: иначе стёрлось бы «до»
					// выше конца шкалы, введённое руками. Правый упор — «без верхнего
					// предела»: поле пустое, подсказка показывает реальный максимум.
					slide: (function(event, ui) {
						if (ui.handleIndex === 0) {
							layerMin.value = ui.values[0];
						}
						else {
							layerMax.value = ui.values[1] >= max ? '' : ui.values[1];
						}
					})
				});

				if (layerMin) {
					layerMin.addEventListener('change', function() {
						slider.setValue(0, layerMin.value);
					});
				}

				if (layerMax) {
					layerMax.addEventListener('change', function() {
						// Пустое «до» — «без верхнего предела», ручка в правый упор
						slider.setValue(1, layerMax.value === '' ? max : layerMax.value);
					});
				}

				var accept = layer.querySelector('div.slider-accept');
				if (accept) {
					accept.addEventListener('click', function(event) {
						// Stop event
						event.preventDefault();

						// Scroll
						filterAjaxScroll = true;

						// Submit
						filterFormSubmit();
					});
				}
			});

			// Lists
			qa('div.list-field', filterLayer).forEach(function(list) {
				var listType = list.getAttribute('data-filter-field-list-type');

				var field = list.getAttribute('data-filter-field-layer');
				var input = list.querySelector('.list-input input');
				var found = list.querySelector('.list-found ul');

				var foundDefault = (function() {
					qa('li[data-list-found-default]', found).forEach(function(li) { li.style.display = ''; });
					qa('li:not([data-list-found-default])', found).forEach(function(li) { li.remove(); });
				});

				var foundClean = (function() {
					qa('li[data-list-found-default]', found).forEach(function(li) { li.style.display = 'none'; });
					qa('li:not([data-list-found-default])', found).forEach(function(li) { li.remove(); });
				});

				var fieldRequest = null;
				var fieldRequestLast = null;

				var fieldSubmitInterval = 300;
				var fieldSubmitId = null;

				var fieldSubmitProcess = (function(query) {
					if (!!(query) && query.length > 0) {
						if ((fieldRequestLast === null || fieldRequestLast !== query)) {
							var data = {list: listType, query: query};

							serializeForm(filterForm).forEach(function(field) {
								if (field.name.indexOf('-search') !== -1) {
									// Skip
									return;
								}

								if (!(field.name in data)) {
									data[field.name] = [];
								}

								data[field.name].push(field.value);
							});

							var controller = new AbortController();
							fieldRequest = controller;

							postJson(filtersEndpoint, data, controller)
								.then(function(data) {
									// Clean
									foundClean();

									if (data) {
										if (data.rows) {
											for (var key in data.rows) {
												var row = data.rows[key];
												var url;

												if (!!(row.id)) {
													if (data.list == 'publisher') {
														url = '/descript?cat=publish&id=' + (row.id);
													}
													else if (data.list == 'supplier') {
														url = '/descript?cat=supplier&id=' + (row.id);
													}
													else if (data.list == 'series') {
														url = '/descript?cat=series&id=' + (row.id);
													}
													else if (data.list == 'peoples') {
														url = '/descript?cat=people&id=' + (row.id);
													}
													// Ok
													found.insertAdjacentHTML('beforeend', '<li data-list-found="' + (row.id) + '" data-list-found-name="' + (row.name) + '"><a href="' + (url || '') + '">' + (row.name) + ' <span style="color: #999; font-size: 0.9em;">(' + (row.count) + ')</span></a></li>');
												}
											}
										}
									}
									imgScroll();
									kk();
								})
								['catch'](requestErrorAlert)
								['finally'](function() {
									if (fieldRequest === controller) {
										fieldRequest = null;
									}

									// Last
									fieldRequestLast = query;
								});
						}
					}
					else {
						// Clean
						foundDefault();
					}
				});

				var fieldSubmit = (function(query) {
					if (null !== fieldSubmitId) {
						clearInterval(fieldSubmitId);

						// Cancel
						fieldSubmitId = null;
					}

					// Cancel request
					if (null !== fieldRequest) {
						fieldRequest.abort();
						fieldRequest = null;
					}

					fieldSubmitId = setTimeout(function() { return fieldSubmitProcess(query); }, fieldSubmitInterval);
				});

				// Add autocomplete
				if (input) {
					['focus', 'blur', 'keypress', 'keyup'].forEach(function(type) {
						input.addEventListener(type, function() {
							// Submit
							fieldSubmit(input.value.trim());
						});
					});
				}
			});
		});

		var filterFormSubmitInterval = filterUseAjaxRequest ? 10 : 400;
		var filterFormSubmitId = null;

		var filterFormSubmit = (function(params, fromHistory) {
			if (null !== filterFormSubmitId) {
				clearInterval(filterFormSubmitId);

				// Cancel
				filterFormSubmitId = null;
			}

			// Default
			if (typeof params == 'undefined') {
				params = null;
			}

			// Submit, инициированный навигацией по истории (popstate): браузер
			// уже сам сменил URL и позицию в истории, поэтому повторно трогать
			// history API нельзя — иначе плодятся лишние записи и ломается «Назад».
			if (typeof fromHistory == 'undefined') {
				fromHistory = false;
			}

			if (filterUseAjaxRequest) {
				filterFormSubmitId = setTimeout((function() {
					if (null !== filterRequest) {
						filterRequest.abort();
						filterRequest = null;
					}

					var dataParams = {};

					serializeForm(filterForm).forEach(function(field) {
						if (field.name.indexOf('-search') !== -1) {
							// Skip
							return;
						}

						if (!(field.name in dataParams)) {
							dataParams[field.name] = [];
						}

						dataParams[field.name].push(field.value);
					});

					dataParams = Object.assign({'produces': 'yes', 'produces-list': 'yes', 'menu': 'yes', 'right': 'yes'}, dataParams);

					// Update params
					if (null !== params) {
						dataParams = Object.assign(dataParams, params);
					}

					dataParams.pathname = window.location.pathname;

					var dataParamsHash = md5(JSON.stringify(dataParams));

					var controller = new AbortController();
					filterRequest = controller;

					// Preloader
					fitlerChangeLayers.forEach(function(el) { fadeTo(el, 0.6, 200); });

					postJson(filtersEndpoint + '?isElastic=' + document.body.getAttribute('data-is-elastic') + '&lang=' + document.documentElement.getAttribute('lang') + '&dataParamsHash=' + dataParamsHash, dataParams, controller)
						.then(function(data) {
							if (data) {
								if (data.error) {
									var unknownError = false;
									var errorMessage = data.error;

									if (data.errorAction) {
										if (data.errorAction == 'pageReload') {
											location.reload(true);
										}
										else {
											unknownError = true;
										}
									}
									else {
										unknownError = true;
									}

									if (unknownError) {
										throw errorMessage;
									}
								}
								else {
									if (data.contents) {
										if (filterContentLayer) {
											if (data.contents.produces) {
												filterContentLayer.innerHTML = data.contents.produces;
											}
											else {
												filterContentLayer.replaceChildren();
											}
										}

										if (data.contents.menu) {
											filterMenuLayer.innerHTML = data.contents.menu;
										}
										else {
											filterMenuLayer.replaceChildren();
										}

										if (filterRightLayer) {
											if (data.contents.right) {
												filterRightLayer.innerHTML = data.contents.right;
												filterRightLayer.style.display = '';
											}
											else {
												filterRightLayer.replaceChildren();
												filterRightLayer.style.display = 'none';
											}
										}
									}

									// history обновляем только для действий пользователя.
									// При popstate («Назад»/«Вперёд») URL уже сменил сам
									// браузер — повторный pushState ломал бы историю.
									if (data.page && !fromHistory) {
										if (filterCountRequests <= 0) {
											history.replaceState({type: 'filter'}, document.title);
										}

										history.pushState({type: 'filter'}, document.title, data.page.url);

										if (window.yaCounter67168) {
											window.yaCounter67168.hit(data.page.url);
										}
									}
								}
							}

							// Re-Init
							filterInit(1);
							imgScroll();
							kk();
						})
						['catch'](function(err) {
							if (typeof err === 'string') throw err;
							requestErrorAlert(err);
						})
						['finally'](function() {
							if (filterRequest === controller) {
								filterRequest = null;
							}
							filterCountRequests++;

							// Preloader
							fitlerChangeLayers.forEach(function(el) { fadeTo(el, 1.0, 100); });

							if (filterAjaxScroll && window.scrollY >= 100) {
								window.scrollTo({top: 0, behavior: 'smooth'});
							}

							// Scroll
							filterAjaxScroll = filterAjaxScrollDefault;
						});
				}), filterFormSubmitInterval);
			}
			else {
				filterFormSubmitId = setTimeout((function() {
					var data = [];

					serializeForm(filterForm).forEach(function(field) {
						if (field.value !== "" && null !== field.value) {
							data.push([encodeURIComponent(field.name), encodeURIComponent(field.value)].join('='));
						}
					});

					// Redirect
					location.href = '/catalog?' + data.join('&');
				}), filterFormSubmitInterval);
			}
		});

		// Init
		filterInit(0);

		window.addEventListener('popstate', function(event) {
			if (event.state && event.state.type) {
				if (event.state.type == 'filter') {
					var result = {};
					var splits = null;

					if (location.search) {
						splits = (location.search.substr(1).split('&'));
					}

					if (null !== splits) {
						for (var part in splits) {
							var values = splits[part].split('=');

							if (values.length == 2) {
								var key = values[0].toLowerCase(),
									value = decodeURIComponent(values[1]).replace(/\+/g, ' ');

								if (key && value) {
									if (key !== "page") {
										if (!(key in result)) {
											result[key] = [];
										}

										result[key].push(value);
									}
									else {
										result[key] = value;
									}
								}
							}
						}
					}

					// Снятые при навигации фильтры в целевом URL отсутствуют, а в
					// форме остаются от прежнего состояния. Без явного сброса
					// сериализация формы вернула бы их в запрос — и контент не
					// откатился бы. Поэтому каждому полю-фильтру формы, которого нет
					// в URL, задаём пустое значение (служебные filter-* — не трогаем).
					var serviceFields = ['filter-from', 'filter-order', 'filter-order-type', 'filter-attr-ids[]', 'filter-show'];

					serializeForm(filterForm).forEach(function(field) {
						var name = field.name.toLowerCase();

						if (name.indexOf('filter-') === 0 && serviceFields.indexOf(name) === -1 && !(name in result)) {
							result[name] = [];
						}
					});

					// Submit (навигация по истории — без повторного pushState)
					filterFormSubmit(result, true);
				}
			}
		});

		delegate('click', 'li[data-list-found]', function(event, self) {
			// Stop event
			event.preventDefault();

			var list = self.closest('div.list-field');
			if (!list) return;

			var field = list.getAttribute('data-filter-field-layer');
			var check = list.querySelector('.list-selected');

			var id = self.getAttribute('data-list-found');
			var name = self.getAttribute('data-list-found-name');

			if (!!(id)) {
				if (!document.getElementById('filter-field-' + field + '-' + id)) {
					// Add
					check.insertAdjacentHTML('beforeend', '<input class="checkboxes no-reload-filter cbx" type="checkbox" checked="checked" name="filter-' + field + '" id="filter-field-' + field + '-' + id + '" value="' + (id) + '" data-list-found-checked="' + (id) + '" />\n' +
					'    <label class="check table" for="filter-field-' + field + '-' + id + '">\n' +
					'       <div class="checkbox cell w-0"><svg width="16px" height="16px" viewBox="0 0 16 16"><path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L12.5,1 C13,1 14,2 14,3.5 L14,12.5 C14,13 13,14 12.5,14 L3.5,14 C2,14 1,13 1,12.5 L1,9 Z"></path><polyline points="1 9 7 14 15 4"></polyline></svg></div>\n' +
					'       <div class="filter-lable cell" style="font-size: 13px">' + (name) + '</div>\n' +
					'    </label>');
				}

				// Scroll
				filterAjaxScroll = true;

				// Submit
				filterFormSubmit();
			}
		});

		delegate('change', 'input[data-list-found-checked]', function(event, self) {
			var active = self.checked;

			if (!(active)) {
				var li = self.closest('li');
				if (li) {
					li.style.transition = 'opacity 0.4s';
					li.style.opacity = '0';
					setTimeout(function() { li.remove(); }, 420);
				}
			}

			// Scroll
			filterAjaxScroll = true;

			// Submit
			filterFormSubmit();
		});

		delegate('click', '#main-catalog-filter span.sub', function(event, self) {
			// Stop event
			event.preventDefault();

			var active = self.classList.contains('active');
			var next = self.nextElementSibling;

			if (active) {
				self.classList.remove('active');
				if (next) slideUp(next);
			}
			else {
				self.classList.add('active');
				if (next) slideDown(next);
			}
		});

		if (filterUseAjaxRequest) {
			delegate('click', 'a[data-page]', function(event, self) {
				// Stop event
				event.preventDefault();

				var page = self.getAttribute('data-page');

				// Scroll
				filterAjaxScroll = true;

				// Submit
				filterFormSubmit({page: page});
			});
		}

		delegate('click', '#send-filter-button', function(event) {
			// Stop event
			event.preventDefault();

			// Submit
			filterFormSubmit();
		});

		delegate('change', '#main-catalog-filter [data-filter-field-layer] input[type="checkbox"], #main-catalog-filter [data-filter-field-layer] select', function(event, self) {
			if (!(self.classList.contains('no-reload-filter'))) {
				// Scroll
				filterAjaxScroll = true;

				// Submit
				filterFormSubmit();
			}
		});

		delegate('click', '#filter-header-layer div', function(event, self) {
			// Stop event
			event.preventDefault();

			var field = self.getAttribute('data-filter-header-field');
			var fieldId = parseInt(field);

			var fieldValue = self.getAttribute('data-filter-header-value');

			if (!!(field)) {
				field = 'filter-' + field;
				fieldValue = fieldValue ? fieldValue : null;

				fadeTo(self, 0.4, 200);

				var result = {};
				var splits = null;

				if (location.search) {
					splits = (location.search.substr(1).split('&'));
				}

				if (null !== splits) {
					for (var part in splits) {
						var values = splits[part].split('=');

						if (values.length == 2) {
							var key = values[0].toLowerCase(),
								value = decodeURIComponent(values[1]).replace(/\+/g, ' ');

							if (key && value) {
								if (fieldId !== -1) {
									if (key !== "page") {
										if (!(key in result)) {
											result[key] = [];
										}

										result[key].push(value);
									}
									else {
										result[key] = value;
									}
								}
								else {
									if (['section', 'subsection', 'filter-show'].indexOf(key) !== -1) {
										if (!(key in result)) {
											result[key] = [];
										}

										result[key].push(value);
									}
									else {
										if (key !== "page") {
											result[key] = [];
										}
									}
								}
							}
						}
					}
				}

				if (fieldId !== -1) {
					if (fieldValue == 'range') {
						if ((field + '-f') in result) {
							result[(field + '-f')] = [];
						}

						if ((field + '-t') in result) {
							result[(field + '-t')] = [];
						}
					}
					else {
						if (field in result) {
							// Delete
							var valueIndex = result[field].indexOf(fieldValue);
							if (valueIndex !== -1) {
								result[field].splice(valueIndex, 1);
							}
						}
					}

					// Reset page
					if ('page' in result) {
						delete result['page'];
					}
				}

				// Submit
				filterFormSubmit(result);
			}
		});
	});
})();
const Clothes = (function (_source, groupped) {
    groupped = groupped === true;

    const mainContent = document.querySelector('div.wrapper');
    const produceContent = mainContent ? mainContent.querySelector('#content') : null;

    let source = {};
    let sizes_source = {};
    const all_sizes = {};
    const sizes_names = {};
    let current_sizes = {};
    let addHistory = true;
    let noSize = false;
    const size_separator = '-';

    const mainImage = document.getElementById('main-image-zoom');

    const names_select = mainContent ? mainContent.querySelector('select[name="size_views"]') : null;

    const size_select_selector_a = '.size_av .size-color';
    const size_select_selector_m = 'select.cart_size_produce';
    const size_select_selector = size_select_selector_a + ', ' + size_select_selector_m;

    const size_select_has = !!(mainContent && mainContent.querySelector(size_select_selector_a));

    const current = this;

    function qa(selector, root) {
        return Array.from((root || document).querySelectorAll(selector));
    }

    // Контролы размера: .size-color (радио-контейнер) и select корзины (легаси)
    function sizeControls() {
        return mainContent ? qa(size_select_selector, mainContent) : [];
    }

    // Выбранный размер хранится как .value на контейнере (наследие jQuery .val())
    function getSizeValue() {
        const first = sizeControls()[0];
        const val = first ? first.value : undefined;
        return val == null ? '' : val;
    }

    function mainImgs() {
        return produceContent ? qa('.img_n_t_b', produceContent) : [];
    }

    function removeSwf() {
        const el = document.getElementById('swf-object');
        if (el) el.remove();
    }

    // Делегат уровня документа (замена .live)
    function delegate(type, selector, handler) {
        document.addEventListener(type, function (e) {
            const target = e.target && e.target.closest ? e.target.closest(selector) : null;
            if (!target) return;
            if (handler.call(target, e, target) === false) {
                e.preventDefault();
                e.stopPropagation();
            }
        });
    }

    this.disabledAllState = function (state) {
        this.disabledAll = !!state;
    };

    this.setCurrentSizes = function (sizes) {
        current_sizes = {};
        let current_index = 0;

        for (const i in sizes) {
            current_sizes[current_index++] = sizes[i];
        }
    };

    this.setSizes = function (_sizes, names) {
        if (!groupped) {
            sizes_source = _sizes;

            for (const i in _sizes) {
                const s = _sizes[i];

                sizes_names[s.name] = names[s.name];

                if (typeof all_sizes[s.group] === 'undefined') {
                    all_sizes[s.group] = {};
                }

                if (typeof all_sizes[s.group][s.name] === 'undefined') {
                    all_sizes[s.group][s.name] = {};
                }

                all_sizes[s.group][s.name]['id'] = i;
                all_sizes[s.group][s.name]['val'] = s.value;
            }

            qa('.size-list').forEach(function (el) { el.replaceChildren(); });

            current.viewSizes();
            current.viewSizesNames();
        }
    };

    this.viewSizesNames = function () {
        if (!names_select) return;

        names_select.replaceChildren();
        for (const i in sizes_names) {
            const option = document.createElement('option');
            option.value = i;
            option.textContent = sizes_names[i];
            names_select.appendChild(option);
        }
    };

    this.updateSizes = function (idProduce) {
        qa('.size-list').forEach(function (el) { el.replaceChildren(); });

        if (typeof idProduce == 'undefined' || (!idProduce)) {
            idProduce = null;
        }

        current.viewSizes(idProduce);
    };

    this.getNameSizeByDefaultName = function (sizes_key) {
        if (all_sizes[sizes_key]) {
            return all_sizes[sizes_key];
        }

        return null;
    };

    this.viewSizes = function (idProduce) {
        if (!size_select_has) {
            return;
        }

        if (typeof idProduce === 'undefined' || (!idProduce)) {
            idProduce = null;
        }

        qa('.size-list li').forEach(function (li) { li.classList.add('none'); });
        sizeControls().forEach(function (el) { el.replaceChildren(); });

        let csizesUnsorted = {};

        for (const i in current_sizes) {
            const group = current_sizes[i].size[0];

            csizesUnsorted[group] = ({
                size: current_sizes[i]['size'],
                id: current_sizes[i]['idProduce'],
                available: current_sizes[i]['available']
            });
        }

        const _tmp_sizes = [];
        csizesUnsorted = Object.entries(csizesUnsorted);

        csizesUnsorted.sort(([, a], [, b]) => {
            if (a.available === b.available) {
                return 0;
            } else if (a.available) {
                return -1;
            } else {
                return 1;
            }
        });

        const csizes = csizesUnsorted.reduce((acc, [key, value]) => {
            acc[key] = value;
            const size = current.getNameSizeByDefaultName(key);
            size['i'] = key;
            _tmp_sizes.push(size);
            return acc;
        }, {});

        for (const j in _tmp_sizes) {
            const i = _tmp_sizes[j]['i'];
            const size = current.getNameSizeByDefaultName(i);

            const option = document.createElement('option');
            const input = document.createElement('input');
            input.type = 'radio';
            input.name = 'size_av';
            const label = document.createElement('label');

            if (csizes[i]['size'].length > 1) {
                const text = [];
                const first = csizes[i]['size'][0];
                const last = csizes[i]['size'][(csizes[i]['size'].length - 1)];

                text[text.length] = current.getNameSizeByDefaultName(first)['val'];
                text[text.length] = current.getNameSizeByDefaultName(last)['val'];

                if (csizes[i]['size'].length > 2) {
                    label.textContent = text.join(size_separator);
                }
                else {
                    option.textContent = text.join(size_separator);
                    label.textContent = text.join(size_separator);
                }
            }
            else if (null !== size) {
                option.textContent = size.val;
                label.textContent = size.val;
            }
            if (!csizes[i]['available']) {
                option.classList.add('text-muted');
                input.classList.add('pre-order');
            }

            if (null !== size) {
                option.value = size.id;
                input.value = size.id;
                input.id = size.id;
                label.htmlFor = size.id;
            }

            option.setAttribute('data-id', csizes[i]['id']);
            input.setAttribute('data-id', csizes[i]['id']);

            qa(size_select_selector_m, mainContent).forEach(function (el) {
                el.appendChild(option.cloneNode(true));
            });
            sizeControls().forEach(function (el) {
                el.appendChild(input.cloneNode(true));
                el.appendChild(label.cloneNode(true));
            });
        }
        if (null !== idProduce) {
            qa(size_select_selector_m, mainContent).forEach(function (el) {
                qa('option[data-id="' + idProduce + '"]', el).forEach(function (o) {
                    o.setAttribute('selected', 'selected');
                });
            });
            sizeControls().forEach(function (el) {
                qa('input[data-id="' + idProduce + '"]', el).forEach(function (inp) {
                    inp.setAttribute('checked', 'checked');
                    inp.checked = true;
                });
            });
        }
    };

    this.setSize = function (val) {
        sizeControls().forEach(function (el) {
            el.value = val == null ? '' : val;
        });

        const picked = produceContent ? produceContent.querySelector(size_select_selector_a + ' input[id="' + val + '"]') : null;

        if (picked) {
            const checked = produceContent.querySelector(size_select_selector_a + ' input:checked');
            const id = checked ? checked.getAttribute('data-id') : undefined;

            if (mainContent) {
                qa('input[name="cart_id_produce"]', mainContent).forEach(function (el) {
                    el.value = id == null ? '' : id;
                });
            }
            current.updateProductInfo("size", id);
        }
        return true;
    };

    this.updateProductInfo = function (type, val) {
        let id;

        if (type === "size") {
            const checked = produceContent ? produceContent.querySelector(size_select_selector_a + ' input:checked') : null;
            id = checked ? checked.getAttribute('data-id') : undefined;
        }
        else if (type === "color") {
            qa('.color_av a').forEach(function (a) { a.classList.remove('active'); });
            qa('.color_av a[data-id="' + val + '"]').forEach(function (a) { a.classList.add('active'); });

            if (source && val in source) {
                const checkedSize = produceContent ? produceContent.querySelector('.size_av .size-color input:checked') : null;
                const current_size = checkedSize ? checkedSize.value : undefined;
                const select_color = mainContent ? mainContent.querySelector('select[name="cart_color_produce"]') : null;
                const sizes = source[val]['sizes'];

                if (select_color) {
                    select_color.value = val;
                }

                id = sizes[0]['idProduce'];

                current.setCurrentSizes(sizes);
                current.viewSizes();

                if (current_size && current_size != 0) {
                    if (current.setSize(current_size)) {
                        return;
                    }
                }
            }
            else {
                const link = mainContent ? mainContent.querySelector('.color_av a[data-id="' + val + '"]') : null;
                id = link ? link.getAttribute('data-id-produce') : undefined;
            }
        }

        if (typeof id !== 'undefined' && id) {
            fetch('/ajax/produce.php', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: new URLSearchParams({
                    produce: id,
                    'preview-request': (type === 'color' && size_select_has ? 'yes' : ''),
                    'with-produce-parts': 'yes',
                    'produce-parts': 'left-images,description,description-content,info,cart-buttons,relations',
                    'lang': document.documentElement.getAttribute('lang')
                })
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                    const idProduce = current.viewProduce(data, type, val);

                    if (!idProduce) {
                        return;
                    }

                    if (type === "size" && size_select_has) {
                        current.updateSizes(idProduce);
                    }
                })
                .catch(function () {})
                .finally(function () {
                    current.disabledAllState(!1);
                });
        }
    };

    // Ванильный ховер-зум: линза на фото + панель с увеличением справа
    let zoomInstance = null;

    function createZoom(anchor) {
        const img = anchor.querySelector('img');
        const bigSrc = anchor.getAttribute('href');
        if (!img || !bigSrc) return null;

        let bigW = 0;
        let bigH = 0;
        let ready = false;
        let over = false;
        let lens = null;
        let pane = null;
        let raf = 0;
        let tx = 0;
        let ty = 0;
        let lx = 0;
        let ly = 0;
        let lensW = 0;
        let lensH = 0;
        let sx = 1;
        let sy = 1;
        let maxX = 0;
        let maxY = 0;

        const big = new Image();
        big.onload = function () {
            bigW = big.naturalWidth;
            bigH = big.naturalHeight;
            ready = bigW > 0 && bigH > 0;
        };
        big.src = bigSrc;

        anchor.style.position = 'relative';
        anchor.style.display = 'block';

        function show() {
            const w = img.offsetWidth;
            const h = img.offsetHeight;
            if (!w || !h) return;

            sx = bigW / w;
            sy = bigH / h;
            // Большое изображение не крупнее показанного — зум бессмысленен
            if (sx <= 1 && sy <= 1) return;

            lensW = Math.round(w / sx);
            lensH = Math.round(h / sy);
            maxX = w - lensW;
            maxY = h - lensH;

            lens = document.createElement('div');
            lens.className = 'clothes-zoom-lens';
            lens.style.width = lensW + 'px';
            lens.style.height = lensH + 'px';

            pane = document.createElement('div');
            pane.className = 'clothes-zoom-pane';
            pane.style.width = w + 'px';
            pane.style.height = h + 'px';
            pane.style.left = (img.offsetLeft + w + 20) + 'px';
            pane.style.top = img.offsetTop + 'px';
            pane.style.backgroundImage = 'url("' + bigSrc + '")';
            pane.style.backgroundSize = bigW + 'px ' + bigH + 'px';

            anchor.appendChild(lens);
            anchor.appendChild(pane);
            anchor.style.cursor = 'zoom-in';
            over = true;
        }

        function hide() {
            over = false;
            if (raf) { cancelAnimationFrame(raf); raf = 0; }
            if (lens) { lens.remove(); lens = null; }
            if (pane) { pane.remove(); pane = null; }
            anchor.style.cursor = '';
        }

        function step() {
            raf = 0;
            if (!over || !lens) return;

            // Плавное доведение линзы к курсору
            lx += (tx - lx) * 0.3;
            ly += (ty - ly) * 0.3;

            lens.style.left = (img.offsetLeft + lx) + 'px';
            lens.style.top = (img.offsetTop + ly) + 'px';
            pane.style.backgroundPosition = (-lx * sx) + 'px ' + (-ly * sy) + 'px';

            if (Math.abs(tx - lx) > 0.3 || Math.abs(ty - ly) > 0.3) {
                raf = requestAnimationFrame(step);
            }
        }

        function onMove(e) {
            if (!over || !lens) return;
            const rect = img.getBoundingClientRect();
            tx = Math.max(0, Math.min(maxX, e.clientX - rect.left - lensW / 2));
            ty = Math.max(0, Math.min(maxY, e.clientY - rect.top - lensH / 2));
            if (!raf) raf = requestAnimationFrame(step);
        }

        function onEnter(e) {
            if (!ready || over) return;
            show();
            if (over) {
                const rect = img.getBoundingClientRect();
                lx = tx = Math.max(0, Math.min(maxX, e.clientX - rect.left - lensW / 2));
                ly = ty = Math.max(0, Math.min(maxY, e.clientY - rect.top - lensH / 2));
                step();
            }
        }

        anchor.addEventListener('mouseenter', onEnter);
        anchor.addEventListener('mousemove', onMove);
        anchor.addEventListener('mouseleave', hide);

        return {
            destroy: function () {
                hide();
                anchor.removeEventListener('mouseenter', onEnter);
                anchor.removeEventListener('mousemove', onMove);
                anchor.removeEventListener('mouseleave', hide);
            }
        };
    }

    this.initZoom = function () {
        this.destroyZoom();

        const anchor = mainImage ? mainImage.parentElement : null;

        if (anchor && anchor.classList.contains('cloud-zoom')) {
            zoomInstance = createZoom(anchor);
        }
    };

    this.destroyZoom = function () {
        if (zoomInstance) {
            zoomInstance.destroy();
            zoomInstance = null;
        }
    };

    this.getCollection = function (id) {

    };

    this.viewProduce = function (data, type, val) {

        if ((!data || !('produce' in data) || !(data.produce)) || (!('parts' in data) || !(data.parts))) {
            return;
        }

        qa('[data-favorite-checker]').forEach(function (checker) {
            checker.setAttribute('data-id', data.produce.idProduce);
            if (data.produce.favorites) {
                checker.setAttribute('checked', 'checked');
                checker.checked = true;
            } else {
                checker.removeAttribute('checked');
                checker.checked = false;
            }
        });

        if (data.produce.idProduce) {
            const reviewsLayer = document.getElementById('reviews-layer');
            if (reviewsLayer) {
                reviewsLayer.setAttribute('data-id-produce', data.produce.idProduce);
            }
        }

        const produce = data['produce'];
        const produceParts = data['parts'];

        noSize = produce.nosize === "yes";

        const lang = document.documentElement.getAttribute('lang');

        if (addHistory) {
            window.history.pushState({type: type, val: val}, produce.name, (lang === 'kk' ? '/kk' : '') + '/catalog?prod=' + produce['idProduce']);
        }

        removeSwf();

        if (mainContent) {
            qa('.clName', mainContent).forEach(function (el) { el.textContent = produce['name']; });
            qa('.main_left_top_middle_right h1', mainContent).forEach(function (el) { el.textContent = produce['nameWithPublisher']; });
        }

        if (produceContent) {
            qa('.right-to-cart .delivery-day-text .delivery-in-type', produceContent).forEach(function (el) {
                el.innerHTML = produce.deliveryInStore ? 'На складе' : 'Под заказ';
            });
            qa('.right-to-cart .delivery-day-text .delivery-day', produceContent).forEach(function (el) {
                el.innerHTML = produce.deliveryDay;
            });
        }

        const preorder = document.getElementById('produce_preorder');
        if (preorder) {
            preorder.setAttribute('href', '/subscribe?type=preorder&action=add&id=' + produce['idProduce']);
        }

        if (produce.image) {
            mainImgs().forEach(function (img) {
                img.setAttribute('src', app.domain_static + produce.big_image);
                if (img.parentElement) {
                    img.parentElement.setAttribute('href', app.domain_static + (produce.very_big_image ? produce.very_big_image : produce.big_image));
                }
            });
        }

        if (produce.image) {
            const ul = produceContent ? produceContent.querySelector('#produce-parts-left-images .add-photos.cell') : null;

            if (ul) {
                ul.innerHTML = '';
                ul.insertAdjacentHTML('beforeend', '<a class="clothes-img-select active" id="clothes-name-main" rel="nofollow" href="' + app.domain_static + (produce.image_main ? (produce.image_main.main_1000 ? produce.image_main.main_1000.path : (produce.image_main.main_550 ? produce.image_main.main_550.path : (produce.image_main.main_240 ? produce.image_main.main_240.path : produce.image.urli))) : null) + '"><img src="' + app.domain_static + produce.image.urli + '"/></a>');

                if (produce.images) {
                    for (const i in produce.images) {
                        if (!!(produce.images[i].id) && !!(produce.images[i].imgInfo) && !!(produce.images[i].imgPath)) {
                            ul.insertAdjacentHTML('beforeend', '<a class="clothes-img-select img" id="clothes-name-' + produce.images[i].id + '" rel="nofollow" href="' + app.domain_static + (produce.images[i].imgInfo.size_1000 ? produce.images[i].imgInfo.size_1000.path : (produce.images[i].imgInfo.size_500 ? produce.images[i].imgInfo.size_500.path : (produce.images[i].imgInfo.size_240 ? produce.images[i].imgInfo.size_240.path : '/prod/photo/' + produce.images[i].imgPath + '/' + produce.images[i].id + '_140.jpg'))) + '" style="background-image: url(' + app.domain_static + '/prod/photo/' + produce.images[i].imgPath + '/' + produce.images[i].id + '_140.jpg);"></a>');
                        }
                    }
                }

                if (produce.flash) {
                    ul.insertAdjacentHTML('beforeend', '<a class="clothes-swf-select" rel="nofollow" href="' + app.domain_static + produce.flash + '"><img src="' + app.domain_static + '/img/play_swf.png"/></a>');
                }

                // Одно фото без дополнительных — прячем колонку миниатюр
                const thumbsCount = ul.querySelectorAll('.clothes-img-select, .clothes-swf-select').length;
                qa('.main_left_top_left', produceContent).forEach(function (el) {
                    el.classList.toggle('single-photo', thumbsCount <= 1);
                });
            }
        }

        if ('color_text' in produce && produce['color_text'] && produceContent) {
            qa('span.clothes-color_text', produceContent).forEach(function (el) {
                el.textContent = produce['color_text'];
            });
        }

        if (produceParts) {
            for (const part in produceParts) {
                const partLayer = document.getElementById('produce-parts-' + part);

                if (partLayer) {
                    partLayer.innerHTML = produceParts[part];
                    partLayer.dispatchEvent(new CustomEvent('check-changes', {bubbles: true}));
                }
            }

            // После перерисовки блока кнопок переинициализируем морф под новый вариант
            if (window.cartMorphInit) window.cartMorphInit();
        }

        if (mainContent) {
            qa('input[name="cart_id_produce"]', mainContent).forEach(function (el) {
                el.value = produce['idProduce'];
            });
        }

        current.initZoom();
        current.getCollection(data['idProduce']);

        addHistory = true;

        return produce['idProduce'];
    };

    // history api
    window.addEventListener('popstate', function (e) {
        addHistory = false;

        if (e.state && e.state.type) {
            current.updateProductInfo(e.state.type, e.state.val);
        }
    }, false);

    delegate('click', '.color_av a', function (e, target) {
        const id = target.getAttribute('data-id');

        setTimeout(function () {
            current.updateProductInfo("color", id);
        }, 1);

        return false;
    });

    const lang = document.documentElement.getAttribute('lang');

    delegate('change', '.change-color-select', function (e, target) {
        const id = target.value;
        const produce = target.getAttribute('data-id-produce');

        if (!document.querySelector('div.size_av')) {
            location.href = (lang === 'kk' ? '/kk' : '') + '/catalog?prod=' + produce;
        }
        else {
            current.updateProductInfo("color", id);
        }

        return false;
    });

    delegate('change', 'select[name="cart_color_produce"]', function (e, target) {
        current.updateProductInfo("color", target.value);

        const colorControl = document.querySelector('.change-color-select[id="' + target.value + '"]');
        if (colorControl) colorControl.click();
    });

    if (size_select_has) {
        delegate('change', size_select_selector, function (e, target) {
            qa('.size-error').forEach(function (el) { el.style.display = 'none'; });

            current.setSize(target.value);

            return false;
        });

        delegate('change', '.size-color input', function (e, target) {
            qa('.size-error').forEach(function (el) { el.style.display = 'none'; });

            current.setSize(target.value);

            return false;
        });

        delegate('change', size_select_selector_m, function (e, target) {
            const input = mainContent ? mainContent.querySelector('.size-color input[id="' + target.value + '"]') : null;
            if (input) input.click();

            return false;
        });
    }

    // Ховер по миниатюре — временный предпросмотр в основном фото; клик фиксирует
    let thumbHoverSavedSrc = null;

    function detachThumbError(img) {
        if (img._thumbErrorHandler) {
            img.removeEventListener('error', img._thumbErrorHandler);
            img._thumbErrorHandler = null;
        }
    }

    document.addEventListener('mouseover', function (e) {
        const target = e.target && e.target.closest ? e.target.closest('.clothes-img-select') : null;
        if (!target || (e.relatedTarget && target.contains(e.relatedTarget))) return;

        const preview = target.getAttribute('href');
        const imgs = mainImgs();
        if (!preview || !imgs.length) return;

        if (thumbHoverSavedSrc === null) thumbHoverSavedSrc = imgs[0].getAttribute('src') || '';
        const restore = thumbHoverSavedSrc;

        imgs.forEach(function (img) {
            detachThumbError(img);
            img._thumbErrorHandler = function () { img.setAttribute('src', restore); };
            img.addEventListener('error', img._thumbErrorHandler, {once: true});
            img.setAttribute('src', preview);
        });
    });

    document.addEventListener('mouseout', function (e) {
        const target = e.target && e.target.closest ? e.target.closest('.clothes-img-select') : null;
        if (!target || (e.relatedTarget && target.contains(e.relatedTarget))) return;

        if (thumbHoverSavedSrc !== null) {
            const restore = thumbHoverSavedSrc;
            mainImgs().forEach(function (img) {
                detachThumbError(img);
                img.setAttribute('src', restore);
            });
            thumbHoverSavedSrc = null;
        }
    });

    delegate('click', '.clothes-img-select', function (e, target) {
        removeSwf();
        if (produceContent) {
            qa('.cloud-zoom', produceContent).forEach(function (el) { el.style.display = ''; });
            qa('.clothes-img-select', produceContent).forEach(function (el) { el.classList.remove('active'); });
            qa('.clothes-swf-select', produceContent).forEach(function (el) { el.classList.remove('active'); });
        }

        target.classList.add('active');

        const href = target.getAttribute('href');

        // Фиксируем выбор, чтобы уход курсора не откатил основное фото
        thumbHoverSavedSrc = href;

        mainImgs().forEach(function (img) {
            detachThumbError(img);
            img.setAttribute('src', href);
            if (img.parentElement) img.parentElement.setAttribute('href', href);
        });

        current.destroyZoom();
        current.initZoom();

        return false;
    });

    delegate('click', '.clothes-swf-select', function (e, target) {
        qa('.clothes-img-select').forEach(function (el) { el.classList.remove('active'); });
        target.classList.add('active');
        removeSwf();

        const object = '<embed id="swf-object" src="' + target.getAttribute('href') + '" type="application/x-shockwave-flash" width="400" height="400" />';

        current.destroyZoom();

        qa('.cloud-zoom').forEach(function (el) { el.style.display = 'none'; });
        qa('.imgbox').forEach(function (el) { el.insertAdjacentHTML('beforebegin', object); });

        return false;
    });

    const validateSize = function () {
        if (size_select_has) {
            const val = getSizeValue();

            if ((!val || val == 0) && !noSize) {
                qa('.size-error').forEach(function (el) { el.style.display = ''; });

                return false;
            }
        }

        return true;
    };

    // Морф-кнопка добавления вызывает этот гейт перед добавлением вариантного товара
    window.flipCartGate = validateSize;

    const cartButton = document.getElementById('cart_button');
    if (cartButton) {
        cartButton.addEventListener('click', function (e) {
            if (validateSize() === false) {
                e.preventDefault();
                e.stopPropagation();
            }
        });
    }

    if (names_select) {
        names_select.addEventListener('change', function () {
            flipCookie('clothes_size_name', names_select.value);

            const current_size = getSizeValue();
            current.setDefaultName(names_select.value);
            current.viewSizes();

            if (current_size > 0) {
                const group = sizes_source[current_size]['group'];
                const size = current.getNameSizeByDefaultName(group)['id'];

                sizeControls().forEach(function (el) {
                    el.value = size == null ? '' : size;
                });
            }
        });
    }

    current.initZoom();

    source = _source;

    if (source !== null) {
        current.setCurrentSizes(source[0]['sizes']);
    }
    else {
        current.setCurrentSizes([]);
    }

    if (_source && _source.length > 0) {
        for (const c in _source) {
            const color = _source[c];
            for (const s in color.sizes_with_info) {
                const size = color.sizes_with_info[s];

                for (const cs in size.size) {
                    all_sizes[size.size[cs].id] = {
                        id: size.size[cs].id,
                        val: size.size[cs].value
                    }
                }

            }
        }
    }

    qa('.size-list').forEach(function (el) { el.replaceChildren(); });

    current.viewSizes();
    current.viewSizesNames();
});
(function () {
    'use strict';

    function init() {

    let productId;
    let floatingBlockTimeoutId;
    const favoriteLayout = document.getElementById('favorites-layout');
    const floatingBlockTimeout = 5000;
    let closeCallback = null;
    let collectionOld = null;
    const currentLanguage = document.documentElement.getAttribute('lang');
    const url_path_prefix = currentLanguage === 'kk' ? '/' + currentLanguage : '';

    function qa(selector, root) {
        return Array.from((root || document).querySelectorAll(selector));
    }

    // Сериализация как jQuery.param: массивы — key[]=v
    function encodeForm(data) {
        const parts = [];
        for (const key in data) {
            if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
            const value = data[key];
            if (Array.isArray(value)) {
                for (let i = 0; i < value.length; i++) {
                    parts.push(encodeURIComponent(key + '[]') + '=' + encodeURIComponent(value[i] == null ? '' : value[i]));
                }
            } else {
                parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value == null ? '' : value));
            }
        }
        return parts.join('&');
    }

    /**
     * Выполняет запрос на сервер
     */
    const request = function (url, data, success, error, method) {
        const isPost = method && method.toLowerCase() === 'post';
        const body = data ? encodeForm(data) : '';

        const fail = function (responseText) {
            if (error) {
                error();
            }
            try {
                const errorRes = JSON.parse(responseText);
                if (errorRes && errorRes.error) {
                    alert(errorRes.error);
                }
            } catch (e) {}
        };

        fetch(isPost || !body ? url : url + '?' + body, {
            method: isPost ? 'POST' : 'GET',
            credentials: 'same-origin',
            headers: isPost ? {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'X-Requested-With': 'XMLHttpRequest'
            } : {
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: isPost ? body : undefined
        }).then(function (res) {
            return res.text().then(function (text) {
                if (!res.ok) {
                    fail(text);
                    return;
                }
                let parsed = null;
                try {
                    parsed = JSON.parse(text);
                } catch (e) {
                    fail(text);
                    return;
                }
                if (success) {
                    success(parsed);
                }
            });
        }).catch(function () {
            fail('');
        });
    };

    /**
     * Добавление товара в избранное
     */
    const addToFavorites = function (id, success, error) {
        request('/favorites', {add: true, id: id}, success, error, 'post');
    };

    /**
     * Массовое добавление товаров в избранное
     */
    const addMultipleToFavorites = function (ids, success, error) {
        request('/favorites', {addMultiple: true, ids: ids}, success, error, 'post');
    };

    /**
     * Удаление товара из избранного
     */
    const removeFromFavorites = function (id, collectionId, success, error) {
        request('/favorites', {remove: true, id: id, collectionId: collectionId}, success, error, 'post');
    };

    /**
     * Ссылка «поделиться» на список
     */
    const shareCollection = function (collectionId, success, error) {
        request('/favorites', {share: true, collectionId: collectionId}, success, error, 'post');
    };

    /**
     * Сохранить себе список, открытый по ссылке
     */
    const saveSharedCollection = function (collectionId, success, error) {
        request('/favorites', {addToList: true, collectionId: collectionId}, success, error, 'post');
    };

    /**
     * Показать готовую ссылку. Окно общее с корзиной и живёт в cart.js,
     * поэтому обращаемся к нему по факту клика, а не при инициализации.
     */
    const shareLink = function (url, title) {
        if (typeof window.flipShareLinkModal === 'function') {
            window.flipShareLinkModal(url, title);
            return;
        }

        prompt(currentLanguage === 'kk' ? 'Сілтеме' : 'Ссылка', url);
    };

    /**
     * Добавление выбранных товаров в корзину
     */
    const addToCart = function (ids, success, error) {
        request('/favorites', {cart: true, ids: ids}, success, error, 'post');
    };

    /**
     * Получение коллекций пользователей
     */
    const getUserCollection = function (success, error) {
        request('/favorites', {'collections': true}, success, error, 'post');
    };

    /**
     * Получение предлагаемых названий для списков
     */
    const getCollectionTitlesSuggests = function (success, error) {
        request('/favorites', {'suggests': true}, success, error, 'post');
    };

    /**
     * Создание новой коллекции или редактирование существующей
     */
    const editCollection = function (title, collectionId, success, error) {
        request('/favorites',
            {'collection': true, 'edit': true, 'title': title, 'collectionId': collectionId},
            function (res) {
                if (success && typeof success == 'function') {
                    success(res);
                }
                if (collectionId) {
                    window.location.reload();
                }
            },
            error,
            'post'
        );
    };

    /**
     * Добавление товара или товаров к коллекции
     */
    const addProductToCollection = function (products, collectionId, success, error) {
        const done = function (res) {
            collectionOld = null;
            if (success && typeof success == 'function') {
                success(res);
            }
        };

        if (collectionOld) {
            request('/favorites',
                {'collection': true, 'move': true, 'products': products, 'collectionOld': collectionOld, 'collectionNew': collectionId},
                done, error, 'post');
        } else {
            request('/favorites',
                {'collection': true, 'add': true, 'products': products, 'collectionId': collectionId},
                done, error, 'post');
        }
    };

    /**
     * Создает плавающий блок
     */
    const generateFloatingBlock = function () {

        const blockTemplate = '<div class="favorites-floating-block">\
            <div data-title></div>\
            <div data-collections-title style="display: none">\
                <div class="table">\
                    <div class="cell">\
                        <strong>Выбрать список</strong>\
                    </div>\
                    <div class="cell w-0 p-r-0">\
                        <a data-button-add-new>Новый список</a>\
                    </div>\
                </div>\
            </div>\
            <div data-new-collection-title style="display: none"><strong>Новый список</strong></div>\
            <div data-collections style="display: none;" class="p-t-8">\
                <div data-collection-item class="f-list-item">\
                    <div class="title" data-collection-title></div>\
                    <div class="count"><span data-collection-count></span></div>\
                </div>\
            </div>\
            <div data-new-collection style="display: none">\
                <div class="form-control p-t-8">\
                    <div class="form-element p-b-0">\
                        <input type="text" id="fnewname" name="title" placeholder="Название списка" value="">\
                        <label for="fnewname">Название списка</label>\
                    </div>\
                </div>\
                <div data-suggests>\
                    <p>Предлагаемые названия</p>\
                    <div data-suggests-item>\
                        <div data-suggests-title></div>\
                    </div>\
                </div>\
            </div>\
            <div data-buttons style="text-align: right;">\
                <a class="btn yellow" data-button-save style="display: none">Сохранить</a>\
                <a class="btn transparant" data-button-back style="display: none">Назад</a>\
                <a class="btn gray" data-button-change>Изменить список</a>\
                <a class="btn transparant" data-button-close>Закрыть</a>\
            </div>\
        </div>';

        const holder = document.createElement('div');
        holder.innerHTML = blockTemplate;
        const block = holder.firstElementChild;

        const input = block.querySelector('[data-new-collection] input');
        const label = block.querySelector('[data-new-collection] label');
        if (input) input.id = 'fnewname-1';
        if (label) label.htmlFor = 'fnewname-1';

        initFloatingBlockEvents(block);
        return block;
    };

    /**
     * Показываем плавающий блок с информации о добавлении товара в избранное
     */
    const showFavoritesFloatingBlock = function (names, isMoveToCollection) {
        if (floatingBlockTimeoutId) {
            clearTimeout(floatingBlockTimeoutId);
        }

        closeCallback = null;
        const block = generateFloatingBlock(isMoveToCollection);
        if (names) {
            if (names.title) {
                block.querySelector('[data-title]').innerHTML = names.title;
            }
            if (names.button) {
                block.querySelector('[data-button-change]').innerHTML = names.button;
            }
        }

        if (isMoveToCollection) {
            block.querySelector('[data-button-change]').click();
            block.classList.remove('favorites-floating-block');
            block.classList.add('favorites-block');
            const close = block.querySelector('[data-button-close]');
            if (close) close.remove();
            const events = showModal({
                onlyClose: true,
                content: block
            });
            closeCallback = function () {
                if (events.close) {
                    events.close();
                }
                window.location.reload();
            };
        } else {
            qa('.favorites-floating-block.showed').forEach(function (el) { el.remove(); });
            block.classList.add('showed');
            document.body.appendChild(block);

            floatingBlockTimeoutId = setTimeout(function () {
                block.remove();
                if (favoriteLayout) {
                    window.location.reload();
                }
            }, floatingBlockTimeout);
        }
    };

    /**
     * Инициализация событий для управления коллекциями в плавающем блоке
     */
    const initFloatingBlockEvents = function (block) {
        const buttonClose = block.querySelector('[data-button-close]');
        const buttonChangeCollection = block.querySelector('[data-button-change]');
        const buttonSave = block.querySelector('[data-button-save]');
        const buttonAddNew = block.querySelector('[data-button-add-new]');
        const buttonBack = block.querySelector('[data-button-back]');

        const blockTitle = block.querySelector('[data-title]');
        const blockNewCollectionTitle = block.querySelector('[data-new-collection-title]');
        const blockCollectionsTitle = block.querySelector('[data-collections-title]');

        const blockCollections = block.querySelector('[data-collections]');
        const blockNewCollection = block.querySelector('[data-new-collection]');
        const blockNewCollectionSuggests = blockNewCollection.querySelector('[data-suggests]');

        const collectionItemProto = blockCollections.querySelector('[data-collection-item]').cloneNode(true);
        blockCollections.querySelector('[data-collection-item]').remove();

        const suggestItemProto = blockNewCollection.querySelector('[data-suggests-item]').cloneNode(true);
        blockNewCollection.querySelector('[data-suggests-item]').remove();

        const show = function (el) { if (el) el.style.display = ''; };
        const hide = function (el) { if (el) el.style.display = 'none'; };

        const closeBlock = function () {
            block.remove();
            if (closeCallback && typeof closeCallback == 'function') {
                closeCallback();
            } else if (favoriteLayout) {
                window.location.reload();
            }
        };

        // Кнопка «Закрыть»
        if (buttonClose) {
            buttonClose.addEventListener('click', function () {
                closeBlock();
            });
        }

        // Кнопка «Назад»
        if (buttonBack) {
            buttonBack.addEventListener('click', function () {
                hide(buttonChangeCollection);
                hide(blockTitle);
                hide(blockNewCollectionTitle);
                hide(blockNewCollection);
                hide(buttonBack);
                hide(buttonSave);

                show(blockCollectionsTitle);
                show(blockCollections);
                show(buttonClose);
            });
        }

        // Кнопка «Изменить список»
        if (buttonChangeCollection) {
            buttonChangeCollection.addEventListener('click', function () {

                if (floatingBlockTimeoutId) {
                    clearTimeout(floatingBlockTimeoutId);
                }

                getUserCollection(function (resCollections) {
                    if (resCollections && resCollections.length) {
                        for (let i = 0; i < resCollections.length; i++) {
                            const item = collectionItemProto.cloneNode(true);
                            item.querySelector('[data-collection-title]').textContent = resCollections[i].title;
                            if (resCollections[i].countProduces) {
                                item.querySelector('[data-collection-count]').textContent = parseInt(resCollections[i].countProduces) + ' ' + getNoun(resCollections[i].countProduces, 'товар', 'товара', 'товаров');
                            }
                            item.addEventListener('click', function () {
                                addProductToCollection(productId, resCollections[i].idCollection, function (res) {
                                    closeBlock();
                                    if (res.collection && res.produce) {
                                        const names = generateTitle(res.collection, res.produce);
                                        showFavoritesFloatingBlock(names);
                                    }
                                });
                            });
                            blockCollections.appendChild(item);
                        }
                    } else {
                        blockCollections.append('Вы пока не создали ни одного списка.');
                    }

                    hide(buttonChangeCollection);
                    hide(blockTitle);
                    hide(blockNewCollectionTitle);
                    show(blockCollectionsTitle);
                    show(blockCollections);
                });
            });
        }

        // Кнопка «Новый список»
        if (buttonAddNew) {
            buttonAddNew.addEventListener('click', function () {
                show(buttonBack);
                show(buttonSave);
                hide(buttonClose);
                hide(blockCollections);
                hide(blockCollectionsTitle);
                show(blockNewCollectionTitle);

                getCollectionTitlesSuggests(function (resSuggest) {
                    if (resSuggest && resSuggest.length) {
                        for (let i = 0; i < resSuggest.length; i++) {
                            const item = suggestItemProto.cloneNode(true);
                            item.querySelector('[data-suggests-title]').textContent = resSuggest[i];
                            blockNewCollectionSuggests.appendChild(item);
                            item.addEventListener('click', function () {
                                blockNewCollection.querySelector('[name=title]').value = item.querySelector('[data-suggests-title]').textContent;
                            });
                        }
                    } else {
                        hide(blockNewCollectionSuggests);
                    }
                    show(blockNewCollection);
                });
            });
        }

        // Кнопка «Сохранить» при создании или переименовании списка
        if (buttonSave) {
            buttonSave.addEventListener('click', function () {
                const title = blockNewCollection.querySelector('[name=title]').value;
                const collectionId = buttonSave.getAttribute('data-collection-id');
                if (title) {
                    editCollection(title, collectionId, function (resCollectionId) {
                        if (!collectionId && resCollectionId && productId) {
                            addProductToCollection(productId, resCollectionId, function (res) {
                                closeBlock();
                                if (res.collection && res.produce) {
                                    const names = generateTitle(res.collection, res.produce);
                                    showFavoritesFloatingBlock(names);
                                }
                            });
                        } else {
                            closeBlock();
                        }
                    });
                }
            });
        }
    };

    const generateTitle = function (collection, produce) {
        let lang = '';

        const langInput = document.querySelector('input[name="lang"]:checked');
        if (langInput && langInput.value == 'kk') {
            lang = '/kk';
        }

        const names = {};
        if (+collection.isDefault) {
            names.button = 'Выбрать список';
            names.title = '<span class="gray-text">Товар</span> ' + produce.name + ' <span class="gray-text">добавлен в <a href="' + lang + '/favorites"> избранное</a>.</span>';
        } else {
            names.button = 'Выбрать другой';
            names.title = '<span class="gray-text">Товар</span> ' + produce.name + ' <span class="gray-text">добавлен в список <a href="' + lang + '/favorites?collection=' + collection.idCollection + '">' + collection.title + '</a>.</span>';
        }
        return names;
    };

    /**
     * Событие по выделению товара в избранное
     */
    document.addEventListener('change', function (e) {
        const self = e.target && e.target.closest ? e.target.closest('input[data-favorite-checker]') : null;
        if (!self) return;

        // Предотвращение повторных кликов во время обработки запроса
        if (self._favProcessing) {
            return;
        }
        self._favProcessing = true;

        const id = self.getAttribute('data-id');
        const mirror = document.getElementById('favorites-' + id);

        if (self.checked) {
            addToFavorites(id, function (res) {
                self._favProcessing = false;
                productId = id;
                if (res.collection && res.produce && !self.getAttribute('data-not-show-floating-block')) {
                    const names = generateTitle(res.collection, res.produce);
                    showFavoritesFloatingBlock(names);
                }
                if (mirror) {
                    mirror.setAttribute('checked', 'checked');
                    mirror.checked = true;
                }
            },
            function () {
                self._favProcessing = false;
                self.removeAttribute('checked');
                self.checked = false;
            });
        } else {
            removeFromFavorites(id, null, function () {
                self._favProcessing = false;
                if (mirror) {
                    mirror.removeAttribute('checked');
                    mirror.checked = false;
                }
            }, function () {
                self._favProcessing = false;
                self.setAttribute('checked', 'checked');
                self.checked = true;
            });
        }
    });

    if (favoriteLayout) {
        qa('select[name=order]', favoriteLayout).forEach(function (sel) {
            sel.addEventListener('change', function () {
                const form = sel.closest('form');
                if (form) form.submit();
            });
        });

        const layoutButtonDelete = qa('[data-favorites-delete]', favoriteLayout);
        const layoutButtonCart = qa('[data-favorites-cart]', favoriteLayout);
        const layoutButtonList = qa('[data-favorites-list]', favoriteLayout);
        const layoutFavoriteSelector = qa('[data-favorite-selector]', favoriteLayout);

        const setDisabled = function (els, disabled) {
            els.forEach(function (el) {
                if (disabled) el.setAttribute('disabled', 'disabled');
                else el.removeAttribute('disabled');
            });
        };

        /**
         * Возвращает выбранные пользователем id товаров
         */
        const getSelectedIds = function () {
            const ids = [];
            qa('input[data-favorite-selector]:checked').forEach(function (input) {
                const id = input.getAttribute('data-id');
                if (id) {
                    ids.push(id);
                }
            });
            return ids;
        };

        layoutFavoriteSelector.forEach(function (input) {
            input.addEventListener('change', function () {
                const selected = getSelectedIds();
                const disabled = selected.length === 0;
                setDisabled(layoutButtonDelete, disabled);
                setDisabled(layoutButtonCart, disabled);
                setDisabled(layoutButtonList, disabled);
            });
        });

        /**
         * Снимаем выделение товаров
         */
        const unselectedProducts = function () {
            qa('input[data-favorite-selector]:checked').forEach(function (input) {
                input.removeAttribute('checked');
                input.checked = false;
            });

            qa('input[data-favorite-selector]').forEach(function (el) { el.style.display = 'none'; });
            qa('.favorite-selector').forEach(function (el) { el.style.display = 'none'; });

            favoriteLayout.classList.remove('favorites-selecting');

            qa('[data-favorites-selectors-show]', favoriteLayout).forEach(function (el) {
                el.removeAttribute('data-showed');
                el.textContent = currentLanguage == 'kk' ? 'Тауарларды таңдау' : 'Выбрать товары';
            });

            setDisabled(layoutButtonDelete, true);
            setDisabled(layoutButtonCart, true);
            setDisabled(layoutButtonList, true);
        };

        qa('[data-favorites-selectors-show]', favoriteLayout).forEach(function (toggle) {
            toggle.addEventListener('click', function () {
                if (!toggle.getAttribute('data-showed')) {
                    toggle.textContent = currentLanguage == 'kk' ? 'Таңдаудан бас тарту' : 'Отменить выбор';
                    // Селекторы скрыты CSS-ом — показываем инлайновым display
                    qa('input[data-favorite-selector]').forEach(function (el) { el.style.display = 'inline-block'; });
                    qa('.favorite-selector').forEach(function (el) { el.style.display = 'inline'; });
                    favoriteLayout.classList.add('favorites-selecting');
                    toggle.setAttribute('data-showed', 'true');
                } else {
                    unselectedProducts();
                }
            });
        });

        /**
         * Кнопка «Удалить»
         */
        layoutButtonDelete.forEach(function (btn) {
            btn.addEventListener('click', function () {
                if (confirm('Удалить выбранные товары?')) {
                    const ids = getSelectedIds();
                    const collectionId = btn.getAttribute('data-collection-id');
                    if (ids && ids.length) {
                        removeFromFavorites(ids, collectionId, function () {
                            window.location.reload();
                        });
                    }
                }
            });
        });

        /**
         * Кнопка «В корзину»
         */
        layoutButtonCart.forEach(function (btn) {
            btn.addEventListener('click', function () {
                if (confirm('Добавить выбранные товары в корзину?')) {
                    const ids = getSelectedIds();

                    if (ids && ids.length) {
                        addToCart(ids, function () {
                            unselectedProducts();
                            const text = 'Товары добавлены в корзину';
                            showMessage(text, 'm_info');
                            cartGet();
                        });
                    }
                }
            });
        });

        /**
         * Кнопка «В список»
         */
        layoutButtonList.forEach(function (btn) {
            btn.addEventListener('click', function () {
                productId = getSelectedIds();
                collectionOld = btn.getAttribute('data-collection-id');

                if (productId && productId.length) {
                    showFavoritesFloatingBlock({}, true);
                }
            });
        });

        /**
         * Удаление коллекции
         */
        qa('[data-favorites-collection-remove]', favoriteLayout).forEach(function (el) {
            el.addEventListener('click', function (e) {
                if (!confirm('Удалить выбранную коллекцию?')) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            });
        });

        /**
         * Редактирование коллекции
         */
        qa('[data-favorites-collection-rename]', favoriteLayout).forEach(function (el) {
            el.addEventListener('click', function () {
                closeCallback = null;
                const collectionId = parseInt(el.getAttribute('data-collection-id'));
                const collectionTitle = el.getAttribute('data-collection-title');
                if (collectionId) {
                    const block = generateFloatingBlock();
                    block.classList.remove('favorites-floating-block');
                    block.classList.add('favorites-block');

                    block.querySelector('[data-new-collection-title] strong').textContent = 'Переименовать список';
                    block.querySelector('[data-button-change]').style.display = 'none';
                    const back = block.querySelector('[data-button-back]');
                    if (back) back.remove();
                    block.querySelector('[data-new-collection] input').value = collectionTitle;
                    block.querySelector('[data-button-save]').setAttribute('data-collection-id', collectionId);

                    const events = showModal({
                        onlyClose: true,
                        content: block
                    });
                    block.querySelector('[data-button-add-new]').click();
                    const close = block.querySelector('[data-button-close]');
                    close.textContent = 'Отмена';
                    close.style.display = '';
                    closeCallback = function () {
                        if (events.close) {
                            events.close();
                        }
                    };
                }
            });
        });

        /**
         * Поделиться списком
         */
        qa('[data-favorites-share]').forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();

                const failed = currentLanguage === 'kk' ? 'Сілтеме жасау мүмкін болмады' : 'Не\u00a0удалось создать ссылку';

                // Предотвращение повторных кликов во время обработки запроса
                if (el.dataset.processing) {
                    return;
                }
                el.dataset.processing = '1';

                shareCollection(el.getAttribute('data-collection-id'), function (res) {
                    delete el.dataset.processing;

                    if (res && res.url) {
                        shareLink(res.url, res.title);
                    } else {
                        showMessage(res && res.error ? res.error : failed);
                    }
                }, function () {
                    delete el.dataset.processing;
                    showMessage(failed);
                });
            });
        });

        /**
         * Сохранить себе список, открытый по ссылке
         */
        qa('[data-favorites-save-shared]').forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();

                const saved = currentLanguage === 'kk' ? 'Тізім таңдаулыға сақталды' : 'Список сохранён в\u00a0избранное';
                const failed = currentLanguage === 'kk' ? 'Тізімді сақтау мүмкін болмады' : 'Не\u00a0удалось сохранить список';

                // Предотвращение повторных кликов во время обработки запроса
                if (el.dataset.processing) {
                    return;
                }
                el.dataset.processing = '1';

                saveSharedCollection(el.getAttribute('data-collection-id'), function (res) {
                    delete el.dataset.processing;

                    if (res && res.url) {
                        showMessage(saved, 'm_info');
                        location.href = res.url;
                    } else {
                        showMessage(failed);
                    }
                }, function () {
                    delete el.dataset.processing;
                    showMessage(failed);
                });
            });
        });

        /**
         * Кнопка «Создать новый список»
         */
        qa('[data-favorites-collection-create]').forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.stopPropagation();
                e.preventDefault();
                closeCallback = null;
                productId = null;
                const block = generateFloatingBlock();
                block.classList.remove('favorites-floating-block');
                block.classList.add('favorites-block');
                block.querySelector('[data-button-change]').style.display = 'none';
                const back = block.querySelector('[data-button-back]');
                if (back) back.remove();

                const events = showModal({
                    onlyClose: true,
                    content: block
                });

                block.querySelector('[data-button-add-new]').click();
                const close = block.querySelector('[data-button-close]');
                close.textContent = 'Отмена';
                close.style.display = '';
                closeCallback = function () {
                    if (events.close) {
                        events.close();
                    }
                    window.location.reload();
                };
            });
        });

    }

    // Expose favorites API to global scope for external callers (e.g., cart mass actions)
    if (typeof window !== 'undefined') {
        try { window.addToFavorites = window.addToFavorites || addToFavorites; } catch (e) {}
        try { window.addMultipleToFavorites = window.addMultipleToFavorites || addMultipleToFavorites; } catch (e) {}
        try { window.removeFromFavorites = window.removeFromFavorites || removeFromFavorites; } catch (e) {}
    }

    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

/**
 * В режиме выбора товаров клик по всей карточке переключает checkbox выбора.
 * Карточка (a.product) в этом режиме под pointer-events: none, поэтому целью
 * клика становится обёртка .new-product; клики по самому checkbox пропускаем,
 * чтобы не переключить его дважды.
 */
document.addEventListener('click', function (e) {
    var layout = document.getElementById('favorites-layout');
    if (!layout || !layout.classList.contains('favorites-selecting')) {
        return;
    }

    if (!e.target || !e.target.closest) {
        return;
    }

    if (e.target.closest('input[data-favorite-selector], .favorite-selector')) {
        return;
    }

    var card = e.target.closest('.new-product');
    if (!card || !layout.contains(card)) {
        return;
    }

    var selector = card.querySelector('input[data-favorite-selector]');
    if (!selector) {
        return;
    }

    e.preventDefault();
    selector.checked = !selector.checked;
    selector.dispatchEvent(new Event('change', { bubbles: true }));
});

var Groupped = (function (groupped) {
    var that = this;

    var request = null;

    var mainContent = document.querySelector('div.wrapper');
    var produceContent = mainContent ? mainContent.querySelector('#content') : null;

    var producePartsPrefix = 'produce-parts-';

    var attributesSelector = 'select[data-clothes-groupped-attributes],div[data-clothes-groupped-attributes]';
    var attributesMirrorsSelector = 'select[data-clothes-groupped-attributes-mirror],div[data-clothes-groupped-attributes-mirror]';

    var attributes = produceContent ? Array.from(produceContent.querySelectorAll(attributesSelector)) : [];

    var attributesCount = attributes.length;

    var attributesSelected = [];

    var cartButton;
    var cartButtonMessage;

    var cartIdProduce = [];

    var mainImage = document.getElementById('main-image-zoom');
    var disabledAll = false;

    var currentIdProduce = null;

    var mainImageSavedSrc = null;

    function qa(selector, root) {
        return Array.from((root || document).querySelectorAll(selector));
    }

    // Делегат уровня документа (замена .live)
    function delegate(type, selector, handler) {
        document.addEventListener(type, function (e) {
            var target = e.target && e.target.closest ? e.target.closest(selector) : null;
            if (!target) return;
            if (handler.call(target, e, target) === false) {
                e.preventDefault();
                e.stopPropagation();
            }
        });
    }

    function mainImgs() {
        return produceContent ? qa('.img_n_t_b', produceContent) : [];
    }

    function removeSwf() {
        var el = document.getElementById('swf-object');
        if (el) el.remove();
    }

    function bindEventOnOtherColors() {
        qa('.size_av label').forEach(function (label) {
            label.addEventListener('click', function () {
                var dataId = (label.getAttribute('for') || '').replace('size_', '');
                var input = document.querySelector('input[value="' + dataId + '"]');
                if (!input) return;

                var value = input.getAttribute('data-id');
                var select = document.querySelector('.clothes_groupped_1');
                if (!select) return;

                select.value = value;
                select.dispatchEvent(new Event('change', {bubbles: true}));
            });
        });
    }

    var producePartsInit = ({
        'cart-buttons': (function () {
            cartButton = document.getElementById('cart_button');
            cartButtonMessage = document.getElementById('cart_button_message');

            cartIdProduce = produceContent ? qa('form input[name="cart_id_produce"]', produceContent) : [];

            // После перерисовки блока кнопок переинициализируем морф под новый вариант
            if (window.cartMorphInit) window.cartMorphInit();
        })
    });

    var producePartsRemove = ({

    });

    for (var part in producePartsInit) {
        if (document.getElementById(producePartsPrefix + part)) {
            producePartsInit[part]();
        }
    }

    // Ванильный ховер-зум: линза на фото + панель с увеличением справа
    var zoomInstance = null;

    function createZoom(anchor) {
        var img = anchor.querySelector('img');
        var bigSrc = anchor.getAttribute('href');
        if (!img || !bigSrc) return null;

        var bigW = 0;
        var bigH = 0;
        var ready = false;
        var over = false;
        var lens = null;
        var pane = null;
        var raf = 0;
        var tx = 0;
        var ty = 0;
        var lx = 0;
        var ly = 0;
        var lensW = 0;
        var lensH = 0;
        var sx = 1;
        var sy = 1;
        var maxX = 0;
        var maxY = 0;

        var big = new Image();
        big.onload = function () {
            bigW = big.naturalWidth;
            bigH = big.naturalHeight;
            ready = bigW > 0 && bigH > 0;
        };
        big.src = bigSrc;

        anchor.style.position = 'relative';
        anchor.style.display = 'block';

        function show() {
            var w = img.offsetWidth;
            var h = img.offsetHeight;
            if (!w || !h) return;

            sx = bigW / w;
            sy = bigH / h;
            // Большое изображение не крупнее показанного — зум бессмысленен
            if (sx <= 1 && sy <= 1) return;

            lensW = Math.round(w / sx);
            lensH = Math.round(h / sy);
            maxX = w - lensW;
            maxY = h - lensH;

            lens = document.createElement('div');
            lens.className = 'clothes-zoom-lens';
            lens.style.width = lensW + 'px';
            lens.style.height = lensH + 'px';

            pane = document.createElement('div');
            pane.className = 'clothes-zoom-pane';
            pane.style.width = w + 'px';
            pane.style.height = h + 'px';
            pane.style.left = (img.offsetLeft + w + 20) + 'px';
            pane.style.top = img.offsetTop + 'px';
            pane.style.backgroundImage = 'url("' + bigSrc + '")';
            pane.style.backgroundSize = bigW + 'px ' + bigH + 'px';

            anchor.appendChild(lens);
            anchor.appendChild(pane);
            anchor.style.cursor = 'zoom-in';
            over = true;
        }

        function hide() {
            over = false;
            if (raf) { cancelAnimationFrame(raf); raf = 0; }
            if (lens) { lens.remove(); lens = null; }
            if (pane) { pane.remove(); pane = null; }
            anchor.style.cursor = '';
        }

        function step() {
            raf = 0;
            if (!over || !lens) return;

            // Плавное доведение линзы к курсору
            lx += (tx - lx) * 0.3;
            ly += (ty - ly) * 0.3;

            lens.style.left = (img.offsetLeft + lx) + 'px';
            lens.style.top = (img.offsetTop + ly) + 'px';
            pane.style.backgroundPosition = (-lx * sx) + 'px ' + (-ly * sy) + 'px';

            if (Math.abs(tx - lx) > 0.3 || Math.abs(ty - ly) > 0.3) {
                raf = requestAnimationFrame(step);
            }
        }

        function onMove(e) {
            if (!over || !lens) return;
            var rect = img.getBoundingClientRect();
            tx = Math.max(0, Math.min(maxX, e.clientX - rect.left - lensW / 2));
            ty = Math.max(0, Math.min(maxY, e.clientY - rect.top - lensH / 2));
            if (!raf) raf = requestAnimationFrame(step);
        }

        function onEnter(e) {
            if (!ready || over) return;
            show();
            if (over) {
                var rect = img.getBoundingClientRect();
                lx = tx = Math.max(0, Math.min(maxX, e.clientX - rect.left - lensW / 2));
                ly = ty = Math.max(0, Math.min(maxY, e.clientY - rect.top - lensH / 2));
                step();
            }
        }

        anchor.addEventListener('mouseenter', onEnter);
        anchor.addEventListener('mousemove', onMove);
        anchor.addEventListener('mouseleave', hide);

        return {
            destroy: function () {
                hide();
                anchor.removeEventListener('mouseenter', onEnter);
                anchor.removeEventListener('mousemove', onMove);
                anchor.removeEventListener('mouseleave', hide);
            }
        };
    }

    this.initZoom = function () {
        this.destroyZoom();

        var anchor = mainImage ? mainImage.parentElement : null;

        if (anchor && anchor.classList.contains('cloud-zoom')) {
            zoomInstance = createZoom(anchor);
        }
    };

    this.destroyZoom = function () {
        if (zoomInstance) {
            zoomInstance.destroy();
            zoomInstance = null;
        }
    };

    this.disabledAllState = function (state) {
        this.disabledAll = !!state;
    };

    this.viewProduce = function (data) {
        if ((!data || !('produce' in data) || !(data.produce)) || (!('parts' in data) || !(data.parts))) {
            return;
        }

        if (data.produce.idProduce) {
            var reviewsLayer = document.getElementById('reviews-layer');
            if (reviewsLayer) {
                reviewsLayer.setAttribute('data-id-produce', data.produce.idProduce);
            }
        }

        var produce = data['produce'];
        var produceParts = data['parts'];

        var lang = '';

        if (document.documentElement.getAttribute('lang') === 'kk') {
            lang = '/kk';
        }

        // Location
        window.history.replaceState({}, produce.name, lang + '/catalog?prod=' + produce['idProduce']);

        if (attributesCount > 1) {
            if (produce.clothes_groupped) {
                // Находим группу, соответствующую выбранному варианту
                var selectedGroup = null;
                for (var gi = 0; gi < produce.clothes_groupped.length; gi++) {
                    var g = produce.clothes_groupped[gi];
                    if (!g.groupped) continue;
                    for (var ii = 0; ii < g.groupped.length; ii++) {
                        if (g.groupped[ii].idProduce == produce.idProduce) {
                            selectedGroup = g;
                            break;
                        }
                    }
                    if (selectedGroup) break;
                }
                if (!selectedGroup) selectedGroup = produce.clothes_groupped[0];

                if (selectedGroup && selectedGroup.groupped) {
                    // Rebuild
                    var attribute = attributes[1];
                    var attributeIndex = 0;

                    if (attribute && attribute.nodeName.toLowerCase() == 'select') {
                        qa('option[data-id="-1"]', attribute).forEach(function (o) {
                            o.removeAttribute('disabled');
                        });
                        qa('option', attribute).forEach(function (o) {
                            if (o.getAttribute('value') !== '' && o.getAttribute('data-id') !== '-1') {
                                o.remove();
                            }
                        });

                        var sizeColorHtml = '';

                        for (var gg = 0; gg < selectedGroup.groupped.length; gg++) {
                            var item = selectedGroup.groupped[gg];
                            if (!item) continue;

                            var grouppedValues = (item.grouppedValue && item.grouppedValue.values != null) ? item.grouppedValue.values : '';

                            var option = document.createElement('option');
                            option.className = (!item.available || item.availableHide === 0 ? 'text-muted' : '');
                            option.value = item.idProduce;
                            option.setAttribute('data-id', String(attributeIndex++));
                            option.textContent = grouppedValues;
                            attribute.appendChild(option);

                            var sizeInputId = (item.grouppedValue && item.grouppedValue.valuesIds !== null && item.grouppedValue.valuesIds !== undefined) ? item.grouppedValue.valuesIds : item.idProduce;
                            sizeColorHtml += '<input ' + (data.produce.idProduce === item.idProduce ? 'checked="checked"' : '') + ' class="' + (!item.available || item.availableHide === 0 ? 'pre-order' : '') + '" id="' + sizeInputId + '" type="radio" name="size_av"  value="' + sizeInputId + '"  data-id="' + item.idProduce + '" /><label for="' + sizeInputId + '">' + grouppedValues + '</label>';
                        }

                        qa('.size-color').forEach(function (el) {
                            el.innerHTML = sizeColorHtml;
                        });

                        bindEventOnOtherColors();
                        qa('option[data-id="-1"]', attribute).forEach(function (o) {
                            o.setAttribute('disabled', 'disabled');
                        });
                    }
                }
            }
        }

        removeSwf();

        if (mainContent) {
            qa('.clName', mainContent).forEach(function (el) { el.textContent = produce['name']; });
            qa('.main_left_top_middle_right h1', mainContent).forEach(function (el) { el.textContent = produce['nameWithPublisher']; });
        }

        if (produceContent) {
            qa('.right-to-cart .delivery-day-text .delivery-in-type', produceContent).forEach(function (el) {
                el.innerHTML = produce.deliveryInStore ? 'На складе' : 'Под заказ';
            });
            qa('.right-to-cart .delivery-day-text .delivery-day', produceContent).forEach(function (el) {
                el.innerHTML = produce.deliveryDay;
            });
        }

        var preorder = document.getElementById('produce_preorder');
        if (preorder) {
            preorder.setAttribute('href', '/subscribe?type=preorder&action=add&id=' + produce['idProduce']);
        }

        if (produce.image) {
            mainImgs().forEach(function (img) {
                img.setAttribute('src', app.domain_static + produce.big_image);
                if (img.parentElement) {
                    img.parentElement.setAttribute('href', produce.very_big_image ? app.domain_static + produce.very_big_image : app.domain_static + produce.big_image);
                }
            });
        }

        if (produceParts) {
            for (var partName in produceParts) {
                var partLayer = document.getElementById(producePartsPrefix + partName);

                if (partLayer) {
                    if (partName in producePartsRemove) {
                        producePartsRemove[partName]();
                    }

                    partLayer.innerHTML = produceParts[partName];
                    partLayer.dispatchEvent(new CustomEvent('check-changes', {bubbles: true}));

                    if (partName in producePartsInit) {
                        producePartsInit[partName]();
                    }
                }
            }
        }

        // Zoom
        that.initZoom();

        // Ok
        return produce['idProduce'];
    };

    // Ховер по миниатюре — временный предпросмотр в основном фото; клик фиксирует
    var thumbHoverSavedSrc = null;

    function detachThumbError(img) {
        if (img._thumbErrorHandler) {
            img.removeEventListener('error', img._thumbErrorHandler);
            img._thumbErrorHandler = null;
        }
    }

    document.addEventListener('mouseover', function (e) {
        var target = e.target && e.target.closest ? e.target.closest('.clothes-img-select') : null;
        if (!target || (e.relatedTarget && target.contains(e.relatedTarget))) return;

        var preview = target.getAttribute('href');
        var imgs = mainImgs();
        if (!preview || !imgs.length) return;

        if (thumbHoverSavedSrc === null) thumbHoverSavedSrc = imgs[0].getAttribute('src') || '';
        var restore = thumbHoverSavedSrc;

        imgs.forEach(function (img) {
            detachThumbError(img);
            img._thumbErrorHandler = function () { img.setAttribute('src', restore); };
            img.addEventListener('error', img._thumbErrorHandler, {once: true});
            img.setAttribute('src', preview);
        });
    });

    document.addEventListener('mouseout', function (e) {
        var target = e.target && e.target.closest ? e.target.closest('.clothes-img-select') : null;
        if (!target || (e.relatedTarget && target.contains(e.relatedTarget))) return;

        if (thumbHoverSavedSrc !== null) {
            var restore = thumbHoverSavedSrc;
            mainImgs().forEach(function (img) {
                detachThumbError(img);
                img.setAttribute('src', restore);
            });
            thumbHoverSavedSrc = null;
        }
    });

    delegate('click', '.clothes-img-select', function (e, target) {
        removeSwf();
        if (produceContent) {
            qa('.cloud-zoom', produceContent).forEach(function (el) { el.style.display = ''; });
            qa('.clothes-img-select', produceContent).forEach(function (el) { el.classList.remove('active'); });
            qa('.clothes-swf-select', produceContent).forEach(function (el) { el.classList.remove('active'); });
        }

        target.classList.add('active');

        var href = target.getAttribute('href');

        // Фиксируем выбор, чтобы уход курсора не откатил основное фото
        thumbHoverSavedSrc = href;

        mainImgs().forEach(function (img) {
            detachThumbError(img);
            img.setAttribute('src', href);
            if (img.parentElement) img.parentElement.setAttribute('href', href);
        });

        // Zoom
        that.initZoom();

        return false;
    });

    this.attributesOnChange = function (type, index, from, value, firstLoad) {
        firstLoad = typeof firstLoad == 'undefined' || (!firstLoad) ? false : true;

        if (null !== request) {
            request.abort();
            request = null;
        }

        if (value) {
            if (attributesCount > 1) {
                if (index == 0) {
                    attributesSelected = [];
                }
            }

            attributesSelected[index] = value;
        }
        else {
            attributesSelected[index] = null;
        }

        if (null !== attributesSelected[index]) {
            if (true === firstLoad) {

            }
            else {
                var currentSizeName = null;
                if (index == 0 && attributesCount > 1) {
                    var checkedSize = document.querySelector('input[name="size_av"]:checked');
                    if (checkedSize) {
                        var checkedLabel = document.querySelector('label[for="' + checkedSize.id + '"]');
                        if (checkedLabel) {
                            currentSizeName = checkedLabel.textContent.trim();
                        }
                    }
                }

                // Disabled all
                that.disabledAllState(!0);
                that.destroyZoom();

                // Вариант выбран (коммит) — сбрасываем сохранённый src hover-превью,
                // иначе mouseleave откатит главное фото к старому варианту и затрёт
                // только что загруженное изображение нового варианта.
                mainImageSavedSrc = null;

                var controller = new AbortController();
                request = controller;

                fetch('/ajax/produce.php', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: new URLSearchParams({
                        produce: attributesSelected[index],
                        'preview-request': (index < (attributesCount - 1) ? 'yes' : ''),
                        'lang': document.documentElement.getAttribute('lang'),
                        'with-produce-parts': 'yes',
                        'produce-parts': 'left-images,description,description-content,info,cart-buttons,relations'
                    }),
                    signal: controller.signal
                })
                    .then(function (response) { return response.json(); })
                    .then(function (data) {
                        var idProduce = that.viewProduce(data);

                        if (!idProduce) {
                            return;
                        }

                        var s1 = mainContent ? mainContent.querySelector('select[data-clothes-groupped-attributes="' + index + '"]') : null;
                        var s2 = mainContent ? qa('div[data-clothes-groupped-attributes="' + index + '"] a[data-id-produce]', mainContent) : [];
                        var s = that.attributesGetTitleSelected(index);

                        if (s1) {
                            s1.value = idProduce;
                        }

                        var s2matched = null;
                        if (s2.length) {
                            s2.forEach(function (a) {
                                a.classList.remove('active');
                                if (a.getAttribute('data-id-produce') == idProduce) {
                                    a.classList.add('active');
                                    s2matched = a;
                                }
                            });
                        }

                        if (s1 || s2.length) {
                            if (s1) {
                                var selectedOption = s1.options[s1.selectedIndex];
                                s.forEach(function (el) { el.textContent = selectedOption ? selectedOption.textContent : ''; });
                            }
                            else if (s2matched) {
                                s.forEach(function (el) { el.textContent = s2matched.getAttribute('data-value'); });
                            }
                        }

                        cartIdProduce.forEach(function (el) {
                            el.value = idProduce;
                        });

                        if (index == 0 && attributesCount > 1) {
                            var matchedLabel = null;
                            var labels = qa('.size_av label');

                            if (currentSizeName) {
                                for (var li = 0; li < labels.length; li++) {
                                    if (labels[li].textContent.trim() === currentSizeName) {
                                        var inputId = labels[li].getAttribute('for');
                                        var input = document.querySelector('input[id="' + inputId + '"]');
                                        if (input && !input.classList.contains('pre-order')) {
                                            matchedLabel = labels[li];
                                            break;
                                        }
                                    }
                                }
                            }
                            if (!matchedLabel) {
                                var sizeInputs = qa('.size_av input[name="size_av"]');
                                for (var si = 0; si < sizeInputs.length; si++) {
                                    if (!sizeInputs[si].classList.contains('pre-order')) {
                                        matchedLabel = document.querySelector('label[for="' + sizeInputs[si].id + '"]');
                                        break;
                                    }
                                }
                            }
                            if (!matchedLabel) {
                                var firstInput = document.querySelector('.size_av input[name="size_av"]');
                                if (firstInput) {
                                    matchedLabel = document.querySelector('label[for="' + firstInput.id + '"]');
                                }
                            }
                            if (matchedLabel) {
                                matchedLabel.click();
                            }
                        }
                    })
                    .catch(function () {})
                    .finally(function () {
                        // Clean
                        if (request === controller) {
                            request = null;

                            // Disabled all
                            that.disabledAllState(!1);
                        }
                    });
            }
        }
        else {
            cartIdProduce.forEach(function (el) {
                el.value = '';
            });

            // Clean
            if (type == 'select' && mainContent) {
                var cleanSelect = mainContent.querySelector('select[data-clothes-groupped-attributes="' + index + '"]');
                if (cleanSelect) cleanSelect.value = '';
            }
        }
    };

    this.attributesGetIndex = function (element) {
        return element ? element.getAttribute('data-clothes-groupped-attributes') : null;
    };

    this.attributesGetTitleSelected = function (index) {
        return mainContent ? qa('span[data-clothes-groupped-attributes-selected="' + index + '"]', mainContent) : [];
    };

    this.attributesGetTitleSelectedPrompt = function (index) {
        return mainContent ? qa('span[data-clothes-groupped-attributes-selected-prompt="' + index + '"]', mainContent) : [];
    };

    this.attributesOnChangeEvent = function (event, firstLoad) {

        if (this.disabledAll) {
            // Skip
            return;
        }

        firstLoad = typeof firstLoad == 'undefined' || (!firstLoad) ? false : true;

        var self = this;
        var from = event.target;
        var type = event.type;

        if (self == from) {
            if (from.nodeName.toLowerCase() == 'select') {
                if ((type == 'change')) {
                    that.attributesOnChange('select',
                        that.attributesGetIndex(from),
                        from,
                        from.value,
                        firstLoad);
                }
            }
        }
        else {
            if (self.nodeName.toLowerCase() == 'div') {
                // Stop
                event.preventDefault();

                var target;
                if (from.getAttribute && from.getAttribute('data-id')) {
                    target = from;
                }
                else {
                    target = from.closest ? from.closest('a[data-id]') : null;
                }

                if (target && (!target.classList.contains('active') || true === firstLoad)) {
                    var targetIdProduce = target.getAttribute('data-id-produce');
                    var index = that.attributesGetIndex(self);

                    that.attributesOnChange('a',
                        index,
                        target,
                        targetIdProduce,
                        firstLoad);
                }
            }
        }
    };

    // Обёртка: delegate передаёт target вторым аргументом, а он бы
    // трактовался как firstLoad
    var attributesEventProxy = function (event) {
        return that.attributesOnChangeEvent.call(this, event);
    };

    delegate('change', attributesSelector, attributesEventProxy);
    delegate('click', attributesSelector, attributesEventProxy);
    delegate('change', attributesMirrorsSelector, attributesEventProxy);
    delegate('click', attributesMirrorsSelector, attributesEventProxy);

    bindEventOnOtherColors();

    // Наведение на вариант-картинку: подставляем его название в подпись и,
    // если задан data-main-image, временно показываем его фото в главном
    // изображении (восстанавливаем при уходе).
    var groupHoverSelector = '[data-clothes-groupped-attributes] a[data-id]';

    function detachMainImageError(img) {
        if (img._gvErrorHandler) {
            img.removeEventListener('error', img._gvErrorHandler);
            img._gvErrorHandler = null;
        }
    }

    document.addEventListener('mouseover', function (e) {
        var target = e.target && e.target.closest ? e.target.closest(groupHoverSelector) : null;
        if (!target || (e.relatedTarget && target.contains(e.relatedTarget))) return;

        var index = that.attributesGetIndex(target.closest('[data-clothes-groupped-attributes]'));

        if (index) {
            that.attributesGetTitleSelected(index).forEach(function (el) { el.classList.add('hidden'); });
            that.attributesGetTitleSelectedPrompt(index).forEach(function (el) {
                el.textContent = target.getAttribute('data-value');
                el.classList.remove('hidden');
            });
        }

        var preview = target.getAttribute('data-main-image');
        if (preview) {
            var img = document.getElementById('main-image-zoom');
            if (img) {
                var current = img.getAttribute('src') || '';
                // data-main-image отдаёт мелкий размер (_140) — подгоняем его под размер
                // главной картинки (_1000), иначе фото выводится крошечным.
                var sizeMatch = current.match(/_(\d+)\.\w+(?:\?.*)?$/);
                if (sizeMatch) preview = preview.replace(/_\d+(\.\w+(?:\?.*)?)$/, '_' + sizeMatch[1] + '$1');
                if (mainImageSavedSrc === null) mainImageSavedSrc = current;
                // если крупной версии нет — откатываемся к исходной, чтобы не мигала битая картинка
                var restore = mainImageSavedSrc;
                detachMainImageError(img);
                img._gvErrorHandler = function () { img.setAttribute('src', restore); };
                img.addEventListener('error', img._gvErrorHandler, {once: true});
                img.setAttribute('src', preview);
            }
        }
    });

    document.addEventListener('mouseout', function (e) {
        var target = e.target && e.target.closest ? e.target.closest(groupHoverSelector) : null;
        if (!target || (e.relatedTarget && target.contains(e.relatedTarget))) return;

        var index = that.attributesGetIndex(target.closest('[data-clothes-groupped-attributes]'));

        if (index) {
            that.attributesGetTitleSelectedPrompt(index).forEach(function (el) { el.classList.add('hidden'); });
            that.attributesGetTitleSelected(index).forEach(function (el) { el.classList.remove('hidden'); });
        }

        if (mainImageSavedSrc !== null) {
            var img = document.getElementById('main-image-zoom');
            if (img) {
                detachMainImageError(img);
                img.setAttribute('src', mainImageSavedSrc);
            }
            mainImageSavedSrc = null;
        }
    });

    var validateSelection = function () {
        if (cartButtonMessage) cartButtonMessage.innerHTML = '';

        // Заранее активный размер (checked-радио уже на загрузке) считаем выбранным —
        // иначе гейт требует «выбрать размер», хотя он визуально уже выбран.
        var selectedCount = attributesSelected.length;
        if (selectedCount >= attributesCount - 1 && selectedCount < attributesCount && document.querySelector('input[name="size_av"]:checked')) {
            selectedCount = attributesCount;
        }

        if (selectedCount < attributesCount) {
            var titles = [];

            attributes.forEach(function (el, index) {
                if ((attributesSelected.length - 1) < index) {
                    var prev = el.previousElementSibling;

                    if (prev && prev.matches('div.title')) {
                        var span = prev.querySelector('span');
                        if (span) {
                            titles.push(span.textContent);
                        }
                    }
                }
            });

            if (titles.length && cartButtonMessage) {
                cartButtonMessage.innerHTML = 'Необходимо выбрать <mark>' + (titles.join('</mark> и <mark>')) + '</mark>';
            }

            // Fail
            return false;
        }

        return true;
    };

    // Морф-кнопка добавления вызывает этот гейт перед добавлением вариантного товара
    window.flipCartGate = validateSelection;

    if (cartButton) {
        delegate('click', '#cart_button', function () {
            return validateSelection();
        });
    }

    // Zoom
    this.initZoom();

    // First load
    if (attributesCount) {
        // Select active
        var fakeEvent = function (target, type) {
            return {target: target, type: type, preventDefault: function () {}};
        };

        var firstDiv = attributes.find(function (el) {
            return el.nodeName.toLowerCase() == 'div' && el.getAttribute('data-clothes-groupped-attributes') === '0';
        });
        if (firstDiv) {
            var activeImg = firstDiv.querySelector('a.active img');
            if (activeImg) {
                that.attributesOnChangeEvent.call(firstDiv, fakeEvent(activeImg, 'click'), true);
            }
        }

        var firstSelect = attributes.find(function (el) {
            return el.nodeName.toLowerCase() == 'select' && el.getAttribute('data-clothes-groupped-attributes') === '0';
        });
        if (firstSelect) {
            that.attributesOnChangeEvent.call(firstSelect, fakeEvent(firstSelect, 'change'), true);
        }
    }

});
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).Cropper=e()}(this,function(){"use strict";function C(e,t){var i,a=Object.keys(e);return Object.getOwnPropertySymbols&&(i=Object.getOwnPropertySymbols(e),t&&(i=i.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),a.push.apply(a,i)),a}function S(a){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?C(Object(n),!0).forEach(function(t){var e,i;e=a,i=n[t=t],(t=D(t))in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i}):Object.getOwnPropertyDescriptors?Object.defineProperties(a,Object.getOwnPropertyDescriptors(n)):C(Object(n)).forEach(function(t){Object.defineProperty(a,t,Object.getOwnPropertyDescriptor(n,t))})}return a}function D(t){t=function(t,e){if("object"!=typeof t||!t)return t;var i=t[Symbol.toPrimitive];if(void 0===i)return("string"===e?String:Number)(t);if("object"!=typeof(i=i.call(t,e||"default")))return i;throw new TypeError("@@toPrimitive must return a primitive value.")}(t,"string");return"symbol"==typeof t?t:t+""}function j(t){return(j="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function A(t,e){for(var i=0;i<e.length;i++){var a=e[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(t,D(a.key),a)}}function P(t){return function(t){if(Array.isArray(t))return a(t)}(t)||function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)}(t)||function(t,e){var i;if(t)return"string"==typeof t?a(t,e):"Map"===(i="Object"===(i=Object.prototype.toString.call(t).slice(8,-1))&&t.constructor?t.constructor.name:i)||"Set"===i?Array.from(t):"Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)?a(t,e):void 0}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function a(t,e){(null==e||e>t.length)&&(e=t.length);for(var i=0,a=new Array(e);i<e;i++)a[i]=t[i];return a}var t="undefined"!=typeof window&&void 0!==window.document,h=t?window:{},e=!(!t||!h.document.documentElement)&&"ontouchstart"in h.document.documentElement,i=t&&"PointerEvent"in h,c="cropper",I="all",U="crop",q="move",$="zoom",B="e",k="w",O="s",T="n",E="ne",W="nw",H="se",N="sw",Q="".concat(c,"-crop"),K="".concat(c,"-disabled"),L="".concat(c,"-hidden"),Z="".concat(c,"-hide"),G="".concat(c,"-invisible"),n="".concat(c,"-modal"),V="".concat(c,"-move"),d="".concat(c,"Action"),m="".concat(c,"Preview"),F="crop",J="move",_="none",tt="crop",et="cropend",it="cropmove",at="cropstart",nt="dblclick",ot=i?"pointerdown":e?"touchstart":"mousedown",ht=i?"pointermove":e?"touchmove":"mousemove",rt=i?"pointerup pointercancel":e?"touchend touchcancel":"mouseup",st="zoom",ct="image/jpeg",dt=/^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/,lt=/^data:/,pt=/^data:image\/jpeg;base64,/,mt=/^img|canvas$/i,ut={viewMode:0,dragMode:F,initialAspectRatio:NaN,aspectRatio:NaN,data:null,preview:"",responsive:!0,restore:!0,checkCrossOrigin:!0,checkOrientation:!0,modal:!0,guides:!0,center:!0,highlight:!0,background:!0,autoCrop:!0,autoCropArea:.8,movable:!0,rotatable:!0,scalable:!0,zoomable:!0,zoomOnTouch:!0,zoomOnWheel:!0,wheelZoomRatio:.1,cropBoxMovable:!0,cropBoxResizable:!0,toggleDragModeOnDblclick:!0,minCanvasWidth:0,minCanvasHeight:0,minCropBoxWidth:0,minCropBoxHeight:0,minContainerWidth:200,minContainerHeight:100,ready:null,cropstart:null,cropmove:null,cropend:null,crop:null,zoom:null},gt=Number.isNaN||h.isNaN;function p(t){return"number"==typeof t&&!gt(t)}function ft(t){return 0<t&&t<1/0}function vt(t){return void 0===t}function o(t){return"object"===j(t)&&null!==t}var wt=Object.prototype.hasOwnProperty;function u(t){if(!o(t))return!1;try{var e=t.constructor,i=e.prototype;return e&&i&&wt.call(i,"isPrototypeOf")}catch(t){return!1}}function l(t){return"function"==typeof t}var bt=Array.prototype.slice;function yt(t){return Array.from?Array.from(t):bt.call(t)}function z(i,a){return i&&l(a)&&(Array.isArray(i)||p(i.length)?yt(i).forEach(function(t,e){a.call(i,t,e,i)}):o(i)&&Object.keys(i).forEach(function(t){a.call(i,i[t],t,i)})),i}var g=Object.assign||function(i){for(var t=arguments.length,e=new Array(1<t?t-1:0),a=1;a<t;a++)e[a-1]=arguments[a];return o(i)&&0<e.length&&e.forEach(function(e){o(e)&&Object.keys(e).forEach(function(t){i[t]=e[t]})}),i},xt=/\.\d*(?:0|9){12}\d*$/;function Y(t,e){e=1<arguments.length&&void 0!==e?e:1e11;return xt.test(t)?Math.round(t*e)/e:t}var Mt=/^width|height|left|top|marginLeft|marginTop$/;function f(t,e){var i=t.style;z(e,function(t,e){Mt.test(e)&&p(t)&&(t="".concat(t,"px")),i[e]=t})}function v(t,e){var i;e&&(p(t.length)?z(t,function(t){v(t,e)}):t.classList?t.classList.add(e):(i=t.className.trim())?i.indexOf(e)<0&&(t.className="".concat(i," ").concat(e)):t.className=e)}function X(t,e){e&&(p(t.length)?z(t,function(t){X(t,e)}):t.classList?t.classList.remove(e):0<=t.className.indexOf(e)&&(t.className=t.className.replace(e,"")))}function r(t,e,i){e&&(p(t.length)?z(t,function(t){r(t,e,i)}):(i?v:X)(t,e))}var Ct=/([a-z\d])([A-Z])/g;function Dt(t){return t.replace(Ct,"$1-$2").toLowerCase()}function Bt(t,e){return o(t[e])?t[e]:t.dataset?t.dataset[e]:t.getAttribute("data-".concat(Dt(e)))}function w(t,e,i){o(i)?t[e]=i:t.dataset?t.dataset[e]=i:t.setAttribute("data-".concat(Dt(e)),i)}var kt,Ot,Tt=/\s\s*/,Et=(Ot=!1,t&&(kt=!1,i=function(){},e=Object.defineProperty({},"once",{get:function(){return Ot=!0,kt},set:function(t){kt=t}}),h.addEventListener("test",i,e),h.removeEventListener("test",i,e)),Ot);function s(i,t,a,e){var n=3<arguments.length&&void 0!==e?e:{},o=a;t.trim().split(Tt).forEach(function(t){var e;Et||(e=i.listeners)&&e[t]&&e[t][a]&&(o=e[t][a],delete e[t][a],0===Object.keys(e[t]).length&&delete e[t],0===Object.keys(e).length)&&delete i.listeners,i.removeEventListener(t,o,n)})}function b(o,t,h,e){var r=3<arguments.length&&void 0!==e?e:{},s=h;t.trim().split(Tt).forEach(function(a){var t,n;r.once&&!Et&&(t=o.listeners,s=function(){delete n[a][h],o.removeEventListener(a,s,r);for(var t=arguments.length,e=new Array(t),i=0;i<t;i++)e[i]=arguments[i];h.apply(o,e)},(n=void 0===t?{}:t)[a]||(n[a]={}),n[a][h]&&o.removeEventListener(a,n[a][h],r),n[a][h]=s,o.listeners=n),o.addEventListener(a,s,r)})}function y(t,e,i){var a;return l(Event)&&l(CustomEvent)?a=new CustomEvent(e,{detail:i,bubbles:!0,cancelable:!0}):(a=document.createEvent("CustomEvent")).initCustomEvent(e,!0,!0,i),t.dispatchEvent(a)}function Wt(t){t=t.getBoundingClientRect();return{left:t.left+(window.pageXOffset-document.documentElement.clientLeft),top:t.top+(window.pageYOffset-document.documentElement.clientTop)}}var Ht=h.location,Nt=/^(\w+:)\/\/([^:/?#]*):?(\d*)/i;function Lt(t){t=t.match(Nt);return null!==t&&(t[1]!==Ht.protocol||t[2]!==Ht.hostname||t[3]!==Ht.port)}function zt(t){var e="timestamp=".concat((new Date).getTime());return t+(-1===t.indexOf("?")?"?":"&")+e}function x(t){var e=t.rotate,i=t.scaleX,a=t.scaleY,n=t.translateX,t=t.translateY,o=[],n=(p(n)&&0!==n&&o.push("translateX(".concat(n,"px)")),p(t)&&0!==t&&o.push("translateY(".concat(t,"px)")),p(e)&&0!==e&&o.push("rotate(".concat(e,"deg)")),p(i)&&1!==i&&o.push("scaleX(".concat(i,")")),p(a)&&1!==a&&o.push("scaleY(".concat(a,")")),o.length?o.join(" "):"none");return{WebkitTransform:n,msTransform:n,transform:n}}function M(t,e){var i=t.pageX,t=t.pageY,a={endX:i,endY:t};return e?a:S({startX:i,startY:t},a)}function R(t,e){var i,a=t.aspectRatio,n=t.height,t=t.width,e=1<arguments.length&&void 0!==e?e:"contain",o=ft(t),h=ft(n);return o&&h?(i=n*a,"contain"===e&&t<i||"cover"===e&&i<t?n=t/a:t=n*a):o?n=t/a:h&&(t=n*a),{width:t,height:n}}var Yt=String.fromCharCode;var Xt=/^data:.*,/;function Rt(t){var e,i,a,n,o,h,r,s=new DataView(t);try{if(255===s.getUint8(0)&&216===s.getUint8(1))for(var c=s.byteLength,d=2;d+1<c;){if(255===s.getUint8(d)&&225===s.getUint8(d+1)){i=d;break}d+=1}if(a=i&&(n=i+10,"Exif"===function(t,e,i){var a="";i+=e;for(var n=e;n<i;n+=1)a+=Yt(t.getUint8(n));return a}(s,i+4,4))&&((r=18761===(o=s.getUint16(n)))||19789===o)&&42===s.getUint16(n+2,r)&&8<=(h=s.getUint32(n+4,r))?n+h:a)for(var l,p=s.getUint16(a,r),m=0;m<p;m+=1)if(l=a+12*m+2,274===s.getUint16(l,r)){l+=8,e=s.getUint16(l,r),s.setUint16(l,1,r);break}}catch(t){e=1}return e}var t={render:function(){this.initContainer(),this.initCanvas(),this.initCropBox(),this.renderCanvas(),this.cropped&&this.renderCropBox()},initContainer:function(){var t=this.element,e=this.options,i=this.container,a=this.cropper,n=Number(e.minContainerWidth),e=Number(e.minContainerHeight),n=(v(a,L),X(t,L),{width:Math.max(i.offsetWidth,0<=n?n:200),height:Math.max(i.offsetHeight,0<=e?e:100)});f(a,{width:(this.containerData=n).width,height:n.height}),v(t,L),X(a,L)},initCanvas:function(){var t=this.containerData,e=this.imageData,i=this.options.viewMode,a=Math.abs(e.rotate)%180==90,n=a?e.naturalHeight:e.naturalWidth,a=a?e.naturalWidth:e.naturalHeight,e=n/a,o=t.width,h=t.height,e=(t.height*e>t.width?3===i?o=t.height*e:h=t.width/e:3===i?h=t.width/e:o=t.height*e,{aspectRatio:e,naturalWidth:n,naturalHeight:a,width:o,height:h});this.canvasData=e,this.limited=1===i||2===i,this.limitCanvas(!0,!0),e.width=Math.min(Math.max(e.width,e.minWidth),e.maxWidth),e.height=Math.min(Math.max(e.height,e.minHeight),e.maxHeight),e.left=(t.width-e.width)/2,e.top=(t.height-e.height)/2,e.oldLeft=e.left,e.oldTop=e.top,this.initialCanvasData=g({},e)},limitCanvas:function(t,e){var i=this.options,a=this.containerData,n=this.canvasData,o=this.cropBoxData,h=i.viewMode,r=n.aspectRatio,s=this.cropped&&o;t&&(t=Number(i.minCanvasWidth)||0,i=Number(i.minCanvasHeight)||0,1<h?(t=Math.max(t,a.width),i=Math.max(i,a.height),3===h&&(t<i*r?t=i*r:i=t/r)):0<h&&(t?t=Math.max(t,s?o.width:0):i?i=Math.max(i,s?o.height:0):s&&((t=o.width)<(i=o.height)*r?t=i*r:i=t/r)),t=(r=R({aspectRatio:r,width:t,height:i})).width,i=r.height,n.minWidth=t,n.minHeight=i,n.maxWidth=1/0,n.maxHeight=1/0),e&&((s?0:1)<h?(r=a.width-n.width,t=a.height-n.height,n.minLeft=Math.min(0,r),n.minTop=Math.min(0,t),n.maxLeft=Math.max(0,r),n.maxTop=Math.max(0,t),s&&this.limited&&(n.minLeft=Math.min(o.left,o.left+(o.width-n.width)),n.minTop=Math.min(o.top,o.top+(o.height-n.height)),n.maxLeft=o.left,n.maxTop=o.top,2===h)&&(n.width>=a.width&&(n.minLeft=Math.min(0,r),n.maxLeft=Math.max(0,r)),n.height>=a.height)&&(n.minTop=Math.min(0,t),n.maxTop=Math.max(0,t))):(n.minLeft=-n.width,n.minTop=-n.height,n.maxLeft=a.width,n.maxTop=a.height))},renderCanvas:function(t,e){var i,a,n,o,h=this.canvasData,r=this.imageData;e&&(e={width:r.naturalWidth*Math.abs(r.scaleX||1),height:r.naturalHeight*Math.abs(r.scaleY||1),degree:r.rotate||0},r=e.width,o=e.height,e=e.degree,i=90==(e=Math.abs(e)%180)?{width:o,height:r}:(a=e%90*Math.PI/180,i=Math.sin(a),n=r*(a=Math.cos(a))+o*i,r=r*i+o*a,90<e?{width:r,height:n}:{width:n,height:r}),a=h.width*((o=i.width)/h.naturalWidth),n=h.height*((e=i.height)/h.naturalHeight),h.left-=(a-h.width)/2,h.top-=(n-h.height)/2,h.width=a,h.height=n,h.aspectRatio=o/e,h.naturalWidth=o,h.naturalHeight=e,this.limitCanvas(!0,!1)),(h.width>h.maxWidth||h.width<h.minWidth)&&(h.left=h.oldLeft),(h.height>h.maxHeight||h.height<h.minHeight)&&(h.top=h.oldTop),h.width=Math.min(Math.max(h.width,h.minWidth),h.maxWidth),h.height=Math.min(Math.max(h.height,h.minHeight),h.maxHeight),this.limitCanvas(!1,!0),h.left=Math.min(Math.max(h.left,h.minLeft),h.maxLeft),h.top=Math.min(Math.max(h.top,h.minTop),h.maxTop),h.oldLeft=h.left,h.oldTop=h.top,f(this.canvas,g({width:h.width,height:h.height},x({translateX:h.left,translateY:h.top}))),this.renderImage(t),this.cropped&&this.limited&&this.limitCropBox(!0,!0)},renderImage:function(t){var e=this.canvasData,i=this.imageData,a=i.naturalWidth*(e.width/e.naturalWidth),n=i.naturalHeight*(e.height/e.naturalHeight);g(i,{width:a,height:n,left:(e.width-a)/2,top:(e.height-n)/2}),f(this.image,g({width:i.width,height:i.height},x(g({translateX:i.left,translateY:i.top},i)))),t&&this.output()},initCropBox:function(){var t=this.options,e=this.canvasData,i=t.aspectRatio||t.initialAspectRatio,t=Number(t.autoCropArea)||.8,a={width:e.width,height:e.height};i&&(e.height*i>e.width?a.height=a.width/i:a.width=a.height*i),this.cropBoxData=a,this.limitCropBox(!0,!0),a.width=Math.min(Math.max(a.width,a.minWidth),a.maxWidth),a.height=Math.min(Math.max(a.height,a.minHeight),a.maxHeight),a.width=Math.max(a.minWidth,a.width*t),a.height=Math.max(a.minHeight,a.height*t),a.left=e.left+(e.width-a.width)/2,a.top=e.top+(e.height-a.height)/2,a.oldLeft=a.left,a.oldTop=a.top,this.initialCropBoxData=g({},a)},limitCropBox:function(t,e){var i,a,n=this.options,o=this.containerData,h=this.canvasData,r=this.cropBoxData,s=this.limited,c=n.aspectRatio;t&&(t=Number(n.minCropBoxWidth)||0,n=Number(n.minCropBoxHeight)||0,i=s?Math.min(o.width,h.width,h.width+h.left,o.width-h.left):o.width,a=s?Math.min(o.height,h.height,h.height+h.top,o.height-h.top):o.height,t=Math.min(t,o.width),n=Math.min(n,o.height),c&&(t&&n?t<n*c?n=t/c:t=n*c:t?n=t/c:n&&(t=n*c),i<a*c?a=i/c:i=a*c),r.minWidth=Math.min(t,i),r.minHeight=Math.min(n,a),r.maxWidth=i,r.maxHeight=a),e&&(s?(r.minLeft=Math.max(0,h.left),r.minTop=Math.max(0,h.top),r.maxLeft=Math.min(o.width,h.left+h.width)-r.width,r.maxTop=Math.min(o.height,h.top+h.height)-r.height):(r.minLeft=0,r.minTop=0,r.maxLeft=o.width-r.width,r.maxTop=o.height-r.height))},renderCropBox:function(){var t=this.options,e=this.containerData,i=this.cropBoxData;(i.width>i.maxWidth||i.width<i.minWidth)&&(i.left=i.oldLeft),(i.height>i.maxHeight||i.height<i.minHeight)&&(i.top=i.oldTop),i.width=Math.min(Math.max(i.width,i.minWidth),i.maxWidth),i.height=Math.min(Math.max(i.height,i.minHeight),i.maxHeight),this.limitCropBox(!1,!0),i.left=Math.min(Math.max(i.left,i.minLeft),i.maxLeft),i.top=Math.min(Math.max(i.top,i.minTop),i.maxTop),i.oldLeft=i.left,i.oldTop=i.top,t.movable&&t.cropBoxMovable&&w(this.face,d,i.width>=e.width&&i.height>=e.height?q:I),f(this.cropBox,g({width:i.width,height:i.height},x({translateX:i.left,translateY:i.top}))),this.cropped&&this.limited&&this.limitCanvas(!0,!0),this.disabled||this.output()},output:function(){this.preview(),y(this.element,tt,this.getData())}},i={initPreview:function(){var t=this.element,i=this.crossOrigin,e=this.options.preview,a=i?this.crossOriginUrl:this.url,n=t.alt||"The image to preview",o=document.createElement("img");i&&(o.crossOrigin=i),o.src=a,o.alt=n,this.viewBox.appendChild(o),this.viewBoxImage=o,e&&("string"==typeof(o=e)?o=t.ownerDocument.querySelectorAll(e):e.querySelector&&(o=[e]),z(this.previews=o,function(t){var e=document.createElement("img");w(t,m,{width:t.offsetWidth,height:t.offsetHeight,html:t.innerHTML}),i&&(e.crossOrigin=i),e.src=a,e.alt=n,e.style.cssText='display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"',t.innerHTML="",t.appendChild(e)}))},resetPreview:function(){z(this.previews,function(e){var i=Bt(e,m),i=(f(e,{width:i.width,height:i.height}),e.innerHTML=i.html,e),e=m;if(o(i[e]))try{delete i[e]}catch(t){i[e]=void 0}else if(i.dataset)try{delete i.dataset[e]}catch(t){i.dataset[e]=void 0}else i.removeAttribute("data-".concat(Dt(e)))})},preview:function(){var h=this.imageData,t=this.canvasData,e=this.cropBoxData,r=e.width,s=e.height,c=h.width,d=h.height,l=e.left-t.left-h.left,p=e.top-t.top-h.top;this.cropped&&!this.disabled&&(f(this.viewBoxImage,g({width:c,height:d},x(g({translateX:-l,translateY:-p},h)))),z(this.previews,function(t){var e=Bt(t,m),i=e.width,e=e.height,a=i,n=e,o=1;r&&(n=s*(o=i/r)),s&&e<n&&(a=r*(o=e/s),n=e),f(t,{width:a,height:n}),f(t.getElementsByTagName("img")[0],g({width:c*o,height:d*o},x(g({translateX:-l*o,translateY:-p*o},h))))}))}},e={bind:function(){var t=this.element,e=this.options,i=this.cropper;l(e.cropstart)&&b(t,at,e.cropstart),l(e.cropmove)&&b(t,it,e.cropmove),l(e.cropend)&&b(t,et,e.cropend),l(e.crop)&&b(t,tt,e.crop),l(e.zoom)&&b(t,st,e.zoom),b(i,ot,this.onCropStart=this.cropStart.bind(this)),e.zoomable&&e.zoomOnWheel&&b(i,"wheel",this.onWheel=this.wheel.bind(this),{passive:!1,capture:!0}),e.toggleDragModeOnDblclick&&b(i,nt,this.onDblclick=this.dblclick.bind(this)),b(t.ownerDocument,ht,this.onCropMove=this.cropMove.bind(this)),b(t.ownerDocument,rt,this.onCropEnd=this.cropEnd.bind(this)),e.responsive&&b(window,"resize",this.onResize=this.resize.bind(this))},unbind:function(){var t=this.element,e=this.options,i=this.cropper;l(e.cropstart)&&s(t,at,e.cropstart),l(e.cropmove)&&s(t,it,e.cropmove),l(e.cropend)&&s(t,et,e.cropend),l(e.crop)&&s(t,tt,e.crop),l(e.zoom)&&s(t,st,e.zoom),s(i,ot,this.onCropStart),e.zoomable&&e.zoomOnWheel&&s(i,"wheel",this.onWheel,{passive:!1,capture:!0}),e.toggleDragModeOnDblclick&&s(i,nt,this.onDblclick),s(t.ownerDocument,ht,this.onCropMove),s(t.ownerDocument,rt,this.onCropEnd),e.responsive&&s(window,"resize",this.onResize)}},St={resize:function(){var t,e,i,a,n,o,h;this.disabled||(t=this.options,a=this.container,e=this.containerData,i=a.offsetWidth/e.width,a=a.offsetHeight/e.height,1!=(n=Math.abs(i-1)>Math.abs(a-1)?i:a)&&(t.restore&&(o=this.getCanvasData(),h=this.getCropBoxData()),this.render(),t.restore)&&(this.setCanvasData(z(o,function(t,e){o[e]=t*n})),this.setCropBoxData(z(h,function(t,e){h[e]=t*n}))))},dblclick:function(){var t,e;this.disabled||this.options.dragMode===_||this.setDragMode((t=this.dragBox,e=Q,(t.classList?t.classList.contains(e):-1<t.className.indexOf(e))?J:F))},wheel:function(t){var e=this,i=Number(this.options.wheelZoomRatio)||.1,a=1;this.disabled||(t.preventDefault(),this.wheeling)||(this.wheeling=!0,setTimeout(function(){e.wheeling=!1},50),t.deltaY?a=0<t.deltaY?1:-1:t.wheelDelta?a=-t.wheelDelta/120:t.detail&&(a=0<t.detail?1:-1),this.zoom(-a*i,t))},cropStart:function(t){var e,i=t.buttons,a=t.button;this.disabled||("mousedown"===t.type||"pointerdown"===t.type&&"mouse"===t.pointerType)&&(p(i)&&1!==i||p(a)&&0!==a||t.ctrlKey)||(i=this.options,e=this.pointers,t.changedTouches?z(t.changedTouches,function(t){e[t.identifier]=M(t)}):e[t.pointerId||0]=M(t),a=1<Object.keys(e).length&&i.zoomable&&i.zoomOnTouch?$:Bt(t.target,d),dt.test(a)&&!1!==y(this.element,at,{originalEvent:t,action:a})&&(t.preventDefault(),this.action=a,this.cropping=!1,a===U)&&(this.cropping=!0,v(this.dragBox,n)))},cropMove:function(t){var e,i=this.action;!this.disabled&&i&&(e=this.pointers,t.preventDefault(),!1!==y(this.element,it,{originalEvent:t,action:i}))&&(t.changedTouches?z(t.changedTouches,function(t){g(e[t.identifier]||{},M(t,!0))}):g(e[t.pointerId||0]||{},M(t,!0)),this.change(t))},cropEnd:function(t){var e,i;this.disabled||(e=this.action,i=this.pointers,t.changedTouches?z(t.changedTouches,function(t){delete i[t.identifier]}):delete i[t.pointerId||0],e&&(t.preventDefault(),Object.keys(i).length||(this.action=""),this.cropping&&(this.cropping=!1,r(this.dragBox,n,this.cropped&&this.options.modal)),y(this.element,et,{originalEvent:t,action:e})))}},jt={change:function(t){function e(t){switch(t){case B:f+D.x>y&&(D.x=y-f);break;case k:p+D.x<w&&(D.x=w-p);break;case T:m+D.y<b&&(D.y=b-m);break;case O:v+D.y>x&&(D.y=x-v)}}var i,a,o,n=this.options,h=this.canvasData,r=this.containerData,s=this.cropBoxData,c=this.pointers,d=this.action,l=n.aspectRatio,p=s.left,m=s.top,u=s.width,g=s.height,f=p+u,v=m+g,w=0,b=0,y=r.width,x=r.height,M=!0,C=(!l&&t.shiftKey&&(l=u&&g?u/g:1),this.limited&&(w=s.minLeft,b=s.minTop,y=w+Math.min(r.width,h.width,h.left+h.width),x=b+Math.min(r.height,h.height,h.top+h.height)),c[Object.keys(c)[0]]),D={x:C.endX-C.startX,y:C.endY-C.startY};switch(d){case I:p+=D.x,m+=D.y;break;case B:0<=D.x&&(y<=f||l&&(m<=b||x<=v))?M=!1:(e(B),(u+=D.x)<0&&(d=k,p-=u=-u),l&&(m+=(s.height-(g=u/l))/2));break;case T:D.y<=0&&(m<=b||l&&(p<=w||y<=f))?M=!1:(e(T),g-=D.y,m+=D.y,g<0&&(d=O,m-=g=-g),l&&(p+=(s.width-(u=g*l))/2));break;case k:D.x<=0&&(p<=w||l&&(m<=b||x<=v))?M=!1:(e(k),u-=D.x,p+=D.x,u<0&&(d=B,p-=u=-u),l&&(m+=(s.height-(g=u/l))/2));break;case O:0<=D.y&&(x<=v||l&&(p<=w||y<=f))?M=!1:(e(O),(g+=D.y)<0&&(d=T,m-=g=-g),l&&(p+=(s.width-(u=g*l))/2));break;case E:if(l){if(D.y<=0&&(m<=b||y<=f)){M=!1;break}e(T),g-=D.y,m+=D.y,u=g*l}else e(T),e(B),!(0<=D.x)||f<y?u+=D.x:D.y<=0&&m<=b&&(M=!1),(!(D.y<=0)||b<m)&&(g-=D.y,m+=D.y);u<0&&g<0?(d=N,m-=g=-g,p-=u=-u):u<0?(d=W,p-=u=-u):g<0&&(d=H,m-=g=-g);break;case W:if(l){if(D.y<=0&&(m<=b||p<=w)){M=!1;break}e(T),g-=D.y,m+=D.y,p+=s.width-(u=g*l)}else e(T),e(k),!(D.x<=0)||w<p?(u-=D.x,p+=D.x):D.y<=0&&m<=b&&(M=!1),(!(D.y<=0)||b<m)&&(g-=D.y,m+=D.y);u<0&&g<0?(d=H,m-=g=-g,p-=u=-u):u<0?(d=E,p-=u=-u):g<0&&(d=N,m-=g=-g);break;case N:if(l){if(D.x<=0&&(p<=w||x<=v)){M=!1;break}e(k),u-=D.x,p+=D.x,g=u/l}else e(O),e(k),!(D.x<=0)||w<p?(u-=D.x,p+=D.x):0<=D.y&&x<=v&&(M=!1),(!(0<=D.y)||v<x)&&(g+=D.y);u<0&&g<0?(d=E,m-=g=-g,p-=u=-u):u<0?(d=H,p-=u=-u):g<0&&(d=W,m-=g=-g);break;case H:if(l){if(0<=D.x&&(y<=f||x<=v)){M=!1;break}e(B),g=(u+=D.x)/l}else e(O),e(B),!(0<=D.x)||f<y?u+=D.x:0<=D.y&&x<=v&&(M=!1),(!(0<=D.y)||v<x)&&(g+=D.y);u<0&&g<0?(d=W,m-=g=-g,p-=u=-u):u<0?(d=N,p-=u=-u):g<0&&(d=E,m-=g=-g);break;case q:this.move(D.x,D.y),M=!1;break;case $:this.zoom((a=S({},i=c),o=0,z(i,function(n,t){delete a[t],z(a,function(t){var e=Math.abs(n.startX-t.startX),i=Math.abs(n.startY-t.startY),a=Math.abs(n.endX-t.endX),t=Math.abs(n.endY-t.endY),e=Math.sqrt(e*e+i*i),i=(Math.sqrt(a*a+t*t)-e)/e;Math.abs(i)>Math.abs(o)&&(o=i)})}),o),t),M=!1;break;case U:D.x&&D.y?(i=Wt(this.cropper),p=C.startX-i.left,m=C.startY-i.top,u=s.minWidth,g=s.minHeight,0<D.x?d=0<D.y?H:E:D.x<0&&(p-=u,d=0<D.y?N:W),D.y<0&&(m-=g),this.cropped||(X(this.cropBox,L),this.cropped=!0,this.limited&&this.limitCropBox(!0,!0))):M=!1}M&&(s.width=u,s.height=g,s.left=p,s.top=m,this.action=d,this.renderCropBox()),z(c,function(t){t.startX=t.endX,t.startY=t.endY})}},At={crop:function(){return!this.ready||this.cropped||this.disabled||(this.cropped=!0,this.limitCropBox(!0,!0),this.options.modal&&v(this.dragBox,n),X(this.cropBox,L),this.setCropBoxData(this.initialCropBoxData)),this},reset:function(){return this.ready&&!this.disabled&&(this.imageData=g({},this.initialImageData),this.canvasData=g({},this.initialCanvasData),this.cropBoxData=g({},this.initialCropBoxData),this.renderCanvas(),this.cropped)&&this.renderCropBox(),this},clear:function(){return this.cropped&&!this.disabled&&(g(this.cropBoxData,{left:0,top:0,width:0,height:0}),this.cropped=!1,this.renderCropBox(),this.limitCanvas(!0,!0),this.renderCanvas(),X(this.dragBox,n),v(this.cropBox,L)),this},replace:function(e){var t=1<arguments.length&&void 0!==arguments[1]&&arguments[1];return!this.disabled&&e&&(this.isImg&&(this.element.src=e),t?(this.url=e,this.image.src=e,this.ready&&(this.viewBoxImage.src=e,z(this.previews,function(t){t.getElementsByTagName("img")[0].src=e}))):(this.isImg&&(this.replaced=!0),this.options.data=null,this.uncreate(),this.load(e))),this},enable:function(){return this.ready&&this.disabled&&(this.disabled=!1,X(this.cropper,K)),this},disable:function(){return this.ready&&!this.disabled&&(this.disabled=!0,v(this.cropper,K)),this},destroy:function(){var t=this.element;return t[c]&&(t[c]=void 0,this.isImg&&this.replaced&&(t.src=this.originalUrl),this.uncreate()),this},move:function(t){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:t,i=this.canvasData,a=i.left,i=i.top;return this.moveTo(vt(t)?t:a+Number(t),vt(e)?e:i+Number(e))},moveTo:function(t){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:t,i=this.canvasData,a=!1;return t=Number(t),e=Number(e),this.ready&&!this.disabled&&this.options.movable&&(p(t)&&(i.left=t,a=!0),p(e)&&(i.top=e,a=!0),a)&&this.renderCanvas(!0),this},zoom:function(t,e){var i=this.canvasData;return t=Number(t),this.zoomTo(i.width*(t=t<0?1/(1-t):1+t)/i.naturalWidth,null,e)},zoomTo:function(t,e,i){var a,n,o,h=this.options,r=this.canvasData,s=r.width,c=r.height,d=r.naturalWidth,l=r.naturalHeight;if(0<=(t=Number(t))&&this.ready&&!this.disabled&&h.zoomable){h=d*t,l=l*t;if(!1===y(this.element,st,{ratio:t,oldRatio:s/d,originalEvent:i}))return this;i?(t=this.pointers,d=Wt(this.cropper),t=t&&Object.keys(t).length?(o=n=a=0,z(t,function(t){var e=t.startX,t=t.startY;a+=e,n+=t,o+=1}),{pageX:a/=o,pageY:n/=o}):{pageX:i.pageX,pageY:i.pageY},r.left-=(h-s)*((t.pageX-d.left-r.left)/s),r.top-=(l-c)*((t.pageY-d.top-r.top)/c)):u(e)&&p(e.x)&&p(e.y)?(r.left-=(h-s)*((e.x-r.left)/s),r.top-=(l-c)*((e.y-r.top)/c)):(r.left-=(h-s)/2,r.top-=(l-c)/2),r.width=h,r.height=l,this.renderCanvas(!0)}return this},rotate:function(t){return this.rotateTo((this.imageData.rotate||0)+Number(t))},rotateTo:function(t){return p(t=Number(t))&&this.ready&&!this.disabled&&this.options.rotatable&&(this.imageData.rotate=t%360,this.renderCanvas(!0,!0)),this},scaleX:function(t){var e=this.imageData.scaleY;return this.scale(t,p(e)?e:1)},scaleY:function(t){var e=this.imageData.scaleX;return this.scale(p(e)?e:1,t)},scale:function(t){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:t,i=this.imageData,a=!1;return t=Number(t),e=Number(e),this.ready&&!this.disabled&&this.options.scalable&&(p(t)&&(i.scaleX=t,a=!0),p(e)&&(i.scaleY=e,a=!0),a)&&this.renderCanvas(!0,!0),this},getData:function(){var i,a,t=0<arguments.length&&void 0!==arguments[0]&&arguments[0],e=this.options,n=this.imageData,o=this.canvasData,h=this.cropBoxData;return this.ready&&this.cropped?(i={x:h.left-o.left,y:h.top-o.top,width:h.width,height:h.height},a=n.width/n.naturalWidth,z(i,function(t,e){i[e]=t/a}),t&&(o=Math.round(i.y+i.height),h=Math.round(i.x+i.width),i.x=Math.round(i.x),i.y=Math.round(i.y),i.width=h-i.x,i.height=o-i.y)):i={x:0,y:0,width:0,height:0},e.rotatable&&(i.rotate=n.rotate||0),e.scalable&&(i.scaleX=n.scaleX||1,i.scaleY=n.scaleY||1),i},setData:function(t){var e,i=this.options,a=this.imageData,n=this.canvasData,o={};return this.ready&&!this.disabled&&u(t)&&(e=!1,i.rotatable&&p(t.rotate)&&t.rotate!==a.rotate&&(a.rotate=t.rotate,e=!0),i.scalable&&(p(t.scaleX)&&t.scaleX!==a.scaleX&&(a.scaleX=t.scaleX,e=!0),p(t.scaleY))&&t.scaleY!==a.scaleY&&(a.scaleY=t.scaleY,e=!0),e&&this.renderCanvas(!0,!0),i=a.width/a.naturalWidth,p(t.x)&&(o.left=t.x*i+n.left),p(t.y)&&(o.top=t.y*i+n.top),p(t.width)&&(o.width=t.width*i),p(t.height)&&(o.height=t.height*i),this.setCropBoxData(o)),this},getContainerData:function(){return this.ready?g({},this.containerData):{}},getImageData:function(){return this.sized?g({},this.imageData):{}},getCanvasData:function(){var e=this.canvasData,i={};return this.ready&&z(["left","top","width","height","naturalWidth","naturalHeight"],function(t){i[t]=e[t]}),i},setCanvasData:function(t){var e=this.canvasData,i=e.aspectRatio;return this.ready&&!this.disabled&&u(t)&&(p(t.left)&&(e.left=t.left),p(t.top)&&(e.top=t.top),p(t.width)?(e.width=t.width,e.height=t.width/i):p(t.height)&&(e.height=t.height,e.width=t.height*i),this.renderCanvas(!0)),this},getCropBoxData:function(){var t,e=this.cropBoxData;return(t=this.ready&&this.cropped?{left:e.left,top:e.top,width:e.width,height:e.height}:t)||{}},setCropBoxData:function(t){var e,i,a=this.cropBoxData,n=this.options.aspectRatio;return this.ready&&this.cropped&&!this.disabled&&u(t)&&(p(t.left)&&(a.left=t.left),p(t.top)&&(a.top=t.top),p(t.width)&&t.width!==a.width&&(e=!0,a.width=t.width),p(t.height)&&t.height!==a.height&&(i=!0,a.height=t.height),n&&(e?a.height=a.width/n:i&&(a.width=a.height*n)),this.renderCropBox()),this},getCroppedCanvas:function(){var t,e,i,a,n,o,h,r,s,c,d,l,p,m,u,g,f,v,w,b,y,x,M,C,D,B,k,O=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};return this.ready&&window.HTMLCanvasElement?(B=this.canvasData,u=this.image,l=this.imageData,a=B,v=O,g=l.aspectRatio,e=l.naturalWidth,n=l.naturalHeight,c=void 0===(c=l.rotate)?0:c,d=void 0===(d=l.scaleX)?1:d,l=void 0===(l=l.scaleY)?1:l,i=a.aspectRatio,r=a.naturalWidth,a=a.naturalHeight,h=void 0===(h=v.fillColor)?"transparent":h,p=void 0===(p=v.imageSmoothingEnabled)||p,m=void 0===(m=v.imageSmoothingQuality)?"low":m,o=void 0===(o=v.maxWidth)?1/0:o,k=void 0===(k=v.maxHeight)?1/0:k,t=void 0===(t=v.minWidth)?0:t,v=void 0===(v=v.minHeight)?0:v,w=document.createElement("canvas"),f=w.getContext("2d"),s=R({aspectRatio:i,width:o,height:k}),i=R({aspectRatio:i,width:t,height:v},"cover"),r=Math.min(s.width,Math.max(i.width,r)),s=Math.min(s.height,Math.max(i.height,a)),i=R({aspectRatio:g,width:o,height:k}),a=R({aspectRatio:g,width:t,height:v},"cover"),o=Math.min(i.width,Math.max(a.width,e)),k=Math.min(i.height,Math.max(a.height,n)),g=[-o/2,-k/2,o,k],w.width=Y(r),w.height=Y(s),f.fillStyle=h,f.fillRect(0,0,r,s),f.save(),f.translate(r/2,s/2),f.rotate(c*Math.PI/180),f.scale(d,l),f.imageSmoothingEnabled=p,f.imageSmoothingQuality=m,f.drawImage.apply(f,[u].concat(P(g.map(function(t){return Math.floor(Y(t))})))),f.restore(),t=w,this.cropped?(e=(v=this.getData(O.rounded)).x,i=v.y,a=v.width,n=v.height,1!=(o=t.width/Math.floor(B.naturalWidth))&&(e*=o,i*=o,a*=o,n*=o),h=R({aspectRatio:k=a/n,width:O.maxWidth||1/0,height:O.maxHeight||1/0}),r=R({aspectRatio:k,width:O.minWidth||0,height:O.minHeight||0},"cover"),c=(s=R({aspectRatio:k,width:O.width||(1!=o?t.width:a),height:O.height||(1!=o?t.height:n)})).width,d=s.height,c=Math.min(h.width,Math.max(r.width,c)),d=Math.min(h.height,Math.max(r.height,d)),p=(l=document.createElement("canvas")).getContext("2d"),l.width=Y(c),l.height=Y(d),p.fillStyle=O.fillColor||"transparent",p.fillRect(0,0,c,d),m=O.imageSmoothingEnabled,u=O.imageSmoothingQuality,p.imageSmoothingEnabled=void 0===m||m,u&&(p.imageSmoothingQuality=u),g=t.width,f=t.height,w=i,(v=e)<=-a||g<v?C=x=b=v=0:v<=0?(x=-v,v=0,C=b=Math.min(g,a+v)):v<=g&&(x=0,C=b=Math.min(a,g-v)),b<=0||w<=-n||f<w?D=M=y=w=0:w<=0?(M=-w,w=0,D=y=Math.min(f,n+w)):w<=f&&(M=0,D=y=Math.min(n,f-w)),B=[v,w,b,y],0<C&&0<D&&B.push(x*(k=c/a),M*k,C*k,D*k),p.drawImage.apply(p,[t].concat(P(B.map(function(t){return Math.floor(Y(t))})))),l):t):null},setAspectRatio:function(t){var e=this.options;return this.disabled||vt(t)||(e.aspectRatio=Math.max(0,t)||NaN,this.ready&&(this.initCropBox(),this.cropped)&&this.renderCropBox()),this},setDragMode:function(t){var e,i,a=this.options,n=this.dragBox,o=this.face;return this.ready&&!this.disabled&&(i=a.movable&&t===J,a.dragMode=t=(e=t===F)||i?t:_,w(n,d,t),r(n,Q,e),r(n,V,i),a.cropBoxMovable||(w(o,d,t),r(o,Q,e),r(o,V,i))),this}},Pt=h.Cropper,It=function(){function n(t){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},i=this,a=n;if(!(i instanceof a))throw new TypeError("Cannot call a class as a function");if(!t||!mt.test(t.tagName))throw new Error("The first argument is required and must be an <img> or <canvas> element.");this.element=t,this.options=g({},ut,u(e)&&e),this.cropped=!1,this.disabled=!1,this.pointers={},this.ready=!1,this.reloading=!1,this.replaced=!1,this.sized=!1,this.sizing=!1,this.init()}return t=n,i=[{key:"noConflict",value:function(){return window.Cropper=Pt,n}},{key:"setDefaults",value:function(t){g(ut,u(t)&&t)}}],(e=[{key:"init",value:function(){var t,e=this.element,i=e.tagName.toLowerCase();if(!e[c]){if(e[c]=this,"img"===i){if(this.isImg=!0,t=e.getAttribute("src")||"",!(this.originalUrl=t))return;t=e.src}else"canvas"===i&&window.HTMLCanvasElement&&(t=e.toDataURL());this.load(t)}}},{key:"load",value:function(t){var e,i,a,n,o,h,r=this;t&&(this.url=t,this.imageData={},e=this.element,(i=this.options).rotatable||i.scalable||(i.checkOrientation=!1),i.checkOrientation&&window.ArrayBuffer?lt.test(t)?pt.test(t)?this.read((h=(h=t).replace(Xt,""),a=atob(h),h=new ArrayBuffer(a.length),z(n=new Uint8Array(h),function(t,e){n[e]=a.charCodeAt(e)}),h)):this.clone():(o=new XMLHttpRequest,h=this.clone.bind(this),this.reloading=!0,(this.xhr=o).onabort=h,o.onerror=h,o.ontimeout=h,o.onprogress=function(){o.getResponseHeader("content-type")!==ct&&o.abort()},o.onload=function(){r.read(o.response)},o.onloadend=function(){r.reloading=!1,r.xhr=null},i.checkCrossOrigin&&Lt(t)&&e.crossOrigin&&(t=zt(t)),o.open("GET",t,!0),o.responseType="arraybuffer",o.withCredentials="use-credentials"===e.crossOrigin,o.send()):this.clone())}},{key:"read",value:function(t){var e=this.options,i=this.imageData,a=Rt(t),n=0,o=1,h=1;1<a&&(this.url=function(t,e){for(var i=[],a=new Uint8Array(t);0<a.length;)i.push(Yt.apply(null,yt(a.subarray(0,8192)))),a=a.subarray(8192);return"data:".concat(e,";base64,").concat(btoa(i.join("")))}(t,ct),n=(t=function(t){var e=0,i=1,a=1;switch(t){case 2:i=-1;break;case 3:e=-180;break;case 4:a=-1;break;case 5:e=90,a=-1;break;case 6:e=90;break;case 7:e=90,i=-1;break;case 8:e=-90}return{rotate:e,scaleX:i,scaleY:a}}(a)).rotate,o=t.scaleX,h=t.scaleY),e.rotatable&&(i.rotate=n),e.scalable&&(i.scaleX=o,i.scaleY=h),this.clone()}},{key:"clone",value:function(){var t=this.element,e=this.url,i=t.crossOrigin,a=e,n=(this.options.checkCrossOrigin&&Lt(e)&&(i=i||"anonymous",a=zt(e)),this.crossOrigin=i,this.crossOriginUrl=a,document.createElement("img"));i&&(n.crossOrigin=i),n.src=a||e,n.alt=t.alt||"The image to crop",(this.image=n).onload=this.start.bind(this),n.onerror=this.stop.bind(this),v(n,Z),t.parentNode.insertBefore(n,t.nextSibling)}},{key:"start",value:function(){function t(t,e){g(a.imageData,{naturalWidth:t,naturalHeight:e,aspectRatio:t/e}),a.initialImageData=g({},a.imageData),a.sizing=!1,a.sized=!0,a.build()}var e,i,a=this,n=this.image,o=(n.onload=null,n.onerror=null,this.sizing=!0,h.navigator&&/(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(h.navigator.userAgent));n.naturalWidth&&!o?t(n.naturalWidth,n.naturalHeight):(e=document.createElement("img"),i=document.body||document.documentElement,(this.sizingImage=e).onload=function(){t(e.width,e.height),o||i.removeChild(e)},e.src=n.src,o||(e.style.cssText="left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;",i.appendChild(e)))}},{key:"stop",value:function(){var t=this.image;t.onload=null,t.onerror=null,t.parentNode.removeChild(t),this.image=null}},{key:"build",value:function(){var t,e,i,a,n,o,h,r,s;this.sized&&!this.ready&&(t=this.element,e=this.options,i=this.image,a=t.parentNode,(n=document.createElement("div")).innerHTML='<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>',o=(n=n.querySelector(".".concat(c,"-container"))).querySelector(".".concat(c,"-canvas")),h=n.querySelector(".".concat(c,"-drag-box")),s=(r=n.querySelector(".".concat(c,"-crop-box"))).querySelector(".".concat(c,"-face")),this.container=a,this.cropper=n,this.canvas=o,this.dragBox=h,this.cropBox=r,this.viewBox=n.querySelector(".".concat(c,"-view-box")),this.face=s,o.appendChild(i),v(t,L),a.insertBefore(n,t.nextSibling),X(i,Z),this.initPreview(),this.bind(),e.initialAspectRatio=Math.max(0,e.initialAspectRatio)||NaN,e.aspectRatio=Math.max(0,e.aspectRatio)||NaN,e.viewMode=Math.max(0,Math.min(3,Math.round(e.viewMode)))||0,v(r,L),e.guides||v(r.getElementsByClassName("".concat(c,"-dashed")),L),e.center||v(r.getElementsByClassName("".concat(c,"-center")),L),e.background&&v(n,"".concat(c,"-bg")),e.highlight||v(s,G),e.cropBoxMovable&&(v(s,V),w(s,d,I)),e.cropBoxResizable||(v(r.getElementsByClassName("".concat(c,"-line")),L),v(r.getElementsByClassName("".concat(c,"-point")),L)),this.render(),this.ready=!0,this.setDragMode(e.dragMode),e.autoCrop&&this.crop(),this.setData(e.data),l(e.ready)&&b(t,"ready",e.ready,{once:!0}),y(t,"ready"))}},{key:"unbuild",value:function(){var t;this.ready&&(this.ready=!1,this.unbind(),this.resetPreview(),(t=this.cropper.parentNode)&&t.removeChild(this.cropper),X(this.element,L))}},{key:"uncreate",value:function(){this.ready?(this.unbuild(),this.ready=!1,this.cropped=!1):this.sizing?(this.sizingImage.onload=null,this.sizing=!1,this.sized=!1):this.reloading?(this.xhr.onabort=null,this.xhr.abort()):this.image&&this.stop()}}])&&A(t.prototype,e),i&&A(t,i),Object.defineProperty(t,"prototype",{writable:!1}),t;var t,e,i}();return g(It.prototype,t,i,e,St,jt,At),It});

;(function () {
'use strict';
function flipCropperInit() {

    // Гард от двойной инициализации: cropper.js может попасть на страницу
    // и из бандла, и отдельным подключением - init должен отработать один раз
    if (window.__flipCropperInited) {
        return;
    }
    window.__flipCropperInited = true;

    var inputImage = document.getElementById('cropperInputImage');

    if (!inputImage) {
        return;
    }

    var URL = window.URL || window.webkitURL;

    if (!URL) {
        inputImage.disabled = true;
        inputImage.parentNode.className += ' disabled';
        return;
    }

    // Показ с семантикой jQuery .show(): скрытые стилем классы получают block
    var vShow = function (el) {
        if (!el) return;
        el.style.display = '';
        if (getComputedStyle(el).display === 'none') {
            el.style.display = 'block';
        }
    };

    var isKk = document.documentElement.getAttribute('lang') == 'kk';
    var l10n = isKk ? {
        title: 'Жаңа фото',
        hint: 'Фотоны жылжытып, масштабын реттеңіз',
        zoom: 'Масштаб',
        save: 'Сақтау',
        cancel: 'Бас тарту',
        tooSmall: 'Фото тым кішкентай — кемінде 110 × 110 пиксель қажет',
        notImage: 'Сурет файлын таңдаңыз',
        uploadFailed: 'Суретті жүктеу мүмкін болмады. Кішірек файлды жүктеп көріңіз'
    } : {
        title: 'Новое фото',
        hint: 'Перетащите фото и настройте масштаб',
        zoom: 'Масштаб',
        save: 'Сохранить',
        cancel: 'Отмена',
        tooSmall: 'Фото слишком маленькое — нужно не меньше 110 × 110 пикселей',
        notImage: 'Пожалуйста, выберите файл с картинкой',
        uploadFailed: 'Не удалось загрузить изображение. Попробуйте загрузить файл меньшего размера'
    };

    var dataURLtoBlob = function(dataurl) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {type: mime});
    };

    var preloader = document.createElement('img');
    preloader.setAttribute('src', '/img/loader.gif');

    var chooseButton = document.getElementById('cropperChooseButton');
    if (chooseButton) {
        chooseButton.addEventListener('click', function () {
            inputImage.click();
        });
    }

    var cropper = null;
    var baseZoom = null;
    var zoomSyncing = false;
    var uploadedImageURL;
    var MAX_ZOOM_FACTOR = 3;

    var destroyCropper = function(){
        if (cropper) {
            cropper.destroy();
            cropper = null;
        }
        baseZoom = null;
    };

    var uploadAvatar = function(canvas){
        var result = document.getElementById('cropperResult');
        if (result) result.replaceChildren(preloader);

        var formData = new FormData();
        var xhr = new XMLHttpRequest();

        formData.append('avatar', dataURLtoBlob(canvas.toDataURL('image/jpeg', 0.92)), 'avatar.jpg');

        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                var url = null;
                try {
                    url = JSON.parse(xhr.responseText);
                } catch (e) {}
                if (xhr.status === 200 && url) {
                    var img = document.createElement('img');
                    img.setAttribute('src', url);
                    if (result) result.replaceChildren(img);
                    document.querySelectorAll('.ath .img').forEach(function (el) {
                        el.style.backgroundImage = 'url(' + url + ')';
                    });
                } else {
                    if (result) result.replaceChildren();
                    showMessage(l10n.uploadFailed);
                }
            }
        };
        xhr.open('POST', '/user?personalis=person', true);
        xhr.send(formData);
    };

    var startCropper = function(file){
        var image = document.getElementById('croppedImage');
        var slider = document.getElementById('cropZoomSlider');

        image.onerror = function(){
            if (image.parentElement) image.parentElement.classList.remove('crop-loading');
            var cropError = document.getElementById('cropError');
            if (cropError) {
                cropError.textContent = l10n.notImage;
                vShow(cropError);
            }
        };

        if (uploadedImageURL) {
            URL.revokeObjectURL(uploadedImageURL);
        }
        image.src = uploadedImageURL = URL.createObjectURL(file);

        destroyCropper();

        cropper = new Cropper(image, {
            aspectRatio: 1,
            viewMode: 1,
            dragMode: 'move',
            autoCropArea: 0.9,
            guides: false,
            center: false,
            highlight: false,
            background: false,
            responsive: true,
            toggleDragModeOnDblclick: false,
            cropBoxMovable: false,
            cropBoxResizable: false,
            ready: function(){
                var canvasData = cropper.getCanvasData();
                baseZoom = canvasData.width / canvasData.naturalWidth;
                if (image.parentElement) image.parentElement.classList.remove('crop-loading');
            },
            zoom: function(e){
                if (baseZoom === null || zoomSyncing) {
                    return;
                }
                // Не даём уменьшить фото меньше вписанного размера
                if (e.detail.ratio < baseZoom - 1e-9) {
                    e.preventDefault();
                    zoomSyncing = true;
                    cropper.zoomTo(baseZoom);
                    zoomSyncing = false;
                    slider.value = 0;
                    return;
                }
                var factor = Math.min(e.detail.ratio / baseZoom, MAX_ZOOM_FACTOR);
                slider.value = Math.round((factor - 1) / (MAX_ZOOM_FACTOR - 1) * 100);
            }
        });

        slider.addEventListener('input', function(){
            if (!cropper || baseZoom === null) {
                return;
            }
            var factor = 1 + (this.value / 100) * (MAX_ZOOM_FACTOR - 1);
            zoomSyncing = true;
            cropper.zoomTo(baseZoom * factor);
            zoomSyncing = false;
        });

        inputImage.value = null;
    };

    var openCropModal = function(file){
        showModal({
            title: l10n.title,
            modalId: 'cropModal',
            modalClass: 'crop-modal',
            content: '<div class="crop-area crop-loading"><img id="croppedImage" src="/img/no_photo_add.jpg" alt=""/></div>'
                + '<input type="range" class="crop-zoom" id="cropZoomSlider" min="0" max="100" step="1" value="0" aria-label="' + l10n.zoom + '"/>'
                + '<div class="crop-hint">' + l10n.hint + '</div>'
                + '<div class="crop-error" id="cropError">' + l10n.tooSmall + '</div>',
            buttons: '<hr noshade="" size="1" color="#FFBD00">'
                + '<a class="yellow nbtn float-right">' + l10n.save + '</a>'
                + '<a class="gray nbtn float-left close_button">' + l10n.cancel + '</a>',
            notCloseInSuccess: true,
            success: function(){
                if (!cropper) {
                    return;
                }
                var data = cropper.getData(true);
                if (data.width < 110 || data.height < 110) {
                    vShow(document.getElementById('cropError'));
                    return;
                }
                var size = Math.min(440, Math.max(110, Math.round(data.width)));
                var canvas = cropper.getCroppedCanvas({
                    width: size,
                    height: size,
                    imageSmoothingQuality: 'high'
                });
                var closeButton = document.querySelector('#cropModal .close_button');
                if (closeButton) closeButton.click();
                uploadAvatar(canvas);
            },
            close: destroyCropper,
            afterShow: function(){
                startCropper(file);
            }
        });
    };

    inputImage.onchange = function () {
        var files = this.files;
        if (!files || !files.length) {
            return;
        }
        var file = files[0];
        if (!/^image\/\w+/.test(file.type)) {
            showMessage(l10n.notImage);
            inputImage.value = null;
            return;
        }
        openCropModal(file);
    };
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', flipCropperInit);
} else {
    flipCropperInit();
}
})();
/**
 * Отзывы о товаре (десктоп): подгрузка списка, сортировка, фильтры,
 * голос «Полезно», комментарии, жалобы и форма добавления отзыва.
 * Также обслуживает страницу /reviews и «Мои отзывы» в личном кабинете
 * (кнопка .add-review внутри .reviews-add-layer).
 * Без jQuery. Глобальные API сайта: showModal, showMessage, getNoun,
 * fillTemplate, GLightbox.
 */
(function () {
    'use strict';

    var AJAX_URL = '/ajax/review.php';

    function qs(selector, root) {
        return (root || document).querySelector(selector);
    }

    function isKk() {
        return (document.documentElement.getAttribute('lang') || '') === 'kk';
    }

    function parseJsonSafe(text) {
        try {
            return JSON.parse(text);
        } catch (e) {
            return null;
        }
    }

    function postText(params) {
        return fetch(AJAX_URL, {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
            body: new URLSearchParams(params).toString(),
            credentials: 'same-origin'
        }).then(function (response) {
            return response.text();
        });
    }

    function postJson(params) {
        return postText(params).then(parseJsonSafe);
    }

    function getJson(params) {
        return fetch(AJAX_URL + '?' + new URLSearchParams(params).toString(), {
            credentials: 'same-origin'
        }).then(function (response) {
            return response.text();
        }).then(parseJsonSafe);
    }

    function loaderHtml() {
        return '<div class="rv-loader"><div class="css-loader"></div></div>';
    }

    function htmlToElement(html) {
        var wrap = document.createElement('div');
        wrap.innerHTML = html.trim();
        return wrap.firstElementChild;
    }

    var gallery = null;

    function initGallery() {
        if (typeof GLightbox === 'undefined' || !qs('.review-item-photo .gallery')) {
            return;
        }
        if (gallery) {
            try {
                gallery.reload();
                return;
            } catch (e) {
                gallery = null;
            }
        }
        gallery = flipLightbox({
            selector: '.review-item-photo .gallery'
        });
    }

    /* ------------------------------------------------------------------ */
    /* Список отзывов: сортировка, фильтры, бесконечная подгрузка          */
    /* ------------------------------------------------------------------ */

    function initReviewsList() {
        var layer = document.getElementById('reviews-layer');
        if (!layer) {
            return;
        }

        var itemsLayout = document.getElementById('reviews-item-list');

        function produceId() {
            return layer.getAttribute('data-id-produce') || '';
        }

        if (!produceId() || !itemsLayout) {
            // Страница /reviews: список статичен, интерактив ниже через делегирование
            return;
        }

        var produceParent = layer.getAttribute('data-produce-parent') || '';
        var limit = parseInt(layer.getAttribute('data-limit'), 10) || 15;
        var offset = limit;
        var more = document.getElementById('reviews-more');
        var loader = document.getElementById('reviews-loader');
        var moreBtn = document.getElementById('reviews-more-btn');
        var chipsBox = qs('.rv-chips', layer);

        var loading = false;
        var exhausted = false;
        var observer = null;

        function getSort() {
            var active = chipsBox ? qs('.rv-chip.is-active[data-sort]', chipsBox) : null;
            return active ? active.getAttribute('data-sort') : '';
        }

        function getFilters() {
            var filters = [];
            var photoChip = chipsBox ? qs('[data-only-with-photo]', chipsBox) : null;
            if (photoChip && photoChip.classList.contains('is-active')) {
                filters.push('only-with-photo');
            }
            var variantChip = chipsBox ? qs('[data-only-this-produce]', chipsBox) : null;
            if (variantChip && variantChip.classList.contains('is-active')) {
                filters.push('only-this-produce-attribute');
            }
            return filters.join(',');
        }

        function showLoader(show) {
            if (loader) {
                loader.style.display = show ? '' : 'none';
            }
        }

        function loadReviews(options) {
            options = options || {};
            if (loading) {
                return;
            }
            loading = true;

            var requestOffset = options.replace ? 0 : offset;

            if (options.replace) {
                itemsLayout.innerHTML = '';
                exhausted = false;
                if (more) {
                    more.style.display = 'none';
                }
            }
            showLoader(true);

            postText({
                produce: produceId(),
                produceParent: produceParent,
                noCheckProduce: 'yes',
                out: 'produce',
                limit: limit,
                offset: requestOffset,
                sort: getSort(),
                filters: getFilters(),
                lang: document.documentElement.getAttribute('lang') || ''
            }).then(function (html) {
                loading = false;

                var received = 0;
                if (html && html.trim()) {
                    var wrap = document.createElement('div');
                    wrap.innerHTML = html;
                    received = wrap.children.length;
                    while (wrap.firstChild) {
                        itemsLayout.appendChild(wrap.firstChild);
                    }
                }

                offset = requestOffset + limit;

                if (received < limit) {
                    exhausted = true;
                    showLoader(false);
                    stopInfinite();
                    if (more) {
                        more.style.display = 'none';
                    }
                } else {
                    showLoader(!!observer);
                    if (observer && loader) {
                        // Перепроверяем пересечение после изменения высоты списка
                        observer.unobserve(loader);
                        observer.observe(loader);
                    }
                    if (!observer && more) {
                        // Полная подгрузка — только по кнопке «Показать все»
                        more.style.display = '';
                    }
                }

                initGallery();
            }).catch(function () {
                loading = false;
                showLoader(false);
            });
        }

        function stopInfinite() {
            if (observer) {
                observer.disconnect();
                observer = null;
            }
        }

        function startInfinite() {
            if (more) {
                more.style.display = 'none';
            }
            if (exhausted || !loader) {
                return;
            }
            if (!('IntersectionObserver' in window)) {
                // Фолбэк без IntersectionObserver: грузим следующую страницу сразу
                if (!loading) {
                    loadReviews();
                }
                return;
            }
            if (observer) {
                return;
            }
            showLoader(true);
            observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting && !loading && !exhausted) {
                        loadReviews();
                    }
                });
            }, {rootMargin: '200px'});
            observer.observe(loader);
        }

        function reload() {
            stopInfinite();
            loadReviews({replace: true});
        }

        if (moreBtn) {
            moreBtn.addEventListener('click', function (event) {
                event.preventDefault();
                startInfinite();
            });
        }

        if (chipsBox) {
            chipsBox.addEventListener('click', function (event) {
                var sortChip = event.target.closest('.rv-chip[data-sort]');
                if (sortChip) {
                    var wasActive = sortChip.classList.contains('is-active');
                    chipsBox.querySelectorAll('.rv-chip[data-sort]').forEach(function (chip) {
                        chip.classList.remove('is-active');
                    });
                    if (!wasActive) {
                        sortChip.classList.add('is-active');
                    }
                    reload();
                    return;
                }

                var variantChip = event.target.closest('[data-only-this-produce]');
                if (variantChip) {
                    variantChip.classList.toggle('is-active');
                    reload();
                    return;
                }

                var photoChip = event.target.closest('[data-only-with-photo]');
                if (photoChip) {
                    photoChip.classList.toggle('is-active');
                    reload();
                }
            });
        }

        // При смене варианта товара скрипты подгрузки обновляют data-id-produce
        // у #reviews-layer; если активен фильтр «Выбранный вариант» — актуализируем список
        var lastProduceId = produceId();
        if ('MutationObserver' in window) {
            new MutationObserver(function () {
                var id = produceId();
                if (id === lastProduceId) {
                    return;
                }
                lastProduceId = id;
                var activeVariantChip = chipsBox ? qs('[data-only-this-produce].is-active', chipsBox) : null;
                if (activeVariantChip) {
                    reload();
                }
            }).observe(layer, {attributes: true, attributeFilter: ['data-id-produce']});
        }
    }

    /* ------------------------------------------------------------------ */
    /* Голос «Полезно»                                                     */
    /* ------------------------------------------------------------------ */

    function handleVote(voteEl, event) {
        event.preventDefault();

        if (voteEl.classList.contains('is-static')) {
            return;
        }
        var id = voteEl.getAttribute('data-id');
        if (!id) {
            return;
        }
        var useful = voteEl.classList.contains('active') ? -1 : 1;

        postJson({review: id, useful: useful}).then(function (data) {
            if (data !== true) {
                return;
            }

            var countEl = voteEl.querySelector('[data-vote-count]');
            if (countEl) {
                var count = (parseInt(countEl.textContent, 10) || 0) + useful;
                countEl.textContent = count;
                countEl.classList.toggle('hidden', count <= 0);
            } else {
                // Легаси-разметка страницы /reviews
                var actions = voteEl.closest('.review-item-actions');
                var legacyBlock = actions ? qs('.gray-text div', actions) : null;
                if (legacyBlock) {
                    var legacyCount = (parseInt(legacyBlock.textContent, 10) || 0) + useful;
                    legacyBlock.textContent = legacyCount + ' '
                        + getNoun(legacyCount, 'человек посчитал', 'человека посчитали', 'человек посчитали')
                        + ' полезным';
                    legacyBlock.classList.toggle('hidden', legacyCount <= 0);
                }
            }

            voteEl.classList.toggle('active', useful === 1);
        });
    }

    /* ------------------------------------------------------------------ */
    /* Комментарии к отзыву                                                */
    /* ------------------------------------------------------------------ */

    function commentsCountText(count) {
        var forms = isKk()
            ? ['түсініктеме', 'түсініктеме', 'түсініктеме']
            : ['комментарий', 'комментария', 'комментариев'];
        return count + ' ' + getNoun(count, forms[0], forms[1], forms[2]);
    }

    function updateCommentsTrigger(reviewId, opened, count) {
        var trigger = qs('#review-item-' + reviewId + ' .show-comments');
        if (!trigger) {
            return;
        }
        if (opened) {
            trigger.textContent = isKk() ? 'Пікірлерді жасыру' : 'Скрыть комментарии';
        } else {
            trigger.textContent = commentsCountText(count);
        }
    }

    function renderComments(commentsBox, reviewId, data) {
        var template = qs('#reviews-templates .template-comment');
        commentsBox.innerHTML = '';

        if (!template || !data) {
            return 0;
        }

        var count = 0;
        for (var i = 0; i < data.length; i++) {
            var row = data[i];
            var complained = String(row.isComplained) === '1';
            var node = htmlToElement(fillTemplate(template.innerHTML, {
                name: complained ? (isKk() ? 'Пайдаланушы жасырылған' : 'Пользователь скрыт') : row.name,
                idClient: row.idClient,
                text: row.text,
                id: row.id,
                idReview: reviewId
            }));
            if (!node) {
                continue;
            }

            var avatar = qs('.review-item-avatar', node);
            if (avatar) {
                if (row.avatar && !complained) {
                    var img = document.createElement('img');
                    img.src = row.avatar;
                    img.alt = row.name || '';
                    avatar.appendChild(img);
                } else {
                    avatar.textContent = complained ? 'П' : String(row.name || '').charAt(0);
                }
            }

            if (complained) {
                node.classList.add('is-complained');
                var complaintLink = qs('[data-complaint-comment]', node);
                if (complaintLink) {
                    complaintLink.remove();
                }
            }

            commentsBox.appendChild(node);
            count++;
        }

        commentsBox.setAttribute('data-loaded', '1');
        return count;
    }

    function loadComments(reviewId, options) {
        options = options || {};
        var item = document.getElementById('review-item-' + reviewId);
        if (!item) {
            return;
        }
        var commentsBox = qs('.review-item-comments', item);
        if (!commentsBox) {
            return;
        }

        var willOpen = options.forceOpen || !commentsBox.classList.contains('is-open');
        commentsBox.classList.toggle('is-open', willOpen);

        if (willOpen && (options.forceReload || !commentsBox.getAttribute('data-loaded'))) {
            commentsBox.innerHTML = loaderHtml();
            getJson({view: reviewId}).then(function (data) {
                var count = renderComments(commentsBox, reviewId, data || []);
                updateCommentsTrigger(reviewId, true, count);
            });
        } else {
            var count = commentsBox.querySelectorAll('.rv-comment').length;
            updateCommentsTrigger(reviewId, willOpen, count);
        }
    }

    /* ------------------------------------------------------------------ */
    /* Форма ответа на отзыв                                               */
    /* ------------------------------------------------------------------ */

    function closeAnswerForm() {
        var form = document.getElementById('review-comment-add-form');
        if (!form || form.closest('.template-comment-add')) {
            return;
        }
        var answerBox = form.closest('.review-item-answer');
        form.remove();
        if (answerBox) {
            answerBox.classList.remove('is-open');
        }
        document.querySelectorAll('.show-answer').forEach(function (link) {
            link.style.display = '';
        });
    }

    function openAnswerForm(trigger) {
        var reviewId = trigger.getAttribute('data-id');
        var item = document.getElementById('review-item-' + reviewId);
        var template = qs('#reviews-templates .template-comment-add');
        if (!reviewId || !item || !template) {
            return;
        }

        closeAnswerForm();

        var answerBox = qs('.review-item-answer', item);
        if (!answerBox) {
            return;
        }

        var form = template.firstElementChild.cloneNode(true);
        var idInput = qs('input[name="idreview"]', form);
        if (idInput) {
            idInput.value = reviewId;
        }

        var nameLink = qs('.rv-comment-name a', form);
        var reviewAuthor = qs('.review-item-name a', item);
        if (nameLink && reviewAuthor) {
            nameLink.replaceWith(reviewAuthor.cloneNode(true));
        }

        answerBox.appendChild(form);
        answerBox.classList.add('is-open');
        trigger.style.display = 'none';

        var textarea = qs('textarea[name="rcomment"]', form);
        if (textarea) {
            textarea.focus();
        }

        form.addEventListener('submit', function (event) {
            event.preventDefault();

            fetch(AJAX_URL, {
                method: 'POST',
                body: new FormData(form),
                credentials: 'same-origin'
            }).then(function (response) {
                return response.text();
            }).then(parseJsonSafe).then(function (data) {
                if (!data) {
                    return;
                }
                if (data.error) {
                    answerBox.insertAdjacentHTML('beforeend', data.error);
                    return;
                }

                var trigger = qs('.show-comments', item);
                if (trigger) {
                    trigger.classList.remove('hidden');
                }

                closeAnswerForm();
                loadComments(reviewId, {forceOpen: true, forceReload: true});

                if (data.message) {
                    var commentsBox = qs('.review-item-comments', item);
                    if (commentsBox) {
                        commentsBox.insertAdjacentHTML('beforeend', data.message);
                    }
                }
            });
        });
    }

    /* ------------------------------------------------------------------ */
    /* Жалобы на отзыв и комментарий                                       */
    /* ------------------------------------------------------------------ */

    function openComplaintForm(reasonsParam, buildSubmitParams) {
        getJson(reasonsParam).then(function (reasons) {
            if (!reasons) {
                return;
            }

            var form = document.createElement('form');
            var list = document.createElement('ul');
            list.className = 'review-complaint-reasons';
            form.appendChild(list);

            var title = document.createElement('li');
            title.className = 'title';
            title.innerHTML = '<strong>' + (isKk()
                ? 'Бұл пікірге неліктен шағымданғыңыз келетінін көрсетіңіз'
                : 'Пожалуйста, укажите почему Вы хотите пожаловаться на этот отзыв') + '</strong>';
            list.appendChild(title);

            for (var i = 0; i < reasons.length; i++) {
                var li = document.createElement('li');
                var label = document.createElement('label');
                label.setAttribute('for', 'reason-' + reasons[i].id);
                label.textContent = reasons[i].title;
                var input = document.createElement('input');
                input.type = 'radio';
                input.name = 'reason';
                input.value = reasons[i].id;
                input.id = 'reason-' + reasons[i].id;
                input.required = true;
                li.appendChild(label);
                li.appendChild(input);
                list.appendChild(li);
            }

            var buttonLi = document.createElement('li');
            buttonLi.className = 'button';
            var button = document.createElement('button');
            button.type = 'submit';
            button.className = 'rv-btn rv-btn-sm rv-btn-yellow';
            button.textContent = isKk() ? 'Шағым жіберу' : 'Отправить жалобу';
            buttonLi.appendChild(button);
            list.appendChild(buttonLi);

            var modal = showModal({
                content: form,
                onlyClose: true
            });

            form.addEventListener('submit', function (event) {
                event.preventDefault();
                event.stopPropagation();

                var checked = qs('input[name=reason]:checked', form);
                if (!checked) {
                    return;
                }

                postJson(buildSubmitParams(checked.value)).then(function (data) {
                    if (!data || !data.success) {
                        return;
                    }
                    modal.close();
                    if (data.message) {
                        showModal({
                            content: data.message,
                            onlyClose: true,
                            close: function () {
                                window.location.reload();
                            }
                        });
                    }
                });
            });
        });
    }

    /* ------------------------------------------------------------------ */
    /* Форма добавления отзыва                                             */
    /* ------------------------------------------------------------------ */

    function fillGoodSelect(form, produces, produceId) {
        var box = qs('.good-select-box', form);
        var template = qs('#good-select-box-template .good-select');
        if (!box || !template) {
            return;
        }

        var item = null;
        for (var i = 0; i < produces.length; i++) {
            if (String(produces[i].idProduce) === String(produceId)) {
                item = produces[i];
                break;
            }
        }
        if (!item) {
            item = produces[0];
        }
        if (!item) {
            return;
        }

        var node = template.cloneNode(true);
        var idInput = qs('.produce-id', node);
        if (idInput) {
            idInput.value = item.idProduce;
        }
        var title = qs('.good-select-title', node);
        if (title) {
            title.textContent = item.name || '';
        }
        var img = qs('.good-select-img img', node);
        var imgSrc = item.image_240 && item.image_240.urli ? item.image_240.urli : item.image_240;
        if (img && typeof imgSrc === 'string' && imgSrc) {
            img.src = imgSrc;
            img.alt = item.name || '';
        } else if (img) {
            img.closest('.good-select-img').remove();
        }

        var attrs = item.attributesCart;
        var value = qs('.good-select-value', node);
        if (value && attrs && attrs.length > 0) {
            value.textContent = attrs[0].title + ': ' + attrs[0].valuesView[0];
            if (attrs.length > 1) {
                var second = document.createElement('div');
                second.className = 'good-select-value';
                second.textContent = attrs[1].title + ': ' + attrs[1].valuesView[0];
                value.parentNode.appendChild(second);
            }
        }

        box.innerHTML = '';
        box.appendChild(node);
    }

    function initPhotoPicker(form, files) {
        var preview = qs('#review-photos-preview', form);
        var chooser = qs('#reviews-photo-chooser', form);
        var addButton = qs('#reviews-add-photo', form);
        if (!preview || !chooser || !addButton) {
            return;
        }

        var MAX_PHOTOS = 30;

        function renderPreviews() {
            preview.innerHTML = '';
            files.forEach(function (item, index) {
                var span = document.createElement('span');
                span.style.backgroundImage = 'url(' + item.base64 + ')';
                var remove = document.createElement('span');
                remove.textContent = isKk() ? 'Жою' : 'Удалить';
                remove.addEventListener('click', function () {
                    files.splice(index, 1);
                    renderPreviews();
                });
                span.appendChild(remove);
                preview.appendChild(span);
            });
            addButton.style.display = files.length >= MAX_PHOTOS ? 'none' : '';
        }

        function readFiles(list) {
            var index = 0;

            function readNext() {
                if (index >= list.length) {
                    renderPreviews();
                    return;
                }
                if (files.length >= MAX_PHOTOS) {
                    showMessage('Максимальное количество фотографий для отзыва 30 штук');
                    renderPreviews();
                    return;
                }

                var file = list[index];
                index++;

                if (['image/jpeg', 'image/gif', 'image/png'].indexOf(file.type) === -1) {
                    showMessage('Выбран неверный формат файла');
                    readNext();
                    return;
                }

                var reader = new FileReader();
                reader.onload = function (event) {
                    files.push({file: file, base64: event.target.result});
                    readNext();
                };
                reader.onerror = readNext;
                reader.readAsDataURL(file);
            }

            readNext();
        }

        // Сбрасываем value, чтобы то же фото можно было выбрать повторно
        chooser.addEventListener('change', function () {
            if (this.files && this.files.length) {
                readFiles(Array.prototype.slice.call(this.files));
            }
            this.value = '';
        });

        addButton.addEventListener('click', function (event) {
            event.preventDefault();
            chooser.click();
        });
    }

    function submitReviewForm(form, files, layer, modal) {
        var submitButton = qs('button[type=submit]', form);
        var originalHtml = submitButton ? submitButton.innerHTML : '';

        if (submitButton) {
            submitButton.innerHTML = '<span class="btn-spinner"></span>'
                + (submitButton.getAttribute('data-sending-text') || 'Отправка отзыва');
        }

        var controls = form.querySelectorAll('input, textarea, button');
        controls.forEach(function (control) {
            control.disabled = true;
        });

        var rating = qs('input[name=rating]:checked', form);
        var produceInput = qs('.produce-id', form);
        var hiddenProduce = qs('input[name="produce"]', form);

        var formData = new FormData();
        formData.append('add', 'produce');
        formData.append('rate', rating ? rating.value : '');
        formData.append('produce', produceInput && produceInput.value
            ? produceInput.value
            : (hiddenProduce ? hiddenProduce.value : ''));

        var userId = qs('input[name="user_id"]', form);
        if (userId) {
            formData.append('user_id', userId.value);
        }

        form.querySelectorAll('.review-fields textarea').forEach(function (textarea) {
            formData.append('review_' + textarea.name, textarea.value);
        });

        files.forEach(function (item) {
            formData.append('photos[]', item.file);
        });

        function restore() {
            controls.forEach(function (control) {
                control.disabled = false;
            });
            if (submitButton) {
                submitButton.innerHTML = originalHtml;
            }
        }

        fetch(AJAX_URL, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        }).then(function (response) {
            return response.text();
        }).then(parseJsonSafe).then(function (data) {
            restore();

            if (!data || (!data.message && !data.error)) {
                showMessage('По неизвестной причине не удалось загрузить Ваш отзыв. Попробуйте сделать это позднее');
                return;
            }
            if (data.error) {
                showMessage(data.error);
                return;
            }

            if (layer && layer.getAttribute('data-removable') !== null) {
                layer.remove();
            }

            modal.close();
            showModal({
                title: isKk() ? 'Рақмет!' : 'Спасибо!',
                content: data.message,
                onlyClose: true
            });

            try {
                if (typeof window.updateAwaitReviewsBadgeFromResponse === 'function') {
                    window.updateAwaitReviewsBadgeFromResponse(data);
                }
            } catch (e) {
            }
        }).catch(function () {
            restore();
            showMessage('По неизвестной причине не удалось загрузить Ваш отзыв. Попробуйте сделать это позднее');
        });
    }

    function openAddReviewForm(trigger) {
        var layer = trigger.closest('.reviews-add-layer');
        if (!layer) {
            return false;
        }

        var produceId = layer.getAttribute('data-id-produce');
        if (!produceId) {
            return false;
        }

        var template = qs('#reviews-templates #review-add-form');
        if (!template) {
            return false;
        }

        var preselectedRating = (trigger.matches('input[name=rating]') && trigger.value) ? trigger.value : null;

        var modal = showModal({
            content: loaderHtml(),
            onlyClose: true
        });

        postJson({produce: produceId, prepare: true}).then(function (data) {
            if (!data || !data.fields || !data.fields.length || !data.produces || !data.produces.length) {
                modal.content(isKk() ? 'Бірдеңе дұрыс болмады :(' : 'Что-то пошло не так :(');
                return;
            }

            var form = template.cloneNode(true);

            var goodListModal = qs('.good-list-modal', form);
            if (goodListModal) {
                goodListModal.innerHTML = '';
            }

            var fieldsBox = qs('.review-fields', form);
            if (fieldsBox) {
                data.fields.forEach(function (field) {
                    var element = document.createElement('div');
                    element.className = 'form-element';
                    var textarea = document.createElement('textarea');
                    textarea.id = field.field;
                    textarea.name = field.field;
                    textarea.placeholder = field.title;
                    textarea.rows = 5;
                    var label = document.createElement('label');
                    label.setAttribute('for', field.field);
                    label.textContent = field.title;
                    element.appendChild(textarea);
                    element.appendChild(label);
                    fieldsBox.appendChild(element);
                });
            }

            fillGoodSelect(form, data.produces, produceId);

            var hiddenProduce = qs('input[name="produce"]', form);
            if (hiddenProduce) {
                hiddenProduce.value = produceId;
            }

            if (preselectedRating) {
                var ratingInput = qs('input[name=rating][value="' + preselectedRating + '"]', form);
                if (ratingInput) {
                    ratingInput.checked = true;
                }
            }

            var files = [];
            initPhotoPicker(form, files);

            form.addEventListener('submit', function (event) {
                event.preventDefault();
                submitReviewForm(form, files, layer, modal);
            });

            modal.content(form);
        });

        return true;
    }

    /* ------------------------------------------------------------------ */
    /* Инициализация                                                       */
    /* ------------------------------------------------------------------ */

    document.addEventListener('DOMContentLoaded', function () {
        initReviewsList();
        initGallery();

        document.addEventListener('click', function (event) {
            var vote = event.target.closest('.review-item-actions .review-item-vote');
            if (vote) {
                handleVote(vote, event);
                return;
            }

            var showComments = event.target.closest('.show-comments');
            if (showComments && showComments.getAttribute('data-id')) {
                event.preventDefault();
                loadComments(showComments.getAttribute('data-id'));
                return;
            }

            var showAnswer = event.target.closest('.show-answer');
            if (showAnswer && showAnswer.getAttribute('data-id')) {
                event.preventDefault();
                openAnswerForm(showAnswer);
                return;
            }

            var hideAnswer = event.target.closest('.hide-answer');
            if (hideAnswer && hideAnswer.closest('#review-comment-add-form')) {
                event.preventDefault();
                closeAnswerForm();
                return;
            }

            var complaint = event.target.closest('[data-complaint]');
            if (complaint && complaint.getAttribute('data-id')) {
                event.preventDefault();
                var reviewId = complaint.getAttribute('data-id');
                openComplaintForm({complaintReasons: true}, function (reasonId) {
                    return {
                        addComplaint: true,
                        idReview: reviewId,
                        idReason: reasonId
                    };
                });
                return;
            }

            var commentComplaint = event.target.closest('[data-complaint-comment]');
            if (commentComplaint) {
                event.preventDefault();
                var commentId = commentComplaint.getAttribute('data-id');
                var commentReviewId = commentComplaint.getAttribute('data-id-review');
                openComplaintForm({complaintCommentReasons: true}, function (reasonId) {
                    return {
                        addCommentComplaint: true,
                        idReview: commentReviewId,
                        idComment: commentId,
                        idReason: reasonId
                    };
                });
                return;
            }

            var addReview = event.target.closest('.add-review');
            if (addReview) {
                // Триггеры — радио-инпуты оценки в личном кабинете:
                // preventDefault снял бы выбранную звезду
                openAddReviewForm(addReview);
            }
        });
    });
}());
(function () {
    'use strict';

    function qa(selector, root) {
        return Array.from((root || document).querySelectorAll(selector));
    }

    function show(el) { if (el) el.style.display = ''; }
    function hide(el) { if (el) el.style.display = 'none'; }

    // Сериализация как jQuery.param: массивы — key[]=v
    function encodeForm(data) {
        var parts = [];
        for (var key in data) {
            if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
            var value = data[key];
            if (Array.isArray(value)) {
                for (var i = 0; i < value.length; i++) {
                    parts.push(encodeURIComponent(key + '[]') + '=' + encodeURIComponent(value[i] == null ? '' : value[i]));
                }
            } else {
                parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value == null ? '' : value));
            }
        }
        return parts.join('&');
    }

    function postJson(url, data) {
        return fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: encodeForm(data)
        }).then(function (res) { return res.json(); });
    }

    document.addEventListener('click', function (event) {
        var button = event.target && event.target.closest ? event.target.closest('.btn-attributes-choose') : null;
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();

        var staticDomain = document.body.getAttribute('data-domain-static');

        qa('.attributes-choose-block.in-used').forEach(function (el) { el.remove(); });

        var id = button.getAttribute('data-id');
        var modal = null;

        var prices = {};
        var sizemapId = null;

        var langInput = document.querySelector('input[name="lang"]:checked');
        var langValue = langInput ? langInput.value : null;

        var lang = langValue == 'kk' ? '/kk' : '';

        var languageUrls = {
            'kk': '/languages/ajax/preview_kk.php',
            'ru': '/languages/ajax/preview_ru.php'
        }[langValue || 'ru'];

        fetch(languageUrls, {credentials: 'same-origin'}).then(function (res) { return res.json(); }).then(function (json) {
            var holder = document.createElement('div');
            holder.innerHTML = `<div class="attributes-choose">
            <div class="attributes-choose-block">
                <div class="product-info-layout">
                    <h1 data-product-name></h1>
                    <div class="rating-layer" style="margin-top: 0;">
                        <div class="rating-layer-stars" title="${json.customer_rating}">
                            <div class="rate-stars h-14">
                                <div class="rate-stars-full" style="width: 0%;"></div>
                            </div>
                        </div>
                        <div class="rating-layer-rating has-reviews" style="display: none">
                            <div class="table w-a v-middle">
                                <div class="cell"><strong><span class="ratingValue">5</span></strong></div>
                                <div class="cell">&nbsp;<a data-reviews-link href=""><span class="reviewCount">7</span>&nbsp;${json.x_reviews}</a></div>
                            </div>
                        </div>
                    </div>
                    <div class="table v-top p-t-16">
                        <div class="cell w-0 p-r-16">
                            <div class="good-img">
                                <div class="good-img-prev">
                                    <div class="select-attribute">
                                    </div>
                                </div>
                                <div class="good-img-f">
                                    <div class="good-img-f-f">
                                        <input data-favorite-checker data-not-show-floating-block="true" id="favorites-attributes" type="checkbox" name="favorite">
                                        <label for="favorites-attributes"></label>
                                        <img src="` + staticDomain + `/media/no_photo_240.jpg" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="cell">
                            <div class="not-available text-warning" style="display: none">${json.item_not_in_stock}</div>
                            <div data-attributes-layout></div>
                            <div class="sizemap-block"><a data-sizemap>${json.size_chart}</a></div>
                            <div data-template-attribute style="display: none">
                                <p><span data-attribute-name></span>: <span class="subheader3"></span></p>
                                <div class="select-attribute"></div>
                            </div>
                            <div data-image-attribute style="display: none">
                                <input type="radio" name="color" id="color-1">
                                <label title="${json.color_name}" for="color-1">
                                    <svg class="dark-hack" width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="200" fill="white"></rect></svg>
                                    <div class="valign-wrapper">
                                        <img class="product-image" src="` + staticDomain + `/media/no_photo_240.jpg">
                                    </div>
                                </label>
                            </div>
                            <div data-label-attribute style="display: none">
                                <input type="radio" name="size" id="size-1">
                                <label for="size-1"></label>
                            </div>
                    <div class="p-t-16" data-sellers style="display: none">
                        <form method="post" action="/cart" class="form-attributes flex-column" style="display: none">
                            <div class="price-block">
                                <div class="discount" data-seller-discount style="display: none"></div>
                                <div class="price-block-price">
                                    <div class="new-price" data-seller-price-disc><span></span></div>
                                    <div class="old-price" data-seller-price style="display: none"><span></span></div>
                                </div>
                            </div>
                            <div data-seller-disc-count style="display: none" class="text-red">${json.discount_available_count} <span></span>&#8239;${json.text_things}</div>
                            <div class="delivery-day-text">
                                <div class="delivery-in-type in-stock" data-seller-instore style="display: none">${json.in_store}</div>
                                <div class="delivery-in-type to-order" data-seller-toorder style="display: none">${json.text_to_order}</div>
                                <div class="ship-seller-box">
                                    <div class="suplier-block">
                                        <div class="suplier-name-block">
                                            <span class="text-gray">${json.text_supplier}: </span>
                                            <span data-seller-name><span class="suplier-name"></span></span>
                                        </div>
                                    </div>
                                    <div class="delivery-day-text-flex" data-seller-delivery-date></div>
                                </div>
                            </div>
                            <input type="hidden" name="cart_id_produce" value="" required>
                            <input type="hidden" name="cart_count_produce" value="1">
                            <input type="hidden" name="supplier" value="">
                            <div class="cart-morph" data-cart-morph="">
                                <button title="${json.add_to_cart}" type="button" class="btn-add cart-morph__add" data-cart-add>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256"><path d="M104,216a16,16,0,1,1-16-16A16,16,0,0,1,104,216Zm88-16a16,16,0,1,0,16,16A16,16,0,0,0,192,200ZM239.71,74.14l-25.64,92.28A24.06,24.06,0,0,1,191,184H92.16A24.06,24.06,0,0,1,69,166.42L33.92,40H16a8,8,0,0,1,0-16H40a8,8,0,0,1,7.71,5.86L57.19,64H232a8,8,0,0,1,7.71,10.14ZM221.47,80H61.64l22.81,82.14A8,8,0,0,0,92.16,168H191a8,8,0,0,0,7.71-5.86Z"></path></svg>
                                    <span>${json.btn_in_cart}</span>
                                </button>
                                <div class="cart-morph__incart" data-cart-incart hidden>
                                    <a class="cart-morph__label" href="${json.url_kk}/cart">${json.text_in_cart}</a>
                                    <div class="cart-stepper" data-cart-stepper>
                                        <button type="button" class="cart-stepper__btn" data-step="-1" aria-label="&minus;">&minus;</button>
                                        <span class="cart-stepper__value" data-stepper-value aria-live="polite">1</span>
                                        <button type="button" class="cart-stepper__btn" data-step="1" aria-label="+">+</button>
                                    </div>
                                </div>
                                <div class="cart-morph__error text-danger" data-cart-error hidden></div>
                            </div>
                            <a class="btn-expected" href="${json.url_kk}/user?personalis=coming" rel="nofollow">${json.waiting_products_list}</a>
                            <a class="btn-report" href="${json.url_kk}/subscribe?type=preorder&action=add&id=" rel="nofollow">${json.notify_arrival}</a>
                        </form>
                    </div>
                    <div class="table w-a p-t-16">
                        <div class="cell">
                            <a data-product-link class="to-product">${json.go_to_product}</a>
                        </div>
                    </div>
                        </div>
                    </div>
                </div>
                <div class="product-sizemap-layout" style="display: none">
                    <span class="btn-back p-b-16" style="cursor: pointer">< ${json.text_backspace}</span>
                    <div class="sizemap">
                        <div style="text-align: center">
                            <div class="css-loader"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
            var content = holder.firstElementChild;

            content.classList.add('in-used');
            var favoritesInput = content.querySelector('[data-favorite-checker]');
            favoritesInput.setAttribute('data-id', id);
            favoritesInput.id = 'favorites-attributes-' + id;
            favoritesInput.nextElementSibling.htmlFor = 'favorites-attributes-' + id;
            favoritesInput.value = id;
            var sizemapBlock = content.querySelector('.sizemap-block');
            var sizemapLayout = content.querySelector('.product-sizemap-layout');
            var productLayout = content.querySelector('.product-info-layout');

            sizemapBlock.querySelector('a').addEventListener('click', function () {
                if (sizemapId) {
                    fetch('/sizemap?id=' + sizemapId, {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: {'X-Requested-With': 'XMLHttpRequest'}
                    }).then(function (res) { return res.text(); }).then(function (data) {
                        if (data) {
                            sizemapLayout.querySelector('.sizemap').innerHTML = data;
                        } else {
                            sizemapLayout.querySelector('.sizemap').innerHTML = `<p>${json.sizemap_fail}</p>`;
                        }
                    });
                    hide(productLayout);
                    show(sizemapLayout);
                }
            });

            sizemapLayout.querySelector('.btn-back').addEventListener('click', function () {
                hide(sizemapLayout);
                show(productLayout);
            });

            content.querySelector('a[data-product-link]').setAttribute('href', lang + '/catalog?prod=' + id);

            qa('.btn-report', content).forEach(function (btn) {
                btn.addEventListener('click', function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    fetch(btn.getAttribute('href'), {
                        credentials: 'same-origin',
                        headers: {'X-Requested-With': 'XMLHttpRequest'}
                    }).then(function () {
                        qa('form .btn-report', content).forEach(hide);
                        qa('form .btn-expected', content).forEach(show);
                    });
                });
            });

            var templateAttributeLayout = content.querySelector('[data-attributes-layout]');

            var templateAttribute = content.querySelector('[data-template-attribute]');
            var templateImageAttribute = content.querySelector('[data-image-attribute]');
            var templateLabelAttribute = content.querySelector('[data-label-attribute]');

            var setProductToForm = function (idProduce) {

                qa('form input[name=cart_id_produce]', content).forEach(function (el) { el.value = ''; });
                qa('form .btn-report', content).forEach(hide);
                qa('form .btn-expected', content).forEach(hide);
                qa('.not-available', content).forEach(hide);
                if (idProduce) {

                    favoritesInput.setAttribute('data-id', idProduce);
                    favoritesInput.value = idProduce;

                    if (prices && prices[idProduce]) {
                        var p1 = content.querySelector('.prices .price span:nth-child(1)');
                        var p2 = content.querySelector('.prices .price span:nth-child(2)');
                        var savingSpan = content.querySelector('.prices .saving span');
                        var saving = content.querySelector('.prices .saving');
                        if (prices[idProduce].priceDiscount) {
                            if (p1) p1.textContent = prices[idProduce].priceDiscountFormat;
                            if (p2) { p2.textContent = prices[idProduce].priceFormat; show(p2); }
                            if (savingSpan) savingSpan.textContent = prices[idProduce].savingFormat + ' (' + prices[idProduce].discount + '%)';
                            show(saving);
                        } else {
                            if (p1) p1.textContent = prices[idProduce].priceFormat;
                            hide(p2);
                            hide(saving);
                        }
                        show(content.querySelector('.prices'));
                    }

                    content.querySelector('a[data-product-link]').setAttribute('href', lang + '/catalog?prod=' + idProduce);
                    var reviewsLink = content.querySelector('a[data-reviews-link]');
                    if (reviewsLink) reviewsLink.setAttribute('href', lang + '/catalog?prod=' + idProduce + '#reviews');

                } else {
                    hide(content.querySelector('.prices'));
                    qa('form .btn-report', content).forEach(hide);
                }
            };

            var setSellers = function (sellers, idProduce, extra) {
                extra = extra || {};
                var originalTemplate = content.querySelector('[data-sellers] form');
                while (originalTemplate.nextElementSibling) {
                    originalTemplate.nextElementSibling.remove();
                }
                if (sellers && sellers.length && sellers.length > 0) {
                    for (var i = 0; i < sellers.length; i++) {
                        var template = originalTemplate.cloneNode(true);
                        template.querySelector('input[name=supplier]').value = sellers[i]['idSupplier'] ? sellers[i]['idSupplier'] : '';
                        var sellerNameSpan = template.querySelector('[data-seller-name] span');
                        if (sellers[i]['idSupplier']) {
                            sellerNameSpan.innerHTML = '<a href="/descript?cat=seller&id=' + sellers[i]['idSupplier'] + '">' + sellers[i]['sellerName'] + '</a>';
                        } else {
                            sellerNameSpan.textContent = sellers[i]['sellerName'];
                        }

                        var hasSale = sellers[i]['salePrice'] && sellers[i]['salePrice'] !== sellers[i]['price'];
                        template.querySelector('[data-seller-price-disc] span').textContent = hasSale ? sellers[i]['salePrice'] : sellers[i]['price'];
                        if (hasSale) {
                            template.querySelector('[data-seller-price] span').textContent = sellers[i]['price'];
                            show(template.querySelector('[data-seller-price]'));
                            if (sellers[i]['discount']) {
                                var discountEl = template.querySelector('[data-seller-discount]');
                                discountEl.textContent = '-' + sellers[i]['discount'] + '%';
                                show(discountEl);
                            }
                        }

                        if (sellers[i]['deliveryInStore']) {
                            show(template.querySelector('[data-seller-instore]'));
                        } else {
                            show(template.querySelector('[data-seller-toorder]'));
                        }

                        var deliveryBlock = template.querySelector('[data-seller-delivery-date]');
                        deliveryBlock.replaceChildren();
                        var deliveryDay = document.createElement('b');
                        deliveryDay.className = 'delivery-day';
                        if (sellers[i]['deliveryDayClient']) {
                            var deliveryLabel = sellers[i]['deliveryClientFree'] ? json.client_delivery_free : json.client_delivery_date;
                            deliveryBlock.append(document.createTextNode(deliveryLabel + ' '));
                            deliveryDay.textContent = sellers[i]['deliveryDayClient'];
                        } else {
                            deliveryBlock.append(document.createTextNode(json.planned_shipment + ': '));
                            deliveryDay.textContent = sellers[i]['deliveryDay'];
                        }
                        deliveryBlock.appendChild(deliveryDay);

                        // -1 - скидка без ограничения по количеству, не показываем (как на карточке)
                        if (sellers[i]['countDiscount'] && sellers[i]['countDiscount'] != -1 && sellers[i]['countDiscount'] <= 10) {
                            template.querySelector('[data-seller-disc-count] span').textContent = sellers[i]['countDiscount'];
                            show(template.querySelector('[data-seller-disc-count]'));
                        } else {
                            hide(template.querySelector('[data-seller-disc-count]'));
                        }

                        var morph = template.querySelector('[data-cart-morph]');
                        morph.removeAttribute('data-cart-morph-ready');
                        morph.setAttribute('data-id-produce', idProduce);
                        if (sellers[i]['idSupplier']) {
                            morph.setAttribute('data-supplier', sellers[i]['idSupplier']);
                        }
                        morph.setAttribute('data-min', sellers[i]['minOrder'] || 1);
                        morph.setAttribute('data-max', sellers[i]['maximumOrder'] || 0);
                        morph.setAttribute('data-step', sellers[i]['minLot'] || 1);
                        morph.setAttribute('data-price', String(hasSale ? sellers[i]['salePrice'] : sellers[i]['price']).replace(/[^0-9]/g, ''));
                        if (sellers[i].inCart) {
                            morph.setAttribute('data-cnt', extra.cartCount || 1);
                            if (extra.cartRowId) {
                                morph.setAttribute('data-cart-row-id', extra.cartRowId);
                            }
                        }

                        template.querySelector('input[name=cart_id_produce]').value = idProduce;
                        qa('form input[name=cart_id_produce]', content).forEach(function (el) { el.value = idProduce; });

                        // Снимаем inline display:none шаблона: flex-column с gap
                        template.removeAttribute('style');

                        content.querySelector('[data-sellers]').appendChild(template);
                    }
                    show(content.querySelector('[data-sellers]'));

                    if (typeof window.cartMorphInit === 'function') {
                        window.cartMorphInit(content.querySelector('[data-sellers]'));
                    }
                }
            };

            var setImagesToContent = function (images) {
                var imagesBlock = content.querySelector('.good-img .select-attribute');
                imagesBlock.replaceChildren();

                if (images) {
                    if (images.main) {
                        content.querySelector('.good-img .good-img-f-f img').setAttribute('src', images.main);
                        var imageBlock = templateImageAttribute.cloneNode(true);
                        imageBlock.querySelector('label').htmlFor = 'image-main';
                        var mainInput = imageBlock.querySelector('input');
                        mainInput.id = 'image-main';
                        mainInput.name = 'image';
                        mainInput.setAttribute('checked', 'checked');
                        mainInput.checked = true;
                        mainInput.setAttribute('data-image', images.main);
                        imageBlock.querySelector('img').setAttribute('src', images.main);
                        show(imageBlock);
                        imagesBlock.appendChild(imageBlock);
                    }

                    if (images.additional) {
                        for (var a in images.additional) {
                            if (images.additional[a] && images.additional[a][110]) {
                                var bigImage = null;
                                var sizes = [240, 550, 1000];
                                for (var s in sizes) {
                                    if (images.additional[a][sizes[s]]) {
                                        bigImage = images.additional[a][sizes[s]].path;
                                    }
                                }
                                var additImage = templateImageAttribute.cloneNode(true);
                                additImage.querySelector('label').htmlFor = 'image-' + a;
                                var additInput = additImage.querySelector('input');
                                additInput.id = 'image-' + a;
                                additInput.setAttribute('data-image', bigImage);
                                additInput.name = 'image';
                                additImage.querySelector('img').setAttribute('src', images.additional[a][110].path);
                                show(additImage);
                                imagesBlock.appendChild(additImage);
                            }
                        }
                    }

                    initChangeImageEvents();
                }
            };

            var initChangeImageEvents = function () {
                qa('.good-img .select-attribute input', content).forEach(function (input) {
                    input.addEventListener('change', function () {
                        if (input.getAttribute('data-image')) {
                            content.querySelector('.good-img .good-img-f-f img').setAttribute('src', input.getAttribute('data-image'));
                        }
                    });
                });
            };

            var initEvents = function (attributesBlock) {
                if (!attributesBlock) return;

                qa('input[type=radio]', attributesBlock).forEach(function (radio) {
                    radio.addEventListener('change', function () {
                        var idProduce = radio.value;
                        var isAvailable = +radio.getAttribute('data-is-available');
                        var title = radio.getAttribute('data-title');
                        if (title) {
                            var holder = radio.closest('div[data-template-attribute]');
                            if (holder) {
                                var sub = holder.querySelector('.subheader3');
                                if (sub) sub.textContent = title;
                            }
                        }
                        radio.click();

                        if (radio.name === 'attribute-0' && content.querySelector('input[name=attribute-1]')) {
                            var checkedSize = content.querySelector('input[name=attribute-1]:checked');
                            var currentSizeTitle = checkedSize ? checkedSize.getAttribute('data-title') : null;
                            var thirdTemplate = document.querySelectorAll('div[data-template-attribute]')[2];
                            if (thirdTemplate) {
                                qa('input[type=radio]', thirdTemplate).forEach(function (inp) { inp.disabled = true; });
                            }
                            postJson('/ajax/produce.php', {
                                'attributes': radio.value,
                                'fields': ['prices', 'attribute', 'price', 'images', 'sellers'],
                                'lang': document.documentElement.getAttribute('lang')
                            }).then(function (data) {

                                favoritesInput.checked = !!data.favorites;

                                if (data.images) {
                                    setImagesToContent(data.images);
                                } else {
                                    setImagesToContent(null);
                                }

                                if (data.prices) {
                                    prices = data.prices;
                                }

                                if (data.price) {
                                    prices[idProduce] = data.price;
                                }

                                if (data.attributes && data.attributes[1]) {
                                    var attributes = data.attributes[1];
                                    var second = qa('div[data-template-attribute]', content)[1];
                                    if (second) second.remove();
                                    if (attributes.title) {
                                        var attributesBlock2 = templateAttribute.cloneNode(true);
                                        attributesBlock2.querySelector('[data-attribute-name]').textContent = attributes.title;
                                        generateAttributes(attributesBlock2, attributes.attributes, 'attribute-1');
                                        initEvents(attributesBlock2);

                                        var inputs = qa('.select-attribute input', attributesBlock2);
                                        var selectedSizeInput = null;
                                        if (currentSizeTitle) {
                                            for (var si = 0; si < inputs.length; si++) {
                                                if (inputs[si].getAttribute('data-title') === currentSizeTitle && !inputs[si].classList.contains('unavailable')) {
                                                    selectedSizeInput = inputs[si];
                                                    break;
                                                }
                                            }
                                        }
                                        if (!selectedSizeInput) {
                                            for (var sj = 0; sj < inputs.length; sj++) {
                                                if (!inputs[sj].classList.contains('unavailable')) {
                                                    selectedSizeInput = inputs[sj];
                                                    break;
                                                }
                                            }
                                        }
                                        if (!selectedSizeInput) {
                                            selectedSizeInput = inputs[0] || null;
                                        }
                                        if (selectedSizeInput) {
                                            selectedSizeInput.checked = true;
                                            var sizeTitle = selectedSizeInput.getAttribute('data-title');
                                            if (sizeTitle) {
                                                var sub2 = attributesBlock2.querySelector('.subheader3');
                                                if (sub2) sub2.textContent = sizeTitle;
                                            }
                                            idProduce = selectedSizeInput.value;
                                        }

                                        show(attributesBlock2);
                                        templateAttributeLayout.appendChild(attributesBlock2);
                                    }
                                }

                                setProductToForm(idProduce);
                                setSellers(data.sellers, idProduce, data);

                                if (!data.sellers || !data.sellers.length) {
                                    hide(content.querySelector('.prices'));
                                    show(content.querySelector('.not-available'));
                                }

                                if (data.preorder) {
                                    qa('form .btn-report', content).forEach(hide);
                                    qa('form .btn-expected', content).forEach(show);
                                }
                            });
                        } else {
                            postJson('/ajax/produce.php', {
                                'attributes': radio.value,
                                'fields': ['price', 'images', 'sellers'],
                                'lang': document.documentElement.getAttribute('lang')
                            }).then(function (data) {
                                favoritesInput.checked = !!data.favorites;

                                if (data.price) {
                                    prices[idProduce] = data.price;
                                }
                                if (data.images) {
                                    setImagesToContent(data.images);
                                } else {
                                    setImagesToContent(null);
                                }

                                setProductToForm(idProduce);
                                if (!isAvailable) {
                                    hide(content.querySelector('[data-sellers]'));
                                    show(content.querySelector('.not-available'));
                                    qa('form .btn-report', content).forEach(function (btn) {
                                        btn.setAttribute('href', lang + '/subscribe?type=preorder&action=add&id=' + idProduce);
                                        show(btn);
                                    });
                                } else {
                                    setSellers(data.sellers, idProduce, data);
                                    if (!data.sellers || !data.sellers.length) {
                                        hide(content.querySelector('.prices'));
                                        show(content.querySelector('.not-available'));
                                    }
                                }

                                if (data.preorder) {
                                    qa('form .btn-report', content).forEach(hide);
                                    qa('form .btn-expected', content).forEach(show);
                                }
                            });
                        }
                    });
                });
            };

            var generateAttributes = function (attributesBlock, attributes, name) {
                for (var i in attributes) {
                    var block = null;
                    var staticClientUrl = document.body.getAttribute('data-domain-static');
                    var src_var = null;
                    if (attributes[i].image) {
                        block = templateImageAttribute.cloneNode(true);
                        var imgLabel = block.querySelector('label');
                        imgLabel.htmlFor = name + '-' + attributes[i].id;
                        imgLabel.setAttribute('title', attributes[i].value);
                        if (attributes[i].image.includes(staticClientUrl)) {
                            src_var = attributes[i].image;
                        } else {
                            src_var = staticClientUrl + attributes[i].image;
                        }
                        block.querySelector('img.product-image').setAttribute('src', src_var);
                    } else {
                        block = templateLabelAttribute.cloneNode(true);
                        var labelEl = block.querySelector('label');
                        labelEl.htmlFor = name + '-' + attributes[i].id;
                        labelEl.textContent = attributes[i].value;
                    }

                    var input = block.querySelector('input');
                    input.id = name + '-' + attributes[i].id;
                    input.name = name;
                    input.setAttribute('data-title', attributes[i].value);
                    input.setAttribute('data-is-available', +attributes[i].available);
                    input.value = attributes[i].idProduce;

                    if (!attributes[i].available) {
                        input.classList.add('unavailable');
                    }

                    show(block);
                    // Вставляем содержимое шаблона (input+label) без обёртки — как в исходнике
                    attributesBlock.querySelector('.select-attribute').insertAdjacentHTML('beforeend', block.innerHTML);
                }
            };

            postJson('/ajax/produce.php', {
                'attributes': id,
                'lang': document.documentElement.getAttribute('lang')
            }).then(function (data) {
                if (!data) return;

                var idProduce = id;
                content.querySelector('[data-product-name]').textContent = data.name;
                var isAvailable = false;
                if (data.attributes) {
                    for (var a in data.attributes) {
                        var attributes = data.attributes[a];
                        if (attributes.title) {
                            if (attributes.id === 'size') {
                                attributes.attributes.sort(function (x, y) {
                                    if (x.available === y.available) {
                                        return x.id.localeCompare(y.id);
                                    } else if (x.available) {
                                        return -1;
                                    } else {
                                        return 1;
                                    }
                                });
                            }

                            var attributesBlock = templateAttribute.cloneNode(true);
                            attributesBlock.querySelector('[data-attribute-name]').textContent = attributes.title;
                            generateAttributes(attributesBlock, attributes.attributes, 'attribute-' + a);
                            initEvents(attributesBlock);
                            show(attributesBlock);
                            templateAttributeLayout.appendChild(attributesBlock);
                        }
                    }
                } else if (data.price) {
                    prices[id] = data.price;
                }

                if (data.review) {
                    content.querySelector('.ratingValue').textContent = data.review.rate;
                    content.querySelector('.reviewCount').textContent = data.review.count;
                    // Заливка шкалы — та же формула, что на карточке
                    // (produce_parts_description.tpl)
                    var rate = parseFloat(data.review.rate) || 0;
                    var rateFraction = Math.max(-1, Math.min(1, 2 * (rate - Math.floor(rate)) - 1));
                    var ratePercent = (Math.floor(rate) + (Math.asin(rateFraction) / Math.PI + 0.5)) * 20;
                    content.querySelector('.rate-stars-full').style.width = ratePercent + '%';
                    // Снимаем inline display, чтобы каскад дал table-cell
                    // (звёзды и «4.5 N отзывов» в одну строку, как на карточке)
                    qa('.has-reviews, .rating-layer-stars', content).forEach(function (el) { el.style.display = ''; });
                } else {
                    qa('.has-reviews, .rating-layer-stars', content).forEach(hide);
                }

                favoritesInput.checked = !!data.favorites;

                if (data.sizemap) {
                    sizemapId = data.sizemap;
                    show(sizemapBlock);
                } else {
                    sizemapId = null;
                    hide(sizemapBlock);
                }

                if (data.images) {
                    setImagesToContent(data.images);
                } else {
                    setImagesToContent(null);
                }

                if (data.prices) {
                    prices = data.prices;
                }

                if (data.price) {
                    prices[id] = data.price;
                }

                var name = '0';
                if (data && data.attributes) {
                    name = data.attributes.length - 1;
                }
                var productInput = content.querySelector('#attribute-' + name + '-' + id);
                qa('.select-attribute input:first-child', content).forEach(function (input) {
                    idProduce = input.value;
                    isAvailable = +input.getAttribute('data-is-available');
                    var title = input.getAttribute('data-title');
                    if (title) {
                        var holder2 = input.closest('div[data-template-attribute]');
                        if (holder2) {
                            var sub3 = holder2.querySelector('.subheader3');
                            if (sub3) sub3.textContent = title;
                        }
                    }
                    input.checked = true;
                });
                if (data.attributes && data.attributes[1] && data.attributes[1].attributes) {
                    var _attr1Set = {};
                    for (var _k in data.attributes[1].attributes) {
                        _attr1Set[String(data.attributes[1].attributes[_k].idProduce)] = true;
                    }
                    if (data.attributes[0] && data.attributes[0].attributes) {
                        for (var _k2 in data.attributes[0].attributes) {
                            var _v = String(data.attributes[0].attributes[_k2].idProduce);
                            if (_attr1Set[_v]) {
                                var _inp = content.querySelector('input[name=attribute-0][value="' + _v + '"]');
                                if (_inp) {
                                    _inp.checked = true;
                                    var _t = _inp.getAttribute('data-title');
                                    if (_t) {
                                        var _holder = _inp.closest('div[data-template-attribute]');
                                        if (_holder) {
                                            var _sub = _holder.querySelector('.subheader3');
                                            if (_sub) _sub.textContent = _t;
                                        }
                                    }
                                }
                                break;
                            }
                        }
                    }
                }
                if (productInput) {
                    productInput.checked = true;
                    var pTitle = productInput.getAttribute('data-title');
                    if (pTitle) {
                        var pHolder = productInput.closest('div[data-template-attribute]');
                        if (pHolder) {
                            var pSub = pHolder.querySelector('.subheader3');
                            if (pSub) pSub.textContent = pTitle;
                        }
                    }
                    setProductToForm(id);
                } else {
                    setProductToForm(id);
                }

                setSellers(data.sellers, id, data);

                if (!data.sellers || !data.sellers.length) {
                    hide(content.querySelector('.prices'));
                    show(content.querySelector('.not-available'));
                }

                if (data.preorder) {
                    qa('form .btn-report', content).forEach(hide);
                    qa('form .btn-expected', content).forEach(show);
                }

                var cartChangedFromModal = false;
                content.addEventListener('click', function (e) {
                    if (e.target && e.target.closest && e.target.closest('[data-cart-add], [data-cart-stepper] [data-step]')) {
                        cartChangedFromModal = true;
                    }
                });

                modal = showModal({
                    content: content,
                    onlyClose: true,
                    modalClass: 'preview-modal',
                    close: function () {
                        // На странице корзины пересчитываем состав перезагрузкой,
                        // если товар добавляли/меняли из быстрого просмотра
                        if (cartChangedFromModal && document.querySelector('.cart-block')) {
                            location.reload();
                        }
                    }
                });
            });

        });
    });
})();


(function (global) {
  if (global.FlipImageResize && global.FlipImageResize.resize) return;
  var DEFAULT_MAX_DIM = 1280;
  var DEFAULT_QUALITY = 0.85;
  var DEFAULT_THRESHOLD = 400 * 1024;
  function resize(file, opts) {
    opts = opts || {};
    var maxDim = opts.maxDim || DEFAULT_MAX_DIM;
    var quality = typeof opts.quality === 'number' ? opts.quality : DEFAULT_QUALITY;
    var threshold = typeof opts.thresholdBytes === 'number' ? opts.thresholdBytes : DEFAULT_THRESHOLD;
    if (!file || file.size < threshold) return Promise.resolve(file);
    var t0 = (global.performance && global.performance.now) ? global.performance.now() : Date.now();
    var imagePromise;
    if (typeof createImageBitmap === 'function') {
      imagePromise = createImageBitmap(file);
    } else {
      imagePromise = new Promise(function (resolve, reject) {
        var im = new Image();
        im.onload = function () { resolve(im); };
        im.onerror = reject;
        im.src = URL.createObjectURL(file);
      });
    }
    return imagePromise.then(function (img) {
      var w = img.width || img.naturalWidth;
      var h = img.height || img.naturalHeight;
      var scale = Math.min(maxDim / w, maxDim / h, 1);
      var newW = Math.round(w * scale);
      var newH = Math.round(h * scale);
      var canvas;
      if (typeof OffscreenCanvas === 'function') {
        canvas = new OffscreenCanvas(newW, newH);
      } else {
        canvas = document.createElement('canvas');
        canvas.width = newW;
        canvas.height = newH;
      }
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, newW, newH);
      var toBlob;
      if (canvas.convertToBlob) {
        toBlob = canvas.convertToBlob({ type: 'image/jpeg', quality: quality });
      } else {
        toBlob = new Promise(function (resolveBlob) {
          canvas.toBlob(function (b) { resolveBlob(b); }, 'image/jpeg', quality);
        });
      }
      return toBlob.then(function (blob) {
        if (img.close) img.close();
        var name = (file.name || 'image').replace(/\.[^.]+$/, '') + '_rs.jpg';
        var resized = new File([blob], name, { type: 'image/jpeg' });
        if (global.console && global.console.debug) {
          var dt = Math.round(
            ((global.performance && global.performance.now) ? global.performance.now() : Date.now()) - t0
          );
          global.console.debug(
            '[image-resize]',
            file.size, '→', resized.size, 'bytes (' +
            Math.round((1 - resized.size / file.size) * 100) + '% reduction) in', dt, 'ms'
          );
        }
        return resized;
      });
    }).catch(function (err) {
      if (global.console && global.console.warn) {
        global.console.warn('[image-resize] failed, fallback to original:', err && err.message ? err.message : err);
      }
      return file;
    });
  }
  global.FlipImageResize = { resize: resize };
})(typeof window !== 'undefined' ? window : this);

(function () {
  'use strict';

  var CONFIG = {
    apiUrl: '/ajax/image-search.php',
    objectsApiUrl: '/ajax/image-objects.php',
    maxFileSize: 30 * 1024 * 1024,
    allowedTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
  };

  function objectSelectionEnabled() {
    return !!(window.FLIP_FEATURES && window.FLIP_FEATURES.useObjectSelection);
  }

  // ===== SEARCH ANALYTICS (GA4) =====
  // Схема: search (уже шлётся счётчиком на выдаче) + кастомные search_open,
  // search_suggest_click, search_history_remove, search_by_image.
  // Способ начала поиска передаётся на выдачу через sessionStorage (SEARCH_CTX_KEY)
  // и подмешивается там в стандартный search как search_method/search_id.

  var SEARCH_CTX_KEY = 'flip_search_ctx';

  function ssEvent(name, params) {
    if (typeof window.gtag !== 'function') return;
    try { window.gtag('event', name, params || {}); } catch (e) { }
  }

  // GA4 запрещает PII. Чистим e-mail и последовательности от 10 цифр
  // (телефон, ИИН, номер карты) + режем до лимита значения параметра в 100 символов.
  function ssScrubTerm(str) {
    var src = String(str == null ? '' : str);
    var out = src.replace(/[^\s@]+@[^\s@]+\.[^\s@]+/g, '[email]');
    out = out.replace(/\+?\d[\d\s()\-]{8,}\d/g, function (m) {
      return m.replace(/\D/g, '').length >= 10 ? '[number]' : m;
    });
    var redacted = out !== src;
    if (out.length > 100) out = out.substring(0, 100);
    return { term: out, redacted: redacted };
  }

  function ssSearchId() {
    return 'sr_' + Math.random().toString(36).substring(2, 10);
  }

  // Источник поиска — для разреза «откуда стартовали»
  function ssSource() {
    var p = location.pathname;
    if (p === '/' || p === '') return 'home';
    if (p.indexOf('/search') === 0) return 'searchresults';
    if (p.indexOf('/catalog') === 0) return 'catalog';
    if (p.indexOf('/produce') === 0 || location.search.indexOf('prod=') !== -1) return 'product';
    return 'other';
  }

  // Мост на страницу результатов: метод + id живут 30 с и сверяются по запросу
  function ssSetContext(method, term, searchId) {
    try {
      sessionStorage.setItem(SEARCH_CTX_KEY, JSON.stringify({
        m: method,
        id: searchId || ssSearchId(),
        q: String(term || '').trim().toLowerCase(),
        t: Date.now()
      }));
    } catch (e) { }
  }

  var ICON_SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.0894 20.7561C21.9849 20.8609 21.8607 20.9442 21.7239 21.0009C21.5872 21.0577 21.4406 21.087 21.2925 21.087C21.1445 21.087 20.9978 21.0577 20.8611 21.0009C20.7244 20.9442 20.6002 20.8609 20.4956 20.7561L18.8006 19.0611C17.9312 19.5459 16.9158 19.6999 15.9417 19.4948C14.9676 19.2897 14.1005 18.7392 13.5004 17.945C12.9004 17.1507 12.6077 16.1663 12.6765 15.1732C12.7453 14.1801 13.171 13.2454 13.8749 12.5415C14.5788 11.8376 15.5135 11.412 16.5065 11.3432C17.4996 11.2744 18.4841 11.567 19.2783 12.1671C20.0726 12.7672 20.623 13.6343 20.8282 14.6084C21.0333 15.5825 20.8792 16.5979 20.3944 17.4673L22.0894 19.1614C22.1944 19.2659 22.2778 19.3902 22.3346 19.527C22.3915 19.6638 22.4208 19.8105 22.4208 19.9587C22.4208 20.1069 22.3915 20.2536 22.3346 20.3904C22.2778 20.5273 22.1944 20.6515 22.0894 20.7561ZM16.7935 17.3351C17.1643 17.3351 17.5268 17.2252 17.8352 17.0191C18.1435 16.8131 18.3838 16.5203 18.5257 16.1777C18.6676 15.835 18.7048 15.458 18.6324 15.0943C18.5601 14.7306 18.3815 14.3965 18.1193 14.1343C17.8571 13.8721 17.523 13.6935 17.1593 13.6212C16.7955 13.5488 16.4185 13.5859 16.0759 13.7279C15.7333 13.8698 15.4405 14.1101 15.2345 14.4184C15.0284 14.7268 14.9185 15.0893 14.9185 15.4601C14.9185 15.7064 14.967 15.9502 15.0612 16.1777C15.1554 16.4051 15.2935 16.6118 15.4676 16.786C15.6417 16.9601 15.8484 17.0982 16.0759 17.1924C16.3034 17.2866 16.5472 17.3351 16.7935 17.3351Z" fill="currentColor"/><path d="M20.25 3.375C20.7473 3.375 21.2239 3.57285 21.5755 3.92448C21.9272 4.27611 22.125 4.75272 22.125 5.25V9.54167C22.125 10.163 21.6213 10.6667 21 10.6667C20.3787 10.6667 19.875 10.163 19.875 9.54167V5.625H4.125V13.099L7.29948 9.92448C7.65109 9.57297 8.12782 9.37565 8.625 9.37565C9.12218 9.37565 9.59891 9.57297 9.95052 9.92448L11.1442 11.117C11.6022 11.5746 11.5645 12.3277 11.0631 12.7373C10.6437 13.0798 10.0368 13.0638 9.63606 12.6996L8.625 11.7806L4.125 16.2806V18.375H10.875C11.4963 18.375 12 18.8787 12 19.5C12 20.1213 11.4963 20.625 10.875 20.625H3.75C3.25272 20.625 2.77611 20.4272 2.42448 20.0755C2.07285 19.7239 1.875 19.2473 1.875 18.75V5.25C1.875 4.75272 2.07285 4.27611 2.42448 3.92448C2.77611 3.57285 3.25272 3.375 3.75 3.375H20.25Z" fill="currentColor"/><path d="M14.4258 7.61393C14.6998 7.50044 15.0015 7.47086 15.2923 7.52865C15.5833 7.58652 15.8508 7.72967 16.0605 7.93945C16.2703 8.14923 16.4135 8.41671 16.4714 8.70768C16.5291 8.99855 16.4996 9.30024 16.3861 9.57422C16.2725 9.84827 16.08 10.0826 15.8333 10.2474C15.5867 10.4122 15.2966 10.5 15 10.5C14.6022 10.5 14.2208 10.3419 13.9395 10.0605C13.6581 9.77924 13.5 9.39782 13.5 9C13.5 8.70337 13.5878 8.41332 13.7526 8.16667C13.9174 7.92002 14.1517 7.72747 14.4258 7.61393Z" fill="currentColor"/></svg>';

  var HEART_STROKE_SVG = '<svg width="24" height="24" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.2233 20.2493L15.3356 20.1492C17.248 18.4446 19.0186 16.8664 20.2924 15.3348C21.616 13.7433 22.6562 11.9113 22.6562 9.68367C22.6562 5.98541 19.6724 3.125 16.0156 3.125C14.7522 3.125 13.539 3.47593 12.5 4.07719C11.461 3.47593 10.2478 3.125 8.98438 3.125C5.32763 3.125 2.34375 5.98541 2.34375 9.68367C2.34375 11.9152 3.3876 13.7498 4.71516 15.3429C5.99293 16.8762 7.76887 18.4558 9.68695 20.1619L9.72273 20.1937L9.80609 20.2679L9.80749 20.2691L10.6797 21.048C11.7142 21.9718 13.2765 21.9747 14.3145 21.0548L15.1873 20.2814L15.2233 20.2493ZM12.7612 18.7171L12.7606 18.7165L12.7612 18.7171Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.6328 18.5273L12.7601 19.3008C12.6118 19.4322 12.3886 19.4318 12.2408 19.2998L11.3672 18.5197L11.3573 18.5109C7.33939 14.9369 4.6875 12.5781 4.6875 9.68367C4.6875 7.32331 6.57813 5.46875 8.98438 5.46875C9.89482 5.46875 10.7807 5.74719 11.5224 6.2258C11.7606 6.37948 11.9838 6.5538 12.1883 6.74617C12.3613 6.90897 12.6387 6.90897 12.8117 6.74617C13.0162 6.5538 13.2394 6.37948 13.4776 6.2258C14.2193 5.74719 15.1052 5.46875 16.0156 5.46875C18.4219 5.46875 20.3125 7.32331 20.3125 9.68367C20.3125 12.5731 17.6698 14.9287 13.6637 18.4998L13.6328 18.5273ZM14.6691 19.6967L13.7964 20.4702C13.055 21.1272 11.939 21.1251 11.2001 20.4652L10.3265 19.6851L10.3189 19.6784L10.242 19.61C8.29576 17.8789 6.55565 16.3311 5.31533 14.8427C4.04173 13.3144 3.125 11.6536 3.125 9.68367C3.125 6.43214 5.74368 3.90625 8.98438 3.90625C10.2107 3.90625 11.3886 4.27988 12.3696 4.91292C12.4134 4.9412 12.4569 4.97002 12.5 4.99938C12.5431 4.97002 12.5866 4.9412 12.6304 4.91292C13.6114 4.27988 14.7893 3.90625 16.0156 3.90625C19.2563 3.90625 21.875 6.43214 21.875 9.68367C21.875 11.6502 20.9614 13.3085 19.6917 14.8352C18.4553 16.3219 16.7205 17.8682 14.7801 19.5978L14.7034 19.6662L14.6691 19.6967Z" fill="black"/></svg>';

  var HEART_FULL_SVG = '<svg width="24" height="24" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.2233 20.2493L15.3356 20.1492C17.248 18.4446 19.0186 16.8664 20.2924 15.3348C21.616 13.7433 22.6562 11.9113 22.6562 9.68367C22.6562 5.98541 19.6724 3.125 16.0156 3.125C14.7522 3.125 13.539 3.47593 12.5 4.07719C11.461 3.47593 10.2478 3.125 8.98438 3.125C5.32763 3.125 2.34375 5.98541 2.34375 9.68367C2.34375 11.9152 3.3876 13.7498 4.71516 15.3429C5.99293 16.8762 7.76887 18.4558 9.68695 20.1619L9.72273 20.1937L9.80609 20.2679L9.80749 20.2691L10.6797 21.048C11.7142 21.9718 13.2765 21.9747 14.3145 21.0548L15.1873 20.2814L15.2233 20.2493ZM12.7612 18.7171L12.7606 18.7165L12.7612 18.7171Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.6691 19.6967L13.7964 20.4702C13.055 21.1272 11.939 21.1251 11.2001 20.4652L10.3265 19.6851L10.3189 19.6784L10.242 19.61C8.29576 17.8789 6.55565 16.3311 5.31533 14.8427C4.04173 13.3144 3.125 11.6536 3.125 9.68367C3.125 6.43214 5.74368 3.90625 8.98438 3.90625C10.2107 3.90625 11.3886 4.27988 12.3696 4.91292C12.4134 4.9412 12.4569 4.97002 12.5 4.99938C12.5431 4.97002 12.5866 4.9412 12.6304 4.91292C13.6114 4.27988 14.7893 3.90625 16.0156 3.90625C19.2563 3.90625 21.875 6.43214 21.875 9.68367C21.875 11.6502 20.9614 13.3085 19.6917 14.8352C18.4553 16.3219 16.7205 17.8682 14.7801 19.5978L14.7034 19.6662L14.6691 19.6967Z" fill="#F14529"/></svg>';

  var CAMERA_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M208,52H182.42L170,33.34A12,12,0,0,0,160,28H96a12,12,0,0,0-10,5.34L73.57,52H48A28,28,0,0,0,20,80V192a28,28,0,0,0,28,28H208a28,28,0,0,0,28-28V80A28,28,0,0,0,208,52Zm4,140a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V80a4,4,0,0,1,4-4H80a12,12,0,0,0,10-5.34L102.42,52h51.15L166,70.66A12,12,0,0,0,176,76h32a4,4,0,0,1,4,4ZM128,84a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,84Zm0,72a24,24,0,1,1,24-24A24,24,0,0,1,128,156Z"/></svg>';

  var UPLOAD_ICON_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#999" viewBox="0 0 256 256"><path d="M144,96a16,16,0,1,1,16,16A16,16,0,0,1,144,96Zm92-40V200a20,20,0,0,1-20,20H40a20,20,0,0,1-20-20V56A20,20,0,0,1,40,36H216A20,20,0,0,1,236,56ZM44,60v79.72l33.86-33.86a20,20,0,0,1,28.28,0L147.31,147l17.18-17.17a20,20,0,0,1,28.28,0L212,149.09V60Zm0,136H162.34L92,125.66l-48,48Zm168,0V183l-33.37-33.37L164.28,164l32,32Z"/></svg>';

  var PASTE_HOTKEY = /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent) ? '\u2318V' : 'Ctrl+V';

  var UPLOAD_PROMPT_HTML = UPLOAD_ICON_SVG +
    '<p>Нажмите или перетащите изображение</p>' +
    '<span>или вставьте из\u00a0буфера\u00a0\u2014 ' + PASTE_HOTKEY + '</span>' +
    '<span>JPG, PNG, GIF, WebP до\u202F30MB</span>';

  var selectedFile = null;
  var selectedBase64 = null;
  var modalOverlay = null;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initSearchSmart();
    createModal();
    initProductPageButton();
    initHeaderButton();
    initResultsPage();
    initBfcacheReset();
    initImageSearchClickTracking();
  }

  function initImageSearchClickTracking() {
    var trackedIds = {};

    function isOnImageSearchPage() {
      try {
        return new URLSearchParams(location.search).get('image_search') === '1';
      } catch (e) {
        return location.search.indexOf('image_search=1') !== -1;
      }
    }

    function extractProduceId(card) {
      if (!card) return null;
      var link = card.querySelector('a[data-event-item-id]');
      if (link && link.getAttribute('data-event-item-id')) {
        return link.getAttribute('data-event-item-id');
      }
      var fav = card.querySelector('input[data-favorite-checker][data-id]');
      if (fav && fav.getAttribute('data-id')) {
        return fav.getAttribute('data-id');
      }
      var anyLink = card.querySelector('a[href*="prod="]');
      if (anyLink) {
        var m = anyLink.getAttribute('href').match(/[?&]prod=(\d+)/);
        if (m) return m[1];
      }
      return null;
    }

    function extractPosition(card) {
      if (!card || !card.parentNode) return null;
      var siblings = Array.prototype.filter.call(card.parentNode.children, function (el) {
        return el.classList && el.classList.contains('new-product');
      });
      var idx = siblings.indexOf(card);
      return idx >= 0 ? idx : null;
    }

    function getContext() {
      var ctx = { query: '', inferredQuery: '', imageUrl: null };
      try {
        var raw = sessionStorage.getItem('imageSearchData');
        if (raw) {
          var d = JSON.parse(raw);
          ctx.imageUrl = d.imageUrl || null;
        }
      } catch (e) {}
      var sd = window.__imageSearchData;
      if (sd) {
        ctx.query = sd.searchText || '';
        ctx.inferredQuery = sd.inferredQuery || sd.searchText || '';
        if (!ctx.imageUrl) ctx.imageUrl = sd.imageUrl || null;
      }
      var input = document.getElementById('search_input') || document.querySelector('input[name="search"]');
      if (input && input.value && !ctx.query) ctx.query = input.value;
      return ctx;
    }

    function fireTrack(e) {
      if (!isOnImageSearchPage()) return;
      var card = e.target.closest && e.target.closest('.new-product');
      if (!card) return;
      var produceId = extractProduceId(card);
      if (!produceId) return;
      if (trackedIds[produceId]) return;
      trackedIds[produceId] = true;

      var ctx = getContext();
      var payload = JSON.stringify({
        produceId: produceId,
        position: extractPosition(card),
        query: ctx.query,
        inferredQuery: ctx.inferredQuery,
        imageUrl: ctx.imageUrl
      });

      try {
        if (navigator.sendBeacon) {
          var blob = new Blob([payload], { type: 'application/json' });
          navigator.sendBeacon('/ajax/is-c.php', blob);
        } else {
          fetch('/ajax/is-c.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: payload,
            keepalive: true,
            credentials: 'same-origin'
          });
        }
      } catch (err) {  }
    }

    document.addEventListener('pointerdown', fireTrack, true);
    document.addEventListener('click', fireTrack, true);
  }

  function initSearchSmart() {
    var input = document.getElementById('search_input')
    if (!input) return

    var form = input.closest('form')
    var wrapper = input.closest('.innerBlock') || form.parentElement
    var isMobile = !input.closest('.innerBlock')
    var dropdown = null
    var activeIndex = -1
    var isOpen = false
    var currentXhr = null
    var debounceTimer = null
    var prevData = null
    var queryCache = {}

    var SS_TOTAL_LIMIT = isMobile ? 7 : 10
    var SS_HISTORY_TYPING_LIMIT = isMobile ? 3 : 4
    var historyCache = {}
    var historyNegative = {}
    var historyXhr = null
    var pendingRender = null
    var SS_HISTORY_TIMEOUT = 1200
    var SS_DEBOUNCE = 250
    var SS_BACKOFF_MS = 3000
    var ssBlockedUntil = 0

    // nginx limit_req отбивает подсказки 503 при быстром наборе.
    // После отказа держим паузу: без неё запросы не дают ведру наполниться.
    function ssThrottled() {
      return Date.now() < ssBlockedUntil
    }

    function ssNoteStatus(status) {
      if (status === 503 || status === 429) ssBlockedUntil = Date.now() + SS_BACKOFF_MS
    }

    var ssOpenTracked = false
    var ssOpenedAt = 0
    var ssShownCount = 0
    var ssSearchIdCurrent = null

    function ssTrackClick(el, action, term) {
      var scrubbed = ssScrubTerm(term)
      ssSearchIdCurrent = ssSearchId()
      ssEvent('search_suggest_click', {
        suggestion_type: el.getAttribute('data-ss-type') || 'unknown',
        suggestion_action: action,
        suggestion_index: parseInt(el.getAttribute('data-ss-index'), 10) || 0,
        suggestion_block_index: parseInt(el.getAttribute('data-ss-block'), 10) || 0,
        suggestions_shown: ssShownCount,
        input_length: input.value.trim().length,
        time_to_select: ssOpenedAt ? (Date.now() - ssOpenedAt) : 0,
        search_term: scrubbed.term,
        term_redacted: scrubbed.redacted,
        search_source: ssSource(),
        search_id: ssSearchIdCurrent
      })
      return ssSearchIdCurrent
    }

    var SS_CLOCK_SVG = '<svg class="ss-icon-search" viewBox="0 0 256 256" width="16" height="16"><path d="M136,80v43.47l36.12,21.67a8,8,0,0,1-8.24,13.72l-40-24A8,8,0,0,1,120,128V80a8,8,0,0,1,16,0Zm-8-48A95.44,95.44,0,0,0,60.08,60.15C52.81,67.51,46.35,74.59,40,82V64a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16H49c7.15-8.42,14.27-16.35,22.39-24.57a80,80,0,1,1,1.66,114.75,8,8,0,1,0-11,11.64A96,96,0,1,0,128,32Z" fill="currentColor"/></svg>'
    var SS_REMOVE_SVG = '<svg viewBox="0 0 256 256" width="14" height="14"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" fill="currentColor"/></svg>'
    var SS_SEARCH_SVG = '<svg class="ss-icon-search" viewBox="0 0 256 256" width="16" height="16"><path d="M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" fill="currentColor"/></svg>'
    var SS_TREND_SVG = '<svg class="ss-icon-search" viewBox="0 0 256 256" width="16" height="16"><path d="M232,56v64a8,8,0,0,1-16,0V75.31l-82.34,82.35a8,8,0,0,1-11.32,0L96,131.31,29.66,197.66a8,8,0,0,1-11.32-11.32l72-72a8,8,0,0,1,11.32,0L128,140.69,204.69,64H168a8,8,0,0,1,0-16h64A8,8,0,0,1,232,56Z" fill="currentColor"/></svg>'

    function getHistoryItems(query) {
      var items = historyCache[(query || '').toLowerCase()]
      if (!Array.isArray(items)) return []
      if (!query) return items.slice(0, SS_TOTAL_LIMIT)
      var q = query.toLowerCase()
      var res = []
      for (var i = 0; i < items.length; i++) {
        if (res.length >= SS_HISTORY_TYPING_LIMIT) break
        if (items[i].toLowerCase() !== q) res.push(items[i])
      }
      return res
    }

    function hasNegativePrefix(key) {
      for (var p in historyNegative) {
        if (key.indexOf(p) === 0) return true
      }
      return false
    }

    function isHistoryReady(query) {
      var key = (query || '').toLowerCase()
      return Array.isArray(historyCache[key]) || hasNegativePrefix(key)
    }

    function flushPendingRender(force) {
      if (!pendingRender) return
      if (!force && !isHistoryReady(pendingRender.query)) return
      var data = pendingRender.data
      var query = pendingRender.query
      pendingRender = null
      renderNow(data, query)
    }

    function loadHistory(query) {
      var key = (query || '').toLowerCase()
      if (historyCache[key] || hasNegativePrefix(key)) return
      // Под лимитом историю не ждём — отдаём то, что уже есть
      if (ssThrottled()) { flushPendingRender(true); return }

      if (historyXhr) {
        historyXhr.abort()
        historyXhr = null
      }

      var xhr = new XMLHttpRequest()
      historyXhr = xhr
      xhr.open('GET', '/ajax/search_keyword.php?type=history' + (key ? '&q=' + encodeURIComponent(query) : ''))
      xhr.timeout = SS_HISTORY_TIMEOUT
      xhr.onload = function () {
        historyXhr = null
        if (xhr.status !== 200) {
          ssNoteStatus(xhr.status)
          flushPendingRender(true)
          return
        }
        var items
        try {
          items = JSON.parse(xhr.responseText).history
        } catch (e) {
          flushPendingRender(true)
          return
        }
        if (!Array.isArray(items)) items = []
        items = items.filter(function (it) { return typeof it === 'string' && it !== '' })
        historyCache[key] = items
        if (items.length === 0) historyNegative[key] = true

        if (pendingRender) {
          flushPendingRender(false)
        } else if (items.length > 0 && document.activeElement === input && input.value.trim().toLowerCase() === key) {
          var cached = queryCache[key]
          if (cached) render(cached, input.value.trim())
        }
      }
      xhr.onerror = function () {
        historyXhr = null
        flushPendingRender(true)
      }
      xhr.ontimeout = function () {
        historyXhr = null
        flushPendingRender(true)
      }
      xhr.send()
    }

    function removeHistoryItem(request) {
      for (var key in historyCache) {
        var arr = historyCache[key]
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] === request) { arr.splice(i, 1); break }
        }
      }

      var xhr = new XMLHttpRequest()
      xhr.open('POST', '/ajax/search_keyword.php')
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
      // Сервер не скрыл запись — сбрасываем кэш, чтобы список не расходился
      // с реальностью: при следующем фокусе придёт честная история
      xhr.onload = function () {
        var ok = false
        try { ok = JSON.parse(xhr.responseText).ok === true } catch (e) { }
        if (!ok) {
          historyCache = {}
          historyNegative = {}
        }
      }
      xhr.send('action=hide_history&request=' + encodeURIComponent(request))

      var query = input.value.trim()
      var data = queryCache[query.toLowerCase()] || prevData
      if (data) {
        render(data, query)
      } else {
        fetchSuggestions(query)
      }
    }

    function createDropdown() {
      dropdown = document.createElement('div')
      dropdown.className = 'ss-dropdown'
      dropdown.id = 'ss-listbox'
      dropdown.setAttribute('role', 'listbox')
      dropdown.style.display = 'none'
      if (!isMobile) {
        wrapper.style.position = 'relative'
      }
      wrapper.appendChild(dropdown)
    }

    createDropdown()

    input.setAttribute('role', 'combobox')
    input.setAttribute('aria-autocomplete', 'list')
    input.setAttribute('aria-controls', 'ss-listbox')
    input.setAttribute('aria-expanded', 'false')

    var submitBtn = form.querySelector('button[type="submit"]')
    var inputWrap = input.closest('.is-input-wrap')

    var searchSuggests = document.getElementById('searchSuggests')
    if (isMobile && searchSuggests) searchSuggests.style.display = 'none'

    var closeSearchBtn = document.getElementById('close-search')
    if (closeSearchBtn) {
      closeSearchBtn.addEventListener('click', function () { close() })
    }

    function open() {
      var formRect = form.getBoundingClientRect()
      if (isMobile) {

        dropdown.style.top = formRect.bottom + 'px'
        dropdown.style.left = formRect.left + 'px'
        dropdown.style.right = (window.innerWidth - formRect.right) + 'px'
      } else {
        var wrapperRect = wrapper.getBoundingClientRect()
        dropdown.style.top = (formRect.bottom - wrapperRect.top) + 'px'
      }
      dropdown.style.display = 'block'
      isOpen = true
      input.setAttribute('aria-expanded', 'true')
      wrapper.classList.add('ss-dropdown-open')

      if (!isMobile && !document.body.classList.contains('ss-search-overlay')) {
        var sbw = window.innerWidth - document.documentElement.clientWidth
        document.body.classList.add('ss-search-overlay')
        if (sbw > 0) document.body.style.paddingRight = sbw + 'px'
      }

      if (searchSuggests) searchSuggests.style.display = 'none'
      if (inputWrap) inputWrap.style.setProperty('border-radius', '8px 0 0 0', 'important')
      if (submitBtn) submitBtn.style.setProperty('border-radius', '0 8px 0 0', 'important')
    }

    function close() {
      if (dropdown) {
        dropdown.style.display = 'none'
        dropdown.innerHTML = ''
      }
      isOpen = false
      activeIndex = -1
      prevData = null
      pendingRender = null
      input.setAttribute('aria-expanded', 'false')
      input.removeAttribute('aria-activedescendant')
      wrapper.classList.remove('ss-dropdown-open')
      document.body.classList.remove('ss-search-overlay')
      document.body.style.removeProperty('padding-right')
      if (inputWrap) inputWrap.style.removeProperty('border-radius')
      if (submitBtn) submitBtn.style.removeProperty('border-radius')
    }

    function fetchSuggestions(query) {

      var cacheKey = query.toLowerCase()
      if (queryCache[cacheKey]) {
        render(queryCache[cacheKey], query)
        return
      }

      if (ssThrottled()) return

      if (currentXhr) {
        currentXhr.abort()
        currentXhr = null
      }

      var xhr = new XMLHttpRequest()
      currentXhr = xhr
      xhr.open('GET', '/ajax/search_keyword.php?q=' + encodeURIComponent(query) + '&type=smart')
      xhr.onload = function () {
        currentXhr = null
        ssNoteStatus(xhr.status)
        if (xhr.status === 200) {
          try {
            var data = JSON.parse(xhr.responseText)
            queryCache[cacheKey] = data
            render(data, query)
          } catch (e) {
            close()
          }
        }
      }
      xhr.onerror = function () {
        currentXhr = null
        close()
      }
      xhr.send()
    }

    function render(data, query) {
      if (!isHistoryReady(query)) {
        pendingRender = { data: data, query: query }
        loadHistory(query)
        return
      }
      pendingRender = null
      renderNow(data, query)
    }

    function renderNow(data, query) {

      if (prevData && query) {
        if ((!data.terms || data.terms.length === 0) && prevData.terms && prevData.terms.length > 0) {
          data.terms = prevData.terms
        }

      }
      prevData = query ? data : null

      var historyItems = getHistoryItems(query)
      var hasHistory = historyItems.length > 0

      var termsToShow = []
      if (data.terms && data.terms.length > 0) {
        var historySet = {}
        for (var hi = 0; hi < historyItems.length; hi++) {
          historySet[historyItems[hi].toLowerCase()] = true
        }
        var termsLimit = Math.max(0, SS_TOTAL_LIMIT - historyItems.length)
        var queryLower = (query || '').toLowerCase()
        for (var ti = 0; ti < data.terms.length; ti++) {
          if (termsToShow.length >= termsLimit) break
          var termLower = String(data.terms[ti]).toLowerCase()
          if (termLower !== queryLower && !historySet[termLower]) termsToShow.push(data.terms[ti])
        }
      }

      var hasTerms = termsToShow.length > 0
      var hasChips = data.chips && data.chips.length > 0
      var hasSections = data.sections && data.sections.length > 0

      if (!hasTerms && !hasChips && !hasSections && !hasHistory) {
        close()
        return
      }

      var html = ''

      if (hasChips) {
        html += '<div class="ss-chips">'
        for (var c = 0; c < data.chips.length; c++) {
          html += '<span class="ss-chip" data-ss-type="chip" data-ss-index="' + c + '" data-chip="' + escapeHtml(data.chips[c]) + '">' + escapeHtml(data.chips[c]) + '</span>'
        }
        html += '</div>'
      }

      if (hasHistory || hasTerms) {
        html += '<div class="ss-section">'
        for (var h = 0; h < historyItems.length; h++) {
          var hVal = escapeHtml(historyItems[h])
          html += '<div class="ss-item ss-item-term ss-item-history" data-ss-type="history" data-ss-index="' + h + '" data-value="' + hVal + '">'
          html += SS_CLOCK_SVG
          html += '<span>' + highlightMatch(historyItems[h], query) + '</span>'
          html += '<button type="button" class="ss-history-remove" data-request="' + hVal + '" aria-label="Удалить из истории поиска">' + SS_REMOVE_SVG + '</button>'
          html += '</div>'
        }
        for (var t = 0; t < termsToShow.length; t++) {
          html += '<div class="ss-item ss-item-term" data-ss-type="' + (query ? 'phrase' : 'trending') + '" data-ss-index="' + t + '" data-value="' + escapeHtml(termsToShow[t]) + '">'
          html += (query ? SS_SEARCH_SVG : SS_TREND_SVG)
          html += '<span>' + highlightMatch(termsToShow[t], query) + '</span>'
          html += '</div>'
        }
        html += '</div>'
      }

      if (hasSections) {
        html += '<div class="ss-columns">'
        for (var s = 0; s < data.sections.length; s++) {
          var section = data.sections[s]
          if (!section.items || section.items.length === 0) continue
          html += '<div class="ss-col">'
          html += '<div class="ss-col-label">' + escapeHtml(section.title) + '</div>'
          for (var si = 0; si < section.items.length; si++) {
            var item = section.items[si]
            if (!item.name) continue
            html += '<div class="ss-item ss-item-section" data-ss-type="' + escapeHtml(section.type || 'section') + '" data-ss-index="' + si + '" data-ss-block="' + s + '" data-url="' + escapeHtml(item.url) + '">'
            if (item.image) {
              html += '<img class="ss-icon-img" src="' + escapeHtml(item.image) + '">'
            } else {
              html += avatarHtml(item.name)
            }
            html += '<div class="ss-item-text">'
            html += '<div class="ss-item-name">' + escapeHtml(item.name) + '</div>'
            if (item.subtitle) html += '<div class="ss-item-sub">' + escapeHtml(item.subtitle) + '</div>'
            html += '</div></div>'
          }
          html += '</div>'
        }
        html += '</div>'
      }

      dropdown.innerHTML = '<div class="ss-dropdown-inner">' + html + '</div>'

      var options = getSelectableItems()
      for (var oi = 0; oi < options.length; oi++) {
        options[oi].id = 'ss-opt-' + oi
        options[oi].setAttribute('role', 'option')
        options[oi].setAttribute('aria-selected', 'false')
      }

      open()
      activeIndex = -1
      input.removeAttribute('aria-activedescendant')

      ssShownCount = options.length
      // Одно событие на загрузку страницы: слать по факту отрисовки списка,
      // а не по focus (иначе случайные фокусы зашумят отчёты)
      if (!ssOpenTracked) {
        ssOpenTracked = true
        ssOpenedAt = Date.now()
        ssEvent('search_open', {
          search_source: ssSource(),
          search_ui: isMobile ? 'overlay_mobile' : 'header',
          has_history: hasHistory,
          history_items: historyItems.length,
          trending_items: query ? 0 : termsToShow.length,
          suggestions_shown: ssShownCount
        })
      }

      bindDropdownEvents()
    }

    function bindDropdownEvents() {

      var imgs = dropdown.querySelectorAll('.ss-icon-img')
      for (var ii = 0; ii < imgs.length; ii++) {
        imgs[ii].addEventListener('error', function () {
          var item = this.closest('.ss-item')
          var nameEl = item ? item.querySelector('.ss-item-name') : null
          var name = nameEl ? nameEl.textContent : '?'
          var avatar = document.createElement('div')
          avatar.className = 'ss-avatar'
          var code = 0
          for (var k = 0; k < name.length; k++) code += name.charCodeAt(k)
          avatar.style.background = avatarColors[code % avatarColors.length]
          avatar.textContent = name.charAt(0).toUpperCase()
          this.parentNode.replaceChild(avatar, this)
        })
      }

      var chips = dropdown.querySelectorAll('.ss-chip')
      for (var i = 0; i < chips.length; i++) {
        chips[i].addEventListener('click', function (e) {
          e.preventDefault()
          e.stopPropagation()
          var words = input.value.trim().split(/\s+/)
          var chip = this.getAttribute('data-chip')
          var lastWord = words[words.length - 1].toLowerCase()
          if (chip.toLowerCase().indexOf(lastWord) === 0) {

            words[words.length - 1] = chip
          } else {

            words.push(chip)
          }
          input.value = words.join(' ') + ' '
          input.focus()
          // Чипс дописывает слово и не отправляет поиск — action=complete
          ssTrackClick(this, 'complete', input.value.trim())
          loadHistory(input.value.trim())
          fetchSuggestions(input.value.trim())
        })
      }

      var terms = dropdown.querySelectorAll('.ss-item-term')
      for (var t = 0; t < terms.length; t++) {
        terms[t].addEventListener('click', function () {
          var value = this.getAttribute('data-value')
          input.value = value
          var id = ssTrackClick(this, 'submit', value)
          ssSetContext(this.getAttribute('data-ss-type') || 'suggest_phrase', value, id)
          close()
          form.submit()
        })
      }

      var linkItems = dropdown.querySelectorAll('.ss-item-section')
      for (var li = 0; li < linkItems.length; li++) {
        linkItems[li].addEventListener('click', function () {
          var url = this.getAttribute('data-url')
          if (!url || (url.charAt(0) !== '/' && url.indexOf('http') !== 0)) return
          var nameEl = this.querySelector('.ss-item-name')
          var id = ssTrackClick(this, 'submit', nameEl ? nameEl.textContent : input.value.trim())
          ssSetContext(this.getAttribute('data-ss-type') || 'category', input.value.trim(), id)
          close()
          window.location.href = url
        })
      }

      var removes = dropdown.querySelectorAll('.ss-history-remove')
      for (var ri = 0; ri < removes.length; ri++) {
        removes[ri].addEventListener('mousedown', function (e) {
          e.preventDefault()
        })
        removes[ri].addEventListener('click', function (e) {
          e.preventDefault()
          e.stopPropagation()
          var row = this.closest('.ss-item-history')
          ssEvent('search_history_remove', {
            suggestion_index: row ? (parseInt(row.getAttribute('data-ss-index'), 10) || 0) : 0,
            history_items: getHistoryItems(input.value.trim()).length,
            search_source: ssSource()
          })
          removeHistoryItem(this.getAttribute('data-request'))
        })
      }
    }

    function escapeHtml(str) {
      if (!str) return ''
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
    }

    var avatarColors = ['#4A90D9', '#E06C75', '#D19A66', '#61AFEF', '#98C379', '#C678DD', '#56B6C2', '#BE5046']
    function avatarHtml(name) {
      var letter = (name || '?').charAt(0).toUpperCase()
      var code = 0
      for (var k = 0; k < name.length; k++) code += name.charCodeAt(k)
      var color = avatarColors[code % avatarColors.length]
      return '<div class="ss-avatar" style="background:' + color + '">' + escapeHtml(letter) + '</div>'
    }

    function highlightMatch(text, query) {
      text = String(text)
      if (!query) return '<b>' + escapeHtml(text) + '</b>'
      var idx = text.toLowerCase().indexOf(query.toLowerCase())
      if (idx === -1) return '<b>' + escapeHtml(text) + '</b>'
      var end = idx + query.length
      return escapeHtml(text.substring(0, idx)) + escapeHtml(text.substring(idx, end)) + '<b>' + escapeHtml(text.substring(end)) + '</b>'
    }

    function getSelectableItems() {
      if (!dropdown) return []
      return dropdown.querySelectorAll('.ss-chip, .ss-item-term, .ss-item-section')
    }

    function setActive(index) {
      var items = getSelectableItems()
      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('ss-item-active')
        items[i].setAttribute('aria-selected', 'false')
      }
      activeIndex = index
      if (index >= 0 && index < items.length) {
        items[index].classList.add('ss-item-active')
        items[index].setAttribute('aria-selected', 'true')
        input.setAttribute('aria-activedescendant', items[index].id)
        items[index].scrollIntoView({ block: 'nearest' })
      } else {
        input.removeAttribute('aria-activedescendant')
      }
    }

    function handleTabEnterNavigation(e, items) {
      if (e.keyCode === 9) {
        e.preventDefault()
        if (e.shiftKey) {
          setActive(activeIndex > 0 ? activeIndex - 1 : items.length - 1)
        } else {
          setActive(activeIndex < items.length - 1 ? activeIndex + 1 : 0)
        }
      } else if (e.keyCode === 13) {
        if (activeIndex >= 0 && activeIndex < items.length) {
          e.preventDefault()
          items[activeIndex].click()
        }
      }
    }

    input.addEventListener('input', function () {
      var value = this.value.trim()
      clearTimeout(debounceTimer)
      debounceTimer = setTimeout(function () {
        loadHistory(value)
        fetchSuggestions(value)
      }, SS_DEBOUNCE)
    })

    input.addEventListener('keydown', function (e) {
      if (!isOpen) return

      var items = getSelectableItems()
      if (items.length === 0) return

      if (e.keyCode === 9 || e.keyCode === 13) {
        handleTabEnterNavigation(e, items)
      } else if (e.keyCode === 40) {
        e.preventDefault()
        if (activeIndex >= 0 && items[activeIndex].classList.contains('ss-chip')) {
          var firstNonChip = -1
          for (var i = activeIndex + 1; i < items.length; i++) {
            if (!items[i].classList.contains('ss-chip')) {
              firstNonChip = i
              break
            }
          }
          if (firstNonChip !== -1) {
            setActive(firstNonChip)
          } else {
            setActive(0)
          }
        } else {
          setActive(activeIndex < items.length - 1 ? activeIndex + 1 : 0)
        }
      } else if (e.keyCode === 38) {
        e.preventDefault()
        if (activeIndex >= 0 && items[activeIndex].classList.contains('ss-chip')) {
          setActive(items.length - 1)
        } else if (activeIndex > 0 && !items[activeIndex].classList.contains('ss-chip') && items[activeIndex - 1].classList.contains('ss-chip')) {
          setActive(0)
        } else {
          setActive(activeIndex > 0 ? activeIndex - 1 : items.length - 1)
        }
      } else if (e.keyCode === 27) {
        close()
      }
    })

    input.addEventListener('focus', function () {
      loadHistory(this.value.trim())
      if (dropdown.innerHTML) {
        open()
      } else {
        fetchSuggestions(this.value.trim())
      }
    })

    // Ручная отправка (Enter или кнопка). Клик по подсказке идёт через
    // form.submit(), который событие submit не порождает — двойной записи нет
    form.addEventListener('submit', function () {
      ssSetContext('manual', input.value.trim(), ssSearchId())
    })

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) {
        close()
      }
    })

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) close()
    })
  }

  function initBfcacheReset() {
    window.addEventListener('pageshow', function (event) {

      resetAllLoaders();
    });
  }

  function resetAllLoaders() {

    var productSearchBtn = document.querySelector('.is-action-btn:not(.is-heart-btn)');
    if (productSearchBtn && productSearchBtn.classList.contains('is-loading')) {
      productSearchBtn.classList.remove('is-loading');
      productSearchBtn.innerHTML = ICON_SVG;
    }

    var camBtns = document.querySelectorAll('.is-cam-btn');
    camBtns.forEach(function (btn) {
      btn.disabled = false;
      if (btn.querySelector('.is-spinner-sm')) btn.innerHTML = CAMERA_SVG;
    });

    var uploadArea = document.getElementById('isUploadArea');
    if (uploadArea && uploadArea.classList.contains('is-loading')) {
      uploadArea.classList.remove('is-loading');
      uploadArea.innerHTML = UPLOAD_PROMPT_HTML;
    }
    var selectBtn = document.getElementById('isSelectBtn');
    if (selectBtn) {
      selectBtn.disabled = false;
      selectBtn.textContent = 'Выбрать на компьютере';
    }

    var searchForm = document.querySelector('#search_produce_form') ||
      document.querySelector('.sAll') ||
      document.querySelector('form[name="search_form"]');
    if (searchForm) {
      var submitBtn = searchForm.querySelector('button[type="submit"]');
      if (submitBtn && (submitBtn.disabled || submitBtn.querySelector('.is-spinner-sm'))) {
        submitBtn.disabled = false;
        submitBtn.textContent = '';
        var img = document.createElement('img');
        img.src = '/img/search-header-icon.svg';
        submitBtn.appendChild(img);
      }
    }
  }

  function initProductPageButton() {
    var urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has('prod')) return;

    var imageContainer = document.querySelector('.prod_pic') ||
      document.querySelector('.main_left_top_middle_left .img') ||
      document.querySelector('.good_page .img');
    if (!imageContainer) return;

    var productImage = imageContainer.querySelector('.product_img_cell img') ||
      imageContainer.querySelector('.cubespinner .face img') ||
      imageContainer.querySelector('img');

    var favInput = imageContainer.querySelector('input[name="favorite"]');
    var favLabel = favInput ? favInput.nextElementSibling : null;
    if (favLabel) {
      favLabel.style.display = 'none';
      favLabel.classList.add('is-hidden');
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'is-action-bar';

    var btn = document.createElement('div');
    btn.className = 'is-action-btn';
    btn.title = 'Найти похожие';
    btn.innerHTML = ICON_SVG;
    wrapper.appendChild(btn);

    if (favInput) {
      var heartBtn = document.createElement('div');
      heartBtn.className = 'is-action-btn is-heart-btn';
      heartBtn.title = 'В избранное';
      heartBtn.innerHTML = favInput.checked ? HEART_FULL_SVG : HEART_STROKE_SVG;

      heartBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        favInput.click();
        setTimeout(function () {
          heartBtn.innerHTML = favInput.checked ? HEART_FULL_SVG : HEART_STROKE_SVG;
        }, 50);
      });
      wrapper.appendChild(heartBtn);
    }

    imageContainer.style.position = 'relative';
    imageContainer.appendChild(wrapper);

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var currentSrc = productImage ? (productImage.src || productImage.getAttribute('data-src')) : null;
      if (!currentSrc) return;
      btn.classList.add('is-loading');
      btn.innerHTML = '<span class="is-spinner-sm"></span>';
      sendSearchRequest({ imageUrl: currentSrc }, function () {
        btn.classList.remove('is-loading');
        btn.innerHTML = ICON_SVG;
      });
    });
  }

  function initHeaderButton() {
    var cameraBtn = document.querySelector('header .sAll .is-cam-btn');
    if (!cameraBtn) return;

    cameraBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      ssEvent('search_by_image', { stage: 'open', search_source: ssSource() });
      openModal();
    });
  }

  function initResultsPage() {
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('image_search') !== '1') return;

    var serverData = window.__imageSearchData || {};
    var inferredQuery = serverData.searchText || serverData.inferredQuery || '';

    var savedImageData = null;
    try {
      var raw = sessionStorage.getItem('imageSearchData');
      if (raw) savedImageData = JSON.parse(raw);
    } catch (e) {  }

    var thumbnail = savedImageData ? savedImageData.thumbnail : (serverData.imageUrl || null);

    var searchInput = document.getElementById('search_input') ||
      document.querySelector('input[name="search"]');
    if (searchInput && inferredQuery) {
      searchInput.value = inferredQuery;
    }

    if (thumbnail && searchInput) {
      var form = searchInput.closest('form');
      var inputWrap = searchInput.closest('.is-input-wrap');
      var target = inputWrap || form;
      if (target) {
        var chip = document.createElement('div');
        chip.className = 'is-chip';

        var chipImg = document.createElement('img');
        chipImg.src = thumbnail;
        chip.appendChild(chipImg);

        var chipX = document.createElement('span');
        chipX.className = 'is-chip-x';
        chipX.textContent = '\u00d7';
        chipX.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          chip.remove();
          savedImageData = null;
          sessionStorage.removeItem('imageSearchData');
          if (form) form._isImageSearchBound = false;

          searchInput.style.paddingLeft = '';
        });
        chip.appendChild(chipX);

        target.insertBefore(chip, searchInput);
        searchInput.style.paddingLeft = '6px';
      }
    }

    var searchForm = searchInput ? searchInput.closest('form') : null;
    if (searchForm && savedImageData) {
      searchForm._isImageSearchBound = true;
      searchForm.addEventListener('submit', function (e) {
        if (!searchForm._isImageSearchBound) return;
        e.preventDefault();

        var text = searchInput.value.trim();
        if (!text && !savedImageData) return;
        var requestData = { text: text };

        if (savedImageData.imageBase64) {
          requestData.imageBase64 = savedImageData.imageBase64;
          requestData.imageMimeType = savedImageData.imageMimeType || 'image/jpeg';
        } else if (savedImageData.imageUrl) {
          requestData.imageUrl = savedImageData.imageUrl;
        } else {
          searchForm._isImageSearchBound = false;
          searchForm.submit();
          return;
        }

        var submitBtn = searchForm.querySelector('button[type="submit"]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = '';
          var sp = document.createElement('span');
          sp.className = 'is-spinner-sm';
          submitBtn.appendChild(sp);
        }

        sendSearchRequest(requestData, function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = '';
            var img = document.createElement('img');
            img.src = '/img/search-header-icon.svg';
            submitBtn.appendChild(img);
          }
        });
      });
    }

    var heading = document.querySelector('.table.h1 h1') || document.querySelector('.table.h1 h2');
    if (heading && inferredQuery) {
      heading.textContent = inferredQuery;
    } else if (heading) {
      heading.textContent = 'Похожие товары';
    }

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {

        sessionStorage.removeItem('imageSearchData');
        var existingChip = document.querySelector('.is-chip');
        if (existingChip) {
          existingChip.remove();
          if (searchInput) searchInput.style.paddingLeft = '';
        }
      }
    });
  }

  function createModal() {
    modalOverlay = document.createElement('div');
    modalOverlay.className = 'is-modal-overlay';

    var modal = document.createElement('div');
    modal.className = 'is-modal';

    var header = document.createElement('div');
    header.className = 'is-modal-header';

    var title = document.createElement('h2');
    title.textContent = 'Поиск по изображению';

    var closeBtn = document.createElement('button');
    closeBtn.className = 'is-modal-close';
    closeBtn.type = 'button';
    closeBtn.textContent = '\u00d7';
    closeBtn.addEventListener('click', closeModal);

    header.appendChild(title);
    modal.appendChild(closeBtn);

    var body = document.createElement('div');
    body.className = 'is-modal-body';

    var uploadArea = document.createElement('div');
    uploadArea.className = 'is-upload-area';
    uploadArea.id = 'isUploadArea';
    uploadArea.innerHTML = UPLOAD_PROMPT_HTML;

    var fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.id = 'isFileInput';
    fileInput.accept = 'image/*';
    fileInput.style.display = 'none';

    var selectBtn = document.createElement('button');
    selectBtn.className = 'is-btn-select';
    selectBtn.id = 'isSelectBtn';
    selectBtn.textContent = 'Выбрать на компьютере';

    var objectsArea = document.createElement('div');
    objectsArea.className = 'is-objects-area';
    objectsArea.id = 'isObjectsArea';
    objectsArea.style.display = 'none';
    objectsArea.innerHTML =
      '<div class="is-objects-hint" id="isObjectsHint">Нажмите на точку чтобы искать по этому объекту</div>' +
      '<div class="is-objects-stage" id="isObjectsStage">' +
        '<img class="is-objects-img" id="isObjectsImg" alt="">' +
        '<svg class="is-objects-svg" id="isObjectsSvg" xmlns="http://www.w3.org/2000/svg"></svg>' +
        '<div class="is-objects-points" id="isObjectsPoints"></div>' +
        '<div class="is-objects-crop" id="isObjectsCrop"></div>' +
      '</div>' +
      '<button type="button" class="is-objects-back" id="isObjectsBack">← Назад</button>';

    body.appendChild(uploadArea);
    body.appendChild(objectsArea);
    body.appendChild(fileInput);
    body.appendChild(selectBtn);

    modal.appendChild(header);
    modal.appendChild(body);
    modalOverlay.appendChild(modal);
    document.body.appendChild(modalOverlay);

    uploadArea.addEventListener('click', function () {
      if (!uploadArea.classList.contains('is-loading')) fileInput.click();
    });
    uploadArea.addEventListener('dragover', function (e) { e.preventDefault(); if (!uploadArea.classList.contains('is-loading')) this.classList.add('dragover'); });
    uploadArea.addEventListener('dragleave', function () { this.classList.remove('dragover'); });
    uploadArea.addEventListener('drop', function (e) {
      e.preventDefault(); this.classList.remove('dragover');
      if (!uploadArea.classList.contains('is-loading') && e.dataTransfer.files.length > 0) handleFile(e.dataTransfer.files[0]);
    });
    fileInput.addEventListener('change', function () {
      if (this.files.length > 0) handleFile(this.files[0]);
    });
    selectBtn.addEventListener('click', function () { fileInput.click(); });
    document.getElementById('isObjectsBack').addEventListener('click', resetToUploadView);
    modalOverlay.addEventListener('click', function (e) {
      if (e.target === modalOverlay) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalOverlay.classList.contains('active')) closeModal();
    });
    // Вставка картинки из буфера (скриншот, «Копировать изображение»).
    // На экране выбора объекта новая картинка заменяет текущую.
    document.addEventListener('paste', function (e) {
      if (!modalOverlay.classList.contains('active') || isUploadBusy()) return;
      var file = getClipboardImage(e.clipboardData);
      if (!file) {
        showToast('В буфере обмена нет изображения', 'error');
        return;
      }
      e.preventDefault();
      resetToUploadView();
      handleFile(file);
    });
  }

  // Идёт детекция объектов или поиск — новую картинку не принимаем.
  function isUploadBusy() {
    var objectsArea = document.getElementById('isObjectsArea');
    if (objectsArea && objectsArea.style.display !== 'none') {
      return document.getElementById('isObjectsPoints').style.pointerEvents === 'none';
    }
    return document.getElementById('isUploadArea').classList.contains('is-loading');
  }

  function getClipboardImage(clipboardData) {
    if (!clipboardData) return null;
    var items = clipboardData.items || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].kind === 'file' && items[i].type.indexOf('image/') === 0) {
        return items[i].getAsFile();
      }
    }
    var files = clipboardData.files || [];
    for (var j = 0; j < files.length; j++) {
      if (files[j].type.indexOf('image/') === 0) return files[j];
    }
    return null;
  }

  function openModal() {
    selectedFile = null;
    selectedBase64 = null;
    resetToUploadView();
    modalOverlay.classList.add('active');
  }

  function resetToUploadView() {
    var uploadArea = document.getElementById('isUploadArea');
    var objectsArea = document.getElementById('isObjectsArea');
    var fileInput = document.getElementById('isFileInput');
    var selectBtn = document.getElementById('isSelectBtn');
    if (!uploadArea) return;
    uploadArea.classList.remove('is-loading');
    uploadArea.style.display = 'flex';
    uploadArea.innerHTML = UPLOAD_PROMPT_HTML;
    selectBtn.disabled = false;
    selectBtn.textContent = 'Выбрать на компьютере';
    if (objectsArea) objectsArea.style.display = 'none';
    // selectObject/animateCropAndSubmit блокируют точки — снимаем, иначе на следующей картинке они некликабельны
    var pointsBox = document.getElementById('isObjectsPoints');
    if (pointsBox) pointsBox.style.pointerEvents = '';
    fileInput.value = '';
  }

  function closeModal() {
    modalOverlay.classList.remove('active');
    selectedFile = null;
    selectedBase64 = null;
  }

  function handleFile(file) {
    if (CONFIG.allowedTypes.indexOf(file.type) === -1) {
      showToast('Неподдерживаемый формат. Используйте JPG, PNG, GIF или WebP.', 'error');
      return;
    }
    if (file.size > CONFIG.maxFileSize) {
      showToast('Файл слишком большой. Максимум\u202F30MB.', 'error');
      return;
    }

    var resizeFn = (window.FlipImageResize && window.FlipImageResize.resize)
      ? window.FlipImageResize.resize
      : function (f) { return Promise.resolve(f); };
    resizeFn(file).then(function (resized) {
      selectedFile = resized;
      if (objectSelectionEnabled()) {
        handleFileWithDetection(resized);
      } else {
        sendWholeFileSearch(resized);
      }
    });
  }

  function sendWholeFileSearch(file) {
    var uploadArea = document.getElementById('isUploadArea');
    var selectBtn = document.getElementById('isSelectBtn');
    uploadArea.classList.add('is-loading');
    uploadArea.innerHTML = '<span class="is-spinner-lg"></span>' +
      '<p>Поиск похожих товаров…</p>';
    selectBtn.disabled = true;

    var reader = new FileReader();
    reader.onload = function (e) {
      var dataUrl = e.target.result;
      selectedBase64 = dataUrl.split(',')[1];
      sendSearchRequest(
        { imageBase64: selectedBase64, imageMimeType: file.type },
        function () {
          uploadArea.classList.remove('is-loading');
          uploadArea.innerHTML = UPLOAD_PROMPT_HTML;
          selectBtn.disabled = false;
        }
      );
    };
    reader.readAsDataURL(file);
  }

  function handleFileWithDetection(file) {
    var uploadArea = document.getElementById('isUploadArea');
    var objectsArea = document.getElementById('isObjectsArea');
    var img = document.getElementById('isObjectsImg');
    var pointsBox = document.getElementById('isObjectsPoints');
    var cropBox = document.getElementById('isObjectsCrop');
    var hint = document.getElementById('isObjectsHint');

    uploadArea.classList.add('is-loading');
    uploadArea.innerHTML = '<span class="is-spinner-lg"></span><p>Ищем объекты на фото…</p>';

    var reader = new FileReader();
    reader.onload = function (e) {
      var dataUrl = e.target.result;
      var base64 = dataUrl.split(',')[1];
      selectedBase64 = base64;

      img.src = dataUrl;
      pointsBox.innerHTML = '';
      cropBox.style.display = 'none';
      cropBox.className = 'is-objects-crop';

      var xhr = new XMLHttpRequest();
      xhr.open('POST', CONFIG.objectsApiUrl, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) return;
        if (xhr.status !== 200) {

          sendWholeFileSearch(file);
          return;
        }
        var resp;
        try { resp = JSON.parse(xhr.responseText); } catch (err) {
          sendWholeFileSearch(file);
          return;
        }
        if (!resp.success) {
          sendWholeFileSearch(file);
          return;
        }
        var objects = resp.objects || [];
        if (objects.length === 0) {

          sendWholeFileSearch(file);
          return;
        }
        if (objects.length === 1) {

          uploadArea.style.display = 'none';
          objectsArea.style.display = 'flex';
          hint.textContent = 'Нашли объект, ищем…';
          var singleRender = function () {
            animateCropAndSubmit(objects[0], resp.imageWidth, resp.imageHeight, img, pointsBox, cropBox, dataUrl, file.type);
          };
          if (img.complete && img.naturalWidth) singleRender();
          else img.addEventListener('load', singleRender, { once: true });
          return;
        }

        uploadArea.style.display = 'none';
        objectsArea.style.display = 'flex';
        hint.textContent = 'Нажмите на объект чтобы искать по нему';
        renderShapes(objects, resp.imageWidth, resp.imageHeight, img, pointsBox, cropBox, dataUrl, file.type);
      };
      xhr.send(JSON.stringify({ imageBase64: base64, imageMimeType: file.type }));
    };
    reader.readAsDataURL(file);
  }

  function renderShapes(objects, imgW, imgH, img, pointsBox, cropBox, dataUrl, mimeType) {
    var svg = document.getElementById('isObjectsSvg');
    var render = function () {

      if (!document.body.contains(img)) {
        window.removeEventListener('resize', onResize);
        window.removeEventListener('orientationchange', onResize);
        return;
      }
      var rendered = img.getBoundingClientRect();

      if (!rendered.width || !rendered.height) {
        requestAnimationFrame(render);
        return;
      }
      var scaleX = rendered.width / imgW;
      var scaleY = rendered.height / imgH;

      svg.setAttribute('viewBox', '0 0 ' + imgW + ' ' + imgH);
      svg.setAttribute('width', rendered.width);
      svg.setAttribute('height', rendered.height);
      svg.innerHTML = '';
      pointsBox.innerHTML = '';

      objects.forEach(function (obj, idx) {
        var bx = obj.bbox[0], by = obj.bbox[1], bw = obj.bbox[2], bh = obj.bbox[3];
        var point = document.createElement('button');
        point.type = 'button';
        point.className = 'is-objects-point';
        point.style.left = ((bx + bw / 2) * scaleX) + 'px';
        point.style.top = ((by + bh / 2) * scaleY) + 'px';
        point.style.animationDelay = (idx * 80) + 'ms';
        point.setAttribute('aria-label', obj.label || 'Объект');
        point.addEventListener('click', function (e) {
          e.stopPropagation();
          selectObject(obj, imgW, imgH, img, pointsBox, cropBox, dataUrl, mimeType);
        });
        pointsBox.appendChild(point);
      });
    };
    var scheduleRender = function () {
      requestAnimationFrame(function () { requestAnimationFrame(render); });
    };
    if (img.complete && img.naturalWidth) scheduleRender();
    img.addEventListener('load', scheduleRender, { once: true });

    var onResize = function () { scheduleRender(); };
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
  }

  function selectObject(obj, imgW, imgH, img, pointsBox, cropBox, dataUrl, mimeType) {

    pointsBox.style.pointerEvents = 'none';
    Array.prototype.forEach.call(pointsBox.querySelectorAll('.is-objects-point'), function (p) {
      p.classList.add('is-objects-point-hide');
    });

    var svg = document.getElementById('isObjectsSvg');
    var ns = 'http://www.w3.org/2000/svg';
    var hasPoly = obj.polygon && obj.polygon.length >= 3;
    var drawMs = hasPoly ? 650 : 0;

    if (hasPoly) {
      var poly = document.createElementNS(ns, 'polygon');
      var pts = obj.polygon.map(function (p) { return p[0] + ',' + p[1]; }).join(' ');
      poly.setAttribute('points', pts);
      poly.setAttribute('class', 'is-objects-shape-selected');
      svg.appendChild(poly);

      var total = poly.getTotalLength ? poly.getTotalLength() : 4000;
      poly.style.strokeDasharray = total;
      poly.style.strokeDashoffset = total;

      poly.getBoundingClientRect();
      poly.style.transition = 'stroke-dashoffset ' + drawMs + 'ms cubic-bezier(0.4, 0, 0.2, 1), fill 300ms ease-out ' + drawMs + 'ms';
      poly.style.strokeDashoffset = '0';
      poly.style.fill = 'rgba(254, 189, 1, 0.4)';
    }

    setTimeout(function () {
      animateCropAndSubmit(obj, imgW, imgH, img, pointsBox, cropBox, dataUrl, mimeType);
    }, drawMs + 200);
  }

  function animateCropAndSubmit(obj, imgW, imgH, img, pointsBox, cropBox, dataUrl, mimeType) {

    pointsBox.style.pointerEvents = 'none';

    var rendered = img.getBoundingClientRect();
    var scaleX = rendered.width / imgW;
    var scaleY = rendered.height / imgH;

    var tx1, ty1, tx2, ty2;
    if (obj.polygon && obj.polygon.length >= 3) {
      tx1 = Infinity; ty1 = Infinity; tx2 = -Infinity; ty2 = -Infinity;
      for (var i = 0; i < obj.polygon.length; i++) {
        var px = obj.polygon[i][0], py = obj.polygon[i][1];
        if (px < tx1) tx1 = px;
        if (py < ty1) ty1 = py;
        if (px > tx2) tx2 = px;
        if (py > ty2) ty2 = py;
      }
    } else {
      tx1 = obj.bbox[0]; ty1 = obj.bbox[1];
      tx2 = tx1 + obj.bbox[2]; ty2 = ty1 + obj.bbox[3];
    }
    var bw = tx2 - tx1, bh = ty2 - ty1;
    var cx = tx1 + bw / 2;
    var cy = ty1 + bh / 2;
    var side = Math.round(Math.max(bw, bh) * 1.03);
    var sqX = Math.max(0, Math.round(cx - side / 2));
    var sqY = Math.max(0, Math.round(cy - side / 2));
    if (sqX + side > imgW) sqX = Math.max(0, imgW - side);
    if (sqY + side > imgH) sqY = Math.max(0, imgH - side);
    var sqW = Math.min(side, imgW - sqX);
    var sqH = Math.min(side, imgH - sqY);

    var visualCx = (tx1 + tx2) / 2;
    var visualCy = (ty1 + ty2) / 2;
    cropBox.style.display = 'block';
    cropBox.classList.remove('is-objects-crop-expand');
    cropBox.style.transition = 'none';
    cropBox.style.left = (visualCx * scaleX) + 'px';
    cropBox.style.top = (visualCy * scaleY) + 'px';
    cropBox.style.width = '0px';
    cropBox.style.height = '0px';

    cropBox.offsetHeight;
    cropBox.classList.add('is-objects-crop-expand');
    cropBox.style.transition = '';
    cropBox.style.left = (tx1 * scaleX) + 'px';
    cropBox.style.top = (ty1 * scaleY) + 'px';
    cropBox.style.width = ((tx2 - tx1) * scaleX) + 'px';
    cropBox.style.height = ((ty2 - ty1) * scaleY) + 'px';

    setTimeout(function () {
      var canvas = document.createElement('canvas');
      canvas.width = sqW;
      canvas.height = sqH;
      var ctx = canvas.getContext('2d');
      var src = new Image();
      src.onload = function () {
        ctx.drawImage(src, sqX, sqY, sqW, sqH, 0, 0, sqW, sqH);
        var out = canvas.toDataURL('image/jpeg', 0.92);
        var b64 = out.split(',')[1];
        sendSearchRequest(
          { imageBase64: b64, imageMimeType: 'image/jpeg' },
          function () { resetToUploadView(); }
        );
      };
      src.src = dataUrl;
    }, 550);
  }

  function sendSearchRequest(data, onError) {
    var imageData = {};
    if (data.imageBase64) {
      imageData.imageBase64 = data.imageBase64;
      imageData.imageMimeType = data.imageMimeType || 'image/jpeg';
      imageData.thumbnail = 'data:' + (data.imageMimeType || 'image/jpeg') + ';base64,' + data.imageBase64;
    }
    if (data.imageUrl) {
      imageData.imageUrl = data.imageUrl;
      imageData.thumbnail = data.imageUrl;
    }
    try {
      sessionStorage.setItem('imageSearchData', JSON.stringify({
        imageUrl: imageData.imageUrl || null,
        imageBase64: imageData.imageBase64 || null,
        imageMimeType: imageData.imageMimeType || null,
        thumbnail: imageData.thumbnail || null
      }));
    } catch (e) {
      try {
        sessionStorage.setItem('imageSearchData', JSON.stringify({
          imageUrl: imageData.imageUrl || null,
          thumbnail: imageData.imageUrl || null
        }));
      } catch (e2) {  }
    }

    var xhr = new XMLHttpRequest();
    xhr.open('POST', CONFIG.apiUrl, true);
    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.timeout = 60000;
    var done = false;
    var finish = function (toastMsg, isError) {
      if (done) return;
      done = true;
      if (toastMsg) showToast(toastMsg, isError ? 'error' : null);
      if (onError) onError();
    };
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      if (xhr.status === 200) {
        try {
          var response = JSON.parse(xhr.responseText);
          if (response.success && response.redirectUrl) {
            done = true;
            window.location.href = response.redirectUrl;
            return;
          }
          finish(response.error || response.message || 'Похожие товары не найдены', true);
        } catch (err) {
          finish('Ошибка обработки ответа', true);
        }
      } else if (xhr.status === 0) {
        finish('Не удалось связаться с сервером. Проверьте соединение.', true);
      } else {
        finish('Ошибка сервера (' + xhr.status + ')', true);
      }
    };
    xhr.ontimeout = function () { finish('Превышено время ожидания. Попробуйте ещё раз.', true); };
    xhr.onerror = function () { finish('Сетевая ошибка. Попробуйте ещё раз.', true); };
    xhr.send(JSON.stringify(data));
  }

  function showToast(message, type) {
    var existing = document.querySelector('.is-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'is-toast' + (type === 'error' ? ' is-toast-error' : '');
    toast.textContent = message;
    document.body.appendChild(toast);
    setTimeout(function () { toast.classList.add('is-toast-show'); }, 10);
    setTimeout(function () {
      toast.classList.remove('is-toast-show');
      setTimeout(function () { toast.remove(); }, 300);
    }, 4000);
  }

})();
/**
 * @fileoverview Логика страницы «Мои посылки» (delivery/list.tpl):
 * универсальная модалка подтверждения, отмена / отказ / возврат доставки,
 * модалка трекинга посылки.
 *
 * Входит в общий бандл (ci/bundle.conf: секции [js] и [js-mobile]), поэтому
 * грузится на всех страницах — ниже стоит ранний выход, если на странице нет
 * модалки подтверждения. Локализуемые строки и языковой суффикс для AJAX
 * приходят из инлайн-бутстрапа в шаблоне (Smarty не работает в статическом .js)
 * — см. window.DLV_I18N и window.DLV_LANG_SUFFIX.
 */

document.addEventListener('DOMContentLoaded', function () {

    // Грузимся в общем бандле — активируемся только на странице «Мои посылки».
    // Маркер — модалка подтверждения; на остальных страницах её (и прочих
    // delivery-элементов) нет, иначе обработчики ниже упали бы на null.
    const confirmOverlay = document.getElementById('deliveryConfirmOverlay');
    if (!confirmOverlay) {
        return;
    }

    // Локализованные строки (RU/KK) и языковой суффикс для AJAX. Читаем внутри
    // DOMContentLoaded, чтобы инлайн-бутстрап из list.tpl точно успел выполниться.
    const DLV_I18N = window.DLV_I18N || {};
    const DLV_LANG_SUFFIX = window.DLV_LANG_SUFFIX || '';

    // Универсальная модалка подтверждения (на базе .delivery-track-modal)
    const confirmText = document.getElementById('deliveryConfirmText');
    const confirmYes = document.getElementById('deliveryConfirmYes');
    const confirmNo = document.getElementById('deliveryConfirmNo');
    const confirmClose = document.getElementById('deliveryConfirmClose');
    let confirmCb = null;

    function closeConfirm() {
        confirmOverlay.classList.remove('active');
        confirmCb = null;
    }
    /**
     * Показывает модалку подтверждения и запоминает колбэк на «Да».
     * @param {string} text Текст подтверждения.
     * @param {function(): void} onYes Действие, выполняемое при подтверждении.
     * @returns {void}
     */
    function dlvConfirm(text, onYes) {
        confirmText.textContent = text;
        confirmCb = onYes;
        confirmOverlay.classList.add('active');
    }
    confirmYes.addEventListener('click', function () {
        const cb = confirmCb;
        closeConfirm();
        if (typeof cb === 'function') cb();
    });
    confirmNo.addEventListener('click', closeConfirm);
    confirmClose.addEventListener('click', closeConfirm);
    confirmOverlay.addEventListener('click', function (e) {
        if (e.target === confirmOverlay) closeConfirm();
    });

    // Отмена заказа
    const cancelButtons = document.querySelectorAll('.js-delivery-cancel');
    cancelButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
            const orderId = btn.getAttribute('data-order-id');
            if (!orderId) return;
            dlvConfirm(DLV_I18N.confirmCancel, function () {
                btn.disabled = true;
                btn.querySelector('span').textContent = DLV_I18N.busyCanceling;

                fetch('/ajax/delivery.php', {
                    method: 'POST',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    body: 'action=cancel&order_id=' + encodeURIComponent(orderId) + DLV_LANG_SUFFIX
                })
                .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
                .then(function (resp) {
                    if (resp.success) {
                        window.location.reload();
                    } else {
                        alert(resp.error || DLV_I18N.cancelFailed);
                        btn.disabled = false;
                        btn.querySelector('span').textContent = DLV_I18N.cancelBtn;
                    }
                })
                .catch(function () {
                    alert(DLV_I18N.genericError);
                    btn.disabled = false;
                    btn.querySelector('span').textContent = DLV_I18N.cancelBtn;
                });
            });
        });
    });

    // Отслеживание заказа
    const trackOverlay = document.getElementById('deliveryTrackOverlay');
    const trackContent = document.getElementById('deliveryTrackContent');
    const trackClose = document.getElementById('deliveryTrackClose');

    function closeTrackModal() {
        trackOverlay.classList.remove('active');
    }

    trackClose.addEventListener('click', closeTrackModal);
    trackOverlay.addEventListener('click', function (e) {
        if (e.target === trackOverlay) closeTrackModal();
    });

    const trackButtons = document.querySelectorAll('.js-delivery-track');
    trackButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
            const orderId = btn.getAttribute('data-order-id');
            if (!orderId) return;

            trackContent.innerHTML = '<div class="delivery-track-loading">' + DLV_I18N.loading + '</div>';
            trackOverlay.classList.add('active');

            fetch('/ajax/delivery.php', {
                method: 'POST',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                body: 'action=tracking&order_id=' + encodeURIComponent(orderId) + DLV_LANG_SUFFIX
            })
            .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
            .then(function (resp) {
                if (!resp.success || !resp.items || resp.items.length === 0) {
                    trackContent.innerHTML = '<div class="delivery-track-empty">' + DLV_I18N.trackEmpty + '</div>';
                    return;
                }
                let html = '<div class="delivery-track-timeline">';
                resp.items.forEach(function (item) {
                    html += '<div class="delivery-track-item' + (item.planned ? ' planned' : '') + '">';
                    html += '<div><div class="delivery-track-date">' + escapeHtml(item.date) + '</div>';
                    html += '<div class="delivery-track-text">' + escapeHtml(item.text) + '</div></div>';
                    html += '</div>';
                });
                html += '</div>';
                trackContent.innerHTML = html;
            })
            .catch(function () {
                trackContent.innerHTML = '<div class="delivery-track-empty">' + DLV_I18N.genericError + '</div>';
            });
        });
    });

    /**
     * Экранирует строку для безопасной вставки в innerHTML.
     * @param {string} str Исходная строка.
     * @returns {string} HTML-экранированная строка.
     */
    function escapeHtml(str) {
        const div = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
    }

    // Отказ от доставки
    const refuseButtons = document.querySelectorAll('.js-delivery-refuse');
    refuseButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
            const orderId = btn.getAttribute('data-order-id');
            if (!orderId) return;
            dlvConfirm(DLV_I18N.confirmRefuse, function () {
                btn.disabled = true;
                btn.querySelector('span').textContent = DLV_I18N.busyCanceling;

                fetch('/ajax/delivery.php', {
                    method: 'POST',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    body: 'action=refuse&order_id=' + encodeURIComponent(orderId) + DLV_LANG_SUFFIX
                })
                .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
                .then(function (resp) {
                    if (resp.success) {
                        window.location.reload();
                    } else {
                        alert(resp.error || DLV_I18N.refuseFailed);
                        btn.disabled = false;
                        btn.querySelector('span').textContent = DLV_I18N.refuseBtn;
                    }
                })
                .catch(function () {
                    alert(DLV_I18N.genericError);
                    btn.disabled = false;
                    btn.querySelector('span').textContent = DLV_I18N.refuseBtn;
                });
            });
        });
    });

    // Возврат посылки
    const returnOverlay = document.getElementById('deliveryReturnOverlay');
    const returnContent = document.getElementById('deliveryReturnContent');
    const returnClose = document.getElementById('deliveryReturnClose');

    function closeReturnModal() {
        returnOverlay.classList.remove('active');
    }

    if (returnClose) {
        returnClose.addEventListener('click', closeReturnModal);
    }
    if (returnOverlay) {
        returnOverlay.addEventListener('click', function (e) {
            if (e.target === returnOverlay) closeReturnModal();
        });
    }

    const returnButtons = document.querySelectorAll('.js-delivery-return');
    returnButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
            const orderId = btn.getAttribute('data-order-id');
            if (!orderId) return;

            returnContent.innerHTML = '<div class="delivery-track-loading">' + DLV_I18N.returnCalculating + '</div>';
            returnOverlay.classList.add('active');

            fetch('/ajax/delivery.php', {
                method: 'POST',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                body: 'action=return-calc&order_id=' + encodeURIComponent(orderId) + DLV_LANG_SUFFIX
            })
            .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
            .then(function (resp) {
                if (!resp.success) {
                    returnContent.innerHTML = '<div class="delivery-track-empty">' + escapeHtml(resp.error || DLV_I18N.errorShort) + '</div>';
                    return;
                }
                const calc = resp["calculation"];
                let html = '<div style="padding: 0 4px;">';
                html += '<div style="font-size: 14px; color: #808080; margin-bottom: 8px;">' + escapeHtml(calc.route_label) + '</div>';
                html += '<div style="font-size: 18px; font-weight: 600; margin-bottom: 8px;">' + DLV_I18N.returnCostLabel + ' ' + escapeHtml(calc.total_formatted) + '</div>';
                if (calc.delivery_days_label) {
                    html += '<div style="font-size: 14px; color: #808080; margin-bottom: 16px;">' + DLV_I18N.returnTermLabel + ' ' + escapeHtml(calc.delivery_days_label) + '</div>';
                }
                if (resp["payMethods"] && resp["payMethods"].length > 0) {
                    html += '<div style="margin-bottom: 16px;"><div style="font-weight: 500; margin-bottom: 8px;">' + DLV_I18N.payMethodLabel + '</div>';
                    resp["payMethods"].forEach(function (m) {
                        const checked = m.selected ? ' checked' : '';
                        html += '<label style="display: block; padding: 6px 0; cursor: pointer;"><input type="radio" name="return_pay_method" value="' + m.id + '"' + checked + ' style="margin-right: 8px;"> ' + escapeHtml(m.name) + '</label>';
                    });
                    html += '</div>';
                }
                html += '<div style="display: flex; gap: 8px;">';
                html += '<button type="button" class="delivery-btn" id="confirmReturnBtn" data-order-id="' + orderId + '" style="flex: 1;"><span>' + DLV_I18N.returnConfirmBtn + '</span></button>';
                html += '<button type="button" class="delivery-btn deliver-blue-stroke" onclick="document.getElementById(\'deliveryReturnOverlay\').classList.remove(\'active\')" style="flex: 1;"><span>' + DLV_I18N.returnCancelBtn + '</span></button>';
                html += '</div></div>';
                returnContent.innerHTML = html;

                const confirmBtn = document.getElementById('confirmReturnBtn');
                if (confirmBtn) {
                    confirmBtn.addEventListener('click', function () {
                        const payMethodEl = document.querySelector('input[name="return_pay_method"]:checked');
                        if (!payMethodEl) { alert(DLV_I18N.selectPayMethod); return; }

                        confirmBtn.disabled = true;
                        confirmBtn.querySelector('span').textContent = DLV_I18N.returnSubmitting;

                        fetch('/ajax/delivery.php', {
                            method: 'POST',
                            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                            body: 'action=return-create&order_id=' + encodeURIComponent(orderId) + '&pay_method=' + encodeURIComponent(payMethodEl.value) + DLV_LANG_SUFFIX
                        })
                        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
                        .then(function (resp) {
                            if (resp.success) {
                                window.location.href = resp.redirect || '/delivery?list';
                            } else {
                                alert(resp.error || DLV_I18N.returnFailed);
                                confirmBtn.disabled = false;
                                confirmBtn.querySelector('span').textContent = DLV_I18N.returnConfirmBtn;
                            }
                        })
                        .catch(function () {
                            alert(DLV_I18N.genericError);
                            confirmBtn.disabled = false;
                            confirmBtn.querySelector('span').textContent = DLV_I18N.returnConfirmBtn;
                        });
                    });
                }
            })
            .catch(function () {
                returnContent.innerHTML = '<div class="delivery-track-empty">' + DLV_I18N.genericError + '</div>';
            });
        });
    });
});
/**
 * @fileoverview Логика страницы «Скидки и акции» (actions/list.tpl):
 * бесконечная подгрузка акций при скролле (IntersectionObserver на #loader)
 * и фильтр по тегам.
 *
 * Входит в общий бандл (ci/bundle.conf: [js]), поэтому грузится на всех
 * страницах — ниже ранний выход, если на странице нет блока акций
 * (.actions-page). Заголовок для перезаписи H1 при подгрузке приходит из
 * инлайн-бутстрапа шаблона (window.ACTIONS_I18N.pageTitle) — Smarty не
 * работает в статическом .js.
 */
(function () {
    'use strict';

    function init() {

        // Грузимся в общем бандле — активируемся только на странице акций.
        if (!document.querySelector('.actions-page')) {
            return;
        }

        var ACTIONS_I18N = window.ACTIONS_I18N || {};
        var pageTitle = ACTIONS_I18N.pageTitle || '';

        // Языковой префикс пути (например, '/kk' для казахской версии, '' для русской).
        // Без него фильтр по тегам и AJAX-подгрузка сбрасывали бы язык на дефолтный.
        var langPrefix = window.location.pathname.replace(/\/actions.*$/, '');

        var allActionInput = document.getElementById('all');
        var limit = 24;
        var offset = 24;
        var checkedTags = document.querySelectorAll('input[name*=tag]:checked');

        function qa(selector) {
            return Array.from(document.querySelectorAll(selector));
        }

        // Бесконечная подгрузка: #loader показался — грузим следующую порцию
        var loaderObserver = new IntersectionObserver(function (entries) {
            var loader = document.getElementById('loader');
            if (entries[entries.length - 1].isIntersecting && loader && !loader.classList.contains('active')) {
                loader.classList.add('active');
                loadData();
            }
        });

        // Переподписка после подгрузки: observe() сразу отдаёт текущее состояние,
        // и если лоадер всё ещё в кадре, следующая порция грузится без скролла
        function watchLoader() {
            loaderObserver.disconnect();
            var loader = document.getElementById('loader');
            if (loader) {
                loaderObserver.observe(loader);
            }
        }
        watchLoader();

        function loadData() {
            var checked = qa('input[name*=tag]:checked');
            var tags = checked.map(function (input) { return input.value; });

            if (tags.length > 0) {
                history.pushState(null, null, langPrefix + '/actions?tags=' + tags.join(','));
            } else {
                history.pushState(null, null, langPrefix + '/actions');
            }

            // Пары name=value отмеченных тегов — как сериализовал jQuery.param
            var tagParams = checked.map(function (input) {
                return encodeURIComponent(input.name) + '=' + encodeURIComponent(input.value);
            }).join('&');

            fetch(langPrefix + '/actions?load&limit=' + limit + '&offset=' + offset + (tagParams ? '&' + tagParams : ''), {
                credentials: 'same-origin',
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            }).then(function (res) { return res.json(); }).then(function (data) {
                var loader = document.getElementById('loader');

                if (data.count > 0) {
                    var list = document.querySelector('.list-actions');
                    if (list) list.insertAdjacentHTML('beforeend', data.rows);
                    var h1 = document.querySelector('.h1-actions');
                    if (h1) h1.innerHTML = pageTitle;
                    if (loader) loader.classList.remove('active');
                    offset += limit;
                    watchLoader();
                }

                if (data.count < offset || !data.rows) {
                    if (loader) loader.remove();
                }
            }).catch(function () {});
        }

        function setChecked(input, state) {
            if (!input) return;
            if (state) {
                input.setAttribute('checked', 'checked');
                input.checked = true;
            } else {
                input.removeAttribute('checked');
                input.checked = false;
            }
        }

        if (allActionInput) {
            allActionInput.addEventListener('change', function () {
                if (allActionInput.checked) {
                    qa('input[name*=tag]').forEach(function (input) { setChecked(input, false); });
                    offset = 0;
                    var list = document.querySelector('.list-actions');
                    if (list) list.innerHTML = '';
                    loadData();
                } else {
                    setChecked(allActionInput, true);
                }
            });
        }

        qa('input[name*=tag]').forEach(function (input) {
            input.addEventListener('change', function () {
                if (document.querySelector('input[name*=tag]:checked')) {
                    setChecked(allActionInput, false);
                } else {
                    setChecked(allActionInput, true);
                }
            });
        });

        var a, b;

        // Вызывается из инлайн-обработчика onclick у радио-тегов в шаблоне,
        // поэтому экспонируется в глобальную область.
        window.removeSelection = function (c) {
            if (checkedTags) {
                if (a !== c) {
                    b = 0;
                    a = c;
                }
                b ^= 1;
                c.checked = b;

                // В оригинале условие всегда истинно и попутно отмечало «Все»
                setChecked(document.getElementById('all'), true);
                offset = 0;
                var list = document.querySelector('.list-actions');
                if (list) list.innerHTML = '';
                loadData();
            }
        };
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
